import { TokensDto } from '@dto/vaults/tokens.dto';

export const tokens: TokensDto = {
  profit: {
    '10': {
      '0x65bf4ba3aac39a066b95de67cc07f2abaf9baf34': {
        address: '0x65bf4ba3aac39a066b95de67cc07f2abaf9baf34',
        chainId: 10,
        type: 'ETF',
        symbol: 'RSETF',
        decimals: 18,
        totalSupply: '14464780315614606315',
        profitToken: '0x65bf4ba3aac39a066b95de67cc07f2abaf9baf34',
        priceInUsd: 0.8917229733862522,
        underlying: '0x238ca40d2a2a35320d2b2fd0a7604b655316b04a',
      },
      '0xd1a34d6c11135efdf921b152ee294eb094b14eee': {
        address: '0xd1a34d6c11135efdf921b152ee294eb094b14eee',
        chainId: 10,
        type: 'ETF',
        symbol: 'ETHMAXIETF',
        decimals: 18,
        totalSupply: '1442635513623112677',
        profitToken: '0xd1a34d6c11135efdf921b152ee294eb094b14eee',
        priceInUsd: 59.012824379902455,
        underlying: '0x280d1b9442c3d9d7bc27b5d2e1ca871f96fb6bb6',
      },
      '0xdcc906dc8ba0c92edfe7e7d003e9b3cd99d4fa60': {
        address: '0xdcc906dc8ba0c92edfe7e7d003e9b3cd99d4fa60',
        chainId: 10,
        type: 'ETF',
        symbol: 'OPMAXIETF',
        decimals: 18,
        totalSupply: '18623839564996966614',
        profitToken: '0xdcc906dc8ba0c92edfe7e7d003e9b3cd99d4fa60',
        priceInUsd: 0.8417195908548101,
        underlying: '0x0da31f47491079a074d3d86cacfc5be1314fc20e',
      },
    },
    '56': {
      '0x0a5bb74d578b228c73bc073d051dfcd56a6cbaf4': {
        address: '0x0a5bb74d578b228c73bc073d051dfcd56a6cbaf4',
        chainId: 56,
        type: 'ETF',
        symbol: 'EMPETF',
        decimals: 18,
        totalSupply: '33185921507245121822',
        profitToken: '0x0a5bb74d578b228c73bc073d051dfcd56a6cbaf4',
        priceInUsd: 4.045119050541702,
        underlying: '0x9732fb5a970186067ec5c135d6ee91568bca228b',
      },
      '0x3a50ac1ed42f5a230ebdd1c9d877d43c137e9e89': {
        address: '0x3a50ac1ed42f5a230ebdd1c9d877d43c137e9e89',
        chainId: 56,
        type: 'ERC20',
        symbol: 'USDC',
        decimals: 18,
        totalSupply: '1048999979839803987446539541',
        profitToken: '0x3a50ac1ed42f5a230ebdd1c9d877d43c137e9e89',
        priceInUsd: 0.991619233353461,
        underlying: '0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d',
      },
      '0xa7a05771422daa64b318c17da250c922090cfd82': {
        address: '0xa7a05771422daa64b318c17da250c922090cfd82',
        chainId: 56,
        type: 'ETF',
        symbol: 'GSETF',
        decimals: 18,
        totalSupply: '443070310382764908067',
        profitToken: '0xa7a05771422daa64b318c17da250c922090cfd82',
        priceInUsd: 2.9926941407072536,
        underlying: '0x01e5e868a6fb767b5219b805b3c39ea98b8fc7d5',
      },
      '0xba65c5086caf782616395cb165877e8e963c59b1': {
        address: '0xba65c5086caf782616395cb165877e8e963c59b1',
        chainId: 56,
        type: 'ETF',
        symbol: 'MCETF',
        decimals: 18,
        totalSupply: '10474479662181119625',
        profitToken: '0xba65c5086caf782616395cb165877e8e963c59b1',
        priceInUsd: 158.10823544601354,
        underlying: '0x227b093d9bc7e59555db823e3d6f700ea2dbf2ca',
      },
    },
    '146': {
      '0x1d8b61137e9ff0fb85a2e7b6f874a0581921381c': {
        address: '0x1d8b61137e9ff0fb85a2e7b6f874a0581921381c',
        chainId: 146,
        type: 'ETF',
        symbol: 'SEETF',
        decimals: 18,
        totalSupply: '4216046739776738325',
        profitToken: '0x1d8b61137e9ff0fb85a2e7b6f874a0581921381c',
        priceInUsd: 8.333426440341908,
        underlying: '0x97dff9a0eb4e8382e998ce847dda2659e7581261',
      },
      '0x8d733825eea479e535e157a4afeb9bb725dfe5ef': {
        address: '0x8d733825eea479e535e157a4afeb9bb725dfe5ef',
        chainId: 146,
        type: 'ETF',
        symbol: 'SETF',
        decimals: 18,
        totalSupply: '285864284190477834239',
        profitToken: '0x8d733825eea479e535e157a4afeb9bb725dfe5ef',
        priceInUsd: 1.1258793633622635,
        underlying: '0x5c2fec17fb8cc110e53d611f8cca59fd9767fa4b',
      },
      '0xe0749379ba2e02fc8f6c118b426c44e2a9c82390': {
        address: '0xe0749379ba2e02fc8f6c118b426c44e2a9c82390',
        chainId: 146,
        type: 'ERC20',
        symbol: 'WS',
        decimals: 18,
        totalSupply: '274396287815247217108724476',
        profitToken: '0xe0749379ba2e02fc8f6c118b426c44e2a9c82390',
        priceInUsd: 0.2525117761308033,
        underlying: '0x039e2fb66102314ce7b64ce5ce3e5183bc94ad38',
      },
      '0xc3687f3d8fb3abd9aa33b34218412dded510db46': {
        address: '0xc3687f3d8fb3abd9aa33b34218412dded510db46',
        chainId: 146,
        type: 'ERC20',
        symbol: 'USDC.E',
        decimals: 6,
        totalSupply: '107809765735442',
        profitToken: '0xc3687f3d8fb3abd9aa33b34218412dded510db46',
        priceInUsd: 0.9945957913700029,
        underlying: '0x29219dd400f2bf60e5a23d13be72b486d4038894',
      },
      '0xa86a21c4ea8bc83f7df6f9ddbee6443db9b051e1': {
        address: '0xa86a21c4ea8bc83f7df6f9ddbee6443db9b051e1',
        chainId: 146,
        type: 'ETF',
        symbol: 'SMETF',
        decimals: 18,
        totalSupply: '1250834181056777976',
        profitToken: '0xa86a21c4ea8bc83f7df6f9ddbee6443db9b051e1',
        priceInUsd: 0.3213748823545775,
        underlying: '0xf56febebb8e7d7aa68f52f8c115a766638102d04',
      },
      '0x2cb519726c222b71014476364452222289d8b7af': {
        address: '0x2cb519726c222b71014476364452222289d8b7af',
        chainId: 146,
        type: 'ERC20',
        symbol: 'WS',
        decimals: 18,
        totalSupply: '274396287815247217108724476',
        profitToken: '0x2cb519726c222b71014476364452222289d8b7af',
        priceInUsd: 0.2525117761308033,
        underlying: '0x039e2fb66102314ce7b64ce5ce3e5183bc94ad38',
      },
      '0x4f169bcb85e62930af0f3e98e8ff417da420b772': {
        address: '0x4f169bcb85e62930af0f3e98e8ff417da420b772',
        chainId: 146,
        type: 'ERC20',
        symbol: 'WBTC',
        decimals: 8,
        totalSupply: '2151923182',
        profitToken: '0x4f169bcb85e62930af0f3e98e8ff417da420b772',
        priceInUsd: 112231.45352495553,
        underlying: '0x0555e30da8f98308edb960aa94c0db47230d2b9c',
      },
    },
    '169': {
      '0x739b27be26a69402a9c215c1352df9ca02f7c8d2': {
        address: '0x739b27be26a69402a9c215c1352df9ca02f7c8d2',
        chainId: 169,
        type: 'ERC20',
        symbol: 'GCETO',
        decimals: 18,
        totalSupply: '10000000000000000000000',
        profitToken: '0x739b27be26a69402a9c215c1352df9ca02f7c8d2',
        priceInUsd: 5.5924905715172315,
        underlying: '0x4c2a0f964a37a3ce305fe41c575beeb48c8c3fa2',
      },
      '0x420b0ac7861fdf1294a03f9b4fc97c61fe04f36e': {
        address: '0x420b0ac7861fdf1294a03f9b4fc97c61fe04f36e',
        chainId: 169,
        type: 'ERC20',
        symbol: 'USDC',
        decimals: 6,
        totalSupply: '2356959618641',
        profitToken: '0x420b0ac7861fdf1294a03f9b4fc97c61fe04f36e',
        priceInUsd: 0.9958041938841876,
        underlying: '0xb73603c5d87fa094b7314c74ace2e64d165016fb',
      },
      '0x103f62be53bdfb3521e6a8661f19319ad2cebdc7': {
        address: '0x103f62be53bdfb3521e6a8661f19319ad2cebdc7',
        chainId: 169,
        type: 'ETF',
        symbol: 'ETHMAXIETF',
        decimals: 18,
        totalSupply: '1764360056129896176',
        profitToken: '0x103f62be53bdfb3521e6a8661f19319ad2cebdc7',
        priceInUsd: 62.11073726688955,
        underlying: '0xeffc99646a5e3479416e3351b48b446937d8c209',
      },
      '0x5def90e6d216776765bcf62a4eb60859a4acb457': {
        address: '0x5def90e6d216776765bcf62a4eb60859a4acb457',
        chainId: 169,
        type: 'ETF',
        symbol: 'GCMETF',
        decimals: 18,
        totalSupply: '6442981947923789554422',
        profitToken: '0x5def90e6d216776765bcf62a4eb60859a4acb457',
        priceInUsd: 0.05085663744706291,
        underlying: '0xa6bdf6dbfaf92f5216f9c87938d4468c1b766e2c',
      },
      '0x6a111389ebe74ba66e96d318fd8a4f0241bf1bc5': {
        address: '0x6a111389ebe74ba66e96d318fd8a4f0241bf1bc5',
        chainId: 169,
        type: 'ERC20',
        symbol: 'USDEX+',
        decimals: 18,
        totalSupply: '485895350571938193100443',
        profitToken: '0x6a111389ebe74ba66e96d318fd8a4f0241bf1bc5',
        priceInUsd: 0.21778316038882078,
        underlying: '0x6da9ebd271a0676f39c088a2b5fd849d5080c0af',
      },
      '0xfc6b9a72312c5efb09d1b77a8e61b0dafaa881dc': {
        address: '0xfc6b9a72312c5efb09d1b77a8e61b0dafaa881dc',
        chainId: 169,
        type: 'ETF',
        symbol: 'METF',
        decimals: 18,
        totalSupply: '252009867707665852265',
        profitToken: '0xfc6b9a72312c5efb09d1b77a8e61b0dafaa881dc',
        priceInUsd: 0.8560560122170731,
        underlying: '0xa9d47ba4d1129d2ebcf3679d799700fb6d6f28ae',
      },
      '0x039ce3ef6b1c17b893453337073b894144014b08': {
        address: '0x039ce3ef6b1c17b893453337073b894144014b08',
        chainId: 169,
        type: 'ETF',
        symbol: 'CETF',
        decimals: 18,
        totalSupply: '40972488168800582344',
        profitToken: '0x039ce3ef6b1c17b893453337073b894144014b08',
        priceInUsd: 0.6012081280081003,
        underlying: '0x433d1134a92362434c5a0619302d74c22e509641',
      },
    },
    '369': {
      '0xaa916efea2235ffc37e705654e825d3a3d18db8c': {
        address: '0xaa916efea2235ffc37e705654e825d3a3d18db8c',
        chainId: 369,
        type: 'ERC20',
        symbol: 'USDEX+',
        decimals: 18,
        totalSupply: '251451858483236672588491',
        profitToken: '0xaa916efea2235ffc37e705654e825d3a3d18db8c',
        priceInUsd: 0.5403032743917803,
        underlying: '0xaa2c47a35c1298795b5271490971ec4874c8e53d',
      },
      '0x2f18e32bc5cdf0d763d00acb93621903d885f0bf': {
        address: '0x2f18e32bc5cdf0d763d00acb93621903d885f0bf',
        chainId: 369,
        type: 'ETF',
        symbol: 'PETF',
        decimals: 18,
        totalSupply: '280023929345690158238',
        profitToken: '0x2f18e32bc5cdf0d763d00acb93621903d885f0bf',
        priceInUsd: 1.5951026091527425,
        underlying: '0xb56aa77d87ecaa9d596b01931eccaddda78b57c1',
      },
      '0xdd32d7e5d9a21feb7e5848c0767eaa9540f9507d': {
        address: '0xdd32d7e5d9a21feb7e5848c0767eaa9540f9507d',
        chainId: 369,
        type: 'ERC20',
        symbol: 'SPARK',
        decimals: 18,
        totalSupply: '71346965343122843931342213',
        profitToken: '0xdd32d7e5d9a21feb7e5848c0767eaa9540f9507d',
        priceInUsd: 0.0012341092347834927,
        underlying: '0x6386704cd6f7a584ea9d23ccca66af7eba5a727e',
      },
      '0x32e90da081bae5e16358d2cc923192821b228754': {
        address: '0x32e90da081bae5e16358d2cc923192821b228754',
        chainId: 369,
        type: 'ETF',
        symbol: 'EMETF',
        decimals: 18,
        totalSupply: '20187217702700644',
        profitToken: '0x32e90da081bae5e16358d2cc923192821b228754',
        priceInUsd: 5.918465545082563,
        underlying: '0x35d4f8f54e80b190a5c326d16c1030a906c47f7d',
      },
      '0x0a9851eff39d6f397db1c50cd0ac28508732149a': {
        address: '0x0a9851eff39d6f397db1c50cd0ac28508732149a',
        chainId: 369,
        type: 'ETF',
        symbol: 'EMPETF',
        decimals: 18,
        totalSupply: '120493975915755382457',
        profitToken: '0x0a9851eff39d6f397db1c50cd0ac28508732149a',
        priceInUsd: 0.3478333739896129,
        underlying: '0x74f82b5f7cd79b98c3924328fb70fffb73a7dd53',
      },
      '0xd9a987371e4b789e731c39f0f1b8e8cbdccbec85': {
        address: '0xd9a987371e4b789e731c39f0f1b8e8cbdccbec85',
        chainId: 369,
        type: 'ETF',
        symbol: 'SMETF',
        decimals: 18,
        totalSupply: '376704767583093000007',
        profitToken: '0xd9a987371e4b789e731c39f0f1b8e8cbdccbec85',
        priceInUsd: 0.048362443970175514,
        underlying: '0x778e55f1472455da958309dffe2923726f8577e0',
      },
      '0xb4370dde29e398bdc08d3569da9a36645f5dd1ff': {
        address: '0xb4370dde29e398bdc08d3569da9a36645f5dd1ff',
        chainId: 369,
        type: 'ETF',
        symbol: 'SETF',
        decimals: 18,
        totalSupply: '1536292999800100462839',
        profitToken: '0xb4370dde29e398bdc08d3569da9a36645f5dd1ff',
        priceInUsd: 0.6659017341938462,
        underlying: '0xa8e6045fb7980eca402b0a3e6ebd15ab2fad3619',
      },
    },
    '8453': {
      '0x11d3c371ce50a93fcff4c0b7fe7e3dc8703c907e': {
        address: '0x11d3c371ce50a93fcff4c0b7fe7e3dc8703c907e',
        chainId: 8453,
        type: 'ETF',
        symbol: 'ETHMAXIETF',
        decimals: 18,
        totalSupply: '864453490744833718704',
        profitToken: '0x11d3c371ce50a93fcff4c0b7fe7e3dc8703c907e',
        priceInUsd: 88.38330674933523,
        underlying: '0x74f82b5f7cd79b98c3924328fb70fffb73a7dd53',
      },
      '0xade7015bc4a63d4df15c3311ad6bdd87024ad58f': {
        address: '0xade7015bc4a63d4df15c3311ad6bdd87024ad58f',
        chainId: 8453,
        type: 'ETF',
        symbol: 'GETF',
        decimals: 18,
        totalSupply: '20086966226639473070248',
        profitToken: '0xade7015bc4a63d4df15c3311ad6bdd87024ad58f',
        priceInUsd: 0.09258041319096691,
        underlying: '0xfa23f8deb13d3fa408d355863c747bf7cd61d9a6',
      },
      '0x6304ff0ce5e63d1530f66059f05326e949e354d1': {
        address: '0x6304ff0ce5e63d1530f66059f05326e949e354d1',
        chainId: 8453,
        type: 'ETF',
        symbol: 'GSETF',
        decimals: 18,
        totalSupply: '5382695500351437210865',
        profitToken: '0x6304ff0ce5e63d1530f66059f05326e949e354d1',
        priceInUsd: 1.2439684879625141,
        underlying: '0xa8e6045fb7980eca402b0a3e6ebd15ab2fad3619',
      },
    },
    '42161': {
      '0x4a432874bce1ec2a8b6ec96acc650b9b74182712': {
        address: '0x4a432874bce1ec2a8b6ec96acc650b9b74182712',
        chainId: 42161,
        type: 'ETF',
        symbol: 'GSETF',
        decimals: 18,
        totalSupply: '770293171682318730204',
        profitToken: '0x4a432874bce1ec2a8b6ec96acc650b9b74182712',
        priceInUsd: 1.3499822289998407,
        underlying: '0xa52980606c4fcbabdc81f132c61dd6e61d8be8bf',
      },
      '0x26c6f78cd631fe74e3288dde758bc972d02274b3': {
        address: '0x26c6f78cd631fe74e3288dde758bc972d02274b3',
        chainId: 42161,
        type: 'ETF',
        symbol: 'ARBMAXIETF',
        decimals: 18,
        totalSupply: '6181429501150160565',
        profitToken: '0x26c6f78cd631fe74e3288dde758bc972d02274b3',
        priceInUsd: 3.8772622956276663,
        underlying: '0x1f0d86b0be59232a6958cfccc159d6ca2d9a42b7',
      },
      '0x8efba3027a71bd4d5fa66788faf7aae3dca4f5c7': {
        address: '0x8efba3027a71bd4d5fa66788faf7aae3dca4f5c7',
        chainId: 42161,
        type: 'ERC20',
        symbol: 'USDEX+',
        decimals: 18,
        totalSupply: '366016395359910839300751',
        profitToken: '0x8efba3027a71bd4d5fa66788faf7aae3dca4f5c7',
        priceInUsd: 0.2808220512710337,
        underlying: '0x4117ec0a779448872d3820f37ba2060ae0b7c34b',
      },
      '0xe31f02c359d42dca777c94a96ece575cc2d657b0': {
        address: '0xe31f02c359d42dca777c94a96ece575cc2d657b0',
        chainId: 42161,
        type: 'ERC20',
        symbol: 'USDEX+',
        decimals: 18,
        totalSupply: '254184174045391486535709',
        profitToken: '0xe31f02c359d42dca777c94a96ece575cc2d657b0',
        priceInUsd: 0.16832017171000146,
        underlying: '0x2c093f7d7db41057a2ddd3cb1ad8b4e9c3dffbec',
      },
      '0xc67deb171c6290cd48199fdb512eb96501830955': {
        address: '0xc67deb171c6290cd48199fdb512eb96501830955',
        chainId: 42161,
        type: 'ETF',
        symbol: '50BCETF',
        decimals: 18,
        totalSupply: '9248923619894219308',
        profitToken: '0xc67deb171c6290cd48199fdb512eb96501830955',
        priceInUsd: 398.67105008630483,
        underlying: '0x3f7eac02201ebfbe9fddd70928e2f921cae31a8d',
      },
      '0xbff31ab15a42031567e0b8bb27c0a747a3bc11f6': {
        address: '0xbff31ab15a42031567e0b8bb27c0a747a3bc11f6',
        chainId: 42161,
        type: 'ETF',
        symbol: 'DEXFIETF',
        decimals: 18,
        totalSupply: '131492382064119891',
        profitToken: '0xbff31ab15a42031567e0b8bb27c0a747a3bc11f6',
        priceInUsd: 22.780575134063472,
        underlying: '0x0676dbb8ca7d13c6a9436ab3c2e5444634f7a058',
      },
      '0x87e1283d2bd780227f49cb55f6f437d1298e41f2': {
        address: '0x87e1283d2bd780227f49cb55f6f437d1298e41f2',
        chainId: 42161,
        type: 'ETF',
        symbol: 'ETF_02',
        decimals: 18,
        totalSupply: '4303106866860198434',
        profitToken: '0x87e1283d2bd780227f49cb55f6f437d1298e41f2',
        priceInUsd: 4.290943590436929,
        underlying: '0x0175b9fdbb7cd36701e6261e4018d7662d7608e3',
      },
      '0xc7706b9dbc2a2999abc072dc5f65c2a9abc3c282': {
        address: '0xc7706b9dbc2a2999abc072dc5f65c2a9abc3c282',
        chainId: 42161,
        type: 'ETF',
        symbol: 'DEXFIETF',
        decimals: 18,
        totalSupply: '15668177312531938658',
        profitToken: '0xc7706b9dbc2a2999abc072dc5f65c2a9abc3c282',
        priceInUsd: 4.656790825913806,
        underlying: '0xe0449ab87048be6982f25b66fe1a03a084e14904',
      },
      '0x8c171913e3f22830a0b521ae5f38f94e066a53b2': {
        address: '0x8c171913e3f22830a0b521ae5f38f94e066a53b2',
        chainId: 42161,
        type: 'ETF',
        symbol: 'ETHMAXIETF',
        decimals: 18,
        totalSupply: '166312234631846286',
        profitToken: '0x8c171913e3f22830a0b521ae5f38f94e066a53b2',
        priceInUsd: 87.80740290206066,
        underlying: '0x3ffc19bb4700d1d65ecf64e9b145b9fd9cc24086',
      },
      '0xba8894888d0ae0a19e99ed288cf88424dbd73307': {
        address: '0xba8894888d0ae0a19e99ed288cf88424dbd73307',
        chainId: 42161,
        type: 'ETF',
        symbol: 'ETHMAXIETF',
        decimals: 18,
        totalSupply: '166312234631846286',
        profitToken: '0xba8894888d0ae0a19e99ed288cf88424dbd73307',
        priceInUsd: 87.80740290206066,
        underlying: '0x3ffc19bb4700d1d65ecf64e9b145b9fd9cc24086',
      },
      '0x980d80fd24c6c9637a603f9c174a4c5afaa8feb3': {
        address: '0x980d80fd24c6c9637a603f9c174a4c5afaa8feb3',
        chainId: 42161,
        type: 'ETF',
        symbol: '50BCETF',
        decimals: 18,
        totalSupply: '9248923619894219308',
        profitToken: '0x980d80fd24c6c9637a603f9c174a4c5afaa8feb3',
        priceInUsd: 398.67105008630483,
        underlying: '0x3f7eac02201ebfbe9fddd70928e2f921cae31a8d',
      },
      '0x950636b2cd571c220dde496ec0cbc83f3e628b71': {
        address: '0x950636b2cd571c220dde496ec0cbc83f3e628b71',
        chainId: 42161,
        type: 'ETF',
        symbol: 'GDEXETF',
        decimals: 18,
        totalSupply: '15319060467859570117',
        profitToken: '0x950636b2cd571c220dde496ec0cbc83f3e628b71',
        priceInUsd: 0.5872090323784181,
        underlying: '0x59ef502d6f278dc65d57a7bef78afb33a2487ff8',
      },
      '0xc4b96ecae6b69a8527161ec1cf3280735993aa5a': {
        address: '0xc4b96ecae6b69a8527161ec1cf3280735993aa5a',
        chainId: 42161,
        type: 'ETF',
        symbol: 'ARBBCETF',
        decimals: 18,
        totalSupply: '122785689828804315',
        profitToken: '0xc4b96ecae6b69a8527161ec1cf3280735993aa5a',
        priceInUsd: 128.16430082307076,
        underlying: '0x6da809359c8005e50ec87d0d368457639b18a45b',
      },
      '0xe116f367a11bd5a65c85f7974a8cd412274f1116': {
        address: '0xe116f367a11bd5a65c85f7974a8cd412274f1116',
        chainId: 42161,
        type: 'ETF',
        symbol: 'ARBBCETF',
        decimals: 18,
        totalSupply: '122785689828804315',
        profitToken: '0xe116f367a11bd5a65c85f7974a8cd412274f1116',
        priceInUsd: 128.16430082307076,
        underlying: '0x6da809359c8005e50ec87d0d368457639b18a45b',
      },
      '0x453558ba3b40d2ab797111e26ff3e99ec479c064': {
        address: '0x453558ba3b40d2ab797111e26ff3e99ec479c064',
        chainId: 42161,
        type: 'ETF',
        symbol: 'GDEXETF',
        decimals: 18,
        totalSupply: '1046887337162514082',
        profitToken: '0x453558ba3b40d2ab797111e26ff3e99ec479c064',
        priceInUsd: 8.583938260121469,
        underlying: '0x2a02e6915ac59dfd52792a9804b3c074bb614109',
      },
      '0x0da7066acbfeed7b960cd97c5d32fc54b8aa4fa2': {
        address: '0x0da7066acbfeed7b960cd97c5d32fc54b8aa4fa2',
        chainId: 42161,
        type: 'ETF',
        symbol: 'ARBMAXIETF',
        decimals: 18,
        totalSupply: '6181429501150160565',
        profitToken: '0x0da7066acbfeed7b960cd97c5d32fc54b8aa4fa2',
        priceInUsd: 3.8772622956276663,
        underlying: '0x1f0d86b0be59232a6958cfccc159d6ca2d9a42b7',
      },
      '0xfe0eb88b4f1f76cb7b2b0acae5a23464ac7dd766': {
        address: '0xfe0eb88b4f1f76cb7b2b0acae5a23464ac7dd766',
        chainId: 42161,
        type: 'ETF',
        symbol: 'GDEXETF',
        decimals: 18,
        totalSupply: '1046887337162514082',
        profitToken: '0xfe0eb88b4f1f76cb7b2b0acae5a23464ac7dd766',
        priceInUsd: 8.583938260121469,
        underlying: '0x2a02e6915ac59dfd52792a9804b3c074bb614109',
      },
    },
    '43114': {
      '0x4f994e49cbf6187a3e1970c7179f1dc5d3b6cd91': {
        address: '0x4f994e49cbf6187a3e1970c7179f1dc5d3b6cd91',
        chainId: 43114,
        type: 'ETF',
        symbol: 'FSETF',
        decimals: 18,
        totalSupply: '5545000000000000',
        profitToken: '0x4f994e49cbf6187a3e1970c7179f1dc5d3b6cd91',
        priceInUsd: 1.1974306826938925,
        underlying: '0xd8daaae660537dd4364dde0807aa621870d6d3cb',
      },
      '0xb3dbd4d49b88786ba0432154407d8852e417b052': {
        address: '0xb3dbd4d49b88786ba0432154407d8852e417b052',
        chainId: 43114,
        type: 'ETF',
        symbol: 'AVAXETF',
        decimals: 18,
        totalSupply: '4873542625341435878',
        profitToken: '0xb3dbd4d49b88786ba0432154407d8852e417b052',
        priceInUsd: 40.27622419583212,
        underlying: '0xce275d4eabfe5dc86d1290d52fb4bc35dd49544b',
      },
      '0xc99ed38eee442fbfbe1c8c84fee10191ff6bc149': {
        address: '0xc99ed38eee442fbfbe1c8c84fee10191ff6bc149',
        chainId: 43114,
        type: 'ETF',
        symbol: 'ETHMAXIETF',
        decimals: 18,
        totalSupply: '159493539972529781',
        profitToken: '0xc99ed38eee442fbfbe1c8c84fee10191ff6bc149',
        priceInUsd: 68.91452230565092,
        underlying: '0x5022131e48e717dffa2f0a376930ba5956d06244',
      },
    },
  },
  farm: {
    '10': {
      '0x41cc89b91d0abe260f2cb53c1abda07b321e71df': {
        address: '0x41cc89b91d0abe260f2cb53c1abda07b321e71df',
        chainId: 10,
        type: 'LP',
        symbol: 'CHI/DAI',
        decimals: 18,
        totalSupply: '1206633512907470865203019',
        token0: '0xca0e54b636db823847b29f506bffee743f57729d',
        token1: '0xda10009cbd5d07dd0cecc66161fc93d7c9000da1',
        priceInUsd: 0.30489568529308675,
      },
      '0xadbb23bcc3c1b9810491897cb0690cf645b858b1': {
        address: '0xadbb23bcc3c1b9810491897cb0690cf645b858b1',
        chainId: 10,
        type: 'LP',
        symbol: 'WETH/TBTC',
        decimals: 18,
        totalSupply: '673382101515782675',
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0x6c84a8f1c29108f47a79964b5fe888d4f4d0de40',
        priceInUsd: 40097.925222597456,
      },
      '0xfa09479d72e2b3f8b6df63399772237ad6658d76': {
        address: '0xfa09479d72e2b3f8b6df63399772237ad6658d76',
        chainId: 10,
        type: 'LP',
        symbol: 'ALUSD/MAI',
        decimals: 18,
        totalSupply: '5355696791422161839301',
        token0: '0xcb8fa9a76b8e203d8c3797bf438d8fb81ea3326a',
        token1: '0xdfa46478f9e5ea86d57387849598dbfb2e964b02',
        priceInUsd: 0.980500984462654,
      },
      '0x1ad06ca54de04dbe9e2817f4c13ecb406dcbeaf0': {
        address: '0x1ad06ca54de04dbe9e2817f4c13ecb406dcbeaf0',
        chainId: 10,
        type: 'LP',
        symbol: 'ALETH/FRXETH',
        decimals: 18,
        totalSupply: '23235196567805567625',
        token0: '0x3e29d3a9316dab217754d13b28646b76607c5f04',
        token1: '0x6806411765af15bddd26f8f544a34cc40cb9838b',
        priceInUsd: 8212.891659184954,
      },
      '0x04f6c85a1b00f6d9b75f91fd23835974cc07e65c': {
        address: '0x04f6c85a1b00f6d9b75f91fd23835974cc07e65c',
        chainId: 10,
        type: 'ERC721-NATIVE',
        symbol: 'WSTETH/WETH',
        decimals: 18,
        token0: '0x1f32b1c2345538c0c6f582fcb022739c4a194ebb',
        token1: '0x4200000000000000000000000000000000000006',
      },
      '0xf2d3941b6e1cbd3616061e556eb06986147715d1': {
        address: '0xf2d3941b6e1cbd3616061e556eb06986147715d1',
        chainId: 10,
        type: 'LP',
        symbol: 'HAI/KITE',
        decimals: 18,
        totalSupply: '29803172730211513091640',
        token0: '0x10398abc267496e49106b07dd6be13364d10dc71',
        token1: '0xf467c7d5a4a9c4687ffc7986ac6ad5a4c81e1404',
        priceInUsd: 2.3892513541253164,
      },
      '0x88391365c225973032275db256b9d15f845d2c72': {
        address: '0x88391365c225973032275db256b9d15f845d2c72',
        chainId: 10,
        type: 'LP',
        symbol: 'WETH/OPENX',
        decimals: 18,
        totalSupply: '8897289859232502556555',
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0xc3864f98f2a61a7caeb95b039d031b4e2f55e0e9',
        priceInUsd: 27.000126516939943,
      },
      '0x1d72b49f81832ef8155d8dedfce9cd122367e3b3': {
        address: '0x1d72b49f81832ef8155d8dedfce9cd122367e3b3',
        chainId: 10,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'WETH/DAI',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0xda10009cbd5d07dd0cecc66161fc93d7c9000da1',
      },
      '0x6e6046e9b5e3d90eac2abba610bca725834ca5b3': {
        address: '0x6e6046e9b5e3d90eac2abba610bca725834ca5b3',
        chainId: 10,
        type: 'LP',
        symbol: 'UNLOCK/VELO',
        decimals: 18,
        totalSupply: '43355902252542148941421',
        token0: '0x7ae97042a4a0eb4d1eb370c34bfec71042a056b7',
        token1: '0x9560e827af36c94d2ac33a39bce1fe78631088db',
        priceInUsd: 0.006238034508347404,
      },
      '0x0df083de449f75691fc5a36477a6f3284c269108': {
        address: '0x0df083de449f75691fc5a36477a6f3284c269108',
        chainId: 10,
        type: 'LP',
        symbol: 'OP/USDC',
        decimals: 18,
        totalSupply: '63068740183097664',
        token0: '0x4200000000000000000000000000000000000042',
        token1: '0x7f5c764cbc14f9669b88837ca1490cca17c31607',
        priceInUsd: 1675428.3921524393,
      },
      '0x69a9b0f791507c50b413d24abb761acb5ac52728': {
        address: '0x69a9b0f791507c50b413d24abb761acb5ac52728',
        chainId: 10,
        type: 'LP',
        symbol: 'RING/WETH',
        decimals: 18,
        totalSupply: '32998334663128026560998',
        token0: '0x259c1c2ed264402b5ed2f02bc7dc25a15c680c18',
        token1: '0x4200000000000000000000000000000000000006',
        priceInUsd: 12.46452741348636,
      },
      '0x6387765ffa609ab9a1da1b16c455548bfed7cbea': {
        address: '0x6387765ffa609ab9a1da1b16c455548bfed7cbea',
        chainId: 10,
        type: 'LP',
        symbol: 'WETH/LUSD',
        decimals: 18,
        totalSupply: '165927293992129063116',
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0xc40f949f8a4e094d1b49a23ea9241d289b7b2819',
        priceInUsd: 134.9006265821969,
      },
      '0x95a05d06decf8e1eb93ae09b612fbd342f2f9e2e': {
        address: '0x95a05d06decf8e1eb93ae09b612fbd342f2f9e2e',
        chainId: 10,
        type: 'LP',
        symbol: 'USDC/WUSDR',
        decimals: 18,
        totalSupply: '34332220662',
        token0: '0x7f5c764cbc14f9669b88837ca1490cca17c31607',
        token1: '0xc03b43d492d904406db2d7d57e67c7e8234ba752',
        priceInUsd: 21954680735.34728,
      },
      '0x2ae3d6096d8215ac2acddf30c60caa984ea5debe': {
        address: '0x2ae3d6096d8215ac2acddf30c60caa984ea5debe',
        chainId: 10,
        type: 'ERC721-NATIVE',
        symbol: 'WETH/WLD',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0xdc6ff44d5d932cbd77b52e5612ba0529dc6226f1',
      },
      '0xe8b8bff1e415258eb3d5fa8deee9c38406e609cd': {
        address: '0xe8b8bff1e415258eb3d5fa8deee9c38406e609cd',
        chainId: 10,
        type: 'LP',
        symbol: 'USDT/LUSD',
        decimals: 18,
        totalSupply: '3081652515687111',
        token0: '0x94b008aa00579c1307b0ef2c499ad98a8ce58e58',
        token1: '0xc40f949f8a4e094d1b49a23ea9241d289b7b2819',
        priceInUsd: 2008967.4549484665,
      },
      '0xfd5f39c74e63f1dace336350afdf11e85bbd56f4': {
        address: '0xfd5f39c74e63f1dace336350afdf11e85bbd56f4',
        chainId: 10,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'USDC/USD+',
        decimals: 18,
        token0: '0x0b2c639c533813f4aa9d7837caf62653d097ff85',
        token1: '0x73cb180bf0521828d8849bc8cf2b920918e23032',
      },
      '0x71d53b5b7141e1ec9a3fc9cc48b4766102d14a4a': {
        address: '0x71d53b5b7141e1ec9a3fc9cc48b4766102d14a4a',
        chainId: 10,
        type: 'LP',
        symbol: 'USDC/SNX',
        decimals: 18,
        totalSupply: '113975049690748537',
        token0: '0x7f5c764cbc14f9669b88837ca1490cca17c31607',
        token1: '0x8700daec35af8ff88c16bdf0418774cb3d7599b4',
        priceInUsd: 1697763.6915096086,
      },
      '0xe5cf854f63152067059afd38e03fefb6cbe25df3': {
        address: '0xe5cf854f63152067059afd38e03fefb6cbe25df3',
        chainId: 10,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'WSTETH/OP',
        decimals: 18,
        token0: '0x1f32b1c2345538c0c6f582fcb022739c4a194ebb',
        token1: '0x4200000000000000000000000000000000000042',
      },
      '0xd1f1bad4c9e6c44dec1e9bf3b94902205c5cd6c3': {
        address: '0xd1f1bad4c9e6c44dec1e9bf3b94902205c5cd6c3',
        chainId: 10,
        type: 'ERC721-NATIVE',
        symbol: 'USDC/WLD',
        decimals: 18,
        token0: '0x7f5c764cbc14f9669b88837ca1490cca17c31607',
        token1: '0xdc6ff44d5d932cbd77b52e5612ba0529dc6226f1',
      },
      '0x68f5c0a2de713a54991e01858fd27a3832401849': {
        address: '0x68f5c0a2de713a54991e01858fd27a3832401849',
        chainId: 10,
        type: 'ERC721-NATIVE',
        symbol: 'WETH/OP',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0x4200000000000000000000000000000000000042',
      },
      '0x7cfc2da3ba598ef4de692905fedca32565ab836e': {
        address: '0x7cfc2da3ba598ef4de692905fedca32565ab836e',
        chainId: 10,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'USDC/VELO',
        decimals: 18,
        token0: '0x0b2c639c533813f4aa9d7837caf62653d097ff85',
        token1: '0x9560e827af36c94d2ac33a39bce1fe78631088db',
      },
      '0xa1055762336f92b4b8d2edc032a0ce45ead6280a': {
        address: '0xa1055762336f92b4b8d2edc032a0ce45ead6280a',
        chainId: 10,
        type: 'LP',
        symbol: 'ALETH/WETH',
        decimals: 18,
        totalSupply: '747103562932356092720',
        token0: '0x3e29d3a9316dab217754d13b28646b76607c5f04',
        token1: '0x4200000000000000000000000000000000000006',
        priceInUsd: 8243.28891791741,
      },
      '0xa80ad5c1f8c21b34b427ea432530ae7ff36e3926': {
        address: '0xa80ad5c1f8c21b34b427ea432530ae7ff36e3926',
        chainId: 10,
        type: 'LP',
        symbol: 'VELO/OPXVELO',
        decimals: 18,
        totalSupply: '947309479182868649993292',
        token0: '0x9560e827af36c94d2ac33a39bce1fe78631088db',
        token1: '0xc38464250f51123078bbd7ea574e185f6623d037',
        priceInUsd: 0.0863100364850007,
      },
      '0x2fa71491f8070fa644d97b4782db5734854c0f6f': {
        address: '0x2fa71491f8070fa644d97b4782db5734854c0f6f',
        chainId: 10,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'USDC/USDC',
        decimals: 18,
        token0: '0x0b2c639c533813f4aa9d7837caf62653d097ff85',
        token1: '0x7f5c764cbc14f9669b88837ca1490cca17c31607',
      },
      '0x1f8b46abe1eabf5a60cbbb5fb2e4a6a46fa0b6e6': {
        address: '0x1f8b46abe1eabf5a60cbbb5fb2e4a6a46fa0b6e6',
        chainId: 10,
        type: 'LP',
        symbol: 'FRAX/DOLA',
        decimals: 18,
        totalSupply: '4642132905686369242743',
        token0: '0x2e3d870790dc77a83dd1d18184acc7439a53f475',
        token1: '0x8ae125e8653821e851f12a49f7765db9a9ce7384',
        priceInUsd: 0,
      },
      '0xe9581d0f1a628b038fc8b2a7f5a7d904f0e2f937': {
        address: '0xe9581d0f1a628b038fc8b2a7f5a7d904f0e2f937',
        chainId: 10,
        type: 'LP',
        symbol: 'OP/VELO',
        decimals: 18,
        totalSupply: '2743072300397483339208201',
        token0: '0x4200000000000000000000000000000000000042',
        token1: '0x9560e827af36c94d2ac33a39bce1fe78631088db',
        priceInUsd: 0.3615225726733019,
      },
      '0x4e60495550071693bc8bdffc40033d278157eac7': {
        address: '0x4e60495550071693bc8bdffc40033d278157eac7',
        chainId: 10,
        type: 'LP',
        symbol: 'SONNE/USDC',
        decimals: 18,
        totalSupply: '184783349984802463',
        token0: '0x1db2466d9f5e10d7090e7152b68d62703a2245f0',
        token1: '0x7f5c764cbc14f9669b88837ca1490cca17c31607',
        priceInUsd: 44161.648240831164,
      },
      '0xebd5311bea1948e1441333976eadcfe5fbda777c': {
        address: '0xebd5311bea1948e1441333976eadcfe5fbda777c',
        chainId: 10,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'USDC/OP',
        decimals: 18,
        token0: '0x0b2c639c533813f4aa9d7837caf62653d097ff85',
        token1: '0x4200000000000000000000000000000000000042',
      },
      '0x439c8a3704bdf52fec25bc271d67baa2bd204104': {
        address: '0x439c8a3704bdf52fec25bc271d67baa2bd204104',
        chainId: 10,
        type: 'LP',
        symbol: 'EXTRA/VELO',
        decimals: 18,
        totalSupply: '36938561099666140619420',
        token0: '0x2dad3a13ef0c6366220f989157009e501e7938f8',
        token1: '0x9560e827af36c94d2ac33a39bce1fe78631088db',
        priceInUsd: 0.05817595831604884,
      },
      '0x6da98bde0068d10ddd11b468b197ea97d96f96bc': {
        address: '0x6da98bde0068d10ddd11b468b197ea97d96f96bc',
        chainId: 10,
        type: 'LP',
        symbol: 'WSTETH/WETH',
        decimals: 18,
        totalSupply: '34376900612732410762',
        token0: '0x1f32b1c2345538c0c6f582fcb022739c4a194ebb',
        token1: '0x4200000000000000000000000000000000000006',
        priceInUsd: 9202.353336226699,
      },
      '0x503320622687b218d4eb488c25295676934497b0': {
        address: '0x503320622687b218d4eb488c25295676934497b0',
        chainId: 10,
        type: 'LP',
        symbol: 'WSTETH/ETH1S',
        decimals: 18,
        totalSupply: '9487893472665955',
        token0: '0x1f32b1c2345538c0c6f582fcb022739c4a194ebb',
        token1: '0xf0dc8c9b7e43e8eef39f0f0ca1c464ab714d7783',
        priceInUsd: 150.7665333517873,
      },
      '0xd5fe49a4c0fc482ee757df703a3a332db209ac2e': {
        address: '0xd5fe49a4c0fc482ee757df703a3a332db209ac2e',
        chainId: 10,
        type: 'LP',
        symbol: 'HAI/PXETH',
        decimals: 18,
        totalSupply: '770926834206892248',
        token0: '0x10398abc267496e49106b07dd6be13364d10dc71',
        token1: '0x300d2c875c6fb8ce4bf5480b4d34b7c9ea8a33a4',
        priceInUsd: 139.77469638409087,
      },
      '0x4e5541815227e3272c405886149f45d2f437c7ff': {
        address: '0x4e5541815227e3272c405886149f45d2f437c7ff',
        chainId: 10,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'USDC/WLD',
        decimals: 18,
        token0: '0x0b2c639c533813f4aa9d7837caf62653d097ff85',
        token1: '0xdc6ff44d5d932cbd77b52e5612ba0529dc6226f1',
      },
      '0x844d7d2fca6786be7de6721aabdff6957ace73a0': {
        address: '0x844d7d2fca6786be7de6721aabdff6957ace73a0',
        chainId: 10,
        type: 'LP',
        symbol: 'OVN/USD+',
        decimals: 18,
        totalSupply: '250449967827224',
        token0: '0x3b08fcd15280e7b5a6e404c4abb87f7c774d1b2e',
        token1: '0x73cb180bf0521828d8849bc8cf2b920918e23032',
        priceInUsd: 1389000.3354865245,
      },
      '0xa925ef1ef90e2932fd4cb0554d1f34cf2ee00d96': {
        address: '0xa925ef1ef90e2932fd4cb0554d1f34cf2ee00d96',
        chainId: 10,
        type: 'LP',
        symbol: 'TKN/VELO',
        decimals: 18,
        totalSupply: '156519203490107036559126',
        token0: '0x3eb398fec5f7327c6b15099a9681d9568ded2e82',
        token1: '0x9560e827af36c94d2ac33a39bce1fe78631088db',
        priceInUsd: 0.04132351096690691,
      },
      '0xe54e4020d1c3afdb312095d90054103e68fe34b0': {
        address: '0xe54e4020d1c3afdb312095d90054103e68fe34b0',
        chainId: 10,
        type: 'LP',
        symbol: 'USDC/MAI',
        decimals: 18,
        totalSupply: '44591649688204853',
        token0: '0x7f5c764cbc14f9669b88837ca1490cca17c31607',
        token1: '0xdfa46478f9e5ea86d57387849598dbfb2e964b02',
        priceInUsd: 982957.0158401738,
      },
      '0x58e6433a6903886e440ddf519ecc573c4046a6b2': {
        address: '0x58e6433a6903886e440ddf519ecc573c4046a6b2',
        chainId: 10,
        type: 'LP',
        symbol: 'WETH/VELO',
        decimals: 18,
        totalSupply: '15264403576612630146914',
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0x9560e827af36c94d2ac33a39bce1fe78631088db',
        priceInUsd: 27.896592411438146,
      },
      '0x3f42dc59dc4df5cd607163bc620168f7ff7ab970': {
        address: '0x3f42dc59dc4df5cd607163bc620168f7ff7ab970',
        chainId: 10,
        type: 'LP',
        symbol: 'WETH/FRXETH',
        decimals: 18,
        totalSupply: '13756324265313704704',
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0x6806411765af15bddd26f8f544a34cc40cb9838b',
        priceInUsd: 8314.39611422427,
      },
      '0xa8a5356ee5d02fe33d72355e4f698782f8f199e8': {
        address: '0xa8a5356ee5d02fe33d72355e4f698782f8f199e8',
        chainId: 10,
        type: 'ERC721-NATIVE',
        symbol: 'USDC/AXLUSDC',
        decimals: 18,
        token0: '0x7f5c764cbc14f9669b88837ca1490cca17c31607',
        token1: '0xeb466342c4d449bc9f53a865d5cb90586f405215',
      },
      '0x4ed90ca704f4f6f3955169f202ea35365e41b424': {
        address: '0x4ed90ca704f4f6f3955169f202ea35365e41b424',
        chainId: 10,
        type: 'LP',
        symbol: 'USDC/PERP',
        decimals: 18,
        totalSupply: '23496507838283',
        token0: '0x7f5c764cbc14f9669b88837ca1490cca17c31607',
        token1: '0x9e1028f5f1d5ede59748ffcee5532509976840e0',
        priceInUsd: 40168921.26568258,
      },
      '0x2b47c794c3789f499d8a54ec12f949eecce8ba16': {
        address: '0x2b47c794c3789f499d8a54ec12f949eecce8ba16',
        chainId: 10,
        type: 'LP',
        symbol: 'USDC/USDT',
        decimals: 18,
        totalSupply: '8496705166',
        token0: '0x7f5c764cbc14f9669b88837ca1490cca17c31607',
        token1: '0x94b008aa00579c1307b0ef2c499ad98a8ce58e58',
        priceInUsd: 2061678625849.8652,
      },
      '0x3eb92113c00f476512bde4c46920ef0a3d42eb0f': {
        address: '0x3eb92113c00f476512bde4c46920ef0a3d42eb0f',
        chainId: 10,
        type: 'LP',
        symbol: 'MODE/WETH',
        decimals: 18,
        totalSupply: '437602440940054414504',
        token0: '0x084382d1cc4f4dfd1769b1cc1ac2a9b1f8365e90',
        token1: '0x4200000000000000000000000000000000000006',
        priceInUsd: 4.937594411198717,
      },
      '0x173cdc71e29d5cffa6d090ad99f555a24b8831f9': {
        address: '0x173cdc71e29d5cffa6d090ad99f555a24b8831f9',
        chainId: 10,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'USDC/MOOBIFI',
        decimals: 18,
        token0: '0x0b2c639c533813f4aa9d7837caf62653d097ff85',
        token1: '0xc55e93c62874d8100dbd2dfe307edc1036ad5434',
      },
      '0x8542dd4744edea38b8a9306268b08f4d26d38581': {
        address: '0x8542dd4744edea38b8a9306268b08f4d26d38581',
        chainId: 10,
        type: 'LP',
        symbol: 'FRAX/USDC',
        decimals: 18,
        totalSupply: '1907541525182903',
        token0: '0x2e3d870790dc77a83dd1d18184acc7439a53f475',
        token1: '0x7f5c764cbc14f9669b88837ca1490cca17c31607',
        priceInUsd: 0,
      },
      '0x0e88a5bff34d39da66bdd32b82dc89a32d7bb6c9': {
        address: '0x0e88a5bff34d39da66bdd32b82dc89a32d7bb6c9',
        chainId: 10,
        type: 'LP',
        symbol: 'WETH/HOP',
        decimals: 18,
        totalSupply: '11634203498568693960879',
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0xc5102fe9359fd9a28f877a67e36b0f050d81a3cc',
        priceInUsd: 11.108495197310898,
      },
      '0x477fa18b063b7728409570d274f7a055e3da0d6e': {
        address: '0x477fa18b063b7728409570d274f7a055e3da0d6e',
        chainId: 10,
        type: 'LP',
        symbol: 'EXTRA/USDC',
        decimals: 18,
        totalSupply: '19934032787353597',
        token0: '0x2dad3a13ef0c6366220f989157009e501e7938f8',
        token1: '0x7f5c764cbc14f9669b88837ca1490cca17c31607',
        priceInUsd: 270519.2900570702,
      },
      '0xdb61f9b480f0a8b817811cfaa89a1c219c355224': {
        address: '0xdb61f9b480f0a8b817811cfaa89a1c219c355224',
        chainId: 10,
        type: 'LP',
        symbol: 'LYRA/USDC',
        decimals: 18,
        totalSupply: '26214287235077270',
        token0: '0x50c5725949a6f0c72e6c4a641f24049a917db0cb',
        token1: '0x7f5c764cbc14f9669b88837ca1490cca17c31607',
        priceInUsd: 39278.75121433352,
      },
      '0x4e316557f63c2156eafdfec08f31df4957136203': {
        address: '0x4e316557f63c2156eafdfec08f31df4957136203',
        chainId: 10,
        type: 'LP',
        symbol: 'RED/OP',
        decimals: 18,
        totalSupply: '158406603373318830942526',
        token0: '0x3417e54a51924c225330f8770514ad5560b9098d',
        token1: '0x4200000000000000000000000000000000000042',
        priceInUsd: 0.48211950036116846,
      },
      '0x8ac2f9dac7a2852d44f3c09634444d533e4c078e': {
        address: '0x8ac2f9dac7a2852d44f3c09634444d533e4c078e',
        chainId: 10,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'USDC/LUSD',
        decimals: 18,
        token0: '0x0b2c639c533813f4aa9d7837caf62653d097ff85',
        token1: '0xc40f949f8a4e094d1b49a23ea9241d289b7b2819',
      },
      '0x9269f5199b01b7b7dd38321b85c3f34ee3f28f7f': {
        address: '0x9269f5199b01b7b7dd38321b85c3f34ee3f28f7f',
        chainId: 10,
        type: 'LP',
        symbol: 'UNIDX/WETH',
        decimals: 18,
        totalSupply: '400823965494514903',
        token0: '0x28b42698caf46b4b012cf38b6c75867e0762186d',
        token1: '0x4200000000000000000000000000000000000006',
        priceInUsd: 41.83054411869832,
      },
      '0x7a7f1187c4710010db17d0a9ad3fce85e6ecd90a': {
        address: '0x7a7f1187c4710010db17d0a9ad3fce85e6ecd90a',
        chainId: 10,
        type: 'LP',
        symbol: 'RED/VELO',
        decimals: 18,
        totalSupply: '1027995346923177849328943',
        token0: '0x3417e54a51924c225330f8770514ad5560b9098d',
        token1: '0x9560e827af36c94d2ac33a39bce1fe78631088db',
        priceInUsd: 0.12410794630821279,
      },
      '0x6da87897bb36d0e2bc4e69c407935bcc7fa9d9c9': {
        address: '0x6da87897bb36d0e2bc4e69c407935bcc7fa9d9c9',
        chainId: 10,
        type: 'LP',
        symbol: 'WETH/DHT',
        decimals: 18,
        totalSupply: '151398362670786249',
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0xaf9fe3b5ccdae78188b1f8b9a49da7ae9510f151',
        priceInUsd: 3405923.4390980955,
      },
      '0xf3c45b45223df6071a478851b9c17e0630fdf535': {
        address: '0xf3c45b45223df6071a478851b9c17e0630fdf535',
        chainId: 10,
        type: 'LP',
        symbol: 'EXA/WETH',
        decimals: 18,
        totalSupply: '3016489457604571096232',
        token0: '0x1e925de1c68ef83bd98ee3e130ef14a50309c01b',
        token1: '0x4200000000000000000000000000000000000006',
        priceInUsd: 82.13829485295804,
      },
      '0xee1bac98527a9fdd57fccf967817215b083ce1f0': {
        address: '0xee1bac98527a9fdd57fccf967817215b083ce1f0',
        chainId: 10,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'USDC/WSTETH',
        decimals: 18,
        token0: '0x0b2c639c533813f4aa9d7837caf62653d097ff85',
        token1: '0x1f32b1c2345538c0c6f582fcb022739c4a194ebb',
      },
      '0x3dd9556a521d6e57be480c94da102fedf0429aba': {
        address: '0x3dd9556a521d6e57be480c94da102fedf0429aba',
        chainId: 10,
        type: 'LP',
        symbol: 'JEUR/EURA',
        decimals: 18,
        totalSupply: '21322045294368099661811',
        token0: '0x79af5dd14e855823fa3e9ecacdf001d99647d043',
        token1: '0x9485aca5bbbe1667ad97c7fe7c4531a624c8b1ed',
        priceInUsd: 2.354985425797215,
      },
      '0x917aa69d539d6518440dd0bea2eaac142a8d5610': {
        address: '0x917aa69d539d6518440dd0bea2eaac142a8d5610',
        chainId: 10,
        type: 'LP',
        symbol: 'MSETH/WETH',
        decimals: 18,
        totalSupply: '186020354798812596202',
        token0: '0x1610e3c85dd44af31ed7f33a63642012dca0c5a5',
        token1: '0x4200000000000000000000000000000000000006',
        priceInUsd: 8339.882962373142,
      },
      '0xe9b168fa9409eaffa07679196c7568317baf80ed': {
        address: '0xe9b168fa9409eaffa07679196c7568317baf80ed',
        chainId: 10,
        type: 'LP',
        symbol: 'FRAX/OP',
        decimals: 18,
        totalSupply: '1310795257977707653515',
        token0: '0x2e3d870790dc77a83dd1d18184acc7439a53f475',
        token1: '0x4200000000000000000000000000000000000042',
        priceInUsd: 0,
      },
      '0xf25bbc18a607bbe218c87ba1ff0e673d9b53dd58': {
        address: '0xf25bbc18a607bbe218c87ba1ff0e673d9b53dd58',
        chainId: 10,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'USDC/SNX',
        decimals: 18,
        token0: '0x0b2c639c533813f4aa9d7837caf62653d097ff85',
        token1: '0x8700daec35af8ff88c16bdf0418774cb3d7599b4',
      },
      '0xa8e4fa96327c5a93e159bd781f3ccfd860519d82': {
        address: '0xa8e4fa96327c5a93e159bd781f3ccfd860519d82',
        chainId: 10,
        type: 'LP',
        symbol: 'WETH/MET',
        decimals: 18,
        totalSupply: '4335637893676655665503',
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0x9a2e53158e12bc09270af10c16a466cb2b5d7836',
        priceInUsd: 95.220078357015,
      },
      '0xc37a0a37664aeb3848f98c5dd5d7ae286a1e9ebd': {
        address: '0xc37a0a37664aeb3848f98c5dd5d7ae286a1e9ebd',
        chainId: 10,
        type: 'LP',
        symbol: 'FRAX/MAI',
        decimals: 18,
        totalSupply: '1757452768491171667612',
        token0: '0x2e3d870790dc77a83dd1d18184acc7439a53f475',
        token1: '0xdfa46478f9e5ea86d57387849598dbfb2e964b02',
        priceInUsd: 0,
      },
      '0xf6ffb55bfb4f149b725211e7ef1cc9f3a67c5b01': {
        address: '0xf6ffb55bfb4f149b725211e7ef1cc9f3a67c5b01',
        chainId: 10,
        type: 'LP',
        symbol: 'MSOP/OP',
        decimals: 18,
        totalSupply: '44093142490127345446879',
        token0: '0x33bca143d9b41322479e8d26072a00a352404721',
        token1: '0x4200000000000000000000000000000000000042',
        priceInUsd: 1.4013004812937047,
      },
      '0x8f47041adbef5bf321c9f63a0660326614ab6b60': {
        address: '0x8f47041adbef5bf321c9f63a0660326614ab6b60',
        chainId: 10,
        type: 'LP',
        symbol: 'WETH/KWENTA',
        decimals: 18,
        totalSupply: '31879165923701577114',
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0x920cf626a271321c151d027030d5d08af699456b',
        priceInUsd: 438.0459044920536,
      },
      '0x84ce89b4f6f67e523a81a82f9f2f14d84b726f6b': {
        address: '0x84ce89b4f6f67e523a81a82f9f2f14d84b726f6b',
        chainId: 10,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'USDC/USDT',
        decimals: 18,
        token0: '0x0b2c639c533813f4aa9d7837caf62653d097ff85',
        token1: '0x94b008aa00579c1307b0ef2c499ad98a8ce58e58',
      },
      '0xd4bee5632960572c83f66f5a5a32b8d8d49355ae': {
        address: '0xd4bee5632960572c83f66f5a5a32b8d8d49355ae',
        chainId: 10,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'WBTC/UNIBTC',
        decimals: 18,
        token0: '0x68f180fcce6836688e9084f035309e29bf0a2095',
        token1: '0x93919784c523f39cacaa98ee0a9d96c3f32b593e',
      },
      '0xbf75051f6e6df9fecf90d9bebbbb08a85950858c': {
        address: '0xbf75051f6e6df9fecf90d9bebbbb08a85950858c',
        chainId: 10,
        type: 'LP',
        symbol: 'FRAX/DUSD',
        decimals: 18,
        totalSupply: '2654893487443755078',
        token0: '0x2e3d870790dc77a83dd1d18184acc7439a53f475',
        token1: '0xb396b31599333739a97951b74652c117be86ee1d',
        priceInUsd: 0,
      },
      '0xdb1fe6da83698885104da02a6e0b3b65c0b0de80': {
        address: '0xdb1fe6da83698885104da02a6e0b3b65c0b0de80',
        chainId: 10,
        type: 'LP',
        symbol: 'POOL/WETH',
        decimals: 18,
        totalSupply: '2678467501185702275549',
        token0: '0x395ae52bb17aef68c2888d941736a71dc6d4e125',
        token1: '0x4200000000000000000000000000000000000006',
        priceInUsd: 62.13362826742578,
      },
      '0xf117719d5460ed6090814213433cb8d4e07bd583': {
        address: '0xf117719d5460ed6090814213433cb8d4e07bd583',
        chainId: 10,
        type: 'LP',
        symbol: 'USDC/EXTRA',
        decimals: 18,
        totalSupply: '268368054040784195',
        token0: '0x0b2c639c533813f4aa9d7837caf62653d097ff85',
        token1: '0x2dad3a13ef0c6366220f989157009e501e7938f8',
        priceInUsd: 273259.7264926288,
      },
      '0x25c488e5f69ac334ac1e8f786d890a97ec1bf713': {
        address: '0x25c488e5f69ac334ac1e8f786d890a97ec1bf713',
        chainId: 10,
        type: 'LP',
        symbol: 'DF/USX',
        decimals: 18,
        totalSupply: '427448382002646618878390',
        token0: '0x9e5aac1ba1a2e6aed6b32689dfcf62a509ca96f3',
        token1: '0xbfd291da8a403daaf7e5e9dc1ec0aceacd4848b9',
        priceInUsd: 0.3204774011530244,
      },
      '0x6ed6df1c23c51cb7cc67a348cc8d9e6108ea3bfe': {
        address: '0x6ed6df1c23c51cb7cc67a348cc8d9e6108ea3bfe',
        chainId: 10,
        type: 'LP',
        symbol: 'WETH/MOOBIFI',
        decimals: 18,
        totalSupply: '324443160243569344203',
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0xc55e93c62874d8100dbd2dfe307edc1036ad5434',
        priceInUsd: 1874.3369399921505,
      },
      '0xadb35413ec50e0afe41039eac8b930d313e94fa4': {
        address: '0xadb35413ec50e0afe41039eac8b930d313e94fa4',
        chainId: 10,
        type: 'ERC721-NATIVE',
        symbol: 'SUSD/DAI',
        decimals: 18,
        token0: '0x8c6f28f2f1a3c87f0f938b96d27520d9751ec8d9',
        token1: '0xda10009cbd5d07dd0cecc66161fc93d7c9000da1',
      },
      '0xed47e3ce6d9c05f562c469ab1bf1244cc697aa73': {
        address: '0xed47e3ce6d9c05f562c469ab1bf1244cc697aa73',
        chainId: 10,
        type: 'LP',
        symbol: 'USDC/USX',
        decimals: 18,
        totalSupply: '88960900511557',
        token0: '0x7f5c764cbc14f9669b88837ca1490cca17c31607',
        token1: '0xbfd291da8a403daaf7e5e9dc1ec0aceacd4848b9',
        priceInUsd: 1966714.902944776,
      },
      '0x1737275d53a5ca5dac582a493aa32c85ba2cfad3': {
        address: '0x1737275d53a5ca5dac582a493aa32c85ba2cfad3',
        chainId: 10,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'USDC/DAI',
        decimals: 18,
        token0: '0x0b2c639c533813f4aa9d7837caf62653d097ff85',
        token1: '0xda10009cbd5d07dd0cecc66161fc93d7c9000da1',
      },
      '0x62191c893df8d26ac295ba1274a00975dc07190c': {
        address: '0x62191c893df8d26ac295ba1274a00975dc07190c',
        chainId: 10,
        type: 'LP',
        symbol: 'WETH/OPP',
        decimals: 18,
        totalSupply: '31228683545597599346537',
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0x676f784d19c7f1ac6c6beaeaac78b02a73427852',
        priceInUsd: 2.656655496431351,
      },
      '0x3a545744f5d0e9425e34741afd9e388d5d0e6dfb': {
        address: '0x3a545744f5d0e9425e34741afd9e388d5d0e6dfb',
        chainId: 10,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'USDC/MAI',
        decimals: 18,
        token0: '0x0b2c639c533813f4aa9d7837caf62653d097ff85',
        token1: '0xdfa46478f9e5ea86d57387849598dbfb2e964b02',
      },
      '0xcecc5dacc7b09d35e19b1c5c47a65bc822a9c559': {
        address: '0xcecc5dacc7b09d35e19b1c5c47a65bc822a9c559',
        chainId: 10,
        type: 'LP',
        symbol: 'KUJI/RETH',
        decimals: 18,
        totalSupply: '1920261803176',
        token0: '0x3a18dcc9745edcd1ef33ecb93b0b6eba5671e7ca',
        token1: '0x9bcef72be871e61ed4fbbc7630889bee758eb81d',
        priceInUsd: 60745781.663159646,
      },
      '0xdff90e4a6c229565f25337b1db9fa12f6d8cb118': {
        address: '0xdff90e4a6c229565f25337b1db9fa12f6d8cb118',
        chainId: 10,
        type: 'LP',
        symbol: 'THALES/WETH',
        decimals: 18,
        totalSupply: '1822993411975409697319',
        token0: '0x217d47011b23bb961eb6d93ca9945b7501a5bb11',
        token1: '0x4200000000000000000000000000000000000006',
        priceInUsd: 65.73189586588899,
      },
      '0x478946bcd4a5a22b316470f5486fafb928c0ba25': {
        address: '0x478946bcd4a5a22b316470f5486fafb928c0ba25',
        chainId: 10,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'USDC/WETH',
        decimals: 18,
        token0: '0x0b2c639c533813f4aa9d7837caf62653d097ff85',
        token1: '0x4200000000000000000000000000000000000006',
      },
      '0xb720fbc32d60bb6dcc955be86b98d8fd3c4ba645': {
        address: '0xb720fbc32d60bb6dcc955be86b98d8fd3c4ba645',
        chainId: 10,
        type: 'LP',
        symbol: 'USDC/DOLA',
        decimals: 18,
        totalSupply: '3122649324676035',
        token0: '0x7f5c764cbc14f9669b88837ca1490cca17c31607',
        token1: '0x8ae125e8653821e851f12a49f7765db9a9ce7384',
        priceInUsd: 1980921.5527636353,
      },
      '0xf04458f7b21265b80fc340de7ee598e24485c5bb': {
        address: '0xf04458f7b21265b80fc340de7ee598e24485c5bb',
        chainId: 10,
        type: 'LP',
        symbol: 'USDC/LUSD',
        decimals: 18,
        totalSupply: '839861821479189',
        token0: '0x7f5c764cbc14f9669b88837ca1490cca17c31607',
        token1: '0xc40f949f8a4e094d1b49a23ea9241d289b7b2819',
        priceInUsd: 2004156.8413198334,
      },
      '0xff5318f81dd791e92d51b8a54fa3538832d2890d': {
        address: '0xff5318f81dd791e92d51b8a54fa3538832d2890d',
        chainId: 10,
        type: 'LP',
        symbol: 'SFRXETH/FRXETH',
        decimals: 18,
        totalSupply: '9121958145091510697',
        token0: '0x484c2d6e3cdd945a8b2df735e079178c1036578c',
        token1: '0x6806411765af15bddd26f8f544a34cc40cb9838b',
        priceInUsd: 8681.3172174993,
      },
      '0xb71ac980569540ce38195b38369204ff555c80be': {
        address: '0xb71ac980569540ce38195b38369204ff555c80be',
        chainId: 10,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'WSTETH/EZETH',
        decimals: 18,
        token0: '0x1f32b1c2345538c0c6f582fcb022739c4a194ebb',
        token1: '0x2416092f143378750bb29b79ed961ab195cceea5',
      },
      '0xc5c247580a4a6e4d3811c0da6215057aac480bac': {
        address: '0xc5c247580a4a6e4d3811c0da6215057aac480bac',
        chainId: 10,
        type: 'LP',
        symbol: 'WSTETH/LDO',
        decimals: 18,
        totalSupply: '924599936006326143991',
        token0: '0x1f32b1c2345538c0c6f582fcb022739c4a194ebb',
        token1: '0xfdb794692724153d1488ccdbe0c56c252596735f',
        priceInUsd: 150.60725150550005,
      },
      '0xefe139aa71b674168f5823360a824b3714f2718d': {
        address: '0xefe139aa71b674168f5823360a824b3714f2718d',
        chainId: 10,
        type: 'LP',
        symbol: 'OP/EURA',
        decimals: 18,
        totalSupply: '1977484093650101576547',
        token0: '0x4200000000000000000000000000000000000042',
        token1: '0x9485aca5bbbe1667ad97c7fe7c4531a624c8b1ed',
        priceInUsd: 1.8148235238907522,
      },
      '0x0b28c2e41058edc7d66c516c617b664ea86eec5d': {
        address: '0x0b28c2e41058edc7d66c516c617b664ea86eec5d',
        chainId: 10,
        type: 'LP',
        symbol: 'USD+/DOLA',
        decimals: 18,
        totalSupply: '414362221350415',
        token0: '0x73cb180bf0521828d8849bc8cf2b920918e23032',
        token1: '0x8ae125e8653821e851f12a49f7765db9a9ce7384',
        priceInUsd: 1631025.5712267237,
      },
      '0xd25711edfbf747efce181442cc1d8f5f8fc8a0d3': {
        address: '0xd25711edfbf747efce181442cc1d8f5f8fc8a0d3',
        chainId: 10,
        type: 'LP',
        symbol: 'WETH/OP',
        decimals: 18,
        totalSupply: '10689739254997681868302',
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0x4200000000000000000000000000000000000042',
        priceInUsd: 108.32819770389841,
      },
      '0xa8c507ddf3ebedbf251f6f643a7d891532745467': {
        address: '0xa8c507ddf3ebedbf251f6f643a7d891532745467',
        chainId: 10,
        type: 'LP',
        symbol: 'USDC/DUSD',
        decimals: 18,
        totalSupply: '400176946348',
        token0: '0x7f5c764cbc14f9669b88837ca1490cca17c31607',
        token1: '0xb396b31599333739a97951b74652c117be86ee1d',
        priceInUsd: 0,
      },
      '0xfc1f3296458f9b2a27a0b91dd7681c4020e09d05': {
        address: '0xfc1f3296458f9b2a27a0b91dd7681c4020e09d05',
        chainId: 10,
        type: 'ERC721-NATIVE',
        symbol: 'WETH/OP',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0x4200000000000000000000000000000000000042',
      },
      '0x10df8a154c806f74c589466214b1c831c2315173': {
        address: '0x10df8a154c806f74c589466214b1c831c2315173',
        chainId: 10,
        type: 'LP',
        symbol: 'WETH/WOPTIDOGE',
        decimals: 18,
        totalSupply: '147401657691131617804697',
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0xc26921b5b9ee80773774d36c84328ccb22c3a819',
        priceInUsd: 0.062329471254496026,
      },
      '0x2fe304b407c7fab2a3c10962f14db751468a4f5b': {
        address: '0x2fe304b407c7fab2a3c10962f14db751468a4f5b',
        chainId: 10,
        type: 'LP',
        symbol: 'OP/FRXETH',
        decimals: 18,
        totalSupply: '213522534347197023583',
        token0: '0x4200000000000000000000000000000000000042',
        token1: '0x6806411765af15bddd26f8f544a34cc40cb9838b',
        priceInUsd: 107.8848729094177,
      },
      '0x0392b358ce4547601befa962680bede836606ae2': {
        address: '0x0392b358ce4547601befa962680bede836606ae2',
        chainId: 10,
        type: 'ERC721-NATIVE',
        symbol: 'WETH/SNX',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0x8700daec35af8ff88c16bdf0418774cb3d7599b4',
      },
      '0x4be2cbe40521279b8fc561e65bb842bf73ec3a80': {
        address: '0x4be2cbe40521279b8fc561e65bb842bf73ec3a80',
        chainId: 10,
        type: 'LP',
        symbol: 'USDC/EURA',
        decimals: 18,
        totalSupply: '52847067578855',
        token0: '0x7f5c764cbc14f9669b88837ca1490cca17c31607',
        token1: '0x9485aca5bbbe1667ad97c7fe7c4531a624c8b1ed',
        priceInUsd: 67134048.40235876,
      },
      '0x707ba27189e8bf89e43b2198e6b88aac4720124f': {
        address: '0x707ba27189e8bf89e43b2198e6b88aac4720124f',
        chainId: 10,
        type: 'LP',
        symbol: 'USDC/TAROT',
        decimals: 18,
        totalSupply: '1012624904871715948',
        token0: '0x0b2c639c533813f4aa9d7837caf62653d097ff85',
        token1: '0x1f514a61bcde34f94bc39731235690ab9da737f7',
        priceInUsd: 614982.461458037,
      },
      '0x3c01ec09d15d5450fc702dc4353b17cd2978d8a5': {
        address: '0x3c01ec09d15d5450fc702dc4353b17cd2978d8a5',
        chainId: 10,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'USDC/SUSD',
        decimals: 18,
        token0: '0x0b2c639c533813f4aa9d7837caf62653d097ff85',
        token1: '0x8c6f28f2f1a3c87f0f938b96d27520d9751ec8d9',
      },
      '0xe5f28fc43bb40cdf7202ebe406793815b6f07fbd': {
        address: '0xe5f28fc43bb40cdf7202ebe406793815b6f07fbd',
        chainId: 10,
        type: 'LP',
        symbol: 'THALES/USDC',
        decimals: 18,
        totalSupply: '476920798049291',
        token0: '0x217d47011b23bb961eb6d93ca9945b7501a5bb11',
        token1: '0x7f5c764cbc14f9669b88837ca1490cca17c31607',
        priceInUsd: 1011442.178883999,
      },
      '0x3ea594548afabfb27e314e766f06d2dff819bb56': {
        address: '0x3ea594548afabfb27e314e766f06d2dff819bb56',
        chainId: 10,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'TBTC/T',
        decimals: 18,
        token0: '0x6c84a8f1c29108f47a79964b5fe888d4f4d0de40',
        token1: '0x747e42eb0591547a0ab429b3627816208c734ea7',
      },
      '0xe0b1da86d17b884c4d246e218a67ae3466ad841c': {
        address: '0xe0b1da86d17b884c4d246e218a67ae3466ad841c',
        chainId: 10,
        type: 'LP',
        symbol: 'USDC/PERP',
        decimals: 18,
        totalSupply: '189937984275083533',
        token0: '0x0b2c639c533813f4aa9d7837caf62653d097ff85',
        token1: '0x9e1028f5f1d5ede59748ffcee5532509976840e0',
        priceInUsd: 1052297.7862025201,
      },
      '0x615b9dd61f1f9a80f5bcd33a53eb79c37b20addc': {
        address: '0x615b9dd61f1f9a80f5bcd33a53eb79c37b20addc',
        chainId: 10,
        type: 'LP',
        symbol: 'USDC/BLU',
        decimals: 18,
        totalSupply: '515047781506333010',
        token0: '0x7f5c764cbc14f9669b88837ca1490cca17c31607',
        token1: '0xa50b23cdfb2ec7c590e84f403256f67ce6dffb84',
        priceInUsd: 21926.554096173102,
      },
      '0xb545592e38b603f4a904a5260a6ffc538bfcb424': {
        address: '0xb545592e38b603f4a904a5260a6ffc538bfcb424',
        chainId: 10,
        type: 'LP',
        symbol: 'IB/WETH',
        decimals: 18,
        totalSupply: '901308072678953948505',
        token0: '0x00a35fd824c717879bf370e70ac6868b95870dfb',
        token1: '0x4200000000000000000000000000000000000006',
        priceInUsd: 88.98383804006995,
      },
      '0xa0a215de234276cac1b844fd58901351a50fec8a': {
        address: '0xa0a215de234276cac1b844fd58901351a50fec8a',
        chainId: 10,
        type: 'LP',
        symbol: 'USDC/VELO',
        decimals: 18,
        totalSupply: '4515695915678528737',
        token0: '0x0b2c639c533813f4aa9d7837caf62653d097ff85',
        token1: '0x9560e827af36c94d2ac33a39bce1fe78631088db',
        priceInUsd: 431397.854815043,
      },
      '0x7e1357fa56c0ecfe69daf22e08489ae8de56d86c': {
        address: '0x7e1357fa56c0ecfe69daf22e08489ae8de56d86c',
        chainId: 10,
        type: 'LP',
        symbol: 'OP/DHT',
        decimals: 18,
        totalSupply: '41534650652743810923258',
        token0: '0x4200000000000000000000000000000000000042',
        token1: '0xaf9fe3b5ccdae78188b1f8b9a49da7ae9510f151',
        priceInUsd: 0.6723903350074037,
      },
      '0x92fb369363498d8bfefc4eb705d8c91a51d22c45': {
        address: '0x92fb369363498d8bfefc4eb705d8c91a51d22c45',
        chainId: 10,
        type: 'LP',
        symbol: 'VELO/WOPTIDOGE',
        decimals: 18,
        totalSupply: '66290805116326428316429244',
        token0: '0x9560e827af36c94d2ac33a39bce1fe78631088db',
        token1: '0xc26921b5b9ee80773774d36c84328ccb22c3a819',
        priceInUsd: 0.00020905544020897893,
      },
      '0xaf03f51de7a0e62bf061f6fc3931cf79166b0a29': {
        address: '0xaf03f51de7a0e62bf061f6fc3931cf79166b0a29',
        chainId: 10,
        type: 'LP',
        symbol: 'FRAX/ALUSD',
        decimals: 18,
        totalSupply: '4282010163060047524096',
        token0: '0x2e3d870790dc77a83dd1d18184acc7439a53f475',
        token1: '0xcb8fa9a76b8e203d8c3797bf438d8fb81ea3326a',
        priceInUsd: 0,
      },
      '0x4ca2f3ceddb88c847d9204124a6edfa0172a7dee': {
        address: '0x4ca2f3ceddb88c847d9204124a6edfa0172a7dee',
        chainId: 10,
        type: 'LP',
        symbol: 'GNODE/VELO',
        decimals: 18,
        totalSupply: '136430366268541726437717',
        token0: '0x5976d4c3bcfc1c5f90ab1419d7f3ddf109cea35a',
        token1: '0x9560e827af36c94d2ac33a39bce1fe78631088db',
        priceInUsd: 0.004896995900195469,
      },
      '0x6e57b9e54ea043a829584b22182ad22bf446926c': {
        address: '0x6e57b9e54ea043a829584b22182ad22bf446926c',
        chainId: 10,
        type: 'LP',
        symbol: 'WBTC/TBTC',
        decimals: 18,
        totalSupply: '71713210179810',
        token0: '0x68f180fcce6836688e9084f035309e29bf0a2095',
        token1: '0x6c84a8f1c29108f47a79964b5fe888d4f4d0de40',
        priceInUsd: 22454232986.32613,
      },
      '0xec3d9098bd40ec741676fc04d4bd26bccf592aa3': {
        address: '0xec3d9098bd40ec741676fc04d4bd26bccf592aa3',
        chainId: 10,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'WETH/TBTC',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0x6c84a8f1c29108f47a79964b5fe888d4f4d0de40',
      },
      '0xf2d42c46528116362aca448837a0236459b53c63': {
        address: '0xf2d42c46528116362aca448837a0236459b53c63',
        chainId: 10,
        type: 'LP',
        symbol: 'TAROT/OP',
        decimals: 18,
        totalSupply: '377029522654748514004905',
        token0: '0x1f514a61bcde34f94bc39731235690ab9da737f7',
        token1: '0x4200000000000000000000000000000000000042',
        priceInUsd: 0.5158088393906632,
      },
      '0xf4638dc488f9c826dc40250515592e678e447238': {
        address: '0xf4638dc488f9c826dc40250515592e678e447238',
        chainId: 10,
        type: 'LP',
        symbol: 'OP/KITE',
        decimals: 18,
        totalSupply: '10308568431161047142860',
        token0: '0x4200000000000000000000000000000000000042',
        token1: '0xf467c7d5a4a9c4687ffc7986ac6ad5a4c81e1404',
        priceInUsd: 1.852526098553374,
      },
      '0x56770b94279539416855fe29ef14b26438b5e421': {
        address: '0x56770b94279539416855fe29ef14b26438b5e421',
        chainId: 10,
        type: 'LP',
        symbol: 'STG/USDC',
        decimals: 18,
        totalSupply: '18652080059372392',
        token0: '0x296f55f8fb28e498b858d0bcda06d955b2cb3f97',
        token1: '0x7f5c764cbc14f9669b88837ca1490cca17c31607',
        priceInUsd: 873767.9969332844,
      },
      '0x2e931de1fcb2681dc98601e0b513308da9c5ceae': {
        address: '0x2e931de1fcb2681dc98601e0b513308da9c5ceae',
        chainId: 10,
        type: 'LP',
        symbol: 'TAROT/USDC',
        decimals: 18,
        totalSupply: '2844837609424641',
        token0: '0x1f514a61bcde34f94bc39731235690ab9da737f7',
        token1: '0x7f5c764cbc14f9669b88837ca1490cca17c31607',
        priceInUsd: 608281.4670226756,
      },
      '0xd330841ef9527e3bd0abc28a230c7ca8dec9423b': {
        address: '0xd330841ef9527e3bd0abc28a230c7ca8dec9423b',
        chainId: 10,
        type: 'LP',
        symbol: 'FRAX/USD+',
        decimals: 18,
        totalSupply: '29683517823361',
        token0: '0x2e3d870790dc77a83dd1d18184acc7439a53f475',
        token1: '0x73cb180bf0521828d8849bc8cf2b920918e23032',
        priceInUsd: 0,
      },
      '0x319c0dd36284ac24a6b2bee73929f699b9f48c38': {
        address: '0x319c0dd36284ac24a6b2bee73929f699b9f48c38',
        chainId: 10,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'WETH/WBTC',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0x68f180fcce6836688e9084f035309e29bf0a2095',
      },
      '0x4d7959d17b9710be87e3657e69d946914221bb88': {
        address: '0x4d7959d17b9710be87e3657e69d946914221bb88',
        chainId: 10,
        type: 'LP',
        symbol: 'USDC/ALUSD',
        decimals: 18,
        totalSupply: '15492606311941438',
        token0: '0x7f5c764cbc14f9669b88837ca1490cca17c31607',
        token1: '0xcb8fa9a76b8e203d8c3797bf438d8fb81ea3326a',
        priceInUsd: 1991099.39664644,
      },
      '0x6ea20dbc05f58ed607c374e545bfb402d5796770': {
        address: '0x6ea20dbc05f58ed607c374e545bfb402d5796770',
        chainId: 10,
        type: 'LP',
        symbol: 'WETH/TLX',
        decimals: 18,
        totalSupply: '394180658358495485908',
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0xd9cc3d70e730503e7f28c1b407389198c4b75fa2',
        priceInUsd: 25.39966662886692,
      },
      '0x6d5ba400640226e24b50214d2bbb3d4db8e6e15a': {
        address: '0x6d5ba400640226e24b50214d2bbb3d4db8e6e15a',
        chainId: 10,
        type: 'LP',
        symbol: 'USDC/SUSD',
        decimals: 18,
        totalSupply: '7961786332770490',
        token0: '0x7f5c764cbc14f9669b88837ca1490cca17c31607',
        token1: '0x8c6f28f2f1a3c87f0f938b96d27520d9751ec8d9',
        priceInUsd: 1955873.2523035083,
      },
      '0x522dc96e6fd6f78a4e7433d0ee05b7087e515236': {
        address: '0x522dc96e6fd6f78a4e7433d0ee05b7087e515236',
        chainId: 10,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'WETH/KWENTA',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0x920cf626a271321c151d027030d5d08af699456b',
      },
      '0x2f318c7c3835df46146768e0c981fbad8b45483d': {
        address: '0x2f318c7c3835df46146768e0c981fbad8b45483d',
        chainId: 10,
        type: 'LP',
        symbol: 'GRAI/LUSD',
        decimals: 18,
        totalSupply: '112773510277072336862',
        token0: '0x894134a25a5fac1c2c26f1d8fbf05111a3cb9487',
        token1: '0xc40f949f8a4e094d1b49a23ea9241d289b7b2819',
        priceInUsd: 2.142229600652641,
      },
      '0x131525f3fa23d65dc2b1eb8b6483a28c43b06916': {
        address: '0x131525f3fa23d65dc2b1eb8b6483a28c43b06916',
        chainId: 10,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'USDC/SDAI',
        decimals: 18,
        token0: '0x0b2c639c533813f4aa9d7837caf62653d097ff85',
        token1: '0x2218a117083f5b482b0bb821d27056ba9c04b1d3',
      },
      '0xe148d6ae042de77c1f9fe0d6c495ebfd7b705b4c': {
        address: '0xe148d6ae042de77c1f9fe0d6c495ebfd7b705b4c',
        chainId: 10,
        type: 'LP',
        symbol: 'USDC/MSUSD',
        decimals: 18,
        totalSupply: '442051695915606320',
        token0: '0x7f5c764cbc14f9669b88837ca1490cca17c31607',
        token1: '0x9dabae7274d28a45f0b65bf8ed201a5731492ca0',
        priceInUsd: 1995729.533463958,
      },
      '0x667002f9dc61ebcba8ee1cbeb2ad04060388f223': {
        address: '0x667002f9dc61ebcba8ee1cbeb2ad04060388f223',
        chainId: 10,
        type: 'LP',
        symbol: 'USD+/DAI+',
        decimals: 18,
        totalSupply: '1613147241963580',
        token0: '0x73cb180bf0521828d8849bc8cf2b920918e23032',
        token1: '0x970d50d09f3a656b43e11b0d45241a84e3a6e011',
        priceInUsd: 1629833.5902737475,
      },
      '0x9560e827af36c94d2ac33a39bce1fe78631088db': {
        address: '0x9560e827af36c94d2ac33a39bce1fe78631088db',
        chainId: 10,
        type: 'ERC20',
        symbol: 'VELO',
        decimals: 18,
        totalSupply: '2215130979333906718250137553',
        priceInUsd: 0.04652118878614488,
      },
      '0x9da9d8dcdac3cab214d2bd241c3835b90aa8ffde': {
        address: '0x9da9d8dcdac3cab214d2bd241c3835b90aa8ffde',
        chainId: 10,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'WETH/USD+',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0x73cb180bf0521828d8849bc8cf2b920918e23032',
      },
      '0x18c830f6a32a06cf2ac4262e977a096f12bdab8d': {
        address: '0x18c830f6a32a06cf2ac4262e977a096f12bdab8d',
        chainId: 10,
        type: 'LP',
        symbol: 'KUJI/VELO',
        decimals: 18,
        totalSupply: '1701417316915974',
        token0: '0x3a18dcc9745edcd1ef33ecb93b0b6eba5671e7ca',
        token1: '0x9560e827af36c94d2ac33a39bce1fe78631088db',
        priceInUsd: 188790.05154775645,
      },
      '0x4b322314d6f7239f094f40d93e7d9c4a3081c625': {
        address: '0x4b322314d6f7239f094f40d93e7d9c4a3081c625',
        chainId: 10,
        type: 'LP',
        symbol: 'USDC/ALCX',
        decimals: 18,
        totalSupply: '3383042186510727',
        token0: '0x0b2c639c533813f4aa9d7837caf62653d097ff85',
        token1: '0xe974b9b31dbff4369b94a1bab5e228f35ed44125',
        priceInUsd: 5894186.986350388,
      },
      '0xbafb44286c5ecafb1f26a6649e15c49fc1c49882': {
        address: '0xbafb44286c5ecafb1f26a6649e15c49fc1c49882',
        chainId: 10,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'WETH/LUSD',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0xc40f949f8a4e094d1b49a23ea9241d289b7b2819',
      },
      '0xc3439bc1a747e545887192d6b7f8be47f608473f': {
        address: '0xc3439bc1a747e545887192d6b7f8be47f608473f',
        chainId: 10,
        type: 'LP',
        symbol: 'OATH/WETH',
        decimals: 18,
        totalSupply: '287098878011555459519',
        token0: '0x00e1724885473b63bce08a9f0a52f35b0979e35a',
        token1: '0x4200000000000000000000000000000000000006',
        priceInUsd: 3.4340269747558736,
      },
      '0x39ed27d101aa4b7ce1cb4293b877954b8b5e14e5': {
        address: '0x39ed27d101aa4b7ce1cb4293b877954b8b5e14e5',
        chainId: 10,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'WETH/VELO',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0x9560e827af36c94d2ac33a39bce1fe78631088db',
      },
      '0xbf30ff33cf9c6b0c48702ff17891293b002dfea4': {
        address: '0xbf30ff33cf9c6b0c48702ff17891293b002dfea4',
        chainId: 10,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'WSTETH/WETH',
        decimals: 18,
        token0: '0x1f32b1c2345538c0c6f582fcb022739c4a194ebb',
        token1: '0x4200000000000000000000000000000000000006',
      },
      '0x36e3c209b373b861c185ecdbb8b2ebdd98587bdb': {
        address: '0x36e3c209b373b861c185ecdbb8b2ebdd98587bdb',
        chainId: 10,
        type: 'LP',
        symbol: 'USDC/USDC',
        decimals: 18,
        totalSupply: '44879317799',
        token0: '0x0b2c639c533813f4aa9d7837caf62653d097ff85',
        token1: '0x7f5c764cbc14f9669b88837ca1490cca17c31607',
        priceInUsd: 1998928385773.2043,
      },
      '0x5954e5b20260c0cdd35c93bbda98d1f2c5abecaf': {
        address: '0x5954e5b20260c0cdd35c93bbda98d1f2c5abecaf',
        chainId: 10,
        type: 'LP',
        symbol: 'GNODE/USDC',
        decimals: 18,
        totalSupply: '13855566445177185',
        token0: '0x5976d4c3bcfc1c5f90ab1419d7f3ddf109cea35a',
        token1: '0x7f5c764cbc14f9669b88837ca1490cca17c31607',
        priceInUsd: 22727.123369717363,
      },
      '0x68387b6647742b11486e65078b39716469572962': {
        address: '0x68387b6647742b11486e65078b39716469572962',
        chainId: 10,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'WETH/CBETH',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0xaddb6a0412de1ba0f936dcaeb8aaa24578dcf3b2',
      },
      '0x0493bf8b6dbb159ce2db2e0e8403e753abd1235b': {
        address: '0x0493bf8b6dbb159ce2db2e0e8403e753abd1235b',
        chainId: 10,
        type: 'LP',
        symbol: 'WETH/USDC',
        decimals: 18,
        totalSupply: '418415805844091',
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0x7f5c764cbc14f9669b88837ca1490cca17c31607',
        priceInUsd: 129278834.22702317,
      },
      '0x4dc22588ade05c40338a9d95a6da9dcee68bcd60': {
        address: '0x4dc22588ade05c40338a9d95a6da9dcee68bcd60',
        chainId: 10,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'WETH/OP',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0x4200000000000000000000000000000000000042',
      },
      '0x8134a2fdc127549480865fb8e5a9e8a8a95a54c5': {
        address: '0x8134a2fdc127549480865fb8e5a9e8a8a95a54c5',
        chainId: 10,
        type: 'LP',
        symbol: 'USDC/VELO',
        decimals: 18,
        totalSupply: '473583091056409341',
        token0: '0x7f5c764cbc14f9669b88837ca1490cca17c31607',
        token1: '0x9560e827af36c94d2ac33a39bce1fe78631088db',
        priceInUsd: 431302.8055204357,
      },
      '0xa08fb94a933eaea787f8191a5a980c4403dc015c': {
        address: '0xa08fb94a933eaea787f8191a5a980c4403dc015c',
        chainId: 10,
        type: 'LP',
        symbol: 'VELO/BLU',
        decimals: 18,
        totalSupply: '11790128958722984250822767',
        token0: '0x9560e827af36c94d2ac33a39bce1fe78631088db',
        token1: '0xa50b23cdfb2ec7c590e84f403256f67ce6dffb84',
        priceInUsd: 0.004794467356448225,
      },
      '0x8949a8e02998d76d7a703cac9ee7e0f529828011': {
        address: '0x8949a8e02998d76d7a703cac9ee7e0f529828011',
        chainId: 10,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'WBTC/TBTC',
        decimals: 18,
        token0: '0x68f180fcce6836688e9084f035309e29bf0a2095',
        token1: '0x6c84a8f1c29108f47a79964b5fe888d4f4d0de40',
      },
      '0x1c3140ab59d6caf9fa7459c6f83d4b52ba881d36': {
        address: '0x1c3140ab59d6caf9fa7459c6f83d4b52ba881d36',
        chainId: 10,
        type: 'ERC721-NATIVE',
        symbol: 'OP/USDC',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000042',
        token1: '0x7f5c764cbc14f9669b88837ca1490cca17c31607',
      },
      '0x0a8f0d4b3de04afade29ca0c84743177c4bcebb6': {
        address: '0x0a8f0d4b3de04afade29ca0c84743177c4bcebb6',
        chainId: 10,
        type: 'LP',
        symbol: 'TKN/WETH',
        decimals: 18,
        totalSupply: '1348931126050625700373',
        token0: '0x3eb398fec5f7327c6b15099a9681d9568ded2e82',
        token1: '0x4200000000000000000000000000000000000006',
        priceInUsd: 12.444526721730607,
      },
      '0x60c94fdf6c72fad78c16a52c0c3fdc3c6504305d': {
        address: '0x60c94fdf6c72fad78c16a52c0c3fdc3c6504305d',
        chainId: 10,
        type: 'LP',
        symbol: 'WETH/WELL',
        decimals: 18,
        totalSupply: '8648036871635201106981',
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0xa88594d404727625a9437c3f886c7643872296ae',
        priceInUsd: 19.457371076142415,
      },
    },
    '56': {
      '0x28df0835942396b7a1b7ae1cd068728e6ddbbafd': {
        address: '0x28df0835942396b7a1b7ae1cd068728e6ddbbafd',
        chainId: 56,
        type: 'ERC721-NATIVE',
        symbol: 'BTCB/WBNB',
        decimals: 18,
        token0: '0x7130d2a12b9bcbfae4f2634d864a1ee1ce3ead9c',
        token1: '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c',
      },
      '0x7d05c84581f0c41ad80ddf677a510360bae09a5a': {
        address: '0x7d05c84581f0c41ad80ddf677a510360bae09a5a',
        chainId: 56,
        type: 'ERC721',
        symbol: 'ETH/WBNB',
        decimals: 18,
        token0: '0x2170ed0880ac9a755fd29b2688956bd959f933f8',
        token1: '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c',
      },
      '0x6fe9e9de56356f7edbfcbb29fab7cd69471a4869': {
        address: '0x6fe9e9de56356f7edbfcbb29fab7cd69471a4869',
        chainId: 56,
        type: 'ERC721-NATIVE',
        symbol: 'USDT/WBNB',
        decimals: 18,
        token0: '0x55d398326f99059ff775485246999027b3197955',
        token1: '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c',
      },
      '0x0adaf134ae0c4583b3a38fc3168a83e33162651e': {
        address: '0x0adaf134ae0c4583b3a38fc3168a83e33162651e',
        chainId: 56,
        type: 'ERC721-NATIVE',
        symbol: 'XRP/USDT',
        decimals: 18,
        token0: '0x1d2f0da169ceb9fc7b3144628db156f3f6c60dbe',
        token1: '0x55d398326f99059ff775485246999027b3197955',
      },
      '0x9169bf3657353e4b2b81c75e235f22bc299a7780': {
        address: '0x9169bf3657353e4b2b81c75e235f22bc299a7780',
        chainId: 56,
        type: 'ERC721-NATIVE',
        symbol: 'ZRO/WBNB',
        decimals: 18,
        token0: '0x6985884c4392d348587b19cb9eaaf157f13271cd',
        token1: '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c',
      },
      '0x4a978a2d4fb7393063babfb0cee741b8bcd4dd4b': {
        address: '0x4a978a2d4fb7393063babfb0cee741b8bcd4dd4b',
        chainId: 56,
        type: 'ERC721-NATIVE',
        symbol: 'NEAR/WBNB',
        decimals: 18,
        token0: '0x1fa4a73a3f0133f0025378af00236f3abdee5d63',
        token1: '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c',
      },
      '0x673516e510d702ab5f2bbf0c6b545111a85f7ea7': {
        address: '0x673516e510d702ab5f2bbf0c6b545111a85f7ea7',
        chainId: 56,
        type: 'ERC721',
        symbol: 'ADA/WBNB',
        decimals: 18,
        token0: '0x3ee2200efb3400fabb9aacf31297cbdd1d435d47',
        token1: '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c',
      },
      '0x803036ac78752ef599ec75c500ac8b0ac0be67df': {
        address: '0x803036ac78752ef599ec75c500ac8b0ac0be67df',
        chainId: 56,
        type: 'ERC721',
        symbol: 'AXLUSDC/USDT',
        decimals: 18,
        token0: '0x4268b8f0b87b6eae5d897996e6b845ddbd99adf3',
        token1: '0x55d398326f99059ff775485246999027b3197955',
      },
      '0x28f8ed3bb8795b11e9be8a6015add73ef7cd3a14': {
        address: '0x28f8ed3bb8795b11e9be8a6015add73ef7cd3a14',
        chainId: 56,
        type: 'LP',
        symbol: 'WBNB/BUSD',
        decimals: 18,
        totalSupply: '862338463464380953120',
        token0: '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c',
        token1: '0xe9e7cea3dedca5984780bafc599bd69add087d56',
        priceInUsd: 80.34202350888653,
      },
      '0x47a90a2d92a8367a91efa1906bfc8c1e05bf10c4': {
        address: '0x47a90a2d92a8367a91efa1906bfc8c1e05bf10c4',
        chainId: 56,
        type: 'ERC721-NATIVE',
        symbol: 'USDT/WBNB',
        decimals: 18,
        token0: '0x55d398326f99059ff775485246999027b3197955',
        token1: '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c',
      },
      '0x7f51c8aaa6b0599abd16674e2b17fec7a9f674a1': {
        address: '0x7f51c8aaa6b0599abd16674e2b17fec7a9f674a1',
        chainId: 56,
        type: 'ERC721',
        symbol: 'CAKE/USDT',
        decimals: 18,
        token0: '0x0e09fabb73bd3ade0a17ecc321fd13a19e81ce82',
        token1: '0x55d398326f99059ff775485246999027b3197955',
      },
      '0x9f4da89774570e27170873befd139a79cb1a3da2': {
        address: '0x9f4da89774570e27170873befd139a79cb1a3da2',
        chainId: 56,
        type: 'LP',
        symbol: 'USDT/USDC',
        decimals: 18,
        totalSupply: '38967191025603376987283',
        token0: '0x55d398326f99059ff775485246999027b3197955',
        token1: '0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d',
        priceInUsd: 2.027136398654494,
      },
      '0x0e09fabb73bd3ade0a17ecc321fd13a19e81ce82': {
        address: '0x0e09fabb73bd3ade0a17ecc321fd13a19e81ce82',
        chainId: 56,
        type: 'ERC20',
        symbol: 'CAKE',
        decimals: 18,
        totalSupply: '2698657747751051201610995531',
        priceInUsd: 2.8367189987054306,
      },
      '0x31d48313bd3dc70458416be2fb12f96fdd77f497': {
        address: '0x31d48313bd3dc70458416be2fb12f96fdd77f497',
        chainId: 56,
        type: 'ERC721-ALGEBRA',
        symbol: 'ETH/EMP',
        decimals: 18,
        token0: '0x2170ed0880ac9a755fd29b2688956bd959f933f8',
        token1: '0x3a30dce3938a2278f4459f2768126de4fc955e9d',
      },
      '0x62f0546cbcd684f7c394d8549119e072527c41bc': {
        address: '0x62f0546cbcd684f7c394d8549119e072527c41bc',
        chainId: 56,
        type: 'ERC721',
        symbol: 'DOT/WBNB',
        decimals: 18,
        token0: '0x7083609fce4d1d8dc0c979aab8c869ea2c873402',
        token1: '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c',
      },
      '0x77d5b2560e4b84b3fc58875cb0133f39560e8ae3': {
        address: '0x77d5b2560e4b84b3fc58875cb0133f39560e8ae3',
        chainId: 56,
        type: 'ERC721',
        symbol: 'WBNB/XVS',
        decimals: 18,
        token0: '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c',
        token1: '0xcf6bb5389c92bdda8a3747ddb454cb7a64626c63',
      },
      '0xaf9aa53146c5752bf6068a84b970e9fbb22a87bc': {
        address: '0xaf9aa53146c5752bf6068a84b970e9fbb22a87bc',
        chainId: 56,
        type: 'LP',
        symbol: 'MDX/WBNB',
        decimals: 18,
        totalSupply: '7405920072112712726690',
        token0: '0x9c65ab58d8d978db963e63f2bfb7121627e3a739',
        token1: '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c',
        priceInUsd: 2.984337263600737,
      },
      '0xb125aa15ad943d96e813e4a06d0c34716f897e26': {
        address: '0xb125aa15ad943d96e813e4a06d0c34716f897e26',
        chainId: 56,
        type: 'ERC721-NATIVE',
        symbol: 'ETH/USDT',
        decimals: 18,
        token0: '0x2170ed0880ac9a755fd29b2688956bd959f933f8',
        token1: '0x55d398326f99059ff775485246999027b3197955',
      },
      '0xacaac9311b0096e04dfe96b6d87dec867d3883dc': {
        address: '0xacaac9311b0096e04dfe96b6d87dec867d3883dc',
        chainId: 56,
        type: 'LP',
        symbol: 'WBNB/BUSD',
        decimals: 18,
        totalSupply: '5196734097661828264449',
        token0: '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c',
        token1: '0xe9e7cea3dedca5984780bafc599bd69add087d56',
        priceInUsd: 84.31730077277425,
      },
      '0xce6160bb594fc055c943f59de92cee30b8c6b32c': {
        address: '0xce6160bb594fc055c943f59de92cee30b8c6b32c',
        chainId: 56,
        type: 'ERC721',
        symbol: 'DOGE/WBNB',
        decimals: 18,
        token0: '0xba2ae424d960c26247dd6c32edc70b295c744c43',
        token1: '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c',
      },
      '0x46cf1cf8c69595804ba91dfdd8d6b960c9b0a7c4': {
        address: '0x46cf1cf8c69595804ba91dfdd8d6b960c9b0a7c4',
        chainId: 56,
        type: 'ERC721',
        symbol: 'USDT/BTCB',
        decimals: 18,
        token0: '0x55d398326f99059ff775485246999027b3197955',
        token1: '0x7130d2a12b9bcbfae4f2634d864a1ee1ce3ead9c',
      },
      '0x5dc30bb8d7f02efef28f7e637d17aea13fa96906': {
        address: '0x5dc30bb8d7f02efef28f7e637d17aea13fa96906',
        chainId: 56,
        type: 'LP',
        symbol: 'XRP/WBNB',
        decimals: 18,
        totalSupply: '825284599948361066939',
        token0: '0x1d2f0da169ceb9fc7b3144628db156f3f6c60dbe',
        token1: '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c',
        priceInUsd: 134.77492868856245,
      },
      '0x66e9acba7c3a82c8ee02faf3e325dd55d6581a8c': {
        address: '0x66e9acba7c3a82c8ee02faf3e325dd55d6581a8c',
        chainId: 56,
        type: 'ERC721',
        symbol: 'ETH/USDT',
        decimals: 18,
        token0: '0x2170ed0880ac9a755fd29b2688956bd959f933f8',
        token1: '0x55d398326f99059ff775485246999027b3197955',
      },
      '0x577d005912c49b1679b4c21e334fdb650e92c077': {
        address: '0x577d005912c49b1679b4c21e334fdb650e92c077',
        chainId: 56,
        type: 'LP',
        symbol: 'ETH/BTCB',
        decimals: 18,
        totalSupply: '3097645110658516018',
        token0: '0x2170ed0880ac9a755fd29b2688956bd959f933f8',
        token1: '0x7130d2a12b9bcbfae4f2634d864a1ee1ce3ead9c',
        priceInUsd: 45019.004569712,
      },
      '0x023b6298e2f9ae728b324757599f2a36e002a55a': {
        address: '0x023b6298e2f9ae728b324757599f2a36e002a55a',
        chainId: 56,
        type: 'ERC721-NATIVE',
        symbol: 'USDT/DOGE',
        decimals: 18,
        token0: '0x55d398326f99059ff775485246999027b3197955',
        token1: '0xba2ae424d960c26247dd6c32edc70b295c744c43',
      },
      '0x3fb2623567e21f8c50f0ae86f54ef4849b4eb47b': {
        address: '0x3fb2623567e21f8c50f0ae86f54ef4849b4eb47b',
        chainId: 56,
        type: 'ERC721-NATIVE',
        symbol: 'ETH/BTCB',
        decimals: 18,
        token0: '0x2170ed0880ac9a755fd29b2688956bd959f933f8',
        token1: '0x7130d2a12b9bcbfae4f2634d864a1ee1ce3ead9c',
      },
      '0xe0caab61ee7a12d03b268e1f6a56537ac1b61d13': {
        address: '0xe0caab61ee7a12d03b268e1f6a56537ac1b61d13',
        chainId: 56,
        type: 'LP',
        symbol: 'DAI/USDT',
        decimals: 18,
        totalSupply: '9178342351592074405018',
        token0: '0x1af3f329e8be154074d8769d1ffa4ee058b1dbc3',
        token1: '0x55d398326f99059ff775485246999027b3197955',
        priceInUsd: 2.0363868764194386,
      },
      '0xcfe783e16c9a8c74f2be9bceb2339769439061bf': {
        address: '0xcfe783e16c9a8c74f2be9bceb2339769439061bf',
        chainId: 56,
        type: 'ERC721',
        symbol: 'USDT/ALPACA',
        decimals: 18,
        token0: '0x55d398326f99059ff775485246999027b3197955',
        token1: '0x8f0528ce5ef7b51152a59745befdd91d97091d2f',
      },
      '0x133b3d95bad5405d14d53473671200e9342896bf': {
        address: '0x133b3d95bad5405d14d53473671200e9342896bf',
        chainId: 56,
        type: 'ERC721',
        symbol: 'CAKE/WBNB',
        decimals: 18,
        token0: '0x0e09fabb73bd3ade0a17ecc321fd13a19e81ce82',
        token1: '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c',
      },
      '0x813c0decbb1097fff46d0ed6a39fb5f6a83043f4': {
        address: '0x813c0decbb1097fff46d0ed6a39fb5f6a83043f4',
        chainId: 56,
        type: 'ERC721-NATIVE',
        symbol: 'USDT/BTCB',
        decimals: 18,
        token0: '0x55d398326f99059ff775485246999027b3197955',
        token1: '0x7130d2a12b9bcbfae4f2634d864a1ee1ce3ead9c',
      },
      '0x4141325bac36affe9db165e854982230a14e6d48': {
        address: '0x4141325bac36affe9db165e854982230a14e6d48',
        chainId: 56,
        type: 'ERC721-NATIVE',
        symbol: 'USDC/WBNB',
        decimals: 18,
        token0: '0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d',
        token1: '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c',
      },
      '0x71f5a8f7d448e59b1ede00a19fe59e05d125e742': {
        address: '0x71f5a8f7d448e59b1ede00a19fe59e05d125e742',
        chainId: 56,
        type: 'ERC721',
        symbol: 'XRP/USDT',
        decimals: 18,
        token0: '0x1d2f0da169ceb9fc7b3144628db156f3f6c60dbe',
        token1: '0x55d398326f99059ff775485246999027b3197955',
      },
      '0xda28eb7aba389c1ea226a420bce04cb565aafb85': {
        address: '0xda28eb7aba389c1ea226a420bce04cb565aafb85',
        chainId: 56,
        type: 'LP',
        symbol: 'USDT/BTCB',
        decimals: 18,
        totalSupply: '61573510029827759293',
        token0: '0x55d398326f99059ff775485246999027b3197955',
        token1: '0x7130d2a12b9bcbfae4f2634d864a1ee1ce3ead9c',
        priceInUsd: 734.0116419383835,
      },
      '0x916d7f23ccbb1d10118dcfc6ad5a10b6446ff73e': {
        address: '0x916d7f23ccbb1d10118dcfc6ad5a10b6446ff73e',
        chainId: 56,
        type: 'ERC721-NATIVE',
        symbol: 'PENDLE/WBNB',
        decimals: 18,
        token0: '0xb3ed0a426155b79b898849803e3b36552f7ed507',
        token1: '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c',
      },
      '0x6bbc40579ad1bbd243895ca0acb086bb6300d636': {
        address: '0x6bbc40579ad1bbd243895ca0acb086bb6300d636',
        chainId: 56,
        type: 'ERC721',
        symbol: 'BTCB/WBNB',
        decimals: 18,
        token0: '0x7130d2a12b9bcbfae4f2634d864a1ee1ce3ead9c',
        token1: '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c',
      },
      '0xd15b00e81f98a7db25f1dc1ba6e983a4316c4cac': {
        address: '0xd15b00e81f98a7db25f1dc1ba6e983a4316c4cac',
        chainId: 56,
        type: 'ERC721',
        symbol: 'XRP/WBNB',
        decimals: 18,
        token0: '0x1d2f0da169ceb9fc7b3144628db156f3f6c60dbe',
        token1: '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c',
      },
      '0xbe141893e4c6ad9272e8c04bab7e6a10604501a5': {
        address: '0xbe141893e4c6ad9272e8c04bab7e6a10604501a5',
        chainId: 56,
        type: 'ERC721',
        symbol: 'ETH/USDT',
        decimals: 18,
        token0: '0x2170ed0880ac9a755fd29b2688956bd959f933f8',
        token1: '0x55d398326f99059ff775485246999027b3197955',
      },
      '0x55458175c5f5d34b9bd01c81f172780ed4271b23': {
        address: '0x55458175c5f5d34b9bd01c81f172780ed4271b23',
        chainId: 56,
        type: 'ERC721',
        symbol: 'AITECH/USDT',
        decimals: 18,
        token0: '0x2d060ef4d6bf7f9e5edde373ab735513c0e4f944',
        token1: '0x55d398326f99059ff775485246999027b3197955',
      },
      '0x515e94dc736b9d8b7d28ecf1cece0aba3d75da97': {
        address: '0x515e94dc736b9d8b7d28ecf1cece0aba3d75da97',
        chainId: 56,
        type: 'ERC721-NATIVE',
        symbol: 'USDT/SOL',
        decimals: 18,
        token0: '0x55d398326f99059ff775485246999027b3197955',
        token1: '0x570a5d26f7765ecb712c0924e4de545b89fd43df',
      },
      '0x539e0ebfffd39e54a0f7e5f8fec40ade7933a664': {
        address: '0x539e0ebfffd39e54a0f7e5f8fec40ade7933a664',
        chainId: 56,
        type: 'ERC721',
        symbol: 'ETH/USDC',
        decimals: 18,
        token0: '0x2170ed0880ac9a755fd29b2688956bd959f933f8',
        token1: '0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d',
      },
      '0xfc75f4e78bf71ed5066db9ca771d4ccb7c1264e0': {
        address: '0xfc75f4e78bf71ed5066db9ca771d4ccb7c1264e0',
        chainId: 56,
        type: 'ERC721',
        symbol: 'BTCB/WBNB',
        decimals: 18,
        token0: '0x7130d2a12b9bcbfae4f2634d864a1ee1ce3ead9c',
        token1: '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c',
      },
      '0xd23811058eb6e7967d9a00dc3886e75610c4abba': {
        address: '0xd23811058eb6e7967d9a00dc3886e75610c4abba',
        chainId: 56,
        type: 'ERC20',
        symbol: 'KNIGHT',
        decimals: 18,
        totalSupply: '380119172146409569042240110',
        priceInUsd: 0.000507476314195018,
      },
      '0x2f3899ffb9fdcf635132f7bb94c1a3a0f906cc6f': {
        address: '0x2f3899ffb9fdcf635132f7bb94c1a3a0f906cc6f',
        chainId: 56,
        type: 'LP',
        symbol: 'AVAX/WBNB',
        decimals: 18,
        totalSupply: '73555094477435314844',
        token0: '0x1ce0c2827e2ef14d5c4f29a091d735a204794041',
        token1: '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c',
        priceInUsd: 458.8651685985604,
      },
      '0x33e59edd3214e97cb68450c6d3d6c167de072aba': {
        address: '0x33e59edd3214e97cb68450c6d3d6c167de072aba',
        chainId: 56,
        type: 'ERC721-NATIVE',
        symbol: 'INJ/WBNB',
        decimals: 18,
        token0: '0xa2b726b1145a4773f68593cf171187d8ebe4d495',
        token1: '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c',
      },
      '0x032ab93b734bef57d98552eb56839f0995d4fb28': {
        address: '0x032ab93b734bef57d98552eb56839f0995d4fb28',
        chainId: 56,
        type: 'ERC721',
        symbol: 'TRUMP/WBNB',
        decimals: 18,
        token0: '0x4ea98c1999575aaadfb38237dd015c5e773f75a2',
        token1: '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c',
      },
      '0xfe4fe5b4575c036ac6d5cccfe13660020270e27a': {
        address: '0xfe4fe5b4575c036ac6d5cccfe13660020270e27a',
        chainId: 56,
        type: 'ERC721-NATIVE',
        symbol: 'CAKE/USDT',
        decimals: 18,
        token0: '0x0e09fabb73bd3ade0a17ecc321fd13a19e81ce82',
        token1: '0x55d398326f99059ff775485246999027b3197955',
      },
      '0x223740a259e461abee12d84a9fff5da69ff071dd': {
        address: '0x223740a259e461abee12d84a9fff5da69ff071dd',
        chainId: 56,
        type: 'LP',
        symbol: 'MDX/BUSD',
        decimals: 18,
        totalSupply: '449141274307315807877294',
        token0: '0x9c65ab58d8d978db963e63f2bfb7121627e3a739',
        token1: '0xe9e7cea3dedca5984780bafc599bd69add087d56',
        priceInUsd: 0.09671899829151173,
      },
      '0xd0e226f674bbf064f54ab47f42473ff80db98cba': {
        address: '0xd0e226f674bbf064f54ab47f42473ff80db98cba',
        chainId: 56,
        type: 'ERC721',
        symbol: 'ETH/WBNB',
        decimals: 18,
        token0: '0x2170ed0880ac9a755fd29b2688956bd959f933f8',
        token1: '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c',
      },
      '0x64ebb904e169cb94e9788fcb68283b4c894ed881': {
        address: '0x64ebb904e169cb94e9788fcb68283b4c894ed881',
        chainId: 56,
        type: 'ERC721',
        symbol: 'WBNB/SFP',
        decimals: 18,
        token0: '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c',
        token1: '0xd41fdb03ba84762dd66a0af1a6c8540ff1ba5dfb',
      },
      '0xa12e1e2e2dea79694448ab9ef63bd4d82a26d90c': {
        address: '0xa12e1e2e2dea79694448ab9ef63bd4d82a26d90c',
        chainId: 56,
        type: 'LP',
        symbol: 'KNIGHT/BUSD',
        decimals: 18,
        totalSupply: '779154785566685448374531',
        token0: '0xd23811058eb6e7967d9a00dc3886e75610c4abba',
        token1: '0xe9e7cea3dedca5984780bafc599bd69add087d56',
        priceInUsd: 0.049242168207866796,
      },
      '0x0f338ec12d3f7c3d77a4b9fcc1f95f3fb6ad0ea6': {
        address: '0x0f338ec12d3f7c3d77a4b9fcc1f95f3fb6ad0ea6',
        chainId: 56,
        type: 'ERC721-NATIVE',
        symbol: 'ETH/WBNB',
        decimals: 18,
        token0: '0x2170ed0880ac9a755fd29b2688956bd959f933f8',
        token1: '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c',
      },
      '0x1483767e665b3591677fd49f724bf7430c18bf83': {
        address: '0x1483767e665b3591677fd49f724bf7430c18bf83',
        chainId: 56,
        type: 'LP',
        symbol: 'USDT/USDC',
        decimals: 18,
        totalSupply: '107016622446596737977559',
        token0: '0x55d398326f99059ff775485246999027b3197955',
        token1: '0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d',
        priceInUsd: 2.062989714462469,
      },
      '0x647d99772863e09f47435782cbb6c96ec4a75f12': {
        address: '0x647d99772863e09f47435782cbb6c96ec4a75f12',
        chainId: 56,
        type: 'ERC721',
        symbol: 'WBNB/UNI',
        decimals: 18,
        token0: '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c',
        token1: '0xbf5140a22578168fd562dccf235e5d43a02ce9b1',
      },
      '0xa322b156b138deaa6b5df1f76154ee019f33db25': {
        address: '0xa322b156b138deaa6b5df1f76154ee019f33db25',
        chainId: 56,
        type: 'ERC721',
        symbol: 'XRP/ETH',
        decimals: 18,
        token0: '0x1d2f0da169ceb9fc7b3144628db156f3f6c60dbe',
        token1: '0x2170ed0880ac9a755fd29b2688956bd959f933f8',
      },
      '0x9c65ab58d8d978db963e63f2bfb7121627e3a739': {
        address: '0x9c65ab58d8d978db963e63f2bfb7121627e3a739',
        chainId: 56,
        type: 'ERC20',
        symbol: 'MDX',
        decimals: 18,
        totalSupply: '338862393138791517261912643',
        priceInUsd: 0.0012375709527297691,
      },
      '0x62c1dec1ff328dcdc157ae0068bb21af3967acd9': {
        address: '0x62c1dec1ff328dcdc157ae0068bb21af3967acd9',
        chainId: 56,
        type: 'LP',
        symbol: 'USDT/BUSD',
        decimals: 18,
        totalSupply: '137946491469744827678957',
        token0: '0x55d398326f99059ff775485246999027b3197955',
        token1: '0xe9e7cea3dedca5984780bafc599bd69add087d56',
        priceInUsd: 2.172200511604336,
      },
      '0xd71710c21fba293eb12e0ca079fe37f50ad17d42': {
        address: '0xd71710c21fba293eb12e0ca079fe37f50ad17d42',
        chainId: 56,
        type: 'LP',
        symbol: 'WBNB/KNIGHT',
        decimals: 18,
        totalSupply: '102927680335857651975917',
        token0: '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c',
        token1: '0xd23811058eb6e7967d9a00dc3886e75610c4abba',
        priceInUsd: 1.5212949115866712,
      },
      '0xd4dca84e1808da3354924cd243c66828cf775470': {
        address: '0xd4dca84e1808da3354924cd243c66828cf775470',
        chainId: 56,
        type: 'ERC721',
        symbol: 'ETH/BTCB',
        decimals: 18,
        token0: '0x2170ed0880ac9a755fd29b2688956bd959f933f8',
        token1: '0x7130d2a12b9bcbfae4f2634d864a1ee1ce3ead9c',
      },
      '0x045e0d7dd6f6b5ab37a4c557c3b5fa0db23be24a': {
        address: '0x045e0d7dd6f6b5ab37a4c557c3b5fa0db23be24a',
        chainId: 56,
        type: 'ERC721-ALGEBRA',
        symbol: 'GG/ETH',
        decimals: 18,
        token0: '0x0c7ecdb459111cd806e54adc9da1f4a03b43b64a',
        token1: '0x2170ed0880ac9a755fd29b2688956bd959f933f8',
      },
      '0x96d5d78b179169ee0a0a0104dc514988f2a797fe': {
        address: '0x96d5d78b179169ee0a0a0104dc514988f2a797fe',
        chainId: 56,
        type: 'ERC721-NATIVE',
        symbol: 'FTM/WBNB',
        decimals: 18,
        token0: '0xad29abb318791d579433d831ed122afeaf29dcfe',
        token1: '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c',
      },
      '0x0fb881c078434b1c0e4d0b64d8c64d12078b7ce2': {
        address: '0x0fb881c078434b1c0e4d0b64d8c64d12078b7ce2',
        chainId: 56,
        type: 'LP',
        symbol: 'ETH/USDT',
        decimals: 18,
        totalSupply: '372389966658830705953',
        token0: '0x2170ed0880ac9a755fd29b2688956bd959f933f8',
        token1: '0x55d398326f99059ff775485246999027b3197955',
        priceInUsd: 148.98438661040402,
      },
      '0xf9878a5dd55edc120fde01893ea713a4f032229c': {
        address: '0xf9878a5dd55edc120fde01893ea713a4f032229c',
        chainId: 56,
        type: 'ERC721-NATIVE',
        symbol: 'ETH/USDT',
        decimals: 18,
        token0: '0x2170ed0880ac9a755fd29b2688956bd959f933f8',
        token1: '0x55d398326f99059ff775485246999027b3197955',
      },
      '0x85bea4fbc57fa22b41fb1632f0d9a6a99390fd0a': {
        address: '0x85bea4fbc57fa22b41fb1632f0d9a6a99390fd0a',
        chainId: 56,
        type: 'ERC721',
        symbol: 'PENDLE/WBNB',
        decimals: 18,
        token0: '0xb3ed0a426155b79b898849803e3b36552f7ed507',
        token1: '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c',
      },
      '0x92b7807bf19b7dddf89b706143896d05228f3121': {
        address: '0x92b7807bf19b7dddf89b706143896d05228f3121',
        chainId: 56,
        type: 'ERC721',
        symbol: 'USDT/USDC',
        decimals: 18,
        token0: '0x55d398326f99059ff775485246999027b3197955',
        token1: '0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d',
      },
      '0x42d749f736051d8933b118324cded52d1f92bec1': {
        address: '0x42d749f736051d8933b118324cded52d1f92bec1',
        chainId: 56,
        type: 'ERC721-NATIVE',
        symbol: 'WBNB/VELO',
        decimals: 18,
        token0: '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c',
        token1: '0xf486ad071f3bee968384d2e39e2d8af0fcf6fd46',
      },
      '0x05c0a0b84b6b67499c33e6403686f45cab063810': {
        address: '0x05c0a0b84b6b67499c33e6403686f45cab063810',
        chainId: 56,
        type: 'ERC721-NATIVE',
        symbol: 'CAT/WBNB',
        decimals: 18,
        token0: '0x6894cde390a3f51155ea41ed24a33a4827d3063d',
        token1: '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c',
      },
      '0x06396509195eb9e07c38a016694dc9ff535b128a': {
        address: '0x06396509195eb9e07c38a016694dc9ff535b128a',
        chainId: 56,
        type: 'ERC721-NATIVE',
        symbol: 'USDT/BTCB',
        decimals: 18,
        token0: '0x55d398326f99059ff775485246999027b3197955',
        token1: '0x7130d2a12b9bcbfae4f2634d864a1ee1ce3ead9c',
      },
      '0x4bba1018b967e59220b22ca03f68821a3276c9a6': {
        address: '0x4bba1018b967e59220b22ca03f68821a3276c9a6',
        chainId: 56,
        type: 'ERC721',
        symbol: 'ETH/BTCB',
        decimals: 18,
        token0: '0x2170ed0880ac9a755fd29b2688956bd959f933f8',
        token1: '0x7130d2a12b9bcbfae4f2634d864a1ee1ce3ead9c',
      },
      '0x99f220eff95dd089784a74d1ed8940cc485f3679': {
        address: '0x99f220eff95dd089784a74d1ed8940cc485f3679',
        chainId: 56,
        type: 'ERC721-ALGEBRA',
        symbol: 'ESHARE/WBNB',
        decimals: 18,
        token0: '0x29c55f1b02a95f0b30e61976835a3eee2359ad92',
        token1: '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c',
      },
      '0x965f527d9159dce6288a2219db51fc6eef120dd1': {
        address: '0x965f527d9159dce6288a2219db51fc6eef120dd1',
        chainId: 56,
        type: 'ERC20',
        symbol: 'BSW',
        decimals: 18,
        totalSupply: '699999999319886546382781285',
        priceInUsd: 0.011117600474872534,
      },
      '0xb1a1b707b143b911c36e1a0f4f901c5017791aca': {
        address: '0xb1a1b707b143b911c36e1a0f4f901c5017791aca',
        chainId: 56,
        type: 'ERC721-NATIVE',
        symbol: 'WBNB/VELO',
        decimals: 18,
        token0: '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c',
        token1: '0xf486ad071f3bee968384d2e39e2d8af0fcf6fd46',
      },
      '0xf7513c120b92fa4dd5cbfa78dffefcb4ced5743f': {
        address: '0xf7513c120b92fa4dd5cbfa78dffefcb4ced5743f',
        chainId: 56,
        type: 'ERC721-NATIVE',
        symbol: 'ADA/USDT',
        decimals: 18,
        token0: '0x3ee2200efb3400fabb9aacf31297cbdd1d435d47',
        token1: '0x55d398326f99059ff775485246999027b3197955',
      },
      '0x06cd679121ec37b0a2fd673d4976b09d81791856': {
        address: '0x06cd679121ec37b0a2fd673d4976b09d81791856',
        chainId: 56,
        type: 'LP',
        symbol: 'USDC/WBNB',
        decimals: 18,
        totalSupply: '741642761737322466747',
        token0: '0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d',
        token1: '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c',
        priceInUsd: 77.6877314320206,
      },
    },
    '146': {
      '0xd760791b29e7894fb827a94ca433254bb5afb653': {
        address: '0xd760791b29e7894fb827a94ca433254bb5afb653',
        chainId: 146,
        type: 'ERC721-ALGEBRA',
        symbol: 'WS/STS',
        decimals: 18,
        token0: '0x039e2fb66102314ce7b64ce5ce3e5183bc94ad38',
        token1: '0xe5da20f15420ad15de0fa650600afc998bbe3955',
      },
      '0xf1c16a99a0f30d505d8f5fe226a6f09b19bd7991': {
        address: '0xf1c16a99a0f30d505d8f5fe226a6f09b19bd7991',
        chainId: 146,
        type: 'LP',
        symbol: 'WS/MEEP',
        decimals: 18,
        totalSupply: '627474363095789054287',
        token0: '0x039e2fb66102314ce7b64ce5ce3e5183bc94ad38',
        token1: '0x8885d6684120aac9520afbcdbccd47079032f069',
        priceInUsd: 0.006241751923222737,
      },
      '0x832e2bb9579f6ff038d3e704fa1bb5b6b18a6521': {
        address: '0x832e2bb9579f6ff038d3e704fa1bb5b6b18a6521',
        chainId: 146,
        type: 'LP',
        symbol: 'WS/GOGLZ',
        decimals: 18,
        totalSupply: '30559203370505472216929',
        token0: '0x039e2fb66102314ce7b64ce5ce3e5183bc94ad38',
        token1: '0x9fdbc3f8abc05fa8f3ad3c17d2f806c1230c4564',
        priceInUsd: 0.275961645241449,
      },
      '0xc291ca0a0a0e793dc6a0442a34e1607ce1905389': {
        address: '0xc291ca0a0a0e793dc6a0442a34e1607ce1905389',
        chainId: 146,
        type: 'ERC721-RAMSES',
        symbol: 'SCETH/WETH',
        decimals: 18,
        token0: '0x3bce5cb273f0f148010bbea2470e7b5df84c7812',
        token1: '0x50c42deacd8fc9773493ed674b675be577f2634b',
      },
      '0x04f1b3ce71cde381097a0601213def55cf336589': {
        address: '0x04f1b3ce71cde381097a0601213def55cf336589',
        chainId: 146,
        type: 'LP',
        symbol: 'WS/HEDGY',
        decimals: 18,
        totalSupply: '67037832217452957115514',
        token0: '0x039e2fb66102314ce7b64ce5ce3e5183bc94ad38',
        token1: '0x6fb9897896fe5d05025eb43306675727887d0b7c',
        priceInUsd: 0.047520650503155605,
      },
      '0x5050bc082ff4a74fb6b0b04385defddb114b2424': {
        address: '0x5050bc082ff4a74fb6b0b04385defddb114b2424',
        chainId: 146,
        type: 'ERC20',
        symbol: 'XSHADOW',
        decimals: 18,
        totalSupply: '3405307450372460771397419',
        priceInUsd: 3.7174714782442493,
      },
      '0x3333b97138d4b086720b5ae8a7844b1345a33333': {
        address: '0x3333b97138d4b086720b5ae8a7844b1345a33333',
        chainId: 146,
        type: 'ERC20',
        symbol: 'SHADOW',
        decimals: 18,
        totalSupply: '3976098218353987895508089',
        priceInUsd: 7.16073163669871,
      },
      '0x2c13383855377faf5a562f1aef47e4be7a0f12ac': {
        address: '0x2c13383855377faf5a562f1aef47e4be7a0f12ac',
        chainId: 146,
        type: 'ERC721-RAMSES',
        symbol: 'USDC.E/SCUSD',
        decimals: 18,
        token0: '0x29219dd400f2bf60e5a23d13be72b486d4038894',
        token1: '0xd3dce716f3ef535c5ff8d041c1a41c3bd89b97ae',
      },
      '0x36688823ef912ca5f3c152163c3082a01f22cc67': {
        address: '0x36688823ef912ca5f3c152163c3082a01f22cc67',
        chainId: 146,
        type: 'ERC721-RAMSES',
        symbol: 'WS/SHADOW',
        decimals: 18,
        token0: '0x039e2fb66102314ce7b64ce5ce3e5183bc94ad38',
        token1: '0x3333b97138d4b086720b5ae8a7844b1345a33333',
      },
      '0xeb5998f9dd9b966ca512adf8ebaa09cb5af96cb7': {
        address: '0xeb5998f9dd9b966ca512adf8ebaa09cb5af96cb7',
        chainId: 146,
        type: 'ERC721-NATIVE',
        symbol: 'WS/SSGRIM',
        decimals: 18,
        token0: '0x039e2fb66102314ce7b64ce5ce3e5183bc94ad38',
        token1: '0xb387f9577cc7df1b0358fb1aea57b3500068130f',
      },
      '0x5c4b7d607aaf7b5cde9f09b5f03cf3b5c923aeea': {
        address: '0x5c4b7d607aaf7b5cde9f09b5f03cf3b5c923aeea',
        chainId: 146,
        type: 'ERC721-ALGEBRA',
        symbol: 'WS/USDC.E',
        decimals: 18,
        token0: '0x039e2fb66102314ce7b64ce5ce3e5183bc94ad38',
        token1: '0x29219dd400f2bf60e5a23d13be72b486d4038894',
      },
      '0x139f8ecc5fc8ef11226a83911febecc08476cfb1': {
        address: '0x139f8ecc5fc8ef11226a83911febecc08476cfb1',
        chainId: 146,
        type: 'LP',
        symbol: 'WS/EQUAL',
        decimals: 18,
        totalSupply: '195539096237238790423914',
        token0: '0x039e2fb66102314ce7b64ce5ce3e5183bc94ad38',
        token1: '0xddf26b42c1d903de8962d3f79a74a501420d5f19',
        priceInUsd: 0.681183296937173,
      },
      '0xec4ee7d6988ab06f7a8daaf8c5fdffde6321be68': {
        address: '0xec4ee7d6988ab06f7a8daaf8c5fdffde6321be68',
        chainId: 146,
        type: 'ERC721-ALGEBRA',
        symbol: 'USDC.E/WETH',
        decimals: 18,
        token0: '0x29219dd400f2bf60e5a23d13be72b486d4038894',
        token1: '0x50c42deacd8fc9773493ed674b675be577f2634b',
      },
      '0xb4a22d3554024437d4d4ae196598f9e093b03396': {
        address: '0xb4a22d3554024437d4d4ae196598f9e093b03396',
        chainId: 146,
        type: 'ERC721-NATIVE',
        symbol: 'WS/WAGMI',
        decimals: 18,
        token0: '0x039e2fb66102314ce7b64ce5ce3e5183bc94ad38',
        token1: '0x0e0ce4d450c705f8a0b6dd9d5123e3df2787d16b',
      },
      '0x1f50e4f90c02411a07474b3209182b1e0162ad1a': {
        address: '0x1f50e4f90c02411a07474b3209182b1e0162ad1a',
        chainId: 146,
        type: 'ERC721-RAMSES',
        symbol: 'SHADOW/EGGS',
        decimals: 18,
        token0: '0x3333b97138d4b086720b5ae8a7844b1345a33333',
        token1: '0xf26ff70573ddc8a90bd7865af8d7d70b8ff019bc',
      },
      '0x7693de58839ff25e265d9b494394cb9c1d1efaf1': {
        address: '0x7693de58839ff25e265d9b494394cb9c1d1efaf1',
        chainId: 146,
        type: 'LP',
        symbol: 'WS/ELITEUSD',
        decimals: 18,
        totalSupply: '8002988424750907261',
        token0: '0x039e2fb66102314ce7b64ce5ce3e5183bc94ad38',
        token1: '0xcc835d13543cec819ac0226dd9ff35b6312b8fca',
        priceInUsd: 0.6554631961410267,
      },
      '0xbb8ae5b889243561ac9261f22f592b72250afd1f': {
        address: '0xbb8ae5b889243561ac9261f22f592b72250afd1f',
        chainId: 146,
        type: 'LP',
        symbol: 'USDC.E/SCUSD',
        decimals: 18,
        totalSupply: '9180625413',
        token0: '0x29219dd400f2bf60e5a23d13be72b486d4038894',
        token1: '0xd3dce716f3ef535c5ff8d041c1a41c3bd89b97ae',
        priceInUsd: 1986208207876.0977,
      },
      '0x913b1c9924f563692b3a306c90c9fde9f825ca27': {
        address: '0x913b1c9924f563692b3a306c90c9fde9f825ca27',
        chainId: 146,
        type: 'LP',
        symbol: 'WS/INDI',
        decimals: 18,
        totalSupply: '22105369416441317917161',
        token0: '0x039e2fb66102314ce7b64ce5ce3e5183bc94ad38',
        token1: '0x4eec869d847a6d13b0f6d1733c5dec0d1e741b4f',
        priceInUsd: 0.04930590857002257,
      },
      '0x9e1a6c05a9d7325f4dd46963f5a5179aa3d59e9b': {
        address: '0x9e1a6c05a9d7325f4dd46963f5a5179aa3d59e9b',
        chainId: 146,
        type: 'LP',
        symbol: 'WS/FROQ',
        decimals: 18,
        totalSupply: '61809865493831941146150',
        token0: '0x039e2fb66102314ce7b64ce5ce3e5183bc94ad38',
        token1: '0x131f5ae1cbfefe8efbdf93da23fa4d39f14a817c',
        priceInUsd: 0.163892369569867,
      },
      '0x9abf712d326da30f77ee14840f0180b571630a32': {
        address: '0x9abf712d326da30f77ee14840f0180b571630a32',
        chainId: 146,
        type: 'ERC721-RAMSES',
        symbol: 'WS/DERP',
        decimals: 18,
        token0: '0x039e2fb66102314ce7b64ce5ce3e5183bc94ad38',
        token1: '0xe920d1da9a4d59126dc35996ea242d60efca1304',
      },
      '0x36e0c9ee4da91101b6509586b820190015e9114f': {
        address: '0x36e0c9ee4da91101b6509586b820190015e9114f',
        chainId: 146,
        type: 'LP',
        symbol: 'WS/HEDGY',
        decimals: 18,
        totalSupply: '514571719186636762157500',
        token0: '0x039e2fb66102314ce7b64ce5ce3e5183bc94ad38',
        token1: '0x6fb9897896fe5d05025eb43306675727887d0b7c',
        priceInUsd: 0.0475300217170879,
      },
      '0x779ca4e7f14d10489cd32655fc513641ba3a8d8f': {
        address: '0x779ca4e7f14d10489cd32655fc513641ba3a8d8f',
        chainId: 146,
        type: 'ERC721-RAMSES',
        symbol: 'USDC.E/SHADOW',
        decimals: 18,
        token0: '0x29219dd400f2bf60e5a23d13be72b486d4038894',
        token1: '0x3333b97138d4b086720b5ae8a7844b1345a33333',
      },
      '0x23abb32a9a242a552b9b3e70c0648b7b6499c164': {
        address: '0x23abb32a9a242a552b9b3e70c0648b7b6499c164',
        chainId: 146,
        type: 'LP',
        symbol: 'WS/JOINT',
        decimals: 18,
        totalSupply: '625467650097265719184128',
        token0: '0x039e2fb66102314ce7b64ce5ce3e5183bc94ad38',
        token1: '0xc046dcb16592fbb3f9fa0c629b8d93090dd4cb76',
        priceInUsd: 0.004906759955589865,
      },
      '0x5c8e4d65c68e4244511f33ecef5ee34f6de5d5ba': {
        address: '0x5c8e4d65c68e4244511f33ecef5ee34f6de5d5ba',
        chainId: 146,
        type: 'ERC721-RAMSES',
        symbol: 'WS/OIL',
        decimals: 18,
        token0: '0x039e2fb66102314ce7b64ce5ce3e5183bc94ad38',
        token1: '0x31e2eed04a62b232da964a097d8c171584e3c3bd',
      },
      '0xf58fc088c33ad46113940173cb0da3dd08c4aa88': {
        address: '0xf58fc088c33ad46113940173cb0da3dd08c4aa88',
        chainId: 146,
        type: 'ERC721-ALGEBRA',
        symbol: 'WS/WETH',
        decimals: 18,
        token0: '0x039e2fb66102314ce7b64ce5ce3e5183bc94ad38',
        token1: '0x50c42deacd8fc9773493ed674b675be577f2634b',
      },
      '0xf19748a0e269c6965a84f8c98ca8c47a064d4dd0': {
        address: '0xf19748a0e269c6965a84f8c98ca8c47a064d4dd0',
        chainId: 146,
        type: 'LP',
        symbol: 'WS/SHADOW',
        decimals: 18,
        totalSupply: '320835908123887194975720',
        token0: '0x039e2fb66102314ce7b64ce5ce3e5183bc94ad38',
        token1: '0x3333b97138d4b086720b5ae8a7844b1345a33333',
        priceInUsd: 3.555334169990112,
      },
      '0x9cb484fad38d953bc79e2a39bbc93655256f0b16': {
        address: '0x9cb484fad38d953bc79e2a39bbc93655256f0b16',
        chainId: 146,
        type: 'ERC721-ALGEBRA',
        symbol: 'SWPX/OS',
        decimals: 18,
        token0: '0xa04bc7140c26fc9bb1f36b1a604c7a5a88fb0e70',
        token1: '0xb1e25689d55734fd3fffc939c4c3eb52dff8a794',
      },
      '0xb73a4d63fa27eb0ded5305c5d4d1ce488edfe2a1': {
        address: '0xb73a4d63fa27eb0ded5305c5d4d1ce488edfe2a1',
        chainId: 146,
        type: 'ERC721-ALGEBRA',
        symbol: 'WS/ANON',
        decimals: 18,
        token0: '0x039e2fb66102314ce7b64ce5ce3e5183bc94ad38',
        token1: '0x79bbf4508b1391af3a0f4b30bb5fc4aa9ab0e07c',
      },
      '0x6fb30f3fcb864d49cdff15061ed5c6adfee40b40': {
        address: '0x6fb30f3fcb864d49cdff15061ed5c6adfee40b40',
        chainId: 146,
        type: 'ERC721-RAMSES',
        symbol: 'USDC.E/WETH',
        decimals: 18,
        token0: '0x29219dd400f2bf60e5a23d13be72b486d4038894',
        token1: '0x50c42deacd8fc9773493ed674b675be577f2634b',
      },
      '0xae8e9b2222031c464342dbfab7433b64eb5c15cf': {
        address: '0xae8e9b2222031c464342dbfab7433b64eb5c15cf',
        chainId: 146,
        type: 'LP',
        symbol: 'WS/THC',
        decimals: 18,
        totalSupply: '385301482028307203699608',
        token0: '0x039e2fb66102314ce7b64ce5ce3e5183bc94ad38',
        token1: '0x17af1df44444ab9091622e4aa66db5bb34e51ad5',
        priceInUsd: 0.15392654265106837,
      },
      '0xa04bc7140c26fc9bb1f36b1a604c7a5a88fb0e70': {
        address: '0xa04bc7140c26fc9bb1f36b1a604c7a5a88fb0e70',
        chainId: 146,
        type: 'ERC20',
        symbol: 'SWPX',
        decimals: 18,
        totalSupply: '95612620723747457060340110',
        priceInUsd: 0.041511072031722364,
      },
      '0x43b3ba354aee512ca45f0c5512440fbadf114e98': {
        address: '0x43b3ba354aee512ca45f0c5512440fbadf114e98',
        chainId: 146,
        type: 'ERC721-RAMSES',
        symbol: 'WS/ANON',
        decimals: 18,
        token0: '0x039e2fb66102314ce7b64ce5ce3e5183bc94ad38',
        token1: '0x79bbf4508b1391af3a0f4b30bb5fc4aa9ab0e07c',
      },
      '0xd441a37aa73fc1ddd2db99fc4c92f233b7d41cbd': {
        address: '0xd441a37aa73fc1ddd2db99fc4c92f233b7d41cbd',
        chainId: 146,
        type: 'ERC20',
        symbol: 'HUBBLE',
        decimals: 18,
        totalSupply: '200000000000000000000000',
        priceInUsd: 3.3565735813800077,
      },
      '0xcb1698a454b957f20b61ba7e8edd9e169baa28ae': {
        address: '0xcb1698a454b957f20b61ba7e8edd9e169baa28ae',
        chainId: 146,
        type: 'ERC721-NATIVE',
        symbol: 'WS/WAGMI',
        decimals: 18,
        token0: '0x039e2fb66102314ce7b64ce5ce3e5183bc94ad38',
        token1: '0x0e0ce4d450c705f8a0b6dd9d5123e3df2787d16b',
      },
      '0xfc64bd7c84f7dc1387d6e752679a533f22f6f1db': {
        address: '0xfc64bd7c84f7dc1387d6e752679a533f22f6f1db',
        chainId: 146,
        type: 'ERC721-ALGEBRA',
        symbol: 'WS/SCETH',
        decimals: 18,
        token0: '0x039e2fb66102314ce7b64ce5ce3e5183bc94ad38',
        token1: '0x3bce5cb273f0f148010bbea2470e7b5df84c7812',
      },
      '0x28f1bb2952ae8742b9e16fd515e3d01f4be6bc30': {
        address: '0x28f1bb2952ae8742b9e16fd515e3d01f4be6bc30',
        chainId: 146,
        type: 'ERC721-RAMSES',
        symbol: 'WS/NAVI',
        decimals: 18,
        token0: '0x039e2fb66102314ce7b64ce5ce3e5183bc94ad38',
        token1: '0x6881b80ea7c858e4aeef63893e18a8a36f3682f3',
      },
      '0x9ff1b68f8bedf4665fe358f92c3e9af386cb295f': {
        address: '0x9ff1b68f8bedf4665fe358f92c3e9af386cb295f',
        chainId: 146,
        type: 'LP',
        symbol: 'USDC.E/HUBBLE',
        decimals: 18,
        totalSupply: '4631959782',
        token0: '0x29219dd400f2bf60e5a23d13be72b486d4038894',
        token1: '0xd441a37aa73fc1ddd2db99fc4c92f233b7d41cbd',
        priceInUsd: 973288311104.6941,
      },
      '0x267fb0fc7694af30ffbcd3c27ce7497a7db73616': {
        address: '0x267fb0fc7694af30ffbcd3c27ce7497a7db73616',
        chainId: 146,
        type: 'ERC721-NATIVE',
        symbol: 'WS/ANON',
        decimals: 18,
        token0: '0x039e2fb66102314ce7b64ce5ce3e5183bc94ad38',
        token1: '0x79bbf4508b1391af3a0f4b30bb5fc4aa9ab0e07c',
      },
      '0x03281b6f11d943157a973cdb6b39b747501bdbba': {
        address: '0x03281b6f11d943157a973cdb6b39b747501bdbba',
        chainId: 146,
        type: 'LP',
        symbol: 'WS/ECO',
        decimals: 18,
        totalSupply: '79439967001520169720595',
        token0: '0x039e2fb66102314ce7b64ce5ce3e5183bc94ad38',
        token1: '0x7a08bf5304094ca4c7b4132ef62b5edc4a3478b7',
        priceInUsd: 0.24667491347200665,
      },
      '0xb6d9b069f6b96a507243d501d1a23b3fccfc85d3': {
        address: '0xb6d9b069f6b96a507243d501d1a23b3fccfc85d3',
        chainId: 146,
        type: 'ERC721-RAMSES',
        symbol: 'WS/WETH',
        decimals: 18,
        token0: '0x039e2fb66102314ce7b64ce5ce3e5183bc94ad38',
        token1: '0x50c42deacd8fc9773493ed674b675be577f2634b',
      },
      '0x1d64b681315839c83bf545b7a041f4e5111bee39': {
        address: '0x1d64b681315839c83bf545b7a041f4e5111bee39',
        chainId: 146,
        type: 'LP',
        symbol: 'WS/FMULTI',
        decimals: 18,
        totalSupply: '6295976270916329815532094',
        token0: '0x039e2fb66102314ce7b64ce5ce3e5183bc94ad38',
        token1: '0x39838b880ba948c49aab7253f61ce1e00c30c014',
        priceInUsd: 0.009460965369919465,
      },
      '0x350598c4c17ddc02049e34bfdf4555422d2d670e': {
        address: '0x350598c4c17ddc02049e34bfdf4555422d2d670e',
        chainId: 146,
        type: 'ERC721-RAMSES',
        symbol: 'SACRA/SCUSD',
        decimals: 18,
        token0: '0x7ad5935ea295c4e743e4f2f5b4cda951f41223c2',
        token1: '0xd3dce716f3ef535c5ff8d041c1a41c3bd89b97ae',
      },
      '0xddf26b42c1d903de8962d3f79a74a501420d5f19': {
        address: '0xddf26b42c1d903de8962d3f79a74a501420d5f19',
        chainId: 146,
        type: 'ERC20',
        symbol: 'EQUAL',
        decimals: 18,
        totalSupply: '5357336108985214806294796',
        priceInUsd: 0.4593305978656352,
      },
      '0x992e53cb4ba7c39deed1cfa3b6fa77863d6e82b0': {
        address: '0x992e53cb4ba7c39deed1cfa3b6fa77863d6e82b0',
        chainId: 146,
        type: 'LP',
        symbol: 'WS/WOOF',
        decimals: 18,
        totalSupply: '17196498252460105473386',
        token0: '0x039e2fb66102314ce7b64ce5ce3e5183bc94ad38',
        token1: '0x7f883da3b0d77978075f7c9c03e1b9f461ca1b8d',
        priceInUsd: 0.07628037489001811,
      },
      '0x8d2b12d0dc9bb13c62d213efbea10fd0bfce3c88': {
        address: '0x8d2b12d0dc9bb13c62d213efbea10fd0bfce3c88',
        chainId: 146,
        type: 'LP',
        symbol: 'WS/WHALE',
        decimals: 18,
        totalSupply: '112064690197404410973093',
        token0: '0x039e2fb66102314ce7b64ce5ce3e5183bc94ad38',
        token1: '0x068e9e009fda970fa953e1f6a43d982ca991f4ba',
        priceInUsd: 0.09125286693590044,
      },
      '0xa6c957e9cee712b098160dcbadcfb32a2cb75437': {
        address: '0xa6c957e9cee712b098160dcbadcfb32a2cb75437',
        chainId: 146,
        type: 'LP',
        symbol: 'WS/⚡',
        decimals: 18,
        totalSupply: '44271865106408155480656',
        token0: '0x039e2fb66102314ce7b64ce5ce3e5183bc94ad38',
        token1: '0xea23c49c156ea501ce60151ad5febea52d5686b9',
        priceInUsd: 0.04014429781703672,
      },
      '0xe45a270b10cfed62ba586d3f1b72b36989a623ba': {
        address: '0xe45a270b10cfed62ba586d3f1b72b36989a623ba',
        chainId: 146,
        type: 'ERC721-NATIVE',
        symbol: 'WS/WETH',
        decimals: 18,
        token0: '0x039e2fb66102314ce7b64ce5ce3e5183bc94ad38',
        token1: '0x50c42deacd8fc9773493ed674b675be577f2634b',
      },
      '0x00b62a8edd7b440b5ce29613e872fc8dfe15f2db': {
        address: '0x00b62a8edd7b440b5ce29613e872fc8dfe15f2db',
        chainId: 146,
        type: 'ERC721-NATIVE',
        symbol: 'WS/JOINT',
        decimals: 18,
        token0: '0x039e2fb66102314ce7b64ce5ce3e5183bc94ad38',
        token1: '0xc046dcb16592fbb3f9fa0c629b8d93090dd4cb76',
      },
      '0xbeca246a76942502f61bfe88f60bbc87dafefe80': {
        address: '0xbeca246a76942502f61bfe88f60bbc87dafefe80',
        chainId: 146,
        type: 'ERC721-ALGEBRA',
        symbol: 'WS/SWPX',
        decimals: 18,
        token0: '0x039e2fb66102314ce7b64ce5ce3e5183bc94ad38',
        token1: '0xa04bc7140c26fc9bb1f36b1a604c7a5a88fb0e70',
      },
      '0xcf0a945ed064ac32ec8d178f865f650a9f9a2fdb': {
        address: '0xcf0a945ed064ac32ec8d178f865f650a9f9a2fdb',
        chainId: 146,
        type: 'ERC721-RAMSES',
        symbol: 'WS/X33',
        decimals: 18,
        token0: '0x039e2fb66102314ce7b64ce5ce3e5183bc94ad38',
        token1: '0x3333111a391cc08fa51353e9195526a70b333333',
      },
      '0xdd35c88b1754879ef86bbf3a24f81fcca5eb6b5d': {
        address: '0xdd35c88b1754879ef86bbf3a24f81fcca5eb6b5d',
        chainId: 146,
        type: 'ERC721-ALGEBRA',
        symbol: 'USDC.E/SCUSD',
        decimals: 18,
        token0: '0x29219dd400f2bf60e5a23d13be72b486d4038894',
        token1: '0xd3dce716f3ef535c5ff8d041c1a41c3bd89b97ae',
      },
      '0x9c2a7bb01951be15fe835886188fa13255ef9486': {
        address: '0x9c2a7bb01951be15fe835886188fa13255ef9486',
        chainId: 146,
        type: 'ERC721-ALGEBRA',
        symbol: 'WETH/SWPX',
        decimals: 18,
        token0: '0x50c42deacd8fc9773493ed674b675be577f2634b',
        token1: '0xa04bc7140c26fc9bb1f36b1a604c7a5a88fb0e70',
      },
      '0x24f5cd888057a721f1acd7cba1afa7a8384c3e12': {
        address: '0x24f5cd888057a721f1acd7cba1afa7a8384c3e12',
        chainId: 146,
        type: 'LP',
        symbol: 'WS/TYSG',
        decimals: 18,
        totalSupply: '720368966371',
        token0: '0x039e2fb66102314ce7b64ce5ce3e5183bc94ad38',
        token1: '0x56192e94434c4fd3278b4fa53039293fb00de3db',
        priceInUsd: 10755065747.769522,
      },
      '0x17af1df44444ab9091622e4aa66db5bb34e51ad5': {
        address: '0x17af1df44444ab9091622e4aa66db5bb34e51ad5',
        chainId: 146,
        type: 'ERC20',
        symbol: 'THC',
        decimals: 18,
        totalSupply: '23333332310000000000000000',
        priceInUsd: 0.023334052496655447,
      },
      '0x6201175832e1313892f86c43806813515ad5abd2': {
        address: '0x6201175832e1313892f86c43806813515ad5abd2',
        chainId: 146,
        type: 'LP',
        symbol: 'WS/HAWG',
        decimals: 18,
        totalSupply: '2430577551104387926713',
        token0: '0x039e2fb66102314ce7b64ce5ce3e5183bc94ad38',
        token1: '0x1cefa23c160ba7f11fd770d51822254238dba3e5',
        priceInUsd: 1.21696019788298,
      },
      '0x5555b2733602ded58d47b8d3d989e631cbee5555': {
        address: '0x5555b2733602ded58d47b8d3d989e631cbee5555',
        chainId: 146,
        type: 'ERC20',
        symbol: 'GEMS',
        decimals: 18,
        totalSupply: '2320925133348580903578',
        priceInUsd: 21.060494225824055,
      },
      '0x25f746bb206041ed8da6f08ed1d32454a5856d37': {
        address: '0x25f746bb206041ed8da6f08ed1d32454a5856d37',
        chainId: 146,
        type: 'ERC721-NATIVE',
        symbol: 'WS/USDC.E',
        decimals: 18,
        token0: '0x039e2fb66102314ce7b64ce5ce3e5183bc94ad38',
        token1: '0x29219dd400f2bf60e5a23d13be72b486d4038894',
      },
      '0x324963c267c354c7660ce8ca3f5f167e05649970': {
        address: '0x324963c267c354c7660ce8ca3f5f167e05649970',
        chainId: 146,
        type: 'ERC721-RAMSES',
        symbol: 'WS/USDC.E',
        decimals: 18,
        token0: '0x039e2fb66102314ce7b64ce5ce3e5183bc94ad38',
        token1: '0x29219dd400f2bf60e5a23d13be72b486d4038894',
      },
      '0x467865e7ce29e7ed8f362d51fd7141117b234b44': {
        address: '0x467865e7ce29e7ed8f362d51fd7141117b234b44',
        chainId: 146,
        type: 'ERC721-ALGEBRA',
        symbol: 'USDC.E/SWPX',
        decimals: 18,
        token0: '0x29219dd400f2bf60e5a23d13be72b486d4038894',
        token1: '0xa04bc7140c26fc9bb1f36b1a604c7a5a88fb0e70',
      },
      '0x3e6daa42268a5097de68ab39e48b860b9b55f589': {
        address: '0x3e6daa42268a5097de68ab39e48b860b9b55f589',
        chainId: 146,
        type: 'LP',
        symbol: 'WS/THC',
        decimals: 18,
        totalSupply: '276649830001614719475877',
        token0: '0x039e2fb66102314ce7b64ce5ce3e5183bc94ad38',
        token1: '0x17af1df44444ab9091622e4aa66db5bb34e51ad5',
        priceInUsd: 0.15353353070369025,
      },
      '0xb75c9073ea00abda9ff420b5ae46fee248993380': {
        address: '0xb75c9073ea00abda9ff420b5ae46fee248993380',
        chainId: 146,
        type: 'LP',
        symbol: 'WS/STS',
        decimals: 18,
        totalSupply: '36278156661612092668447',
        token0: '0x039e2fb66102314ce7b64ce5ce3e5183bc94ad38',
        token1: '0xe5da20f15420ad15de0fa650600afc998bbe3955',
        priceInUsd: 0.5118953777487921,
      },
      '0x8d0c7fe4814afa5428c79ae6915e44738cc3a39a': {
        address: '0x8d0c7fe4814afa5428c79ae6915e44738cc3a39a',
        chainId: 146,
        type: 'ERC721-RAMSES',
        symbol: 'WS/SGOAT',
        decimals: 18,
        token0: '0x039e2fb66102314ce7b64ce5ce3e5183bc94ad38',
        token1: '0x43f9a13675e352154f745d6402e853fecc388aa5',
      },
      '0x5ddbef774488cc68266d5f15bfb08eaa7cd513f9': {
        address: '0x5ddbef774488cc68266d5f15bfb08eaa7cd513f9',
        chainId: 146,
        type: 'ERC721-ALGEBRA',
        symbol: 'USDC.E/STS',
        decimals: 18,
        token0: '0x29219dd400f2bf60e5a23d13be72b486d4038894',
        token1: '0xe5da20f15420ad15de0fa650600afc998bbe3955',
      },
      '0xbf23e7fc58b7094d17fe52ef8bde979aa06b8916': {
        address: '0xbf23e7fc58b7094d17fe52ef8bde979aa06b8916',
        chainId: 146,
        type: 'LP',
        symbol: 'WS/SDOG',
        decimals: 18,
        totalSupply: '268745271894732011322781',
        token0: '0x039e2fb66102314ce7b64ce5ce3e5183bc94ad38',
        token1: '0x50bc6e1dff8039a4b967c1bf507ba5ea13fa18b6',
        priceInUsd: 0.037298698945575276,
      },
      '0xe8b696fb500c2a3b1faa5e0fce4d53d6ad26765f': {
        address: '0xe8b696fb500c2a3b1faa5e0fce4d53d6ad26765f',
        chainId: 146,
        type: 'LP',
        symbol: 'USDC.E/X33',
        decimals: 18,
        totalSupply: '3037306245506630',
        token0: '0x29219dd400f2bf60e5a23d13be72b486d4038894',
        token1: '0x3333111a391cc08fa51353e9195526a70b333333',
        priceInUsd: 8349782.877856109,
      },
      '0x31e2eed04a62b232da964a097d8c171584e3c3bd': {
        address: '0x31e2eed04a62b232da964a097d8c171584e3c3bd',
        chainId: 146,
        type: 'ERC20',
        symbol: 'OIL',
        decimals: 18,
        totalSupply: '24204858967907175011861201',
        priceInUsd: 0.0001827855493735745,
      },
      '0x6d9b4d31c66291c13f33ae1b2d8c1a5be8a77c4f': {
        address: '0x6d9b4d31c66291c13f33ae1b2d8c1a5be8a77c4f',
        chainId: 146,
        type: 'LP',
        symbol: 'WS/MOON',
        decimals: 18,
        totalSupply: '1482919987649793144189961',
        token0: '0x039e2fb66102314ce7b64ce5ce3e5183bc94ad38',
        token1: '0x486b6fa0419b33a0c7a6e4698c231d7e2f2d5299',
        priceInUsd: 0.027906269615276102,
      },
      '0x61974f520630b11e2af36e2c92cf0c0920dd487a': {
        address: '0x61974f520630b11e2af36e2c92cf0c0920dd487a',
        chainId: 146,
        type: 'LP',
        symbol: 'WS/WOOF',
        decimals: 18,
        totalSupply: '155434770532295',
        token0: '0x039e2fb66102314ce7b64ce5ce3e5183bc94ad38',
        token1: '0x7f883da3b0d77978075f7c9c03e1b9f461ca1b8d',
        priceInUsd: 108847688.4297965,
      },
      '0xc2c3beb4bceb9b37d2b4b5eea3b7810858b3b68c': {
        address: '0xc2c3beb4bceb9b37d2b4b5eea3b7810858b3b68c',
        chainId: 146,
        type: 'LP',
        symbol: 'WS/FBUX',
        decimals: 18,
        totalSupply: '9000425997906292720589',
        token0: '0x039e2fb66102314ce7b64ce5ce3e5183bc94ad38',
        token1: '0xd43b5d6899635e514a00b475eea04c364979e076',
        priceInUsd: 0.003140957107580317,
      },
      '0x3333111a391cc08fa51353e9195526a70b333333': {
        address: '0x3333111a391cc08fa51353e9195526a70b333333',
        chainId: 146,
        type: 'ERC20',
        symbol: 'X33',
        decimals: 18,
        totalSupply: '614350293774813286608191',
        priceInUsd: 13.133833784407413,
      },
      '0x66af3655e14a045f1742b3c9544553ef7915ed35': {
        address: '0x66af3655e14a045f1742b3c9544553ef7915ed35',
        chainId: 146,
        type: 'ERC721-RAMSES',
        symbol: 'SHADOW/STS',
        decimals: 18,
        token0: '0x3333b97138d4b086720b5ae8a7844b1345a33333',
        token1: '0xe5da20f15420ad15de0fa650600afc998bbe3955',
      },
      '0x8218825e5964e17d872adcefa4c72d73c0d44021': {
        address: '0x8218825e5964e17d872adcefa4c72d73c0d44021',
        chainId: 146,
        type: 'LP',
        symbol: 'WS/MOON',
        decimals: 18,
        totalSupply: '277349025437130464473513',
        token0: '0x039e2fb66102314ce7b64ce5ce3e5183bc94ad38',
        token1: '0x486b6fa0419b33a0c7a6e4698c231d7e2f2d5299',
        priceInUsd: 0.0279062382793823,
      },
      '0xcb63f3d4deb888aa3f5bf6f3eea095ce59e10a70': {
        address: '0xcb63f3d4deb888aa3f5bf6f3eea095ce59e10a70',
        chainId: 146,
        type: 'ERC721-NATIVE',
        symbol: '$STONER/JOINT',
        decimals: 18,
        token0: '0x9b567e03d891f537b2b7874aa4a3308cfe2f4fbb',
        token1: '0xc046dcb16592fbb3f9fa0c629b8d93090dd4cb76',
      },
      '0x297000941c155962b04760ecaeaa422757f20bc1': {
        address: '0x297000941c155962b04760ecaeaa422757f20bc1',
        chainId: 146,
        type: 'ERC721-NATIVE',
        symbol: 'WS/ANON',
        decimals: 18,
        token0: '0x039e2fb66102314ce7b64ce5ce3e5183bc94ad38',
        token1: '0x79bbf4508b1391af3a0f4b30bb5fc4aa9ab0e07c',
      },
      '0xe72b6dd415cdaceac76616df2c9278b33079e0d3': {
        address: '0xe72b6dd415cdaceac76616df2c9278b33079e0d3',
        chainId: 146,
        type: 'ERC721-NATIVE',
        symbol: 'WS/USDC.E',
        decimals: 18,
        token0: '0x039e2fb66102314ce7b64ce5ce3e5183bc94ad38',
        token1: '0x29219dd400f2bf60e5a23d13be72b486d4038894',
      },
      '0xde861c8fc9ab78fe00490c5a38813d26e2d09c95': {
        address: '0xde861c8fc9ab78fe00490c5a38813d26e2d09c95',
        chainId: 146,
        type: 'ERC721-RAMSES',
        symbol: 'WS/STS',
        decimals: 18,
        token0: '0x039e2fb66102314ce7b64ce5ce3e5183bc94ad38',
        token1: '0xe5da20f15420ad15de0fa650600afc998bbe3955',
      },
      '0x7432d8e46d1e72f7af15247b36909e3eb6319931': {
        address: '0x7432d8e46d1e72f7af15247b36909e3eb6319931',
        chainId: 146,
        type: 'LP',
        symbol: 'WS/BOL',
        decimals: 18,
        totalSupply: '184270301041779631477005',
        token0: '0x039e2fb66102314ce7b64ce5ce3e5183bc94ad38',
        token1: '0x38628cb4cc74cbdfb6ddd877b17c1f60fcae7c2c',
        priceInUsd: 0.04478064164476256,
      },
      '0x8f76e0deb376d81fd75028d47de0da7af0a5547e': {
        address: '0x8f76e0deb376d81fd75028d47de0da7af0a5547e',
        chainId: 146,
        type: 'ERC721-NATIVE',
        symbol: 'WAGMI/ANON',
        decimals: 18,
        token0: '0x0e0ce4d450c705f8a0b6dd9d5123e3df2787d16b',
        token1: '0x79bbf4508b1391af3a0f4b30bb5fc4aa9ab0e07c',
      },
      '0x875819746112630cee95aa78e4327cd4837da70d': {
        address: '0x875819746112630cee95aa78e4327cd4837da70d',
        chainId: 146,
        type: 'ERC721-ALGEBRA',
        symbol: 'WS/SACRA',
        decimals: 18,
        token0: '0x039e2fb66102314ce7b64ce5ce3e5183bc94ad38',
        token1: '0x7ad5935ea295c4e743e4f2f5b4cda951f41223c2',
      },
      '0x4b478f2d431e955f11c61b319351cbfd5053f1b6': {
        address: '0x4b478f2d431e955f11c61b319351cbfd5053f1b6',
        chainId: 146,
        type: 'ERC721-RAMSES',
        symbol: 'X33/SHADOW',
        decimals: 18,
        token0: '0x3333111a391cc08fa51353e9195526a70b333333',
        token1: '0x3333b97138d4b086720b5ae8a7844b1345a33333',
      },
      '0xe6aa7ca47ddb6203e71d4d1497959da51f87aa98': {
        address: '0xe6aa7ca47ddb6203e71d4d1497959da51f87aa98',
        chainId: 146,
        type: 'LP',
        symbol: 'WS/GOGLZ',
        decimals: 18,
        totalSupply: '38413546905199966695639',
        token0: '0x039e2fb66102314ce7b64ce5ce3e5183bc94ad38',
        token1: '0x9fdbc3f8abc05fa8f3ad3c17d2f806c1230c4564',
        priceInUsd: 0.27576425638387864,
      },
      '0x14d1db2367312ee3bba54905b64f3bf0f0d677a8': {
        address: '0x14d1db2367312ee3bba54905b64f3bf0f0d677a8',
        chainId: 146,
        type: 'ERC20',
        symbol: 'XHUBBLE',
        decimals: 18,
        totalSupply: '183668244851515661650389',
        priceInUsd: 1.6785541984567278,
      },
      '0x95f808cc1e83dba7818dd728fe720b2a8088ff61': {
        address: '0x95f808cc1e83dba7818dd728fe720b2a8088ff61',
        chainId: 146,
        type: 'ERC721-RAMSES',
        symbol: 'WS/GEMS',
        decimals: 18,
        token0: '0x039e2fb66102314ce7b64ce5ce3e5183bc94ad38',
        token1: '0x5555b2733602ded58d47b8d3d989e631cbee5555',
      },
      '0xbb528a050a3b3b998a9651f893fa46162967a04c': {
        address: '0xbb528a050a3b3b998a9651f893fa46162967a04c',
        chainId: 146,
        type: 'ERC721-RAMSES',
        symbol: 'X33/SHADOW',
        decimals: 18,
        token0: '0x3333111a391cc08fa51353e9195526a70b333333',
        token1: '0x3333b97138d4b086720b5ae8a7844b1345a33333',
      },
      '0x29219dd400f2bf60e5a23d13be72b486d4038894': {
        address: '0x29219dd400f2bf60e5a23d13be72b486d4038894',
        chainId: 146,
        type: 'ERC20',
        symbol: 'USDC.E',
        decimals: 6,
        totalSupply: '107809765735442',
        priceInUsd: 0.9945957913700029,
      },
      '0xad88149c1030d7544f244958f4889b5eda49a381': {
        address: '0xad88149c1030d7544f244958f4889b5eda49a381',
        chainId: 146,
        type: 'LP',
        symbol: 'WS/FIERY',
        decimals: 18,
        totalSupply: '6049923141876419919001',
        token0: '0x039e2fb66102314ce7b64ce5ce3e5183bc94ad38',
        token1: '0xf97d438bc03ad0f75b83ce5714c9619880b305bc',
        priceInUsd: 0.009630337998997622,
      },
      '0x3d31f9d80211a8cae138aeedceb36d571b16803f': {
        address: '0x3d31f9d80211a8cae138aeedceb36d571b16803f',
        chainId: 146,
        type: 'ERC721-NATIVE',
        symbol: 'WS/SPUB',
        decimals: 18,
        token0: '0x039e2fb66102314ce7b64ce5ce3e5183bc94ad38',
        token1: '0xb5a10bd15af95381d830f71e85328f2d1d823de7',
      },
      '0x1f4efc47e5a5ab6539d95a76e2dde6d74462acea': {
        address: '0x1f4efc47e5a5ab6539d95a76e2dde6d74462acea',
        chainId: 146,
        type: 'ERC721-RAMSES',
        symbol: 'WS/GOGLZ',
        decimals: 18,
        token0: '0x039e2fb66102314ce7b64ce5ce3e5183bc94ad38',
        token1: '0x9fdbc3f8abc05fa8f3ad3c17d2f806c1230c4564',
      },
      '0xb8bda81eccb1a21198899ac8f1f2f73c82bd7695': {
        address: '0xb8bda81eccb1a21198899ac8f1f2f73c82bd7695',
        chainId: 146,
        type: 'ERC721-RAMSES',
        symbol: 'WS/BRUSH',
        decimals: 18,
        token0: '0x039e2fb66102314ce7b64ce5ce3e5183bc94ad38',
        token1: '0xe51ee9868c1f0d6cd968a8b8c8376dc2991bfe44',
      },
      '0x822b6e8d0a3eaf306a6a604f6af370f6d893292d': {
        address: '0x822b6e8d0a3eaf306a6a604f6af370f6d893292d',
        chainId: 146,
        type: 'LP',
        symbol: 'WS/FSONIC',
        decimals: 18,
        totalSupply: '3596857131622510881880351',
        token0: '0x039e2fb66102314ce7b64ce5ce3e5183bc94ad38',
        token1: '0x05e31a691405d06708a355c029599c12d5da8b28',
        priceInUsd: 0.017714516371814412,
      },
      '0xa76beaf111bad5dd866fa4835d66b9aa2eb1fdec': {
        address: '0xa76beaf111bad5dd866fa4835d66b9aa2eb1fdec',
        chainId: 146,
        type: 'ERC721-ALGEBRA',
        symbol: 'WS/OS',
        decimals: 18,
        token0: '0x039e2fb66102314ce7b64ce5ce3e5183bc94ad38',
        token1: '0xb1e25689d55734fd3fffc939c4c3eb52dff8a794',
      },
      '0xc95b82d389c6a0ea9e12c7e05e5a6be939bb2afb': {
        address: '0xc95b82d389c6a0ea9e12c7e05e5a6be939bb2afb',
        chainId: 146,
        type: 'LP',
        symbol: 'WS/RUGGIE',
        decimals: 18,
        totalSupply: '4662343332878117825',
        token0: '0x039e2fb66102314ce7b64ce5ce3e5183bc94ad38',
        token1: '0xb2a909b8bcce9b30bbc9d4c748fd897d6ad9c285',
        priceInUsd: 0.0011353077497729949,
      },
      '0x3fccdda302b23f3741df05e698d1300a346d92b1': {
        address: '0x3fccdda302b23f3741df05e698d1300a346d92b1',
        chainId: 146,
        type: 'ERC721-RAMSES',
        symbol: 'USDC.E/X33',
        decimals: 18,
        token0: '0x29219dd400f2bf60e5a23d13be72b486d4038894',
        token1: '0x3333111a391cc08fa51353e9195526a70b333333',
      },
      '0xc363bb3fc74917a31c5244d28edd332b7b2f9bdc': {
        address: '0xc363bb3fc74917a31c5244d28edd332b7b2f9bdc',
        chainId: 146,
        type: 'ERC721-NATIVE',
        symbol: 'WS/SBEER',
        decimals: 18,
        token0: '0x039e2fb66102314ce7b64ce5ce3e5183bc94ad38',
        token1: '0x93cd403693da40d27188714a872943f717e3c543',
      },
      '0x38cfa6cb37d074b6e954c52d10a4cf0e4268607b': {
        address: '0x38cfa6cb37d074b6e954c52d10a4cf0e4268607b',
        chainId: 146,
        type: 'LP',
        symbol: 'WS/BRUSH',
        decimals: 18,
        totalSupply: '667008802519886294986244',
        token0: '0x039e2fb66102314ce7b64ce5ce3e5183bc94ad38',
        token1: '0xe51ee9868c1f0d6cd968a8b8c8376dc2991bfe44',
        priceInUsd: 0.08872116789046407,
      },
    },
    '169': {
      '0xd6359083da64e79ad7c54106ee71a889268f0462': {
        address: '0xd6359083da64e79ad7c54106ee71a889268f0462',
        chainId: 169,
        type: 'LP',
        symbol: 'WETH/USDC',
        decimals: 18,
        totalSupply: '12106269841951',
        token0: '0x0dc808adce2099a9f62aa87d9670745aba741746',
        token1: '0xb73603c5d87fa094b7314c74ace2e64d165016fb',
        priceInUsd: 128904943.14414427,
      },
      '0x462609c41ca27bd4240778c53c0908542b59b972': {
        address: '0x462609c41ca27bd4240778c53c0908542b59b972',
        chainId: 169,
        type: 'ERC721-NATIVE',
        symbol: 'USDC/USDT',
        decimals: 18,
        token0: '0xb73603c5d87fa094b7314c74ace2e64d165016fb',
        token1: '0xf417f5a458ec102b90352f697d6e2ac3a3d2851f',
      },
      '0x3838753b9b9b7cf26ddc71d0f1a0ee0b9144aba5': {
        address: '0x3838753b9b9b7cf26ddc71d0f1a0ee0b9144aba5',
        chainId: 169,
        type: 'LP',
        symbol: 'USDEX+/USDC',
        decimals: 18,
        totalSupply: '2454986174771984',
        token0: '0x6da9ebd271a0676f39c088a2b5fd849d5080c0af',
        token1: '0xb73603c5d87fa094b7314c74ace2e64d165016fb',
        priceInUsd: 932464.5775549964,
      },
      '0xd7f09148eb22686cb5dcbdd0cf27d04123d14c74': {
        address: '0xd7f09148eb22686cb5dcbdd0cf27d04123d14c74',
        chainId: 169,
        type: 'ERC721-NATIVE',
        symbol: 'WETH/USDC',
        decimals: 18,
        token0: '0x0dc808adce2099a9f62aa87d9670745aba741746',
        token1: '0xb73603c5d87fa094b7314c74ace2e64d165016fb',
      },
      '0x66e354c61f877574a97c501335e1fe93da114f24': {
        address: '0x66e354c61f877574a97c501335e1fe93da114f24',
        chainId: 169,
        type: 'ERC721-NATIVE',
        symbol: 'WETH/MANTA',
        decimals: 18,
        token0: '0x0dc808adce2099a9f62aa87d9670745aba741746',
        token1: '0x95cef13441be50d20ca4558cc0a27b601ac544e5',
      },
      '0x05db409bc3c2629e2987dc7aa87c39376bc49477': {
        address: '0x05db409bc3c2629e2987dc7aa87c39376bc49477',
        chainId: 169,
        type: 'LP',
        symbol: 'WETH/STONE',
        decimals: 18,
        totalSupply: '276897070767792401',
        token0: '0x0dc808adce2099a9f62aa87d9670745aba741746',
        token1: '0xec901da9c68e90798bbbb74c11406a32a70652c3',
        priceInUsd: 8504.632859081634,
      },
      '0x6c72baee6d7074e54add3f617ec5d6b22afe779b': {
        address: '0x6c72baee6d7074e54add3f617ec5d6b22afe779b',
        chainId: 169,
        type: 'LP',
        symbol: 'WETH/CETO',
        decimals: 18,
        totalSupply: '656090321466243318666',
        token0: '0x0dc808adce2099a9f62aa87d9670745aba741746',
        token1: '0x3af03e8c993900f0ea6b84217071e1d4cc783982',
        priceInUsd: 1.8479358577940903,
      },
      '0x8f0111df7d48c9117d44b9cedfc23f160e3311f3': {
        address: '0x8f0111df7d48c9117d44b9cedfc23f160e3311f3',
        chainId: 169,
        type: 'ERC721-NATIVE',
        symbol: 'WETH/MANTA',
        decimals: 18,
        token0: '0x0dc808adce2099a9f62aa87d9670745aba741746',
        token1: '0x95cef13441be50d20ca4558cc0a27b601ac544e5',
      },
      '0x3af03e8c993900f0ea6b84217071e1d4cc783982': {
        address: '0x3af03e8c993900f0ea6b84217071e1d4cc783982',
        chainId: 169,
        type: 'ERC20',
        symbol: 'CETO',
        decimals: 18,
        totalSupply: '14310034066805829837812308',
        priceInUsd: 0.00020458272977757913,
      },
      '0x97433019b560c1c20055ba5edc8eef226f2d1be7': {
        address: '0x97433019b560c1c20055ba5edc8eef226f2d1be7',
        chainId: 169,
        type: 'ERC721-NATIVE',
        symbol: 'WETH/MANTA',
        decimals: 18,
        token0: '0x0dc808adce2099a9f62aa87d9670745aba741746',
        token1: '0x95cef13441be50d20ca4558cc0a27b601ac544e5',
      },
      '0xef799451a28a1432712d19df82e512d985d685d4': {
        address: '0xef799451a28a1432712d19df82e512d985d685d4',
        chainId: 169,
        type: 'LP',
        symbol: 'CETO/USDEX+',
        decimals: 18,
        totalSupply: '32790745738307238903744',
        token0: '0x3af03e8c993900f0ea6b84217071e1d4cc783982',
        token1: '0x6da9ebd271a0676f39c088a2b5fd849d5080c0af',
        priceInUsd: 0.013354271593843732,
      },
      '0x8294b6e9a5ce9d322b710c45d83e3a3cb1592199': {
        address: '0x8294b6e9a5ce9d322b710c45d83e3a3cb1592199',
        chainId: 169,
        type: 'ERC721-NATIVE',
        symbol: 'WETH/STONE',
        decimals: 18,
        token0: '0x0dc808adce2099a9f62aa87d9670745aba741746',
        token1: '0xec901da9c68e90798bbbb74c11406a32a70652c3',
      },
      '0x3afed5925034bb3b730ffdae6d98b6df45c0ff74': {
        address: '0x3afed5925034bb3b730ffdae6d98b6df45c0ff74',
        chainId: 169,
        type: 'LP',
        symbol: 'WETH/BCETO',
        decimals: 18,
        totalSupply: '864006806216100881542',
        token0: '0x0dc808adce2099a9f62aa87d9670745aba741746',
        token1: '0xe68874e57224d1e4e6d4c6b4cf5af7ca51867611',
        priceInUsd: 1.7073848383080468,
      },
      '0x12cdded759b14bf6a34fbf6638aec9b735824a9e': {
        address: '0x12cdded759b14bf6a34fbf6638aec9b735824a9e',
        chainId: 169,
        type: 'ERC721-NATIVE',
        symbol: 'WETH/USDC',
        decimals: 18,
        token0: '0x0dc808adce2099a9f62aa87d9670745aba741746',
        token1: '0xb73603c5d87fa094b7314c74ace2e64d165016fb',
      },
      '0xb9454b5fc78c826cf028f4e513b0e0a4d2bf51a9': {
        address: '0xb9454b5fc78c826cf028f4e513b0e0a4d2bf51a9',
        chainId: 169,
        type: 'LP',
        symbol: 'WETH/MANTA',
        decimals: 18,
        totalSupply: '11566167053513993758',
        token0: '0x0dc808adce2099a9f62aa87d9670745aba741746',
        token1: '0x95cef13441be50d20ca4558cc0a27b601ac544e5',
        priceInUsd: 55.879609658690974,
      },
      '0xfc9ffc1c6e0ebf7be3ce93245b309f4d3b593101': {
        address: '0xfc9ffc1c6e0ebf7be3ce93245b309f4d3b593101',
        chainId: 169,
        type: 'ERC721-NATIVE',
        symbol: 'WETH/WBTC',
        decimals: 18,
        token0: '0x0dc808adce2099a9f62aa87d9670745aba741746',
        token1: '0x305e88d809c9dc03179554bfbf85ac05ce8f18d6',
      },
      '0x02b25ffb7269fc167f8959de9a1bcd4213c06aaf': {
        address: '0x02b25ffb7269fc167f8959de9a1bcd4213c06aaf',
        chainId: 169,
        type: 'ERC721-NATIVE',
        symbol: 'WETH/STONE',
        decimals: 18,
        token0: '0x0dc808adce2099a9f62aa87d9670745aba741746',
        token1: '0xec901da9c68e90798bbbb74c11406a32a70652c3',
      },
      '0x75791775dc127d4441ecc532be128214ca4c6f72': {
        address: '0x75791775dc127d4441ecc532be128214ca4c6f72',
        chainId: 169,
        type: 'LP',
        symbol: 'STGAI/MANTA',
        decimals: 18,
        totalSupply: '153531051473096968896781',
        token0: '0x25f0beb8876859008d00d457fa2ae6493f0fe020',
        token1: '0x95cef13441be50d20ca4558cc0a27b601ac544e5',
        priceInUsd: 0.031558772199043246,
      },
    },
    '369': {
      '0x9095d464a29abd1b840c1c5205fb602ae5b011ff': {
        address: '0x9095d464a29abd1b840c1c5205fb602ae5b011ff',
        chainId: 369,
        type: 'LP',
        symbol: 'SDAI/SPARK',
        decimals: 18,
        totalSupply: '219725030953977629649042',
        token0: '0x30fcb23a906493371b1721c8feb8815804808d74',
        token1: '0x6386704cd6f7a584ea9d23ccca66af7eba5a727e',
        priceInUsd: 0.05208650496559012,
      },
      '0x2fa878ab3f87cc1c9737fc071108f904c0b0c95d': {
        address: '0x2fa878ab3f87cc1c9737fc071108f904c0b0c95d',
        chainId: 369,
        type: 'ERC20',
        symbol: 'INC',
        decimals: 18,
        totalSupply: '55598960721558318926243213',
        priceInUsd: 1.4479257901381328,
      },
      '0x633055aa25f33bbae94091bbb753dd3b1849de0e': {
        address: '0x633055aa25f33bbae94091bbb753dd3b1849de0e',
        chainId: 369,
        type: 'LP',
        symbol: '9INCH/NOPE',
        decimals: 18,
        totalSupply: '796026468781051816976001264',
        token0: '0x3ca80d83277e721171284667829c686527b8b3c5',
        token1: '0x8d36123903f504eb81eeb832727af517c0db26bd',
        priceInUsd: 3.113423907217109e-5,
      },
      '0xd3300f0bd587f0b9a77b62f74ea26fca1086618b': {
        address: '0xd3300f0bd587f0b9a77b62f74ea26fca1086618b',
        chainId: 369,
        type: 'LP',
        symbol: 'WETH/EMP',
        decimals: 18,
        totalSupply: '167508586794870013793',
        token0: '0x02dcdd04e3f455d838cd1249292c58f3b79e3c3c',
        token1: '0x9231937ac31506b6913ac5fb1db5a1c1ae83783a',
        priceInUsd: 3.0412422829757655,
      },
      '0x994e575563f8204d2ccc022e91dd91138b0506c2': {
        address: '0x994e575563f8204d2ccc022e91dd91138b0506c2',
        chainId: 369,
        type: 'LP',
        symbol: 'WPLS/TEDDY BEAR',
        decimals: 18,
        totalSupply: '1646942511699500717461497398',
        token0: '0xa1077a294dde1b09bb078844df40758a5d0f9a27',
        token1: '0xd6c31ba0754c4383a41c0e9df042c62b5e918f6d',
        priceInUsd: 2.189266924794703e-6,
      },
      '0xf3a8a528c6300cf1e70762c3695b9c60b5a79e15': {
        address: '0xf3a8a528c6300cf1e70762c3695b9c60b5a79e15',
        chainId: 369,
        type: 'LP',
        symbol: 'SDAI/USDEX+',
        decimals: 18,
        totalSupply: '19296086788445818516349',
        token0: '0x30fcb23a906493371b1721c8feb8815804808d74',
        token1: '0xaa2c47a35c1298795b5271490971ec4874c8e53d',
        priceInUsd: 1.0931378527519828,
      },
      '0xd98c555186bb218b0fe0967c417cce4ef6ba6859': {
        address: '0xd98c555186bb218b0fe0967c417cce4ef6ba6859',
        chainId: 369,
        type: 'LP',
        symbol: '9INCH/SOLIDX',
        decimals: 18,
        totalSupply: '793857264583547759240327',
        token0: '0x3ca80d83277e721171284667829c686527b8b3c5',
        token1: '0x8da17db850315a34532108f0f5458fc0401525f6',
        priceInUsd: 0.005920257361801237,
      },
      '0xa11e5d05295767fa83e8e7db3b6adea6bb67573a': {
        address: '0xa11e5d05295767fa83e8e7db3b6adea6bb67573a',
        chainId: 369,
        type: 'LP',
        symbol: 'BBC/AXIS',
        decimals: 18,
        totalSupply: '243200348776572780032',
        token0: '0x8b4cfb020af9acad95ad80020ce8f67fbb2c700e',
        token1: '0x8bdb63033b02c15f113de51ea1c3a96af9e8ecb5',
        priceInUsd: 11.080594424902808,
      },
      '0xb89ea01677529a8bbcece3a486404880f9463c45': {
        address: '0xb89ea01677529a8bbcece3a486404880f9463c45',
        chainId: 369,
        type: 'LP',
        symbol: 'PLSX/WPLS',
        decimals: 18,
        totalSupply: '1297841216197591176568503350',
        token0: '0x95b303987a60c71504d99aa1b13b4da07b0790ab',
        token1: '0xa1077a294dde1b09bb078844df40758a5d0f9a27',
        priceInUsd: 6.500023373263693e-5,
      },
      '0xbd1d593a038da65f247c8b3d5c445de9a031db53': {
        address: '0xbd1d593a038da65f247c8b3d5c445de9a031db53',
        chainId: 369,
        type: 'LP',
        symbol: 'WBTC/WPLS',
        decimals: 18,
        totalSupply: '273615799723094421',
        token0: '0x2260fac5e5542a773aa44fbcfedf7c193bc2c599',
        token1: '0xa1077a294dde1b09bb078844df40758a5d0f9a27',
        priceInUsd: 45059.52711751911,
      },
      '0x8e680888c29ae549f1cc293930d4fead8abb5bad': {
        address: '0x8e680888c29ae549f1cc293930d4fead8abb5bad',
        chainId: 369,
        type: 'LP',
        symbol: 'BBC/SOLIDX',
        decimals: 18,
        totalSupply: '14403096645030720880493',
        token0: '0x8b4cfb020af9acad95ad80020ce8f67fbb2c700e',
        token1: '0x8da17db850315a34532108f0f5458fc0401525f6',
        priceInUsd: 0.4763396866799914,
      },
      '0x31acf819060ae711f63bd6b682640598e250c689': {
        address: '0x31acf819060ae711f63bd6b682640598e250c689',
        chainId: 369,
        type: 'LP',
        symbol: '9INCH/DAI',
        decimals: 18,
        totalSupply: '14876223167735291318806360',
        token0: '0x3ca80d83277e721171284667829c686527b8b3c5',
        token1: '0xefd766ccb38eaf1dfd701853bfce31359239f305',
        priceInUsd: 0.0024768538742180927,
      },
      '0xe56043671df55de5cdf8459710433c10324de0ae': {
        address: '0xe56043671df55de5cdf8459710433c10324de0ae',
        chainId: 369,
        type: 'LP',
        symbol: 'WPLS/DAI',
        decimals: 18,
        totalSupply: '411677841566429823199732244',
        token0: '0xa1077a294dde1b09bb078844df40758a5d0f9a27',
        token1: '0xefd766ccb38eaf1dfd701853bfce31359239f305',
        priceInUsd: 0.01196453774366492,
      },
      '0xb543812ddebc017976f867da710ddb30cca22929': {
        address: '0xb543812ddebc017976f867da710ddb30cca22929',
        chainId: 369,
        type: 'LP',
        symbol: '9INCH/BBC',
        decimals: 18,
        totalSupply: '984713521330812128631230188',
        token0: '0x3ca80d83277e721171284667829c686527b8b3c5',
        token1: '0x8b4cfb020af9acad95ad80020ce8f67fbb2c700e',
        priceInUsd: 0.0001796517798752725,
      },
      '0x6c5a0f22b459973a0305e2a565fc208a35a13850': {
        address: '0x6c5a0f22b459973a0305e2a565fc208a35a13850',
        chainId: 369,
        type: 'LP',
        symbol: 'USDC/9INCH',
        decimals: 18,
        totalSupply: '11682065025186706434',
        token0: '0x15d38573d2feeb82e7ad5187ab8c1d52810b1f07',
        token1: '0x3ca80d83277e721171284667829c686527b8b3c5',
        priceInUsd: 2389.470068905271,
      },
      '0x52729266e890de1f9f83c462f5c9fbdeae78dbf9': {
        address: '0x52729266e890de1f9f83c462f5c9fbdeae78dbf9',
        chainId: 369,
        type: 'LP',
        symbol: 'WETH/DAI',
        decimals: 18,
        totalSupply: '6057998759117073103',
        token0: '0x02dcdd04e3f455d838cd1249292c58f3b79e3c3c',
        token1: '0xefd766ccb38eaf1dfd701853bfce31359239f305',
        priceInUsd: 130.68187892906838,
      },
      '0x6753560538eca67617a9ce605178f788be7e524e': {
        address: '0x6753560538eca67617a9ce605178f788be7e524e',
        chainId: 369,
        type: 'LP',
        symbol: 'USDC/WPLS',
        decimals: 18,
        totalSupply: '187469237560495069496',
        token0: '0x15d38573d2feeb82e7ad5187ab8c1d52810b1f07',
        token1: '0xa1077a294dde1b09bb078844df40758a5d0f9a27',
        priceInUsd: 12687.555404954246,
      },
      '0x207288d32a108dfa89733b6e7354da0a8e768973': {
        address: '0x207288d32a108dfa89733b6e7354da0a8e768973',
        chainId: 369,
        type: 'LP',
        symbol: 'SPARK/GOAT',
        decimals: 18,
        totalSupply: '580853255198119384240458',
        token0: '0x6386704cd6f7a584ea9d23ccca66af7eba5a727e',
        token1: '0xf5d0140b4d53c9476dc1488bc6d8597d7393f074',
        priceInUsd: 0.0005452068288601098,
      },
      '0x8b951eb284ec0d80e94bf19874740b59e7392275': {
        address: '0x8b951eb284ec0d80e94bf19874740b59e7392275',
        chainId: 369,
        type: 'LP',
        symbol: 'WPLS/BSPARK',
        decimals: 18,
        totalSupply: '39863289741749334323079211',
        token0: '0xa1077a294dde1b09bb078844df40758a5d0f9a27',
        token1: '0xfcff9ddd271c8dc3a00d6f7e9c9cfe0ff80e3732',
        priceInUsd: 0.0004228871752543235,
      },
      '0xd7b70d726cb370ac96eb6912db1f57a8df73267f': {
        address: '0xd7b70d726cb370ac96eb6912db1f57a8df73267f',
        chainId: 369,
        type: 'LP',
        symbol: 'WBTC/DAI',
        decimals: 18,
        totalSupply: '28607404984314545',
        token0: '0x2260fac5e5542a773aa44fbcfedf7c193bc2c599',
        token1: '0x6b175474e89094c44da98b954eedeac495271d0f',
        priceInUsd: 354290.6000349457,
      },
      '0x097d19b2061c5f31b68852349187c664920b4ba4': {
        address: '0x097d19b2061c5f31b68852349187c664920b4ba4',
        chainId: 369,
        type: 'LP',
        symbol: '9INCH/9INCH',
        decimals: 18,
        totalSupply: '56462295489005480630945899660',
        token0: '0x3ca80d83277e721171284667829c686527b8b3c5',
        token1: '0xed22494279e0f3f1ab491f823c6ec4055afeb21f',
        priceInUsd: 0,
      },
      '0x42abdfdb63f3282033c766e72cc4810738571609': {
        address: '0x42abdfdb63f3282033c766e72cc4810738571609',
        chainId: 369,
        type: 'LP',
        symbol: 'WETH/WPLS',
        decimals: 18,
        totalSupply: '6266685517047311886295470',
        token0: '0x02dcdd04e3f455d838cd1249292c58f3b79e3c3c',
        token1: '0xa1077a294dde1b09bb078844df40758a5d0f9a27',
        priceInUsd: 0.8060750919060515,
      },
      '0xdaa4b508e1a958038f0f0b1f2eac796a2fc17bb8': {
        address: '0xdaa4b508e1a958038f0f0b1f2eac796a2fc17bb8',
        chainId: 369,
        type: 'LP',
        symbol: 'AXIS/WPLS',
        decimals: 18,
        totalSupply: '2998929038432150122734',
        token0: '0x8bdb63033b02c15f113de51ea1c3a96af9e8ecb5',
        token1: '0xa1077a294dde1b09bb078844df40758a5d0f9a27',
        priceInUsd: 0.972306433326638,
      },
      '0x33208439e1b28b1d6fcfbb6334e9950027ee3b52': {
        address: '0x33208439e1b28b1d6fcfbb6334e9950027ee3b52',
        chainId: 369,
        type: 'LP',
        symbol: 'SPARK/WPLS',
        decimals: 18,
        totalSupply: '126493155213409580472133186',
        token0: '0x6386704cd6f7a584ea9d23ccca66af7eba5a727e',
        token1: '0xa1077a294dde1b09bb078844df40758a5d0f9a27',
        priceInUsd: 0.00042351800297842134,
      },
      '0x7dbeca4c74d01cd8782d4ef5c05c0769723fb0ea': {
        address: '0x7dbeca4c74d01cd8782d4ef5c05c0769723fb0ea',
        chainId: 369,
        type: 'LP',
        symbol: 'INC/PLSX',
        decimals: 18,
        totalSupply: '282829667671498637706915999',
        token0: '0x2fa878ab3f87cc1c9737fc071108f904c0b0c95d',
        token1: '0x95b303987a60c71504d99aa1b13b4da07b0790ab',
        priceInUsd: 0.011896212574585773,
      },
      '0x322df7921f28f1146cdf62afdac0d6bc0ab80711': {
        address: '0x322df7921f28f1146cdf62afdac0d6bc0ab80711',
        chainId: 369,
        type: 'LP',
        symbol: 'USDT/WPLS',
        decimals: 18,
        totalSupply: '151069951323657061024',
        token0: '0x0cb6f5a34ad42ec934882a05265a7d5f59b51a2f',
        token1: '0xa1077a294dde1b09bb078844df40758a5d0f9a27',
        priceInUsd: 12248.093968913552,
      },
      '0x898bb93f4629c73f0c519415a85d6bd2977cb0b5': {
        address: '0x898bb93f4629c73f0c519415a85d6bd2977cb0b5',
        chainId: 369,
        type: 'LP',
        symbol: '9INCH/PLSX',
        decimals: 18,
        totalSupply: '5573080135069067929100984867',
        token0: '0x3ca80d83277e721171284667829c686527b8b3c5',
        token1: '0x95b303987a60c71504d99aa1b13b4da07b0790ab',
        priceInUsd: 1.0791786593557205e-5,
      },
      '0x5449a776797b55a4aac0b4a76b2ac878bff3d3e3': {
        address: '0x5449a776797b55a4aac0b4a76b2ac878bff3d3e3',
        chainId: 369,
        type: 'LP',
        symbol: 'USDT/9INCH',
        decimals: 18,
        totalSupply: '11631319202201323588',
        token0: '0x0cb6f5a34ad42ec934882a05265a7d5f59b51a2f',
        token1: '0x3ca80d83277e721171284667829c686527b8b3c5',
        priceInUsd: 2369.212520422635,
      },
      '0x8948940e76efc27b5e3253ea30acc8e325a9cca2': {
        address: '0x8948940e76efc27b5e3253ea30acc8e325a9cca2',
        chainId: 369,
        type: 'LP',
        symbol: 'HEX/9INCH',
        decimals: 18,
        totalSupply: '388576854827300643055',
        token0: '0x2b591e99afe9f32eaa6214f7b7629768c40eeb39',
        token1: '0x3ca80d83277e721171284667829c686527b8b3c5',
        priceInUsd: 20.722656605206332,
      },
      '0x13f31a66a0f844d0bcfe1832a3c7096dd4bde79e': {
        address: '0x13f31a66a0f844d0bcfe1832a3c7096dd4bde79e',
        chainId: 369,
        type: 'LP',
        symbol: 'INC/BBC',
        decimals: 18,
        totalSupply: '17886120014279241567837',
        token0: '0x2fa878ab3f87cc1c9737fc071108f904c0b0c95d',
        token1: '0x8b4cfb020af9acad95ad80020ce8f67fbb2c700e',
        priceInUsd: 0.21632387853791035,
      },
      '0xf808bb6265e9ca27002c0a04562bf50d4fe37eaa': {
        address: '0xf808bb6265e9ca27002c0a04562bf50d4fe37eaa',
        chainId: 369,
        type: 'LP',
        symbol: 'INC/WPLS',
        decimals: 18,
        totalSupply: '169071490922345659446385667',
        token0: '0x2fa878ab3f87cc1c9737fc071108f904c0b0c95d',
        token1: '0xa1077a294dde1b09bb078844df40758a5d0f9a27',
        priceInUsd: 0.014496250791523895,
      },
      '0x1b45b9148791d3a104184cd5dfe5ce57193a3ee9': {
        address: '0x1b45b9148791d3a104184cd5dfe5ce57193a3ee9',
        chainId: 369,
        type: 'LP',
        symbol: 'PLSX/WPLS',
        decimals: 18,
        totalSupply: '136037731200968765693966348453',
        token0: '0x95b303987a60c71504d99aa1b13b4da07b0790ab',
        token1: '0xa1077a294dde1b09bb078844df40758a5d0f9a27',
        priceInUsd: 5.959400147744358e-5,
      },
      '0x6386704cd6f7a584ea9d23ccca66af7eba5a727e': {
        address: '0x6386704cd6f7a584ea9d23ccca66af7eba5a727e',
        chainId: 369,
        type: 'ERC20',
        symbol: 'SPARK',
        decimals: 18,
        totalSupply: '71346965343122843931342213',
        priceInUsd: 0.0012378227028921691,
      },
      '0xf34157a1aecfeef326c1c33d90802354abc5a702': {
        address: '0xf34157a1aecfeef326c1c33d90802354abc5a702',
        chainId: 369,
        type: 'LP',
        symbol: 'HEX/HEX',
        decimals: 18,
        totalSupply: '580077142468791',
        token0: '0x2b591e99afe9f32eaa6214f7b7629768c40eeb39',
        token1: '0x57fde0a71132198bbec939b98976993d8d89d225',
        priceInUsd: 0,
      },
      '0x1164dab36cd7036668ddcbb430f7e0b15416ef0b': {
        address: '0x1164dab36cd7036668ddcbb430f7e0b15416ef0b',
        chainId: 369,
        type: 'LP',
        symbol: '9INCH/WPLS',
        decimals: 18,
        totalSupply: '7965480233486715614547914669',
        token0: '0x3ca80d83277e721171284667829c686527b8b3c5',
        token1: '0xa1077a294dde1b09bb078844df40758a5d0f9a27',
        priceInUsd: 1.5460729927126128e-5,
      },
      '0x8356edc1d60b0ede626bc52980e708a604b0e861': {
        address: '0x8356edc1d60b0ede626bc52980e708a604b0e861',
        chainId: 369,
        type: 'LP',
        symbol: 'DAI/WPLS',
        decimals: 18,
        totalSupply: '33226535524377891808554744',
        token0: '0x6b175474e89094c44da98b954eedeac495271d0f',
        token1: '0xa1077a294dde1b09bb078844df40758a5d0f9a27',
        priceInUsd: 0.0016640589102979158,
      },
      '0x8b4cfb020af9acad95ad80020ce8f67fbb2c700e': {
        address: '0x8b4cfb020af9acad95ad80020ce8f67fbb2c700e',
        chainId: 369,
        type: 'ERC20',
        symbol: 'BBC',
        decimals: 18,
        totalSupply: '51691342426850093112963190',
        priceInUsd: 0.006376889371138919,
      },
      '0xd7e98780c10c9c716a87a7f76e76cb1d49556da1': {
        address: '0xd7e98780c10c9c716a87a7f76e76cb1d49556da1',
        chainId: 369,
        type: 'LP',
        symbol: 'WPLS/ATROPA',
        decimals: 18,
        totalSupply: '2821051329446983549625110',
        token0: '0xa1077a294dde1b09bb078844df40758a5d0f9a27',
        token1: '0xcc78a0acdf847a2c1714d2a925bb4477df5d48a6',
        priceInUsd: 0.0077189302266052725,
      },
      '0xf32b9398a7277609772f328fc2005d7da5420e77': {
        address: '0xf32b9398a7277609772f328fc2005d7da5420e77',
        chainId: 369,
        type: 'LP',
        symbol: 'SDAI/DAI',
        decimals: 18,
        totalSupply: '27798860004360191238535',
        token0: '0x30fcb23a906493371b1721c8feb8815804808d74',
        token1: '0xefd766ccb38eaf1dfd701853bfce31359239f305',
        priceInUsd: 1.4603978450566077,
      },
      '0xf1f4ee610b2babb05c635f726ef8b0c568c8dc65': {
        address: '0xf1f4ee610b2babb05c635f726ef8b0c568c8dc65',
        chainId: 369,
        type: 'LP',
        symbol: 'HEX/WPLS',
        decimals: 18,
        totalSupply: '25120574786368906992233',
        token0: '0x2b591e99afe9f32eaa6214f7b7629768c40eeb39',
        token1: '0xa1077a294dde1b09bb078844df40758a5d0f9a27',
        priceInUsd: 109.88234096247322,
      },
      '0xb823f30963511fb0a083073763f55d1285900c0c': {
        address: '0xb823f30963511fb0a083073763f55d1285900c0c',
        chainId: 369,
        type: 'LP',
        symbol: 'NOPE/WPLS',
        decimals: 18,
        totalSupply: '75326066062465565556637053',
        token0: '0x8d36123903f504eb81eeb832727af517c0db26bd',
        token1: '0xa1077a294dde1b09bb078844df40758a5d0f9a27',
        priceInUsd: 0.00021444615333506519,
      },
    },
    '8453': {
      '0xe22a2dfaaaaec8a7b2b7acb4909eaaa5c5bd6e64': {
        address: '0xe22a2dfaaaaec8a7b2b7acb4909eaaa5c5bd6e64',
        chainId: 8453,
        type: 'ERC721-NATIVE',
        symbol: 'NOGS/WETH',
        decimals: 18,
        token0: '0x13741c5df9ab03e7aa9fb3bf1f714551dd5a5f8a',
        token1: '0x4200000000000000000000000000000000000006',
      },
      '0x1d4dab3f27c7f656b6323c1d6ef713b48a8f72f1': {
        address: '0x1d4dab3f27c7f656b6323c1d6ef713b48a8f72f1',
        chainId: 8453,
        type: 'ERC721-NATIVE',
        symbol: 'VIRTUAL/WETH',
        decimals: 18,
        token0: '0x0b3e328455c4059eeb9e3f84b5543f74e24e7e1b',
        token1: '0x4200000000000000000000000000000000000006',
      },
      '0xbae6f0e8d43e6158d3df940b332adc75beeba75f': {
        address: '0xbae6f0e8d43e6158d3df940b332adc75beeba75f',
        chainId: 8453,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'SIMMI/WETH',
        decimals: 18,
        token0: '0x161e113b8e9bbaefb846f73f31624f6f9607bd44',
        token1: '0x4200000000000000000000000000000000000006',
      },
      '0x4a3636608d7bc5776cb19eb72caa36ebb9ea683b': {
        address: '0x4a3636608d7bc5776cb19eb72caa36ebb9ea683b',
        chainId: 8453,
        type: 'LP',
        symbol: 'USD+/USDBC',
        decimals: 18,
        totalSupply: '2698238753',
        token0: '0xb79dd08ea68a908a97220c76d19a6aa9cbde4376',
        token1: '0xd9aaec86b65d86f6a7b5b1b0c42ffa531710b6ca',
        priceInUsd: 1999543423112.0127,
      },
      '0xf471d220f16cc9c3400b5bd97d728072a87b9c75': {
        address: '0xf471d220f16cc9c3400b5bd97d728072a87b9c75',
        chainId: 8453,
        type: 'LP',
        symbol: 'BET/USDC',
        decimals: 18,
        totalSupply: '1226585815306039666',
        token0: '0x80f6bcedd3d4fa1035285affa30e38f464db3895',
        token1: '0x833589fcd6edb6e08f4c7c32d4f71b54bda02913',
        priceInUsd: 0,
      },
      '0xf3610a81ea40175346e272387498433fc27a8fda': {
        address: '0xf3610a81ea40175346e272387498433fc27a8fda',
        chainId: 8453,
        type: 'ERC721-NATIVE',
        symbol: 'HEIR/WETH',
        decimals: 18,
        token0: '0x01e75e59eabf83c85360351a100d22e025a75bc2',
        token1: '0x4200000000000000000000000000000000000006',
      },
      '0xc825c67ca3a80d487c339a6c16bb84f7dca16012': {
        address: '0xc825c67ca3a80d487c339a6c16bb84f7dca16012',
        chainId: 8453,
        type: 'LP',
        symbol: 'WETH/SCALE',
        decimals: 18,
        totalSupply: '561429403235844391033',
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0x54016a4848a38f257b6e96331f7404073fd9c32c',
        priceInUsd: 25.84815186388018,
      },
      '0x9d933f0af9dc01a6f9e5d2e6dcb25b6d0837ea81': {
        address: '0x9d933f0af9dc01a6f9e5d2e6dcb25b6d0837ea81',
        chainId: 8453,
        type: 'LP',
        symbol: 'WBASEDOGE/WETH',
        decimals: 18,
        totalSupply: '467339023656238841121449',
        token0: '0x373504da48418c67e6fcd071f33cb0b3b47613c7',
        token1: '0x4200000000000000000000000000000000000006',
        priceInUsd: 0.0677096989928119,
      },
      '0xb07d7eece8866e549601af5c7622d8cdbedc914e': {
        address: '0xb07d7eece8866e549601af5c7622d8cdbedc914e',
        chainId: 8453,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'EURC/CBBTC',
        decimals: 18,
        token0: '0x60a3e35cc302bfa44cb288bc5a4f316fdb1adb42',
        token1: '0xcbb7c0000ab88b473b1f5afd9ef808440eed33bf',
      },
      '0x7ec6c9d993d9832aa654593f2dbc21303650bc6c': {
        address: '0x7ec6c9d993d9832aa654593f2dbc21303650bc6c',
        chainId: 8453,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'WETH/VVV',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0xacfe6019ed1a7dc6f7b508c02d1b04ec88cc21bf',
      },
      '0x8de9eb567b5eaa3ed205161e1d80c567c4ab9907': {
        address: '0x8de9eb567b5eaa3ed205161e1d80c567c4ab9907',
        chainId: 8453,
        type: 'ERC721-NATIVE',
        symbol: 'VIRTUAL/AIXCB',
        decimals: 18,
        token0: '0x0b3e328455c4059eeb9e3f84b5543f74e24e7e1b',
        token1: '0x76c71f1703fbf19ffdcf3051e1e684cb9934510f',
      },
      '0x139e9f235588a9720e7eab045da29dc781c4b658': {
        address: '0x139e9f235588a9720e7eab045da29dc781c4b658',
        chainId: 8453,
        type: 'LP',
        symbol: 'WETH/DOGINME',
        decimals: 18,
        totalSupply: '115220586901658717876509',
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0x6921b130d297cc43754afba22e5eac0fbf8db75b',
        priceInUsd: 2.6650041912749063,
      },
      '0xb21b821ec1bb22d0241ae425e07e14d1ccea4aed': {
        address: '0xb21b821ec1bb22d0241ae425e07e14d1ccea4aed',
        chainId: 8453,
        type: 'LP',
        symbol: 'WETH/PRIME',
        decimals: 18,
        totalSupply: '3784193631669275121',
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0xfa980ced6895ac314e7de34ef1bfae90a5add21b',
        priceInUsd: 169.7234949875107,
      },
      '0xc200f21efe67c7f41b81a854c26f9cda80593065': {
        address: '0xc200f21efe67c7f41b81a854c26f9cda80593065',
        chainId: 8453,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'VIRTUAL/WETH',
        decimals: 18,
        token0: '0x0b3e328455c4059eeb9e3f84b5543f74e24e7e1b',
        token1: '0x4200000000000000000000000000000000000006',
      },
      '0xf85fa96193f411ae7baa892dd4abb7dacedf9191': {
        address: '0xf85fa96193f411ae7baa892dd4abb7dacedf9191',
        chainId: 8453,
        type: 'ERC721-NATIVE',
        symbol: 'USDC/VVV',
        decimals: 18,
        token0: '0x833589fcd6edb6e08f4c7c32d4f71b54bda02913',
        token1: '0xacfe6019ed1a7dc6f7b508c02d1b04ec88cc21bf',
      },
      '0x2a1463cebe85315224c536afd389b381b43f3206': {
        address: '0x2a1463cebe85315224c536afd389b381b43f3206',
        chainId: 8453,
        type: 'LP',
        symbol: 'USDC/MAI',
        decimals: 18,
        totalSupply: '16833146861382436',
        token0: '0x833589fcd6edb6e08f4c7c32d4f71b54bda02913',
        token1: '0xbf1aea8670d2528e08334083616dd9c5f3b087ae',
        priceInUsd: 298471511.5613283,
      },
      '0xd95bae63641d822dc591bd4aca7a64e53eac76f9': {
        address: '0xd95bae63641d822dc591bd4aca7a64e53eac76f9',
        chainId: 8453,
        type: 'ERC721-NATIVE',
        symbol: 'WETH/CHOMP',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0xebff2db643cf955247339c8c6bcd8406308ca437',
      },
      '0x4ef1e503c4f1e5664ac98294d0e42ddc9c0ff961': {
        address: '0x4ef1e503c4f1e5664ac98294d0e42ddc9c0ff961',
        chainId: 8453,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'USDZ/USD+',
        decimals: 18,
        token0: '0x04d5ddf5f3a8939889f11e97f8c4bb48317f1938',
        token1: '0xb79dd08ea68a908a97220c76d19a6aa9cbde4376',
      },
      '0x90359da9715411b828769ab9343fa2732f726e19': {
        address: '0x90359da9715411b828769ab9343fa2732f726e19',
        chainId: 8453,
        type: 'LP',
        symbol: 'WELS/AERO',
        decimals: 18,
        totalSupply: '61289383607923360244261',
        token0: '0x7f62ac1e974d65fab4a81821ca6af659a5f46298',
        token1: '0x940181a94a35a4569e4529a3cdfb74e38fd98631',
        priceInUsd: 0.08975857402249332,
      },
      '0xa213c82265cd3d94f972f735a4f5130e34df81bc': {
        address: '0xa213c82265cd3d94f972f735a4f5130e34df81bc',
        chainId: 8453,
        type: 'ERC721-NATIVE',
        symbol: 'WETH/REI',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0x6b2504a03ca4d43d0d73776f6ad46dab2f2a4cfd',
      },
      '0x138acee5573fa09e7f215965ff60898cc33c6330': {
        address: '0x138acee5573fa09e7f215965ff60898cc33c6330',
        chainId: 8453,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'TBTC/CBBTC',
        decimals: 18,
        token0: '0x236aa50979d5f3de3bd1eeb40e81137f22ab794b',
        token1: '0xcbb7c0000ab88b473b1f5afd9ef808440eed33bf',
      },
      '0x5116773e18a9c7bb03ebb961b38678e45e238923': {
        address: '0x5116773e18a9c7bb03ebb961b38678e45e238923',
        chainId: 8453,
        type: 'ERC721-NATIVE',
        symbol: 'DRB/WETH',
        decimals: 18,
        token0: '0x3ec2156d4c0a9cbdab4a016633b7bcf6a8d68ea2',
        token1: '0x4200000000000000000000000000000000000006',
      },
      '0x8b432c54d6e8e1b8d1802753514ab53044af1861': {
        address: '0x8b432c54d6e8e1b8d1802753514ab53044af1861',
        chainId: 8453,
        type: 'LP',
        symbol: 'DOLA/MAI',
        decimals: 18,
        totalSupply: '431153703266442312972',
        token0: '0x4621b7a9c75199271f773ebd9a499dbd165c3191',
        token1: '0xbf1aea8670d2528e08334083616dd9c5f3b087ae',
        priceInUsd: 1.9696867308318642,
      },
      '0xc197d33b4eeb83ae01fef727f74f360efb6f4d7e': {
        address: '0xc197d33b4eeb83ae01fef727f74f360efb6f4d7e',
        chainId: 8453,
        type: 'ERC721-NATIVE',
        symbol: 'WETH/ANON',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0x79bbf4508b1391af3a0f4b30bb5fc4aa9ab0e07c',
      },
      '0xde5ff829fef54d1bdec957d9538a306f0ead1368': {
        address: '0xde5ff829fef54d1bdec957d9538a306f0ead1368',
        chainId: 8453,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'USDZ/USDC',
        decimals: 18,
        token0: '0x04d5ddf5f3a8939889f11e97f8c4bb48317f1938',
        token1: '0x833589fcd6edb6e08f4c7c32d4f71b54bda02913',
      },
      '0xf239650fefb8feeb4d168a54fa071c7a8dfd3d65': {
        address: '0xf239650fefb8feeb4d168a54fa071c7a8dfd3d65',
        chainId: 8453,
        type: 'ERC721-NATIVE',
        symbol: 'WETH/AGENT',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0xd98832e8a59156acbee4744b9a94a9989a728f36',
      },
      '0x723aef6543aece026a15662be4d3fb3424d502a9': {
        address: '0x723aef6543aece026a15662be4d3fb3424d502a9',
        chainId: 8453,
        type: 'LP',
        symbol: 'TBTC/USDBC',
        decimals: 18,
        totalSupply: '133832529284336',
        token0: '0x236aa50979d5f3de3bd1eeb40e81137f22ab794b',
        token1: '0xd9aaec86b65d86f6a7b5b1b0c42ffa531710b6ca',
        priceInUsd: 671837753.2656101,
      },
      '0xcf88b8bf7ccce2d836878e538197eb20fc673bce': {
        address: '0xcf88b8bf7ccce2d836878e538197eb20fc673bce',
        chainId: 8453,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'USDZ/WETH',
        decimals: 18,
        token0: '0x04d5ddf5f3a8939889f11e97f8c4bb48317f1938',
        token1: '0x4200000000000000000000000000000000000006',
      },
      '0x0c8bf3cb3e1f951b284ef14aa95444be86a33e2f': {
        address: '0x0c8bf3cb3e1f951b284ef14aa95444be86a33e2f',
        chainId: 8453,
        type: 'LP',
        symbol: 'EZETH/WETH',
        decimals: 18,
        totalSupply: '2599376641995873254',
        token0: '0x2416092f143378750bb29b79ed961ab195cceea5',
        token1: '0x4200000000000000000000000000000000000006',
        priceInUsd: 8587.656222980764,
      },
      '0xf185f82a1948d014bae23d30b06fa8da35110315': {
        address: '0xf185f82a1948d014bae23d30b06fa8da35110315',
        chainId: 8453,
        type: 'LP',
        symbol: 'USDC/DEUS',
        decimals: 18,
        totalSupply: '8329986833835081',
        token0: '0x833589fcd6edb6e08f4c7c32d4f71b54bda02913',
        token1: '0xde5ed76e7c05ec5e4572cfc88d1acea165109e44',
        priceInUsd: 5237196.451031179,
      },
      '0x37785d5be19d0d9559d4634a5385c72c419b25da': {
        address: '0x37785d5be19d0d9559d4634a5385c72c419b25da',
        chainId: 8453,
        type: 'LP',
        symbol: 'WETH/RFL',
        decimals: 18,
        totalSupply: '13878152779190166286063',
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0x6e2c81b6c2c0e02360f00a0da694e489acb0b05e',
        priceInUsd: 35.69296007303079,
      },
      '0xf89042057d079debe2a65a1a899e48e0e825105f': {
        address: '0xf89042057d079debe2a65a1a899e48e0e825105f',
        chainId: 8453,
        type: 'LP',
        symbol: 'WETH/DOG',
        decimals: 18,
        totalSupply: '6829294948694180955127',
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0x9e53e88dcff56d3062510a745952dec4cefdff9e',
        priceInUsd: 1.535930642078006,
      },
      '0x74f8a8c18010659a456c8584e625996ab62c1b62': {
        address: '0x74f8a8c18010659a456c8584e625996ab62c1b62',
        chainId: 8453,
        type: 'ERC721-NATIVE',
        symbol: 'FROC/WETH',
        decimals: 18,
        token0: '0x3c8cd0db9a01efa063a7760267b822a129bc7dca',
        token1: '0x4200000000000000000000000000000000000006',
      },
      '0xc95582235d8905ea7dac517286bec72f653fa24b': {
        address: '0xc95582235d8905ea7dac517286bec72f653fa24b',
        chainId: 8453,
        type: 'LP',
        symbol: 'WETH/XEN',
        decimals: 18,
        totalSupply: '303205786205160',
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0x981d41c115a2d48cb1215d13bda8f989d407c9c5',
        priceInUsd: 8359680.675965641,
      },
      '0x4e829f8a5213c42535ab84aa40bd4adcce9cba02': {
        address: '0x4e829f8a5213c42535ab84aa40bd4adcce9cba02',
        chainId: 8453,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'WETH/BRETT',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0x532f27101965dd16442e59d40670faf5ebb142e4',
      },
      '0x45d8c7bf5be7c99d39cdc724f60497bd79546458': {
        address: '0x45d8c7bf5be7c99d39cdc724f60497bd79546458',
        chainId: 8453,
        type: 'LP',
        symbol: 'AERO/ZOOMER',
        decimals: 18,
        totalSupply: '3479474089076306477812251',
        token0: '0x940181a94a35a4569e4529a3cdfb74e38fd98631',
        token1: '0xd1db4851bcf5b41442caa32025ce0afe6b8eabc2',
        priceInUsd: 0.004583158541120268,
      },
      '0xfd7abc461df4e496a25898cab0c6ea88cdd94cf9': {
        address: '0xfd7abc461df4e496a25898cab0c6ea88cdd94cf9',
        chainId: 8453,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'WETH/SPEC',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0x96419929d7949d6a801a6909c145c8eef6a40431',
      },
      '0x5e14319d52c9c18a04bfbbe12dd3a0fe3c1a816a': {
        address: '0x5e14319d52c9c18a04bfbbe12dd3a0fe3c1a816a',
        chainId: 8453,
        type: 'LP',
        symbol: 'WETH/NPC',
        decimals: 18,
        totalSupply: '3594737943734170068195',
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0xb166e8b140d35d9d8226e40c09f757bac5a4d87d',
        priceInUsd: 16.883479570011644,
      },
      '0x95f04b5594e2a944ca91d56933d119841eef9a99': {
        address: '0x95f04b5594e2a944ca91d56933d119841eef9a99',
        chainId: 8453,
        type: 'LP',
        symbol: 'RSR/BSDETH',
        decimals: 18,
        totalSupply: '10481912453934996132779',
        token0: '0xab36452dbac151be02b16ca17d8919826072f64a',
        token1: '0xcb327b99ff831bf8223cced12b1338ff3aa322ff',
        priceInUsd: 10.174854833532756,
      },
      '0x9287c921f5d920ceee0d07d7c58d476e46acc640': {
        address: '0x9287c921f5d920ceee0d07d7c58d476e46acc640',
        chainId: 8453,
        type: 'LP',
        symbol: 'WETH/DAI',
        decimals: 18,
        totalSupply: '29825343370141630125',
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0x50c5725949a6f0c72e6c4a641f24049a917db0cb',
        priceInUsd: 132.4839350208552,
      },
      '0xcc28456d4ff980cee3457ca809a257e52cd9cdb0': {
        address: '0xcc28456d4ff980cee3457ca809a257e52cd9cdb0',
        chainId: 8453,
        type: 'ERC721-NATIVE',
        symbol: 'HIGHER/WETH',
        decimals: 18,
        token0: '0x0578d8a44db98b23bf096a382e016e29a5ce0ffe',
        token1: '0x4200000000000000000000000000000000000006',
      },
      '0xe05ce080119b33dd30482a6ec9b8911508ae226e': {
        address: '0xe05ce080119b33dd30482a6ec9b8911508ae226e',
        chainId: 8453,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'USD+/CBBTC',
        decimals: 18,
        token0: '0xb79dd08ea68a908a97220c76d19a6aa9cbde4376',
        token1: '0xcbb7c0000ab88b473b1f5afd9ef808440eed33bf',
      },
      '0x4200000000000000000000000000000000000006': {
        address: '0x4200000000000000000000000000000000000006',
        chainId: 8453,
        type: 'ERC721-NATIVE',
        symbol: 'WETH',
        decimals: 18,
        totalSupply: '184493080476368713223810',
      },
      '0xba3f945812a83471d709bce9c3ca699a19fb46f7': {
        address: '0xba3f945812a83471d709bce9c3ca699a19fb46f7',
        chainId: 8453,
        type: 'ERC721-NATIVE',
        symbol: 'WETH/BRETT',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0x532f27101965dd16442e59d40670faf5ebb142e4',
      },
      '0xfbfa69c021105e8f97ea12cf9d385e875d0f9e8f': {
        address: '0xfbfa69c021105e8f97ea12cf9d385e875d0f9e8f',
        chainId: 8453,
        type: 'ERC721-NATIVE',
        symbol: 'WETH/RWA',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0x928a6a9fc62b2c94baf2992a6fba4715f5bb0066',
      },
      '0x5a1401c002f67ca00557e7179d34c3fe6d753b28': {
        address: '0x5a1401c002f67ca00557e7179d34c3fe6d753b28',
        chainId: 8453,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'EXTRA/WETH',
        decimals: 18,
        token0: '0x2dad3a13ef0c6366220f989157009e501e7938f8',
        token1: '0x4200000000000000000000000000000000000006',
      },
      '0xf8d0037be52d84a28a3b95b88590aadee605e41f': {
        address: '0xf8d0037be52d84a28a3b95b88590aadee605e41f',
        chainId: 8453,
        type: 'ERC721-NATIVE',
        symbol: 'NFTXBT/WETH',
        decimals: 18,
        token0: '0x08c81699f9a357a9f0d04a09b353576ca328d60d',
        token1: '0x4200000000000000000000000000000000000006',
      },
      '0xb5a0da376245e67b2e55e4f011b4daa464278cfa': {
        address: '0xb5a0da376245e67b2e55e4f011b4daa464278cfa',
        chainId: 8453,
        type: 'ERC721-NATIVE',
        symbol: 'GRK/WETH',
        decimals: 18,
        token0: '0x2e2cc4dfce60257f091980631e75f5c436b71c87',
        token1: '0x4200000000000000000000000000000000000006',
      },
      '0x06709c364dd4e2f5b0c10b1ebf80b2ce483dbdc5': {
        address: '0x06709c364dd4e2f5b0c10b1ebf80b2ce483dbdc5',
        chainId: 8453,
        type: 'LP',
        symbol: 'WETH/QI',
        decimals: 18,
        totalSupply: '2677844362791865145399',
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0xd3fdcb837dafdb7c9c3ebd48fe22a53f6dd3d7d7',
        priceInUsd: 19.82179185684006,
      },
      '0x9ed7eb51a8e6af23d77180acc32a3312a06bdc79': {
        address: '0x9ed7eb51a8e6af23d77180acc32a3312a06bdc79',
        chainId: 8453,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'CBBTC/UBTC',
        decimals: 18,
        token0: '0xcbb7c0000ab88b473b1f5afd9ef808440eed33bf',
        token1: '0xf1143f3a8d76f1ca740d29d5671d365f66c44ed1',
      },
      '0x7810f8f3253ced11e8c56c6c8497f3134055d44c': {
        address: '0x7810f8f3253ced11e8c56c6c8497f3134055d44c',
        chainId: 8453,
        type: 'LP',
        symbol: 'AERO/TAROT',
        decimals: 18,
        totalSupply: '4014903869092577701063955',
        token0: '0x940181a94a35a4569e4529a3cdfb74e38fd98631',
        token1: '0xf544251d25f3d243a36b07e7e7962a678f952691',
        priceInUsd: 0.6437914345763078,
      },
      '0x54cdd0222df6b3bc17754c2c1b3d7d4203fe3d89': {
        address: '0x54cdd0222df6b3bc17754c2c1b3d7d4203fe3d89',
        chainId: 8453,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'WETH/REI',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0x6b2504a03ca4d43d0d73776f6ad46dab2f2a4cfd',
      },
      '0x688f778c51db4d990bf1abaf8d33fd95e48c6641': {
        address: '0x688f778c51db4d990bf1abaf8d33fd95e48c6641',
        chainId: 8453,
        type: 'LP',
        symbol: 'EXTRA/AERO',
        decimals: 18,
        totalSupply: '171610031257181929393172',
        token0: '0x2dad3a13ef0c6366220f989157009e501e7938f8',
        token1: '0x940181a94a35a4569e4529a3cdfb74e38fd98631',
        priceInUsd: 0.28616645563288867,
      },
      '0x2f25d28f03bbcda4675875171bc53bf40cff2c9d': {
        address: '0x2f25d28f03bbcda4675875171bc53bf40cff2c9d',
        chainId: 8453,
        type: 'ERC721-NATIVE',
        symbol: 'DORA/WETH',
        decimals: 18,
        token0: '0x1e2093ab84768948c6176db5ad98c909ce97f368',
        token1: '0x4200000000000000000000000000000000000006',
      },
      '0x6de6b99274821f7f675a5794cd759c54bdc180b1': {
        address: '0x6de6b99274821f7f675a5794cd759c54bdc180b1',
        chainId: 8453,
        type: 'LP',
        symbol: 'NORMIE/AERO',
        decimals: 18,
        totalSupply: '16088934733317068',
        token0: '0x7f12d13b34f5f4f0a9449c16bcd42f0da47af200',
        token1: '0x940181a94a35a4569e4529a3cdfb74e38fd98631',
        priceInUsd: 12.77176270116586,
      },
      '0xeff0891e5a1bd47a8f1e77abebfee4145974d088': {
        address: '0xeff0891e5a1bd47a8f1e77abebfee4145974d088',
        chainId: 8453,
        type: 'LP',
        symbol: 'WETH/JARVIS',
        decimals: 18,
        totalSupply: '23026587088940505690042',
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0x777b2839832982b35213063d850848369390ee16',
        priceInUsd: 21.529917991735488,
      },
      '0xdab27fb1923fc017e941d837040add59b9aff9fd': {
        address: '0xdab27fb1923fc017e941d837040add59b9aff9fd',
        chainId: 8453,
        type: 'LP',
        symbol: 'WBASEDOGE/AERO',
        decimals: 18,
        totalSupply: '30433929051287069670435956',
        token0: '0x373504da48418c67e6fcd071f33cb0b3b47613c7',
        token1: '0x940181a94a35a4569e4529a3cdfb74e38fd98631',
        priceInUsd: 0.0010936872426202493,
      },
      '0x82321f3beb69f503380d6b233857d5c43562e2d0': {
        address: '0x82321f3beb69f503380d6b233857d5c43562e2d0',
        chainId: 8453,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'WETH/AERO',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0x940181a94a35a4569e4529a3cdfb74e38fd98631',
      },
      '0x3a3dc4a26d1aceae12fd1026a5856f12d20658ea': {
        address: '0x3a3dc4a26d1aceae12fd1026a5856f12d20658ea',
        chainId: 8453,
        type: 'ERC721-NATIVE',
        symbol: 'WETH/LUNA',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0x55cd6469f597452b5a7536e2cd98fde4c1247ee4',
      },
      '0x688b0380360c84135769d4f75d70038119846a8e': {
        address: '0x688b0380360c84135769d4f75d70038119846a8e',
        chainId: 8453,
        type: 'LP',
        symbol: 'WETH/DHT',
        decimals: 18,
        totalSupply: '4350688564515755343994',
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0x54bc229d1cb15f8b6415efeab4290a40bc8b7d84',
        priceInUsd: 51.38714051457783,
      },
      '0x5fcfe2a2bc5954e6065428f6d8693814ef0491ac': {
        address: '0x5fcfe2a2bc5954e6065428f6d8693814ef0491ac',
        chainId: 8453,
        type: 'LP',
        symbol: 'ZUN/ZUNETH',
        decimals: 18,
        totalSupply: '25859522470240029760',
        token0: '0x1db0fc8933f545648b54a9ee4326209a9a259643',
        token1: '0x24cb2b89844604c57350776d81e14765d03b91de',
        priceInUsd: 0.3854788680048189,
      },
      '0xf629864e8b4914284f79641ef9ce034c161f26ae': {
        address: '0xf629864e8b4914284f79641ef9ce034c161f26ae',
        chainId: 8453,
        type: 'LP',
        symbol: 'USDC/CTX',
        decimals: 18,
        totalSupply: '405502633130',
        token0: '0x833589fcd6edb6e08f4c7c32d4f71b54bda02913',
        token1: '0xbb22ff867f8ca3d5f2251b4084f6ec86d4666e14',
        priceInUsd: 0,
      },
      '0xb099c658e784b41ee435d48a8eb67e8f27285c93': {
        address: '0xb099c658e784b41ee435d48a8eb67e8f27285c93',
        chainId: 8453,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'WETH/B3',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0xb3b32f9f8827d4634fe7d973fa1034ec9fddb3b3',
      },
      '0xfad14c545e464e04c737d00643296144eb20c7f8': {
        address: '0xfad14c545e464e04c737d00643296144eb20c7f8',
        chainId: 8453,
        type: 'ERC721-AERODROME-CL',
        symbol: 'BRETT/USD+',
        decimals: 18,
        token0: '0x532f27101965dd16442e59d40670faf5ebb142e4',
        token1: '0xb79dd08ea68a908a97220c76d19a6aa9cbde4376',
      },
      '0x65b6ee9cac744d4eed9886406ead6bc4e5681068': {
        address: '0x65b6ee9cac744d4eed9886406ead6bc4e5681068',
        chainId: 8453,
        type: 'ERC721-NATIVE',
        symbol: 'WETH/GDEX',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0x53cb59d32a8d08fc6d3f81454f150946a028a44d',
      },
      '0x20000fbfedfd172821821c9c59284129b04ffb2e': {
        address: '0x20000fbfedfd172821821c9c59284129b04ffb2e',
        chainId: 8453,
        type: 'LP',
        symbol: 'TYBG/WETH',
        decimals: 18,
        totalSupply: '123441325917439633276669',
        token0: '0x0d97f261b1e88845184f678e2d1e7a98d9fd38de',
        token1: '0x4200000000000000000000000000000000000006',
        priceInUsd: 0.9123347995270995,
      },
      '0x54016a4848a38f257b6e96331f7404073fd9c32c': {
        address: '0x54016a4848a38f257b6e96331f7404073fd9c32c',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'SCALE',
        decimals: 18,
        totalSupply: '22385605110898278013185964',
        priceInUsd: 0.03985523613580551,
      },
      '0xfea9e8a7daef9497fff3e3501ed504984f96aa33': {
        address: '0xfea9e8a7daef9497fff3e3501ed504984f96aa33',
        chainId: 8453,
        type: 'LP',
        symbol: 'WELS/USDC',
        decimals: 18,
        totalSupply: '1759988028319915',
        token0: '0x7f62ac1e974d65fab4a81821ca6af659a5f46298',
        token1: '0x833589fcd6edb6e08f4c7c32d4f71b54bda02913',
        priceInUsd: 85016.52690075904,
      },
      '0xb49a3eb20ada6fa09104c06690b9ab45959c153d': {
        address: '0xb49a3eb20ada6fa09104c06690b9ab45959c153d',
        chainId: 8453,
        type: 'ERC721-NATIVE',
        symbol: 'WETH/OBT',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0x514d8e8099286a13486ef6c525c120f51c239b52',
      },
      '0x8055e6de251e414e8393b20adab096afb3cf8399': {
        address: '0x8055e6de251e414e8393b20adab096afb3cf8399',
        chainId: 8453,
        type: 'ERC721-NATIVE',
        symbol: 'WETH/SPEC',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0x96419929d7949d6a801a6909c145c8eef6a40431',
      },
      '0xb37642e87613d8569fd8ec80888ea6c63684e79e': {
        address: '0xb37642e87613d8569fd8ec80888ea6c63684e79e',
        chainId: 8453,
        type: 'LP',
        symbol: 'WETH/KLIMA',
        decimals: 18,
        totalSupply: '101327402607547747',
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0xdcefd8c8fcc492630b943abcab3429f12ea9fea2',
        priceInUsd: 2051264.9329121169,
      },
      '0xcaedc2561356b6a01a94e3c0438011459e91fbb9': {
        address: '0xcaedc2561356b6a01a94e3c0438011459e91fbb9',
        chainId: 8453,
        type: 'LP',
        symbol: 'WETH/WELS',
        decimals: 18,
        totalSupply: '19323132688331309085406',
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0x7f62ac1e974d65fab4a81821ca6af659a5f46298',
        priceInUsd: 5.553839479160295,
      },
      '0x0fac819628a7f612abac1cad939768058cc0170c': {
        address: '0x0fac819628a7f612abac1cad939768058cc0170c',
        chainId: 8453,
        type: 'LP',
        symbol: 'ION/WETH',
        decimals: 18,
        totalSupply: '79185406556174462305802',
        token0: '0x3ee5e23eee121094f1cfc0ccc79d6c809ebd22e5',
        token1: '0x4200000000000000000000000000000000000006',
        priceInUsd: 2.2004692657865768,
      },
      '0x1f019b4420936a800ff6f54c00d9da05445de433': {
        address: '0x1f019b4420936a800ff6f54c00d9da05445de433',
        chainId: 8453,
        type: 'LP',
        symbol: 'USDC/USX',
        decimals: 18,
        totalSupply: '276329688119787700',
        token0: '0x833589fcd6edb6e08f4c7c32d4f71b54bda02913',
        token1: '0xc142171b138db17a1b7cb999c44526094a4dae05',
        priceInUsd: 1983221.636455562,
      },
      '0xd3c2fa602b8da5b0b9c25dfbe7f2f31bb512db13': {
        address: '0xd3c2fa602b8da5b0b9c25dfbe7f2f31bb512db13',
        chainId: 8453,
        type: 'LP',
        symbol: 'BAVA/AERO',
        decimals: 18,
        totalSupply: '242804513013313570068920',
        token0: '0x3fbde9864362ce4abb244ebef2ef0482aba8ea39',
        token1: '0x940181a94a35a4569e4529a3cdfb74e38fd98631',
        priceInUsd: 0.010880365164558908,
      },
      '0x82a0c1a0d4ef0c0ca3cfda3ad1aa78309cc6139b': {
        address: '0x82a0c1a0d4ef0c0ca3cfda3ad1aa78309cc6139b',
        chainId: 8453,
        type: 'LP',
        symbol: 'AERO/WSTETH',
        decimals: 18,
        totalSupply: '2430238129583078191020',
        token0: '0x940181a94a35a4569e4529a3cdfb74e38fd98631',
        token1: '0xc1cba3fcea344f92d9239c08c0568f6f2f0ee452',
        priceInUsd: 149.30920600963165,
      },
      '0xd79ef386f26e40b5e60e4aeb324f2678f6ebbf49': {
        address: '0xd79ef386f26e40b5e60e4aeb324f2678f6ebbf49',
        chainId: 8453,
        type: 'LP',
        symbol: 'ALB/WETH',
        decimals: 18,
        totalSupply: '3566310200317891625296',
        token0: '0x1dd2d631c92b1acdfcdd51a0f7145a50130050c4',
        token1: '0x4200000000000000000000000000000000000006',
        priceInUsd: 37.9672062811155,
      },
      '0x1dd2d631c92b1acdfcdd51a0f7145a50130050c4': {
        address: '0x1dd2d631c92b1acdfcdd51a0f7145a50130050c4',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'ALB',
        decimals: 18,
        totalSupply: '422200070013351940279405792',
        priceInUsd: 0.0531493359066078,
      },
      '0x1b199d80188fc0488f938e14c5a361f858d882b6': {
        address: '0x1b199d80188fc0488f938e14c5a361f858d882b6',
        chainId: 8453,
        type: 'ERC721-NATIVE',
        symbol: 'VIRTUAL/GAME',
        decimals: 18,
        token0: '0x0b3e328455c4059eeb9e3f84b5543f74e24e7e1b',
        token1: '0x1c4cca7c5db003824208adda61bd749e55f463a3',
      },
      '0x5aa4ad647580bfe86258d300bc9852f4434e2c61': {
        address: '0x5aa4ad647580bfe86258d300bc9852f4434e2c61',
        chainId: 8453,
        type: 'ERC721-NATIVE',
        symbol: 'WETH/TOSHI',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0xac1bd2486aaf3b5c0fc3fd868558b082a531b2b4',
      },
      '0x734fa91d5ccdf79a6bb2716eb5d3ff78cbace536': {
        address: '0x734fa91d5ccdf79a6bb2716eb5d3ff78cbace536',
        chainId: 8453,
        type: 'ERC721-NATIVE',
        symbol: 'EMP/WETH',
        decimals: 18,
        token0: '0x39d5313c3750140e5042887413ba8aa6145a9bd2',
        token1: '0x4200000000000000000000000000000000000006',
      },
      '0x090d9c28e1edca0e693a9e553b256e07ca2af021': {
        address: '0x090d9c28e1edca0e693a9e553b256e07ca2af021',
        chainId: 8453,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'WIF/USD+',
        decimals: 18,
        token0: '0x1fba65de0a9cbd2d1df82d141897042d36bb6c86',
        token1: '0xb79dd08ea68a908a97220c76d19a6aa9cbde4376',
      },
      '0xf6aec4f97623e691a9426a69baf5501509fca05d': {
        address: '0xf6aec4f97623e691a9426a69baf5501509fca05d',
        chainId: 8453,
        type: 'LP',
        symbol: 'MAI/USDBC',
        decimals: 18,
        totalSupply: '4550869687046133',
        token0: '0xbf1aea8670d2528e08334083616dd9c5f3b087ae',
        token1: '0xd9aaec86b65d86f6a7b5b1b0c42ffa531710b6ca',
        priceInUsd: 1991816.6024671206,
      },
      '0xc1a6fbedae68e1472dbb91fe29b51f7a0bd44f97': {
        address: '0xc1a6fbedae68e1472dbb91fe29b51f7a0bd44f97',
        chainId: 8453,
        type: 'ERC721-NATIVE',
        symbol: 'CLANKER/WETH',
        decimals: 18,
        token0: '0x1bc0c42215582d5a085795f4badbac3ff36d1bcb',
        token1: '0x4200000000000000000000000000000000000006',
      },
      '0x1a9f461a371559f82976fa18c46a6a0d29f131d0': {
        address: '0x1a9f461a371559f82976fa18c46a6a0d29f131d0',
        chainId: 8453,
        type: 'LP',
        symbol: 'WETH/TKN',
        decimals: 18,
        totalSupply: '17925749374668599102451',
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0x78b3c724a2f663d11373c4a1978689271895256f',
        priceInUsd: 12.600378577043582,
      },
      '0x74e4c08bb50619b70550733d32b7e60424e9628e': {
        address: '0x74e4c08bb50619b70550733d32b7e60424e9628e',
        chainId: 8453,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'WETH/TOSHI',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0xac1bd2486aaf3b5c0fc3fd868558b082a531b2b4',
      },
      '0x2a36148a416cba81699b555120bd65f4682bdfd2': {
        address: '0x2a36148a416cba81699b555120bd65f4682bdfd2',
        chainId: 8453,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'GAME/WETH',
        decimals: 18,
        token0: '0x1c4cca7c5db003824208adda61bd749e55f463a3',
        token1: '0x4200000000000000000000000000000000000006',
      },
      '0xe96a4e9ea3a2c6db214174738a19eb7dbb8a3069': {
        address: '0xe96a4e9ea3a2c6db214174738a19eb7dbb8a3069',
        chainId: 8453,
        type: 'LP',
        symbol: 'WETH/SPX',
        decimals: 18,
        totalSupply: '122180785792913964',
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0x50da645f148798f68ef2d7db7c1cb22a6819bb2c',
        priceInUsd: 13328070.219580328,
      },
      '0x4ec1828654b4a28936701d08164721876e88f456': {
        address: '0x4ec1828654b4a28936701d08164721876e88f456',
        chainId: 8453,
        type: 'ERC721-NATIVE',
        symbol: 'FCAST/WETH',
        decimals: 18,
        token0: '0x05019be5a6750bbde6f889d6471c37ef923472d3',
        token1: '0x4200000000000000000000000000000000000006',
      },
      '0x27a8afa3bd49406e48a074350fb7b2020c43b2bd': {
        address: '0x27a8afa3bd49406e48a074350fb7b2020c43b2bd',
        chainId: 8453,
        type: 'LP',
        symbol: 'USDC/USDBC',
        decimals: 18,
        totalSupply: '28019248219',
        token0: '0x833589fcd6edb6e08f4c7c32d4f71b54bda02913',
        token1: '0xd9aaec86b65d86f6a7b5b1b0c42ffa531710b6ca',
        priceInUsd: 2000668903949.723,
      },
      '0xe9a65059e895dd5d49806f6a71b63fed0ffffd4b': {
        address: '0xe9a65059e895dd5d49806f6a71b63fed0ffffd4b',
        chainId: 8453,
        type: 'ERC721-NATIVE',
        symbol: 'SIMMI/WETH',
        decimals: 18,
        token0: '0x161e113b8e9bbaefb846f73f31624f6f9607bd44',
        token1: '0x4200000000000000000000000000000000000006',
      },
      '0x67a11022b7b6ed66f81233f6c8ed6e48f7826530': {
        address: '0x67a11022b7b6ed66f81233f6c8ed6e48f7826530',
        chainId: 8453,
        type: 'ERC721-NATIVE',
        symbol: 'USDC/VVV',
        decimals: 18,
        token0: '0x833589fcd6edb6e08f4c7c32d4f71b54bda02913',
        token1: '0xacfe6019ed1a7dc6f7b508c02d1b04ec88cc21bf',
      },
      '0x8dd9751961621fcfc394d90969e5ae0c5babe147': {
        address: '0x8dd9751961621fcfc394d90969e5ae0c5babe147',
        chainId: 8453,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'USDC/USDC+',
        decimals: 18,
        token0: '0x833589fcd6edb6e08f4c7c32d4f71b54bda02913',
        token1: '0x85483696cc9970ad9edd786b2c5ef735f38d156f',
      },
      '0xbeaab7dbfa682636fb855ac19ea583eb06478852': {
        address: '0xbeaab7dbfa682636fb855ac19ea583eb06478852',
        chainId: 8453,
        type: 'ERC721-NATIVE',
        symbol: 'WETH/NORMILIO',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0xcde90558fc317c69580deeaf3efc509428df9080',
      },
      '0x553666081db0a8fdb337560009932852059d589a': {
        address: '0x553666081db0a8fdb337560009932852059d589a',
        chainId: 8453,
        type: 'LP',
        symbol: 'USD+/USDBC',
        decimals: 18,
        totalSupply: '4646891931',
        token0: '0xb79dd08ea68a908a97220c76d19a6aa9cbde4376',
        token1: '0xd9aaec86b65d86f6a7b5b1b0c42ffa531710b6ca',
        priceInUsd: 2012371437186.4204,
      },
      '0x0c40e7f5b43f6759060a3c4d2fb406dfecf03b57': {
        address: '0x0c40e7f5b43f6759060a3c4d2fb406dfecf03b57',
        chainId: 8453,
        type: 'ERC721-AERODROME-CL',
        symbol: 'USDC/TRUMP',
        decimals: 18,
        token0: '0x833589fcd6edb6e08f4c7c32d4f71b54bda02913',
        token1: '0xc27468b12ffa6d714b1b5fbc87ef403f38b82ad4',
      },
      '0xaa4bdf13c4ca0594daebb38ae7d772b7e975b284': {
        address: '0xaa4bdf13c4ca0594daebb38ae7d772b7e975b284',
        chainId: 8453,
        type: 'ERC721-NATIVE',
        symbol: 'WETH/TRUMP',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0x57f5fbd3de65dfc0bd3630f732969e5fb97e6d37',
      },
      '0xaa721dc836b5195f33f09b7713f73171a0030e36': {
        address: '0xaa721dc836b5195f33f09b7713f73171a0030e36',
        chainId: 8453,
        type: 'LP',
        symbol: 'WETH/SKR',
        decimals: 18,
        totalSupply: '4508334468310096834370',
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0xe2dca969624795985f2f083bcd0b674337ba130a',
        priceInUsd: 3.7390857174335803,
      },
      '0xa32ecde2c559c462610ed35740cc2b9642133c9b': {
        address: '0xa32ecde2c559c462610ed35740cc2b9642133c9b',
        chainId: 8453,
        type: 'LP',
        symbol: 'WETH/MOZ',
        decimals: 18,
        totalSupply: '661933517477818968997',
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0xc227717ef4ae4d982e14789eb33ba942243c3fee',
        priceInUsd: 2.8130655065768524,
      },
      '0x253da544f498b85429f6acdc6e98b36b36c1c824': {
        address: '0x253da544f498b85429f6acdc6e98b36b36c1c824',
        chainId: 8453,
        type: 'LP',
        symbol: 'WETH/L2VE',
        decimals: 18,
        totalSupply: '1944007276346560995846',
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0xa19328fb05ce6fd204d16c2a2a98f7cf434c12f4',
        priceInUsd: 1.6198929198193595,
      },
      '0x7f670f78b17dec44d5ef68a48740b6f8849cc2e6': {
        address: '0x7f670f78b17dec44d5ef68a48740b6f8849cc2e6',
        chainId: 8453,
        type: 'LP',
        symbol: 'WETH/AERO',
        decimals: 18,
        totalSupply: '54627499356543756954933',
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0x940181a94a35a4569e4529a3cdfb74e38fd98631',
        priceInUsd: 135.84454218071204,
      },
      '0x0d4953d2bde145d316296cc72cce509d899a5529': {
        address: '0x0d4953d2bde145d316296cc72cce509d899a5529',
        chainId: 8453,
        type: 'LP',
        symbol: 'WETH/LUCHA',
        decimals: 18,
        totalSupply: '14872148292095399844932',
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0xf4435cc8b478d54313f04c956882be3d9acf9f6f',
        priceInUsd: 20.67043365020604,
      },
      '0xda679706ff21114ac9fac5198bff24543f357a16': {
        address: '0xda679706ff21114ac9fac5198bff24543f357a16',
        chainId: 8453,
        type: 'ERC721-NATIVE',
        symbol: 'WETH/CIRCLE',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0x5babfc2f240bc5de90eb7e19d789412db1dec402',
      },
      '0x1807af3897aa6419e770d4642df7b8b06e542c02': {
        address: '0x1807af3897aa6419e770d4642df7b8b06e542c02',
        chainId: 8453,
        type: 'ERC721-AERODROME-CL',
        symbol: 'WETH/ANON',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0x79bbf4508b1391af3a0f4b30bb5fc4aa9ab0e07c',
      },
      '0xef24722d5dae32dc155d961561cffbc5f347eee7': {
        address: '0xef24722d5dae32dc155d961561cffbc5f347eee7',
        chainId: 8453,
        type: 'LP',
        symbol: 'WETH/USDBC',
        decimals: 18,
        totalSupply: '831187677885636',
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0xd9aaec86b65d86f6a7b5b1b0c42ffa531710b6ca',
        priceInUsd: 162496472.45331982,
      },
      '0x4b0aaf3ebb163dd45f663b38b6d93f6093ebc2d3': {
        address: '0x4b0aaf3ebb163dd45f663b38b6d93f6093ebc2d3',
        chainId: 8453,
        type: 'ERC721-NATIVE',
        symbol: 'WETH/TOSHI',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0xac1bd2486aaf3b5c0fc3fd868558b082a531b2b4',
      },
      '0xa6385c73961dd9c58db2ef0c4eb98ce4b60651e8': {
        address: '0xa6385c73961dd9c58db2ef0c4eb98ce4b60651e8',
        chainId: 8453,
        type: 'LP',
        symbol: 'WETH/WSTETH',
        decimals: 18,
        totalSupply: '160348844839126467976',
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0xc1cba3fcea344f92d9239c08c0568f6f2f0ee452',
        priceInUsd: 9200.515438534727,
      },
      '0x4a311ac4563abc30e71d0631c88a6232c1309ac5': {
        address: '0x4a311ac4563abc30e71d0631c88a6232c1309ac5',
        chainId: 8453,
        type: 'LP',
        symbol: 'MOG/WETH',
        decimals: 18,
        totalSupply: '313528457083217387609121',
        token0: '0x2da56acb9ea78330f947bd57c54119debda7af71',
        token1: '0x4200000000000000000000000000000000000006',
        priceInUsd: 0.8844452602693134,
      },
      '0x21594b992f68495dd28d605834b58889d0a727c7': {
        address: '0x21594b992f68495dd28d605834b58889d0a727c7',
        chainId: 8453,
        type: 'LP',
        symbol: 'VIRTUAL/WETH',
        decimals: 18,
        totalSupply: '33079893735278248785649',
        token0: '0x0b3e328455c4059eeb9e3f84b5543f74e24e7e1b',
        token1: '0x4200000000000000000000000000000000000006',
        priceInUsd: 136.5242765520481,
      },
      '0x70acdf2ad0bf2402c957154f944c19ef4e1cbae1': {
        address: '0x70acdf2ad0bf2402c957154f944c19ef4e1cbae1',
        chainId: 8453,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'WETH/CBBTC',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0xcbb7c0000ab88b473b1f5afd9ef808440eed33bf',
      },
      '0x0aa3e62f4d97c404012352e881a2d0f2712c24a2': {
        address: '0x0aa3e62f4d97c404012352e881a2d0f2712c24a2',
        chainId: 8453,
        type: 'LP',
        symbol: 'WETH/RECORD',
        decimals: 18,
        totalSupply: '36702043843233701790898',
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0xe642657e4f43e6dcf0bd73ef24008394574dee28',
        priceInUsd: 3.655523305674589,
      },
      '0xc91ce85da7fb4523926a2930e930a8b52a7b85b2': {
        address: '0xc91ce85da7fb4523926a2930e930a8b52a7b85b2',
        chainId: 8453,
        type: 'LP',
        symbol: 'KWENTA/WETH',
        decimals: 18,
        totalSupply: '53061907318021912',
        token0: '0x37ab9f42051c112caaba55ab6487dd74286a0b29',
        token1: '0x4200000000000000000000000000000000000006',
        priceInUsd: 464.196684769287,
      },
      '0xf53b7af40be75043eeba493c622f4f56b3c27a31': {
        address: '0xf53b7af40be75043eeba493c622f4f56b3c27a31',
        chainId: 8453,
        type: 'LP',
        symbol: 'LUSD/USDC',
        decimals: 18,
        totalSupply: '3440982152370036',
        token0: '0x368181499736d0c0cc614dbb145e2ec1ac86b8c6',
        token1: '0x833589fcd6edb6e08f4c7c32d4f71b54bda02913',
        priceInUsd: 1999153.3870885775,
      },
      '0xa19acc3b4f11c46c2b1fc36b5f592af422ee338c': {
        address: '0xa19acc3b4f11c46c2b1fc36b5f592af422ee338c',
        chainId: 8453,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'DEGEN/USD+',
        decimals: 18,
        token0: '0x4ed4e862860bed51a9570b96d89af5e1b0efefed',
        token1: '0xb79dd08ea68a908a97220c76d19a6aa9cbde4376',
      },
      '0x554eca2a48136724294ce47fb7bfe9aadfcee3c6': {
        address: '0x554eca2a48136724294ce47fb7bfe9aadfcee3c6',
        chainId: 8453,
        type: 'LP',
        symbol: 'SONNE/USDBC',
        decimals: 18,
        totalSupply: '14839535617625426',
        token0: '0x22a2488fe295047ba13bd8cccdbc8361dbd8cf7c',
        token1: '0xd9aaec86b65d86f6a7b5b1b0c42ffa531710b6ca',
        priceInUsd: 44828.97976001046,
      },
      '0x08b935148ab10d3699cb8d944519e8213abe6f1d': {
        address: '0x08b935148ab10d3699cb8d944519e8213abe6f1d',
        chainId: 8453,
        type: 'LP',
        symbol: 'WETH/USD+',
        decimals: 18,
        totalSupply: '2411625856460',
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0xb79dd08ea68a908a97220c76d19a6aa9cbde4376',
        priceInUsd: 154353196.92825186,
      },
      '0xf1fdc83c3a336bdbdc9fb06e318b08eaddc82ff4': {
        address: '0xf1fdc83c3a336bdbdc9fb06e318b08eaddc82ff4',
        chainId: 8453,
        type: 'ERC721-NATIVE',
        symbol: 'AIXBT/USDC',
        decimals: 18,
        token0: '0x4f9fd6be4a90f2620860d680c0d4d5fb53d1a825',
        token1: '0x833589fcd6edb6e08f4c7c32d4f71b54bda02913',
      },
      '0x83240b049fa89b65be714aed68e5b074df6aac84': {
        address: '0x83240b049fa89b65be714aed68e5b074df6aac84',
        chainId: 8453,
        type: 'LP',
        symbol: 'WETH/USDC',
        decimals: 18,
        totalSupply: '8742555358703',
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0x833589fcd6edb6e08f4c7c32d4f71b54bda02913',
        priceInUsd: 177786090.8501648,
      },
      '0xe96c788e66a97cf455f46c5b27786191fd3bc50b': {
        address: '0xe96c788e66a97cf455f46c5b27786191fd3bc50b',
        chainId: 8453,
        type: 'LP',
        symbol: 'USDC+/USD+',
        decimals: 18,
        totalSupply: '61023991663',
        token0: '0x85483696cc9970ad9edd786b2c5ef735f38d156f',
        token1: '0xb79dd08ea68a908a97220c76d19a6aa9cbde4376',
        priceInUsd: 1993218604927.5046,
      },
      '0x1dda8b6469df243971381f1f3f4137814ca68722': {
        address: '0x1dda8b6469df243971381f1f3f4137814ca68722',
        chainId: 8453,
        type: 'LP',
        symbol: 'WMTX/WETH',
        decimals: 18,
        totalSupply: '8431787262585840',
        token0: '0x3e31966d4f81c72d2a55310a6365a56a4393e98d',
        token1: '0x4200000000000000000000000000000000000006',
        priceInUsd: 61073395.655904286,
      },
      '0xe846373c1a92b167b4e9cd5d8e4d6b1db9e90ec7': {
        address: '0xe846373c1a92b167b4e9cd5d8e4d6b1db9e90ec7',
        chainId: 8453,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'EURC/USDC',
        decimals: 18,
        token0: '0x60a3e35cc302bfa44cb288bc5a4f316fdb1adb42',
        token1: '0x833589fcd6edb6e08f4c7c32d4f71b54bda02913',
      },
      '0x8f24dd646e2ae3615767ebdccc6691c54c41793f': {
        address: '0x8f24dd646e2ae3615767ebdccc6691c54c41793f',
        chainId: 8453,
        type: 'LP',
        symbol: 'USDC/YFX',
        decimals: 18,
        totalSupply: '302151149846666',
        token0: '0x833589fcd6edb6e08f4c7c32d4f71b54bda02913',
        token1: '0x8901cb2e82cc95c01e42206f8d1f417fe53e7af0',
        priceInUsd: 1985205.2596607844,
      },
      '0xe25bc9133d26f62c9fa03b6750f3f3ba57e9eb44': {
        address: '0xe25bc9133d26f62c9fa03b6750f3f3ba57e9eb44',
        chainId: 8453,
        type: 'LP',
        symbol: 'SFRXETH/AERO',
        decimals: 18,
        totalSupply: '1030899666195609137',
        token0: '0x1f55a02a049033e3419a8e2975cf3f572f4e6e9a',
        token1: '0x940181a94a35a4569e4529a3cdfb74e38fd98631',
        priceInUsd: 149.8774774887984,
      },
      '0x89d0f320ac73dd7d9513ffc5bc58d1161452a657': {
        address: '0x89d0f320ac73dd7d9513ffc5bc58d1161452a657',
        chainId: 8453,
        type: 'LP',
        symbol: 'WETH/WELL',
        decimals: 18,
        totalSupply: '737752018985036952120678',
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0xa88594d404727625a9437c3f886c7643872296ae',
        priceInUsd: 19.45706935800197,
      },
      '0x565aecf84b5d30a6e79a5cef3f0da0fc4280debc': {
        address: '0x565aecf84b5d30a6e79a5cef3f0da0fc4280debc',
        chainId: 8453,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'AERO/WSTETH',
        decimals: 18,
        token0: '0x940181a94a35a4569e4529a3cdfb74e38fd98631',
        token1: '0xc1cba3fcea344f92d9239c08c0568f6f2f0ee452',
      },
      '0x385b47e56b73eb6549378f78f7c7cbc42c56c9e0': {
        address: '0x385b47e56b73eb6549378f78f7c7cbc42c56c9e0',
        chainId: 8453,
        type: 'ERC721-AERODROME-CL',
        symbol: 'DRB/WETH',
        decimals: 18,
        token0: '0x3ec2156d4c0a9cbdab4a016633b7bcf6a8d68ea2',
        token1: '0x4200000000000000000000000000000000000006',
      },
      '0x76bf0abd20f1e0155ce40a62615a90a709a6c3d8': {
        address: '0x76bf0abd20f1e0155ce40a62615a90a709a6c3d8',
        chainId: 8453,
        type: 'ERC721-NATIVE',
        symbol: 'WETH/BRETT',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0x532f27101965dd16442e59d40670faf5ebb142e4',
      },
      '0x4cc2fefb2635c86b1bae1b58e0f60fb43e95e264': {
        address: '0x4cc2fefb2635c86b1bae1b58e0f60fb43e95e264',
        chainId: 8453,
        type: 'LP',
        symbol: 'SONNE/USDC',
        decimals: 18,
        totalSupply: '35733502565266829',
        token0: '0x22a2488fe295047ba13bd8cccdbc8361dbd8cf7c',
        token1: '0x833589fcd6edb6e08f4c7c32d4f71b54bda02913',
        priceInUsd: 44920.9426428708,
      },
      '0x61366a4e6b1db1b85dd701f2f4bfa275ef271197': {
        address: '0x61366a4e6b1db1b85dd701f2f4bfa275ef271197',
        chainId: 8453,
        type: 'LP',
        symbol: 'OVN/USD+',
        decimals: 18,
        totalSupply: '132037551717536743',
        token0: '0xa3d1a8deb97b111454b294e2324efad13a9d8396',
        token1: '0xb79dd08ea68a908a97220c76d19a6aa9cbde4376',
        priceInUsd: 1713125.67074381,
      },
      '0xfc131b9981fb053c2cab7373daf70def1436c4bb': {
        address: '0xfc131b9981fb053c2cab7373daf70def1436c4bb',
        chainId: 8453,
        type: 'ERC721-NATIVE',
        symbol: 'USDC/TOSHI',
        decimals: 18,
        token0: '0x833589fcd6edb6e08f4c7c32d4f71b54bda02913',
        token1: '0xac1bd2486aaf3b5c0fc3fd868558b082a531b2b4',
      },
      '0xfc13b664e814098f08f10ba0fb23b1bb916f344e': {
        address: '0xfc13b664e814098f08f10ba0fb23b1bb916f344e',
        chainId: 8453,
        type: 'LP',
        symbol: 'AERO/L2VE',
        decimals: 18,
        totalSupply: '498210124142398128484804',
        token0: '0x940181a94a35a4569e4529a3cdfb74e38fd98631',
        token1: '0xa19328fb05ce6fd204d16c2a2a98f7cf434c12f4',
        priceInUsd: 0.026343878606970714,
      },
      '0x9b4db2f16199b8639ba386f44903ea2d51d65e43': {
        address: '0x9b4db2f16199b8639ba386f44903ea2d51d65e43',
        chainId: 8453,
        type: 'LP',
        symbol: 'MTA/USDBC',
        decimals: 18,
        totalSupply: '551762949231',
        token0: '0xba7d47f471add16875e765edee0858c3413a56fd',
        token1: '0xd9aaec86b65d86f6a7b5b1b0c42ffa531710b6ca',
        priceInUsd: 0,
      },
      '0xd448670823ff9667848c821bee829c642f67e064': {
        address: '0xd448670823ff9667848c821bee829c642f67e064',
        chainId: 8453,
        type: 'LP',
        symbol: 'WETH/RWAX',
        decimals: 18,
        totalSupply: '1154290940221212535152',
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0xe0023e73aab4fe9a22f059a9d27e857e027ee3dc',
        priceInUsd: 26.73199810587537,
      },
      '0x0b25c51637c43decd6cc1c1e3da4518d54ddb528': {
        address: '0x0b25c51637c43decd6cc1c1e3da4518d54ddb528',
        chainId: 8453,
        type: 'LP',
        symbol: 'DOLA/USDBC',
        decimals: 18,
        totalSupply: '53082989858168861',
        token0: '0x4621b7a9c75199271f773ebd9a499dbd165c3191',
        token1: '0xd9aaec86b65d86f6a7b5b1b0c42ffa531710b6ca',
        priceInUsd: 1983621.8703658725,
      },
      '0x8c7d15fcb443e07c5dc980901a6281f96d87c10f': {
        address: '0x8c7d15fcb443e07c5dc980901a6281f96d87c10f',
        chainId: 8453,
        type: 'LP',
        symbol: 'LUSD/USDBC',
        decimals: 18,
        totalSupply: '1174412024947',
        token0: '0x368181499736d0c0cc614dbb145e2ec1ac86b8c6',
        token1: '0xd9aaec86b65d86f6a7b5b1b0c42ffa531710b6ca',
        priceInUsd: 1698488.0276869705,
      },
      '0x862a9d8443bbf74cf86bc05afc8e05c63319dc1e': {
        address: '0x862a9d8443bbf74cf86bc05afc8e05c63319dc1e',
        chainId: 8453,
        type: 'LP',
        symbol: 'WETH/SEXY',
        decimals: 18,
        totalSupply: '7791721295569103475653',
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0xd1917629b3e6a72e6772aab5dbe58eb7fa3c2f33',
        priceInUsd: 27.206396900451118,
      },
      '0x2c114787d52e9f080464dbed8e285e07ec4e120f': {
        address: '0x2c114787d52e9f080464dbed8e285e07ec4e120f',
        chainId: 8453,
        type: 'ERC721-NATIVE',
        symbol: 'SEKOIA/WETH',
        decimals: 18,
        token0: '0x1185cb5122edad199bdbc0cbd7a0457e448f23c7',
        token1: '0x4200000000000000000000000000000000000006',
      },
      '0x988702fe529a3461ec7fd09eea3f962856709fd9': {
        address: '0x988702fe529a3461ec7fd09eea3f962856709fd9',
        chainId: 8453,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'USDC/EUSD',
        decimals: 18,
        token0: '0x833589fcd6edb6e08f4c7c32d4f71b54bda02913',
        token1: '0xcfa3ef56d303ae4faaba0592388f19d7c3399fb4',
      },
      '0xee6f3c5f418d1097c50c4698d535edb33bd72931': {
        address: '0xee6f3c5f418d1097c50c4698d535edb33bd72931',
        chainId: 8453,
        type: 'ERC721-NATIVE',
        symbol: 'WETH/SPEC',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0x96419929d7949d6a801a6909c145c8eef6a40431',
      },
      '0x76c0106bba123e9b32770b2b34b6d13bf4cfa933': {
        address: '0x76c0106bba123e9b32770b2b34b6d13bf4cfa933',
        chainId: 8453,
        type: 'ERC721-NATIVE',
        symbol: 'CLIZA/WETH',
        decimals: 18,
        token0: '0x290f057a2c59b95d8027aa4abf31782676502071',
        token1: '0x4200000000000000000000000000000000000006',
      },
      '0x6cdcb1c4a4d1c3c6d054b27ac5b77e89eafb971d': {
        address: '0x6cdcb1c4a4d1c3c6d054b27ac5b77e89eafb971d',
        chainId: 8453,
        type: 'LP',
        symbol: 'USDC/AERO',
        decimals: 18,
        totalSupply: '628798592530492002',
        token0: '0x833589fcd6edb6e08f4c7c32d4f71b54bda02913',
        token1: '0x940181a94a35a4569e4529a3cdfb74e38fd98631',
        priceInUsd: 115510051.542895,
      },
      '0x98c7a2338336d2d354663246f64676009c7bda97': {
        address: '0x98c7a2338336d2d354663246f64676009c7bda97',
        chainId: 8453,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'USDC/USDBC',
        decimals: 18,
        token0: '0x833589fcd6edb6e08f4c7c32d4f71b54bda02913',
        token1: '0xd9aaec86b65d86f6a7b5b1b0c42ffa531710b6ca',
      },
      '0x9bb646bf0f4da44bfaf3d899e774de065731edfe': {
        address: '0x9bb646bf0f4da44bfaf3d899e774de065731edfe',
        chainId: 8453,
        type: 'LP',
        symbol: 'CBETH/WETH',
        decimals: 18,
        totalSupply: '680366963318565022051',
        token0: '0x2ae3f1ec7f1f5012cfeab0185bfc7aa3cf0dec22',
        token1: '0x4200000000000000000000000000000000000006',
        priceInUsd: 8802.23798385141,
      },
      '0xcfccd3eb9f54fc9b3e171e9d128160701f38033b': {
        address: '0xcfccd3eb9f54fc9b3e171e9d128160701f38033b',
        chainId: 8453,
        type: 'ERC721-NATIVE',
        symbol: 'WETH/H4CK',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0x625bb9bb04bdca51871ed6d07e2dd9034e914631',
      },
      '0xb909f567c5c2bb1a4271349708cc4637d7318b4a': {
        address: '0xb909f567c5c2bb1a4271349708cc4637d7318b4a',
        chainId: 8453,
        type: 'LP',
        symbol: 'VIRTUAL/CBBTC',
        decimals: 18,
        totalSupply: '36854197385862230',
        token0: '0x0b3e328455c4059eeb9e3f84b5543f74e24e7e1b',
        token1: '0xcbb7c0000ab88b473b1f5afd9ef808440eed33bf',
        priceInUsd: 70963133.34710291,
      },
      '0x6d7da1a335dabca718e4ee5357041c96550d7563': {
        address: '0x6d7da1a335dabca718e4ee5357041c96550d7563',
        chainId: 8453,
        type: 'LP',
        symbol: 'WELS/PEGG',
        decimals: 18,
        totalSupply: '794532590240542164478',
        token0: '0x7f62ac1e974d65fab4a81821ca6af659a5f46298',
        token1: '0x82b0e1a2374ea0198f62a48b14ffab53db6c1e36',
        priceInUsd: 0.0213108652853164,
      },
      '0x3ba13e5074292aaba8f56faf65055952ccc20dc6': {
        address: '0x3ba13e5074292aaba8f56faf65055952ccc20dc6',
        chainId: 8453,
        type: 'ERC721-NATIVE',
        symbol: 'POLY/WETH',
        decimals: 18,
        token0: '0x2676e4e0e2eb58d9bdb5078358ff8a3a964cedf5',
        token1: '0x4200000000000000000000000000000000000006',
      },
      '0xf213f2d02837012dc0236cc105061e121bb03e37': {
        address: '0xf213f2d02837012dc0236cc105061e121bb03e37',
        chainId: 8453,
        type: 'LP',
        symbol: 'DOLA/USDC',
        decimals: 18,
        totalSupply: '483620366237760192',
        token0: '0x4621b7a9c75199271f773ebd9a499dbd165c3191',
        token1: '0x833589fcd6edb6e08f4c7c32d4f71b54bda02913',
        priceInUsd: 1981522.9247081343,
      },
      '0x4ba1e3e9280facbacafa7baf4ae0b78bea60beca': {
        address: '0x4ba1e3e9280facbacafa7baf4ae0b78bea60beca',
        chainId: 8453,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'WETH/SPX',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0x50da645f148798f68ef2d7db7c1cb22a6819bb2c',
      },
      '0x6689a0582bafcc286a81dc38d76e0470acd17275': {
        address: '0x6689a0582bafcc286a81dc38d76e0470acd17275',
        chainId: 8453,
        type: 'LP',
        symbol: 'WETH/AAG',
        decimals: 18,
        totalSupply: '378491251985501615143',
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0x96e890c6b2501a69cad5dba402bfb871a2a2874c',
        priceInUsd: 3.0579304954259663,
      },
      '0x47808ddbc91646b21b307fefbaf7ee200b004ccc': {
        address: '0x47808ddbc91646b21b307fefbaf7ee200b004ccc',
        chainId: 8453,
        type: 'ERC721-NATIVE',
        symbol: 'WETH/AIXBT',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0x4f9fd6be4a90f2620860d680c0d4d5fb53d1a825',
      },
      '0x8f5f1d63599362115e7f9fe71bfd5ab883d82c82': {
        address: '0x8f5f1d63599362115e7f9fe71bfd5ab883d82c82',
        chainId: 8453,
        type: 'LP',
        symbol: 'WETH/TN100X',
        decimals: 18,
        totalSupply: '362028481558788613102041',
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0x5b5dee44552546ecea05edea01dcd7be7aa6144a',
        priceInUsd: 1.2034383173451573,
      },
      '0x61c6e9e93592e535efc1bee07f491a517e98f6d0': {
        address: '0x61c6e9e93592e535efc1bee07f491a517e98f6d0',
        chainId: 8453,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'UXRP/WETH',
        decimals: 18,
        token0: '0x2615a94df961278dcbc41fb0a54fec5f10a693ae',
        token1: '0x4200000000000000000000000000000000000006',
      },
      '0x80326ed67271fb298d674c43aef3bc437b801b0e': {
        address: '0x80326ed67271fb298d674c43aef3bc437b801b0e',
        chainId: 8453,
        type: 'LP',
        symbol: 'ZUN/USDC',
        decimals: 18,
        totalSupply: '2766365676296689',
        token0: '0x1db0fc8933f545648b54a9ee4326209a9a259643',
        token1: '0x833589fcd6edb6e08f4c7c32d4f71b54bda02913',
        priceInUsd: 25616.453927605828,
      },
      '0x9785ef59e2b499fb741674ecf6faf912df7b3c1b': {
        address: '0x9785ef59e2b499fb741674ecf6faf912df7b3c1b',
        chainId: 8453,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'WETH/USDT',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0xfde4c96c8593536e31f229ea8f37b2ada2699bb2',
      },
      '0x44ecc644449fc3a9858d2007caa8cfaa4c561f91': {
        address: '0x44ecc644449fc3a9858d2007caa8cfaa4c561f91',
        chainId: 8453,
        type: 'LP',
        symbol: 'CBETH/WETH',
        decimals: 18,
        totalSupply: '37648829227822846692',
        token0: '0x2ae3f1ec7f1f5012cfeab0185bfc7aa3cf0dec22',
        token1: '0x4200000000000000000000000000000000000006',
        priceInUsd: 8770.906876931993,
      },
      '0x2ae9df02539887d4ebce0230168a302d34784c82': {
        address: '0x2ae9df02539887d4ebce0230168a302d34784c82',
        chainId: 8453,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'WETH/BSDETH',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0xcb327b99ff831bf8223cced12b1338ff3aa322ff',
      },
      '0x7f770a81811b58094b75cea1de76304aa8eae72c': {
        address: '0x7f770a81811b58094b75cea1de76304aa8eae72c',
        chainId: 8453,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'USDZ/CBBTC',
        decimals: 18,
        token0: '0x04d5ddf5f3a8939889f11e97f8c4bb48317f1938',
        token1: '0xcbb7c0000ab88b473b1f5afd9ef808440eed33bf',
      },
      '0xd07b4d7cea966b6e8087c8be3347e4b790679785': {
        address: '0xd07b4d7cea966b6e8087c8be3347e4b790679785',
        chainId: 8453,
        type: 'LP',
        symbol: 'HPC/WETH',
        decimals: 18,
        totalSupply: '2204366789525443627355',
        token0: '0x1f3ba804efb9cfe17d595e7262cea4782dbf6e4e',
        token1: '0x4200000000000000000000000000000000000006',
        priceInUsd: 1.6718094422608576,
      },
      '0x951fdfa193d92c74c9e35ea8c8c757cbcbb85147': {
        address: '0x951fdfa193d92c74c9e35ea8c8c757cbcbb85147',
        chainId: 8453,
        type: 'LP',
        symbol: 'WETH/VELA',
        decimals: 18,
        totalSupply: '13527480433980959209',
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0x5a76a56ad937335168b30df3aa1327277421c6ae',
        priceInUsd: 6.0019344189236925,
      },
      '0x97e6ff909f30d034f1dc9721e2939cea57116d95': {
        address: '0x97e6ff909f30d034f1dc9721e2939cea57116d95',
        chainId: 8453,
        type: 'LP',
        symbol: 'USDC/SUUSD',
        decimals: 18,
        totalSupply: '590153692990',
        token0: '0x833589fcd6edb6e08f4c7c32d4f71b54bda02913',
        token1: '0x8bf591eae535f93a242d5a954d3cde648b48a5a8',
        priceInUsd: 293104171.74168295,
      },
      '0xe5ff624bc6c0f85c5e1e27f94366b5829b1877a3': {
        address: '0xe5ff624bc6c0f85c5e1e27f94366b5829b1877a3',
        chainId: 8453,
        type: 'ERC721-NATIVE',
        symbol: 'GAME/WETH',
        decimals: 18,
        token0: '0x1c4cca7c5db003824208adda61bd749e55f463a3',
        token1: '0x4200000000000000000000000000000000000006',
      },
      '0xa51c7a5a121ad3d73e2e9888bb016e07bdd5ba94': {
        address: '0xa51c7a5a121ad3d73e2e9888bb016e07bdd5ba94',
        chainId: 8453,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'EURC/USD+',
        decimals: 18,
        token0: '0x60a3e35cc302bfa44cb288bc5a4f316fdb1adb42',
        token1: '0xb79dd08ea68a908a97220c76d19a6aa9cbde4376',
      },
      '0xa819af1cc8abe618ea8abadeb464960f7451ceab': {
        address: '0xa819af1cc8abe618ea8abadeb464960f7451ceab',
        chainId: 8453,
        type: 'LP',
        symbol: 'WETH/UNIDX',
        decimals: 18,
        totalSupply: '16602131878072186',
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0x6b4712ae9797c199edd44f897ca09bc57628a1cf',
        priceInUsd: 46.53214580793351,
      },
      '0x598299fb3f3829f7ba08662948706cdff7ec2350': {
        address: '0x598299fb3f3829f7ba08662948706cdff7ec2350',
        chainId: 8453,
        type: 'LP',
        symbol: 'WETH/SAM',
        decimals: 18,
        totalSupply: '31806996886723909414183',
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0xed1779845520339693cdbffec49a74246e7d671b',
        priceInUsd: 5.550705648125741,
      },
      '0x4d69971ccd4a636c403a3c1b00c85e99bb9b5606': {
        address: '0x4d69971ccd4a636c403a3c1b00c85e99bb9b5606',
        chainId: 8453,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'WETH/USD+',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0xb79dd08ea68a908a97220c76d19a6aa9cbde4376',
      },
      '0xa33f162da19c7273ba1205bfd9d4340da2446e3a': {
        address: '0xa33f162da19c7273ba1205bfd9d4340da2446e3a',
        chainId: 8453,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'TBTC/WETH',
        decimals: 18,
        token0: '0x236aa50979d5f3de3bd1eeb40e81137f22ab794b',
        token1: '0x4200000000000000000000000000000000000006',
      },
      '0xc41430a2090f0640e93322c6347c6740b4bdf9cd': {
        address: '0xc41430a2090f0640e93322c6347c6740b4bdf9cd',
        chainId: 8453,
        type: 'LP',
        symbol: 'WETH/YFX',
        decimals: 18,
        totalSupply: '1201885460718275351',
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0x8901cb2e82cc95c01e42206f8d1f417fe53e7af0',
        priceInUsd: 127.2387514186881,
      },
      '0x3333e1d9174720d6ec2cf815e65b82915a9eae1e': {
        address: '0x3333e1d9174720d6ec2cf815e65b82915a9eae1e',
        chainId: 8453,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'WETH/PEPE',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0xb4fde59a779991bfb6a52253b51947828b982be3',
      },
      '0xb7a0b6322834014f95841e643dffa7bb9b9dc0ed': {
        address: '0xb7a0b6322834014f95841e643dffa7bb9b9dc0ed',
        chainId: 8453,
        type: 'LP',
        symbol: 'WETH/BETS',
        decimals: 18,
        totalSupply: '743954963010645237896',
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0x94025780a1ab58868d9b2dbbb775f44b32e8e6e5',
        priceInUsd: 1.8199356267161209,
      },
      '0x0b15b1d434f86ecaa83d14398c8db6d162f3921e': {
        address: '0x0b15b1d434f86ecaa83d14398c8db6d162f3921e',
        chainId: 8453,
        type: 'LP',
        symbol: 'LUSD/POOL',
        decimals: 18,
        totalSupply: '15252314119163765539719',
        token0: '0x368181499736d0c0cc614dbb145e2ec1ac86b8c6',
        token1: '0xd652c5425aea2afd5fb142e120fecf79e18fafc3',
        priceInUsd: 0.9513814556160629,
      },
      '0x5c45b0f48c326f79b56709d8f63ce2bee7697106': {
        address: '0x5c45b0f48c326f79b56709d8f63ce2bee7697106',
        chainId: 8453,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'WETH/USUI',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0xb0505e5a99abd03d94a1169e638b78edfed26ea4',
      },
      '0xc4ecaf115cbce3985748c58dccfc4722fef8247c': {
        address: '0xc4ecaf115cbce3985748c58dccfc4722fef8247c',
        chainId: 8453,
        type: 'ERC721-NATIVE',
        symbol: 'ANON/WETH',
        decimals: 18,
        token0: '0x0db510e79909666d6dec7f5e49370838c16d950f',
        token1: '0x4200000000000000000000000000000000000006',
      },
      '0x3d5d143381916280ff91407febeb52f2b60f33cf': {
        address: '0x3d5d143381916280ff91407febeb52f2b60f33cf',
        chainId: 8453,
        type: 'ERC721-NATIVE',
        symbol: 'WETH/AERO',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0x940181a94a35a4569e4529a3cdfb74e38fd98631',
      },
      '0x14f7ce67e16c435c876aff4092eb547584121312': {
        address: '0x14f7ce67e16c435c876aff4092eb547584121312',
        chainId: 8453,
        type: 'LP',
        symbol: 'WETH/LRDS',
        decimals: 18,
        totalSupply: '24578237369082027947628',
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0xb676f87a6e701f0de8de5ab91b56b66109766db1',
        priceInUsd: 44.88498928524668,
      },
      '0x5bfb340fa9305abb164fb0248d0d82fc3d82c3bb': {
        address: '0x5bfb340fa9305abb164fb0248d0d82fc3d82c3bb',
        chainId: 8453,
        type: 'LP',
        symbol: 'EUSD/USDBC',
        decimals: 18,
        totalSupply: '342430790897588',
        token0: '0xcfa3ef56d303ae4faaba0592388f19d7c3399fb4',
        token1: '0xd9aaec86b65d86f6a7b5b1b0c42ffa531710b6ca',
        priceInUsd: 1988781.0532913376,
      },
      '0x094080dfa2467263159f8054b3960f90996bfd77': {
        address: '0x094080dfa2467263159f8054b3960f90996bfd77',
        chainId: 8453,
        type: 'ERC721-NATIVE',
        symbol: 'WETH/CERTAI',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0xf5f2a79eeccf6e7f4c570c803f529930e29cc96b',
      },
      '0xe8f548d25db0b4073c34ec2c5d3f30b1a5b72da8': {
        address: '0xe8f548d25db0b4073c34ec2c5d3f30b1a5b72da8',
        chainId: 8453,
        type: 'ERC721-NATIVE',
        symbol: '$COOL/WETH',
        decimals: 18,
        token0: '0x3080ce06eee2869e1b0287ad0de73f9421f977a3',
        token1: '0x4200000000000000000000000000000000000006',
      },
      '0x0f741e1f9ed5428b07ba4911497cce310647d0c2': {
        address: '0x0f741e1f9ed5428b07ba4911497cce310647d0c2',
        chainId: 8453,
        type: 'ERC721-NATIVE',
        symbol: 'VIRTUAL/LUNA',
        decimals: 18,
        token0: '0x0b3e328455c4059eeb9e3f84b5543f74e24e7e1b',
        token1: '0x55cd6469f597452b5a7536e2cd98fde4c1247ee4',
      },
      '0xa41bc0affba7fd420d186b84899d7ab2ac57fcd1': {
        address: '0xa41bc0affba7fd420d186b84899d7ab2ac57fcd1',
        chainId: 8453,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'USDC/USDT',
        decimals: 18,
        token0: '0x833589fcd6edb6e08f4c7c32d4f71b54bda02913',
        token1: '0xfde4c96c8593536e31f229ea8f37b2ada2699bb2',
      },
      '0x17cf4abb54a9d18c90fa0e36b8669ab0f4936f2e': {
        address: '0x17cf4abb54a9d18c90fa0e36b8669ab0f4936f2e',
        chainId: 8453,
        type: 'LP',
        symbol: 'WETH/CHAD',
        decimals: 18,
        totalSupply: '23582280172391309593449',
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0xecaf81eb42cd30014eb44130b89bcd6d4ad98b92',
        priceInUsd: 0.5988808529584518,
      },
      '0xda74029240f657a7be372906290300dbb8f1bccd': {
        address: '0xda74029240f657a7be372906290300dbb8f1bccd',
        chainId: 8453,
        type: 'LP',
        symbol: 'GROW/WETH',
        decimals: 18,
        totalSupply: '910373378771887449',
        token0: '0x321725ee44cb4bfa544cf45a5a585b925d30a58c',
        token1: '0x4200000000000000000000000000000000000006',
        priceInUsd: 87.585456648537,
      },
      '0x01a1f5758c3a53057b6c819ec7331e39c167794a': {
        address: '0x01a1f5758c3a53057b6c819ec7331e39c167794a',
        chainId: 8453,
        type: 'ERC721-NATIVE',
        symbol: 'CHAOS/WETH',
        decimals: 18,
        token0: '0x20d704099b62ada091028bcfc44445041ed16f09',
        token1: '0x4200000000000000000000000000000000000006',
      },
      '0x67b00b46fa4f4f24c03855c5c8013c0b938b3eec': {
        address: '0x67b00b46fa4f4f24c03855c5c8013c0b938b3eec',
        chainId: 8453,
        type: 'LP',
        symbol: 'DAI/USDC',
        decimals: 18,
        totalSupply: '14987167112065885',
        token0: '0x50c5725949a6f0c72e6c4a641f24049a917db0cb',
        token1: '0x833589fcd6edb6e08f4c7c32d4f71b54bda02913',
        priceInUsd: 2001093.2863355624,
      },
      '0x45e20300f4a1d13c86440b098ecc5673ca927928': {
        address: '0x45e20300f4a1d13c86440b098ecc5673ca927928',
        chainId: 8453,
        type: 'ERC721-NATIVE',
        symbol: 'GIA/EMP',
        decimals: 18,
        token0: '0x2bd8880e7424dfb94597429de7253de73694de01',
        token1: '0x39d5313c3750140e5042887413ba8aa6145a9bd2',
      },
      '0x1da71ce5ebf772f9fdd44e29bec53c7185e188ba': {
        address: '0x1da71ce5ebf772f9fdd44e29bec53c7185e188ba',
        chainId: 8453,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'WETH/OVN',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0xa3d1a8deb97b111454b294e2324efad13a9d8396',
      },
      '0x5d4e504eb4c526995e0cc7a6e327fda75d8b52b5': {
        address: '0x5d4e504eb4c526995e0cc7a6e327fda75d8b52b5',
        chainId: 8453,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'WETH/EURC',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0x60a3e35cc302bfa44cb288bc5a4f316fdb1adb42',
      },
      '0xb6b777577a05d85ffca7d9ebc7476fb344b92445': {
        address: '0xb6b777577a05d85ffca7d9ebc7476fb344b92445',
        chainId: 8453,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'WETH/LUNA',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0x55cd6469f597452b5a7536e2cd98fde4c1247ee4',
      },
      '0x4e962bb3889bf030368f56810a9c96b83cb3e778': {
        address: '0x4e962bb3889bf030368f56810a9c96b83cb3e778',
        chainId: 8453,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'USDC/CBBTC',
        decimals: 18,
        token0: '0x833589fcd6edb6e08f4c7c32d4f71b54bda02913',
        token1: '0xcbb7c0000ab88b473b1f5afd9ef808440eed33bf',
      },
      '0xb211a9ddff3a10806c8fdb92dbc4c34596a23f84': {
        address: '0xb211a9ddff3a10806c8fdb92dbc4c34596a23f84',
        chainId: 8453,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'WETH/KEYCAT',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0x9a26f5433671751c3276a065f57e5a02d2817973',
      },
      '0x63b9877618e27081181a59f9ca52040ada1332fc': {
        address: '0x63b9877618e27081181a59f9ca52040ada1332fc',
        chainId: 8453,
        type: 'LP',
        symbol: 'WETH/XCAD',
        decimals: 18,
        totalSupply: '1354781199886425255952',
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0x750cf88d9e0c2bcedeec31d5faad6ed6e3f1abc6',
        priceInUsd: 20.6873034038291,
      },
      '0xebab2be57727f0165f4bb35d765377b951100b5f': {
        address: '0xebab2be57727f0165f4bb35d765377b951100b5f',
        chainId: 8453,
        type: 'ERC721-NATIVE',
        symbol: 'WETH/VADER',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0x731814e491571a2e9ee3c5b1f7f3b962ee8f4870',
      },
      '0xf91e0dfe1265b914182de54e08c9ca2068beddde': {
        address: '0xf91e0dfe1265b914182de54e08c9ca2068beddde',
        chainId: 8453,
        type: 'LP',
        symbol: 'WETH/MET',
        decimals: 18,
        totalSupply: '21110042503216645450206',
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0x93dc5cb35627a759848c7a7f0079ea7b49e435a5',
        priceInUsd: 95.19915162019039,
      },
      '0x062d9afe7d0c0cbc1806b8c035ee6a08268362f2': {
        address: '0x062d9afe7d0c0cbc1806b8c035ee6a08268362f2',
        chainId: 8453,
        type: 'ERC721-NATIVE',
        symbol: 'WETH/AIXCB',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0x76c71f1703fbf19ffdcf3051e1e684cb9934510f',
      },
      '0xaec085e5a5ce8d96a7bdd3eb3a62445d4f6ce703': {
        address: '0xaec085e5a5ce8d96a7bdd3eb3a62445d4f6ce703',
        chainId: 8453,
        type: 'ERC721-NATIVE',
        symbol: 'BNKR/WETH',
        decimals: 18,
        token0: '0x22af33fe49fd1fa80c7149773dde5890d3c76f3b',
        token1: '0x4200000000000000000000000000000000000006',
      },
      '0x326841efd63340767e02ec88e583f18a82af4a48': {
        address: '0x326841efd63340767e02ec88e583f18a82af4a48',
        chainId: 8453,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'WETH/MIGGLES',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0xb1a03eda10342529bbf8eb700a06c60441fef25d',
      },
      '0xf4348227607b166917b9f50cf51979e376995b73': {
        address: '0xf4348227607b166917b9f50cf51979e376995b73',
        chainId: 8453,
        type: 'ERC721-NATIVE',
        symbol: 'WETH/BSHIB',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0xfea9dcdc9e23a9068bf557ad5b186675c61d33ea',
      },
      '0xade9bcd4b968ee26bed102dd43a55f6a8c2416df': {
        address: '0xade9bcd4b968ee26bed102dd43a55f6a8c2416df',
        chainId: 8453,
        type: 'ERC721-NATIVE',
        symbol: 'WETH/DOGINME',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0x6921b130d297cc43754afba22e5eac0fbf8db75b',
      },
      '0x0c1a09d5d0445047da3ab4994262b22404288a3b': {
        address: '0x0c1a09d5d0445047da3ab4994262b22404288a3b',
        chainId: 8453,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'USDC/USD+',
        decimals: 18,
        token0: '0x833589fcd6edb6e08f4c7c32d4f71b54bda02913',
        token1: '0xb79dd08ea68a908a97220c76d19a6aa9cbde4376',
      },
      '0x3fc28bfac25fc8e93b5b2fc15efbbd5a8aa44efe': {
        address: '0x3fc28bfac25fc8e93b5b2fc15efbbd5a8aa44efe',
        chainId: 8453,
        type: 'LP',
        symbol: 'WUSDR/USDBC',
        decimals: 18,
        totalSupply: '4601424640852',
        token0: '0x9483ab65847a447e36d21af1cab8c87e9712ff93',
        token1: '0xd9aaec86b65d86f6a7b5b1b0c42ffa531710b6ca',
        priceInUsd: 22139007211.86753,
      },
      '0xb4885bc63399bf5518b994c1d0c153334ee579d0': {
        address: '0xb4885bc63399bf5518b994c1d0c153334ee579d0',
        chainId: 8453,
        type: 'LP',
        symbol: 'WETH/USDBC',
        decimals: 18,
        totalSupply: '3299128049936641',
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0xd9aaec86b65d86f6a7b5b1b0c42ffa531710b6ca',
        priceInUsd: 129407569.17707464,
      },
      '0xfd8aa87c97d32345bfe4f753acf25729008331c9': {
        address: '0xfd8aa87c97d32345bfe4f753acf25729008331c9',
        chainId: 8453,
        type: 'LP',
        symbol: 'TBTC/T',
        decimals: 18,
        totalSupply: '11618069896243186384',
        token0: '0x236aa50979d5f3de3bd1eeb40e81137f22ab794b',
        token1: '0x26f3901ac8a79c50fb0d8289c74f0d09adc42e29',
        priceInUsd: 82.90542815221596,
      },
      '0xa01a2513e95263b9bace60b573ce874e1e7a5246': {
        address: '0xa01a2513e95263b9bace60b573ce874e1e7a5246',
        chainId: 8453,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'USD+/WSTETH',
        decimals: 18,
        token0: '0xb79dd08ea68a908a97220c76d19a6aa9cbde4376',
        token1: '0xc1cba3fcea344f92d9239c08c0568f6f2f0ee452',
      },
      '0x22a52bb644f855ebd5ca2edb643ff70222d70c31': {
        address: '0x22a52bb644f855ebd5ca2edb643ff70222d70c31',
        chainId: 8453,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'WETH/AIXBT',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0x4f9fd6be4a90f2620860d680c0d4d5fb53d1a825',
      },
      '0x97f0470819080e85724d42ba4325c56698c3b387': {
        address: '0x97f0470819080e85724d42ba4325c56698c3b387',
        chainId: 8453,
        type: 'ERC721-NATIVE',
        symbol: 'WETH/COOKIE',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0xc0041ef357b183448b235a8ea73ce4e4ec8c265f',
      },
      '0x8ce9b689018fc94f44540b62ba6e10dc8b346448': {
        address: '0x8ce9b689018fc94f44540b62ba6e10dc8b346448',
        chainId: 8453,
        type: 'ERC721-NATIVE',
        symbol: 'WETH/FUNGI',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0x7d9ce55d54ff3feddb611fc63ff63ec01f26d15f',
      },
      '0x940181a94a35a4569e4529a3cdfb74e38fd98631': {
        address: '0x940181a94a35a4569e4529a3cdfb74e38fd98631',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'AERO',
        decimals: 18,
        totalSupply: '1748524991070015284057744555',
        priceInUsd: 1.101278081912534,
      },
      '0x3f386acc3a8e9194cf6279c219df8dd3c5b71974': {
        address: '0x3f386acc3a8e9194cf6279c219df8dd3c5b71974',
        chainId: 8453,
        type: 'LP',
        symbol: 'WETH/THALES',
        decimals: 18,
        totalSupply: '346864400920091402095',
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0xf34e0cff046e154cafcae502c7541b9e5fd8c249',
        priceInUsd: 66.14963212556403,
      },
      '0x9e4cb8b916289864321661ce02cf66aa5ba63c94': {
        address: '0x9e4cb8b916289864321661ce02cf66aa5ba63c94',
        chainId: 8453,
        type: 'LP',
        symbol: 'WETH/DEUS',
        decimals: 18,
        totalSupply: '1687564089644186020800',
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0xde5ed76e7c05ec5e4572cfc88d1acea165109e44',
        priceInUsd: 338.74094083451064,
      },
      '0x2ea054c177abd8b8c87704eaa08680db5c6d805c': {
        address: '0x2ea054c177abd8b8c87704eaa08680db5c6d805c',
        chainId: 8453,
        type: 'ERC721-NATIVE',
        symbol: 'WETH/KAITO',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0x98d0baa52b2d063e780de12f615f963fe8537553',
      },
      '0x14dccdd311ab827c42cca448ba87b1ac1039e2a4': {
        address: '0x14dccdd311ab827c42cca448ba87b1ac1039e2a4',
        chainId: 8453,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'WSTETH/WRSETH',
        decimals: 18,
        token0: '0xc1cba3fcea344f92d9239c08c0568f6f2f0ee452',
        token1: '0xedfa23602d0ec14714057867a78d01e94176bea0',
      },
      '0x670e77c361375be9013869ccc516027ccc90383f': {
        address: '0x670e77c361375be9013869ccc516027ccc90383f',
        chainId: 8453,
        type: 'ERC721-NATIVE',
        symbol: 'KUDAI/WETH',
        decimals: 18,
        token0: '0x288f4eb27400fa220d14b864259ad1b7f77c1594',
        token1: '0x4200000000000000000000000000000000000006',
      },
      '0xa4463789e8f3c6a599b3dfb608dde55513bcf289': {
        address: '0xa4463789e8f3c6a599b3dfb608dde55513bcf289',
        chainId: 8453,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'WETH/ZRO',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0x6985884c4392d348587b19cb9eaaf157f13271cd',
      },
      '0x1416d46ebf8afc4efe1942d7d8e14459aabc7891': {
        address: '0x1416d46ebf8afc4efe1942d7d8e14459aabc7891',
        chainId: 8453,
        type: 'LP',
        symbol: 'USDC/HLSP',
        decimals: 18,
        totalSupply: '29439250636',
        token0: '0x833589fcd6edb6e08f4c7c32d4f71b54bda02913',
        token1: '0xe54b0c7dad72fb102ade2b1b9f4eece69408ab36',
        priceInUsd: 1907102239870.7378,
      },
      '0xd97a40434627d5c897790de9a3d2e577cba5f2e0': {
        address: '0xd97a40434627d5c897790de9a3d2e577cba5f2e0',
        chainId: 8453,
        type: 'LP',
        symbol: 'DAI+/USD+',
        decimals: 18,
        totalSupply: '65822293222946',
        token0: '0x65a2508c429a6078a7bc2f7df81ab575bd9d9275',
        token1: '0xb79dd08ea68a908a97220c76d19a6aa9cbde4376',
        priceInUsd: 1954644.9828987366,
      },
      '0xc02dc3a9b6ead739c56cdea716d8fec4ffe4c799': {
        address: '0xc02dc3a9b6ead739c56cdea716d8fec4ffe4c799',
        chainId: 8453,
        type: 'LP',
        symbol: 'WETH/MOXIE',
        decimals: 18,
        totalSupply: '13501842975302160179289',
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0x8c9037d1ef5c6d1f6816278c7aaf5491d24cd527',
        priceInUsd: 0.5164157500823716,
      },
      '0x0ebcee3165654d9c52dd6d438423be76f2df1b0e': {
        address: '0x0ebcee3165654d9c52dd6d438423be76f2df1b0e',
        chainId: 8453,
        type: 'ERC721-NATIVE',
        symbol: 'FDREAM/WETH',
        decimals: 18,
        token0: '0x0521aaa7c96e25afee79fdd4f1bb48f008ae4eac',
        token1: '0x4200000000000000000000000000000000000006',
      },
      '0x7a034374c89c463dd65d8c9bcfe63bcbced41f4f': {
        address: '0x7a034374c89c463dd65d8c9bcfe63bcbced41f4f',
        chainId: 8453,
        type: 'LP',
        symbol: 'USDC/EUSD',
        decimals: 18,
        totalSupply: '820422696266671993',
        token0: '0x833589fcd6edb6e08f4c7c32d4f71b54bda02913',
        token1: '0xcfa3ef56d303ae4faaba0592388f19d7c3399fb4',
        priceInUsd: 1999081.8759166624,
      },
      '0xd8582fc6daf45ed8076292e7a8586e87fd67bc0c': {
        address: '0xd8582fc6daf45ed8076292e7a8586e87fd67bc0c',
        chainId: 8453,
        type: 'ERC721-NATIVE',
        symbol: 'WETH/G3',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0xcf67815cce72e682eb4429eca46843bed81ca739',
      },
      '0x5f43555b02507133ecd5b78218283ed849b07eac': {
        address: '0x5f43555b02507133ecd5b78218283ed849b07eac',
        chainId: 8453,
        type: 'LP',
        symbol: 'USDBC/THALES',
        decimals: 18,
        totalSupply: '1679568708692830',
        token0: '0xd9aaec86b65d86f6a7b5b1b0c42ffa531710b6ca',
        token1: '0xf34e0cff046e154cafcae502c7541b9e5fd8c249',
        priceInUsd: 1020070.3115577645,
      },
      '0x28a9ec9928a689410e82e579fd9418fbbf6452f3': {
        address: '0x28a9ec9928a689410e82e579fd9418fbbf6452f3',
        chainId: 8453,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'WETH/FAI',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0xb33ff54b9f7242ef1593d2c9bcd8f9df46c77935',
      },
      '0xc9034c3e7f58003e6ae0c8438e7c8f4598d5acaa': {
        address: '0xc9034c3e7f58003e6ae0c8438e7c8f4598d5acaa',
        chainId: 8453,
        type: 'ERC721-NATIVE',
        symbol: 'WETH/DEGEN',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0x4ed4e862860bed51a9570b96d89af5e1b0efefed',
      },
      '0x43b97febdadad12afde21baa96eb762bc26d13f3': {
        address: '0x43b97febdadad12afde21baa96eb762bc26d13f3',
        chainId: 8453,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'USDC/AXLUSDC',
        decimals: 18,
        token0: '0x833589fcd6edb6e08f4c7c32d4f71b54bda02913',
        token1: '0xeb466342c4d449bc9f53a865d5cb90586f405215',
      },
      '0x2b7704f1cb9324cd8586b33c6c540cbd64e58237': {
        address: '0x2b7704f1cb9324cd8586b33c6c540cbd64e58237',
        chainId: 8453,
        type: 'LP',
        symbol: 'EXTRA/USDBC',
        decimals: 18,
        totalSupply: '5127438937626308',
        token0: '0x2dad3a13ef0c6366220f989157009e501e7938f8',
        token1: '0xd9aaec86b65d86f6a7b5b1b0c42ffa531710b6ca',
        priceInUsd: 269557.54239179863,
      },
      '0x2223f9fe624f69da4d8256a7bcc9104fba7f8f75': {
        address: '0x2223f9fe624f69da4d8256a7bcc9104fba7f8f75',
        chainId: 8453,
        type: 'LP',
        symbol: 'AERO/USDBC',
        decimals: 18,
        totalSupply: '299962750609349308',
        token0: '0x940181a94a35a4569e4529a3cdfb74e38fd98631',
        token1: '0xd9aaec86b65d86f6a7b5b1b0c42ffa531710b6ca',
        priceInUsd: 2115092.6635795645,
      },
      '0x1307f36bc34081401497a873522570aeba4cde90': {
        address: '0x1307f36bc34081401497a873522570aeba4cde90',
        chainId: 8453,
        type: 'LP',
        symbol: 'USDC/MTA',
        decimals: 18,
        totalSupply: '5461510063112565',
        token0: '0x833589fcd6edb6e08f4c7c32d4f71b54bda02913',
        token1: '0xba7d47f471add16875e765edee0858c3413a56fd',
        priceInUsd: 346137.1910293413,
      },
      '0x1d2bdb7117a5a7d7fe4c1d95681a92e4df13bb69': {
        address: '0x1d2bdb7117a5a7d7fe4c1d95681a92e4df13bb69',
        chainId: 8453,
        type: 'ERC721-NATIVE',
        symbol: 'WETH/VVV',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0xacfe6019ed1a7dc6f7b508c02d1b04ec88cc21bf',
      },
      '0x0f4647926fba360fdff107917682fad847a54d6b': {
        address: '0x0f4647926fba360fdff107917682fad847a54d6b',
        chainId: 8453,
        type: 'ERC721-NATIVE',
        symbol: 'GIA/WETH',
        decimals: 18,
        token0: '0x2bd8880e7424dfb94597429de7253de73694de01',
        token1: '0x4200000000000000000000000000000000000006',
      },
      '0xeb956b77d455e33b41bbe6052dbe4388dcfd729b': {
        address: '0xeb956b77d455e33b41bbe6052dbe4388dcfd729b',
        chainId: 8453,
        type: 'LP',
        symbol: 'ANIME/WETH',
        decimals: 18,
        totalSupply: '3879878846734127287538',
        token0: '0x0e0c9756a3290cd782cf4ab73ac24d25291c9564',
        token1: '0x4200000000000000000000000000000000000006',
        priceInUsd: 0.7614810999788283,
      },
      '0x9b4705112943beb2215ee19fe31af657a55c9ab1': {
        address: '0x9b4705112943beb2215ee19fe31af657a55c9ab1',
        chainId: 8453,
        type: 'ERC721-NATIVE',
        symbol: 'SIMMI/CHAOS',
        decimals: 18,
        token0: '0x161e113b8e9bbaefb846f73f31624f6f9607bd44',
        token1: '0x20d704099b62ada091028bcfc44445041ed16f09',
      },
      '0xc29dc26b28fff463e32834ce6325b5c74fac7098': {
        address: '0xc29dc26b28fff463e32834ce6325b5c74fac7098',
        chainId: 8453,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'MOG/WETH',
        decimals: 18,
        token0: '0x2da56acb9ea78330f947bd57c54119debda7af71',
        token1: '0x4200000000000000000000000000000000000006',
      },
      '0x2c4909355b0c036840819484c3a882a95659abf3': {
        address: '0x2c4909355b0c036840819484c3a882a95659abf3',
        chainId: 8453,
        type: 'LP',
        symbol: 'WETH/DEGEN',
        decimals: 18,
        totalSupply: '38411590572630903547425',
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0x4ed4e862860bed51a9570b96d89af5e1b0efefed',
        priceInUsd: 7.160514455522225,
      },
      '0x2d25e0514f23c6367687de89bd5167dc754d4934': {
        address: '0x2d25e0514f23c6367687de89bd5167dc754d4934',
        chainId: 8453,
        type: 'LP',
        symbol: 'WETH/TAROT',
        decimals: 18,
        totalSupply: '44481304863441443499889',
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0xf544251d25f3d243a36b07e7e7962a678f952691',
        priceInUsd: 39.66038863553785,
      },
      '0x68b27e9066d3aadc6078e17c8611b37868f96a1d': {
        address: '0x68b27e9066d3aadc6078e17c8611b37868f96a1d',
        chainId: 8453,
        type: 'ERC721-NATIVE',
        symbol: 'WETH/FAI',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0xb33ff54b9f7242ef1593d2c9bcd8f9df46c77935',
      },
      '0x2722c8f9b5e2ac72d1f225f8e8c990e449ba0078': {
        address: '0x2722c8f9b5e2ac72d1f225f8e8c990e449ba0078',
        chainId: 8453,
        type: 'LP',
        symbol: 'TBTC/WETH',
        decimals: 18,
        totalSupply: '7891441893158701878',
        token0: '0x236aa50979d5f3de3bd1eeb40e81137f22ab794b',
        token1: '0x4200000000000000000000000000000000000006',
        priceInUsd: 43412.79158330456,
      },
      '0xc58fecb0c0f0d5b40b5bdac3cca989e8a49f732f': {
        address: '0xc58fecb0c0f0d5b40b5bdac3cca989e8a49f732f',
        chainId: 8453,
        type: 'ERC721-NATIVE',
        symbol: 'WETH/CAPO',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0x63cb9a22cbc00bf9159429e9dede4b88c3dba8ce',
      },
      '0xf81e1a62cbfa487e807044618661bfd4802b4982': {
        address: '0xf81e1a62cbfa487e807044618661bfd4802b4982',
        chainId: 8453,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'TBTC/USDC',
        decimals: 18,
        token0: '0x236aa50979d5f3de3bd1eeb40e81137f22ab794b',
        token1: '0x833589fcd6edb6e08f4c7c32d4f71b54bda02913',
      },
      '0xcdb55b284257fd5f879598ba9e4b852bb0c3edf1': {
        address: '0xcdb55b284257fd5f879598ba9e4b852bb0c3edf1',
        chainId: 8453,
        type: 'LP',
        symbol: 'USDC/XSWAP',
        decimals: 18,
        totalSupply: '355797596123036489',
        token0: '0x833589fcd6edb6e08f4c7c32d4f71b54bda02913',
        token1: '0x8fe815417913a93ea99049fc0718ee1647a2a07c',
        priceInUsd: 354711.0091691505,
      },
      '0x82ad659c2f152aad59bb37cbc5e7663a2de0c607': {
        address: '0x82ad659c2f152aad59bb37cbc5e7663a2de0c607',
        chainId: 8453,
        type: 'ERC721-NATIVE',
        symbol: 'WETH/BRIUN',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0x8c81b4c816d66d36c4bf348bdec01dbcbc70e987',
      },
      '0x7ce345561e1690445eefa0db04f59d64b65598a8': {
        address: '0x7ce345561e1690445eefa0db04f59d64b65598a8',
        chainId: 8453,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'WBLT/USDC',
        decimals: 18,
        token0: '0x4e74d4db6c0726ccded4656d0bce448876bb4c7a',
        token1: '0x833589fcd6edb6e08f4c7c32d4f71b54bda02913',
      },
      '0x6d8503c85340176f61d5593182cccd37ba7e9b6a': {
        address: '0x6d8503c85340176f61d5593182cccd37ba7e9b6a',
        chainId: 8453,
        type: 'ERC721-NATIVE',
        symbol: 'WETH/GUD',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0xa608512bbc9934e4b1ddecf0f5fb38b6ad93308d',
      },
      '0xfdbaf04326acc24e3d1788333826b71e3291863a': {
        address: '0xfdbaf04326acc24e3d1788333826b71e3291863a',
        chainId: 8453,
        type: 'ERC721-NATIVE',
        symbol: 'FARTCOIN/WETH',
        decimals: 18,
        token0: '0x2f6c17fa9f9bc3600346ab4e48c0701e1d5962ae',
        token1: '0x4200000000000000000000000000000000000006',
      },
      '0xacbff2edbcf8089adec9706ff3cb6df2502a30e1': {
        address: '0xacbff2edbcf8089adec9706ff3cb6df2502a30e1',
        chainId: 8453,
        type: 'LP',
        symbol: 'USDBC/AXLUSDC',
        decimals: 18,
        totalSupply: '200516087',
        token0: '0xd9aaec86b65d86f6a7b5b1b0c42ffa531710b6ca',
        token1: '0xeb466342c4d449bc9f53a865d5cb90586f405215',
        priceInUsd: 2005582791452.6663,
      },
      '0x7ec18abf80e865c6799069df91073335935c4185': {
        address: '0x7ec18abf80e865c6799069df91073335935c4185',
        chainId: 8453,
        type: 'ERC721-NATIVE',
        symbol: 'WETH/$MFER',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0xe3086852a4b125803c815a158249ae468a3254ca',
      },
      '0x68cfb52c74827f91e1f664ffed634f849aece455': {
        address: '0x68cfb52c74827f91e1f664ffed634f849aece455',
        chainId: 8453,
        type: 'LP',
        symbol: 'HBR/USDC',
        decimals: 18,
        totalSupply: '17017843126292587',
        token0: '0x416bd43bc76d496ff49923c20ecaf86b52ab078d',
        token1: '0x833589fcd6edb6e08f4c7c32d4f71b54bda02913',
        priceInUsd: 10909.039587553385,
      },
      '0xcc79bfa7a3212d94390c358e88afcd39294549ca': {
        address: '0xcc79bfa7a3212d94390c358e88afcd39294549ca',
        chainId: 8453,
        type: 'LP',
        symbol: 'SNX/USDC',
        decimals: 18,
        totalSupply: '66875410675739184',
        token0: '0x22e6966b799c4d5b13be962e1d117b56327fda66',
        token1: '0x833589fcd6edb6e08f4c7c32d4f71b54bda02913',
        priceInUsd: 1694692.20898391,
      },
      '0xdc7ead706795eda3feda08ad519d9452badf2c0d': {
        address: '0xdc7ead706795eda3feda08ad519d9452badf2c0d',
        chainId: 8453,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'EZETH/WETH',
        decimals: 18,
        token0: '0x2416092f143378750bb29b79ed961ab195cceea5',
        token1: '0x4200000000000000000000000000000000000006',
      },
      '0x46d398a5b33709877f50c8918a7ee96f1be1d7dd': {
        address: '0x46d398a5b33709877f50c8918a7ee96f1be1d7dd',
        chainId: 8453,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'WETH/VVV',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0xacfe6019ed1a7dc6f7b508c02d1b04ec88cc21bf',
      },
      '0x3225b7a01f8f3e68d89292141e22f1c6829e08cd': {
        address: '0x3225b7a01f8f3e68d89292141e22f1c6829e08cd',
        chainId: 8453,
        type: 'LP',
        symbol: 'PEGG/AERO',
        decimals: 18,
        totalSupply: '35578659245524231532459',
        token0: '0x82b0e1a2374ea0198f62a48b14ffab53db6c1e36',
        token1: '0x940181a94a35a4569e4529a3cdfb74e38fd98631',
        priceInUsd: 0.522247609399591,
      },
      '0x266f421f80016d670c9de757d561a5c4a6a9ffac': {
        address: '0x266f421f80016d670c9de757d561a5c4a6a9ffac',
        chainId: 8453,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'WETH/STTAO',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0x806041b6473da60abbe1b256d9a2749a151be6c6',
      },
      '0xb5e331615fdba7df49e05cdeaceb14acdd5091c3': {
        address: '0xb5e331615fdba7df49e05cdeaceb14acdd5091c3',
        chainId: 8453,
        type: 'LP',
        symbol: 'HYUSD/EUSD',
        decimals: 18,
        totalSupply: '1741902347018998884906187',
        token0: '0xcc7ff230365bd730ee4b352cc2492cedac49383e',
        token1: '0xcfa3ef56d303ae4faaba0592388f19d7c3399fb4',
        priceInUsd: 2.1007939328821146,
      },
      '0x861a2922be165a5bd41b1e482b49216b465e1b5f': {
        address: '0x861a2922be165a5bd41b1e482b49216b465e1b5f',
        chainId: 8453,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'WETH/WSTETH',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0xc1cba3fcea344f92d9239c08c0568f6f2f0ee452',
      },
      '0x84ff3b6e2046579fb2f2b891ce18ee10b5fbdbf2': {
        address: '0x84ff3b6e2046579fb2f2b891ce18ee10b5fbdbf2',
        chainId: 8453,
        type: 'LP',
        symbol: 'EXTRA/WETH',
        decimals: 18,
        totalSupply: '10008469882970305',
        token0: '0x2dad3a13ef0c6366220f989157009e501e7938f8',
        token1: '0x4200000000000000000000000000000000000006',
        priceInUsd: 34669119.08091171,
      },
      '0x96331fcb46a7757854d9e26aff3aca2815d623fd': {
        address: '0x96331fcb46a7757854d9e26aff3aca2815d623fd',
        chainId: 8453,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'DOLA/USD+',
        decimals: 18,
        token0: '0x4621b7a9c75199271f773ebd9a499dbd165c3191',
        token1: '0xb79dd08ea68a908a97220c76d19a6aa9cbde4376',
      },
      '0xce6709d66854e09de838cc56e7f4a0661fa3c432': {
        address: '0xce6709d66854e09de838cc56e7f4a0661fa3c432',
        chainId: 8453,
        type: 'ERC721-NATIVE',
        symbol: 'WETH/CONVO',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0xab964f7b7b6391bd6c4e8512ef00d01f255d9c0d',
      },
      '0xb4bc690e35ff10327036ae8033b89863c0add929': {
        address: '0xb4bc690e35ff10327036ae8033b89863c0add929',
        chainId: 8453,
        type: 'ERC721-NATIVE',
        symbol: 'WETH/GUAN',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0xcc0adb6c436eb1f65b2f27733bf926691b94c5f1',
      },
      '0x413d78628d688edcde29518199a3a3db955068ec': {
        address: '0x413d78628d688edcde29518199a3a3db955068ec',
        chainId: 8453,
        type: 'LP',
        symbol: 'MAI/EUSD',
        decimals: 18,
        totalSupply: '707890748346244170850',
        token0: '0xbf1aea8670d2528e08334083616dd9c5f3b087ae',
        token1: '0xcfa3ef56d303ae4faaba0592388f19d7c3399fb4',
        priceInUsd: 1.994425282832286,
      },
      '0xe9c137071861fba0359eeccb5865c2588d1be2be': {
        address: '0xe9c137071861fba0359eeccb5865c2588d1be2be',
        chainId: 8453,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'USD+/USDT',
        decimals: 18,
        token0: '0xb79dd08ea68a908a97220c76d19a6aa9cbde4376',
        token1: '0xfde4c96c8593536e31f229ea8f37b2ada2699bb2',
      },
      '0x70faafb3c7990771f6724c00f2574437bf805a9f': {
        address: '0x70faafb3c7990771f6724c00f2574437bf805a9f',
        chainId: 8453,
        type: 'LP',
        symbol: 'SUUSD/EMTRG',
        decimals: 18,
        totalSupply: '82299095305127248',
        token0: '0x8bf591eae535f93a242d5a954d3cde648b48a5a8',
        token1: '0xa023e6f6b4862ea38cbe45e377abd908abab2f82',
        priceInUsd: 0,
      },
      '0x56b92e5b391dbfb8b8028ac95a4b97f52ffeb416': {
        address: '0x56b92e5b391dbfb8b8028ac95a4b97f52ffeb416',
        chainId: 8453,
        type: 'ERC721-AERODROME-CL',
        symbol: 'WETH/KAITO',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0x98d0baa52b2d063e780de12f615f963fe8537553',
      },
      '0x448686ca47fbe77d8fc9eec6829837bf45e8ea75': {
        address: '0x448686ca47fbe77d8fc9eec6829837bf45e8ea75',
        chainId: 8453,
        type: 'LP',
        symbol: 'YFX/AERO',
        decimals: 18,
        totalSupply: '15963762556082412810',
        token0: '0x8901cb2e82cc95c01e42206f8d1f417fe53e7af0',
        token1: '0x940181a94a35a4569e4529a3cdfb74e38fd98631',
        priceInUsd: 2.038115202251342,
      },
      '0x58342c302dd4df0531f60dd3c0eabb0c95ac08cb': {
        address: '0x58342c302dd4df0531f60dd3c0eabb0c95ac08cb',
        chainId: 8453,
        type: 'ERC721-NATIVE',
        symbol: 'WETH/OKAYEG',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0xdb6e0e5094a25a052ab6845a9f1e486b9a9b3dde',
      },
      '0x2092f4acbb18bb1649595df59b9cb601bba1ebb7': {
        address: '0x2092f4acbb18bb1649595df59b9cb601bba1ebb7',
        chainId: 8453,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'WETH/RDNT',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0xd722e55c1d9d9fa0021a5215cbb904b92b3dc5d4',
      },
      '0x77e09a5043820820390904357463bfb739a76104': {
        address: '0x77e09a5043820820390904357463bfb739a76104',
        chainId: 8453,
        type: 'LP',
        symbol: 'BCT/USDC',
        decimals: 18,
        totalSupply: '3441865993102589',
        token0: '0x576bca23dcb6d94ff8e537d88b0d3e1bead444a2',
        token1: '0x833589fcd6edb6e08f4c7c32d4f71b54bda02913',
        priceInUsd: 0,
      },
      '0x717358a47ac99f3cd233e723be331756b3951164': {
        address: '0x717358a47ac99f3cd233e723be331756b3951164',
        chainId: 8453,
        type: 'ERC721-NATIVE',
        symbol: 'LUM/WETH',
        decimals: 18,
        token0: '0x0fd7a301b51d0a83fcaf6718628174d527b373b6',
        token1: '0x4200000000000000000000000000000000000006',
      },
      '0x47ca96ea59c13f72745928887f84c9f52c3d7348': {
        address: '0x47ca96ea59c13f72745928887f84c9f52c3d7348',
        chainId: 8453,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'CBETH/WETH',
        decimals: 18,
        token0: '0x2ae3f1ec7f1f5012cfeab0185bfc7aa3cf0dec22',
        token1: '0x4200000000000000000000000000000000000006',
      },
      '0x20086910e220d5f4c9695b784d304a72a0de403b': {
        address: '0x20086910e220d5f4c9695b784d304a72a0de403b',
        chainId: 8453,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'USD+/USDBC',
        decimals: 18,
        token0: '0xb79dd08ea68a908a97220c76d19a6aa9cbde4376',
        token1: '0xd9aaec86b65d86f6a7b5b1b0c42ffa531710b6ca',
      },
      '0x887de0c0aa6c1d5e781b17867b29734f84dc1372': {
        address: '0x887de0c0aa6c1d5e781b17867b29734f84dc1372',
        chainId: 8453,
        type: 'LP',
        symbol: 'WETH/PEGG',
        decimals: 18,
        totalSupply: '4371723587583471985886',
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0x82b0e1a2374ea0198f62a48b14ffab53db6c1e36',
        priceInUsd: 32.169312838534076,
      },
      '0x6d33206adb1462992c642ba5dd4f4e16beb4d047': {
        address: '0x6d33206adb1462992c642ba5dd4f4e16beb4d047',
        chainId: 8453,
        type: 'ERC721-NATIVE',
        symbol: 'WETH/ROCK',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0xece7b98bd817ee5b1f2f536daf34d0b6af8bb542',
      },
      '0xcdf927c0f7b81b146c0c9e9323eb5a28d1bfa183': {
        address: '0xcdf927c0f7b81b146c0c9e9323eb5a28d1bfa183',
        chainId: 8453,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'XPUFETH/WETH',
        decimals: 18,
        token0: '0x23da5f2d509cb43a59d43c108a43edf34510eff1',
        token1: '0x4200000000000000000000000000000000000006',
      },
      '0x8e9154ac849e839d60299e85156bcb589de2693a': {
        address: '0x8e9154ac849e839d60299e85156bcb589de2693a',
        chainId: 8453,
        type: 'LP',
        symbol: 'DOLA/USD+',
        decimals: 18,
        totalSupply: '82523583383431977',
        token0: '0x4621b7a9c75199271f773ebd9a499dbd165c3191',
        token1: '0xb79dd08ea68a908a97220c76d19a6aa9cbde4376',
        priceInUsd: 1990457.967992959,
      },
      '0xe140c5930889c4064a3d11b17bb04fe7224a5cdc': {
        address: '0xe140c5930889c4064a3d11b17bb04fe7224a5cdc',
        chainId: 8453,
        type: 'LP',
        symbol: 'WETH/OX',
        decimals: 18,
        totalSupply: '19313292821394919346639',
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0xba0dda8762c24da9487f5fa026a9b64b695a07ea',
        priceInUsd: 1.026006644933629,
      },
      '0x77c1b9db1197b5d9145036aef1221ac17b8e4a54': {
        address: '0x77c1b9db1197b5d9145036aef1221ac17b8e4a54',
        chainId: 8453,
        type: 'ERC721-NATIVE',
        symbol: 'USDC/GUAN',
        decimals: 18,
        token0: '0x833589fcd6edb6e08f4c7c32d4f71b54bda02913',
        token1: '0xcc0adb6c436eb1f65b2f27733bf926691b94c5f1',
      },
      '0x0225ba893d5f8ecd6d2022f9dec59b34f61098a1': {
        address: '0x0225ba893d5f8ecd6d2022f9dec59b34f61098a1',
        chainId: 8453,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'WETH/USOL',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0x9b8df6e244526ab5f6e6400d331db28c8fdddb55',
      },
      '0x3cacb8007d50f3e4166d7c5fd303c1a6ed337531': {
        address: '0x3cacb8007d50f3e4166d7c5fd303c1a6ed337531',
        chainId: 8453,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'WIF/WETH',
        decimals: 18,
        token0: '0x1fba65de0a9cbd2d1df82d141897042d36bb6c86',
        token1: '0x4200000000000000000000000000000000000006',
      },
      '0x958682ec6282bc7e939fa8ba9397805c214c3a09': {
        address: '0x958682ec6282bc7e939fa8ba9397805c214c3a09',
        chainId: 8453,
        type: 'LP',
        symbol: 'USDC/KLIMA',
        decimals: 18,
        totalSupply: '4893681483970',
        token0: '0x833589fcd6edb6e08f4c7c32d4f71b54bda02913',
        token1: '0xdcefd8c8fcc492630b943abcab3429f12ea9fea2',
        priceInUsd: 24238164672.31895,
      },
      '0xd88b9f7185f404015b665e070a5ef03a7e26661f': {
        address: '0xd88b9f7185f404015b665e070a5ef03a7e26661f',
        chainId: 8453,
        type: 'LP',
        symbol: 'TKN/AERO',
        decimals: 18,
        totalSupply: '1386722005020795767316334',
        token0: '0x78b3c724a2f663d11373c4a1978689271895256f',
        token1: '0x940181a94a35a4569e4529a3cdfb74e38fd98631',
        priceInUsd: 0.20154618154279144,
      },
      '0xa56be957d432a5d0edc040b27078d9726f54e7f6': {
        address: '0xa56be957d432a5d0edc040b27078d9726f54e7f6',
        chainId: 8453,
        type: 'LP',
        symbol: 'EURA/USDBC',
        decimals: 18,
        totalSupply: '16664749629706',
        token0: '0xa61beb4a3d02decb01039e378237032b351125b4',
        token1: '0xd9aaec86b65d86f6a7b5b1b0c42ffa531710b6ca',
        priceInUsd: 2039919.9619031895,
      },
      '0x1b05e4e814b3431a48b8164c41eac834d9ce2da6': {
        address: '0x1b05e4e814b3431a48b8164c41eac834d9ce2da6',
        chainId: 8453,
        type: 'LP',
        symbol: 'DAI+/USD+',
        decimals: 18,
        totalSupply: '243094192225483',
        token0: '0x65a2508c429a6078a7bc2f7df81ab575bd9d9275',
        token1: '0xb79dd08ea68a908a97220c76d19a6aa9cbde4376',
        priceInUsd: 1973610.9883934539,
      },
      '0xaace080ea9ce5e7942ea826d311b6170bdfcf73b': {
        address: '0xaace080ea9ce5e7942ea826d311b6170bdfcf73b',
        chainId: 8453,
        type: 'LP',
        symbol: 'WETH/TOWER',
        decimals: 18,
        totalSupply: '57012594761169128562657',
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0xf7c1cefcf7e1dd8161e00099facd3e1db9e528ee',
        priceInUsd: 4.356145754270339,
      },
      '0x323121cd6f6274c9aeb9f87e0664c8fda5d343a5': {
        address: '0x323121cd6f6274c9aeb9f87e0664c8fda5d343a5',
        chainId: 8453,
        type: 'LP',
        symbol: 'TBTC/USDC',
        decimals: 18,
        totalSupply: '372698802796839',
        token0: '0x236aa50979d5f3de3bd1eeb40e81137f22ab794b',
        token1: '0x833589fcd6edb6e08f4c7c32d4f71b54bda02913',
        priceInUsd: 2530084269.276945,
      },
      '0x52f38a65dab3cf23478cc567110bec90162ab832': {
        address: '0x52f38a65dab3cf23478cc567110bec90162ab832',
        chainId: 8453,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'SEKOIA/WETH',
        decimals: 18,
        token0: '0x1185cb5122edad199bdbc0cbd7a0457e448f23c7',
        token1: '0x4200000000000000000000000000000000000006',
      },
      '0xb2cc224c1c9fee385f8ad6a55b4d94e92359dc59': {
        address: '0xb2cc224c1c9fee385f8ad6a55b4d94e92359dc59',
        chainId: 8453,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'WETH/USDC',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0x833589fcd6edb6e08f4c7c32d4f71b54bda02913',
      },
      '0x26cbe9f2ad77e811e40cd11c0d04ff182e3b0975': {
        address: '0x26cbe9f2ad77e811e40cd11c0d04ff182e3b0975',
        chainId: 8453,
        type: 'ERC721-NATIVE',
        symbol: 'ZERO/WETH',
        decimals: 18,
        token0: '0x3ed6a56a9adec22cf1abfc8fc7100fda77312a10',
        token1: '0x4200000000000000000000000000000000000006',
      },
      '0xfd22d75b2fb405ee185155d57b0277b9db2f8e29': {
        address: '0xfd22d75b2fb405ee185155d57b0277b9db2f8e29',
        chainId: 8453,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'BITCOIN/WETH',
        decimals: 18,
        token0: '0x2a06a17cbc6d0032cac2c6696da90f29d39a1a29',
        token1: '0x4200000000000000000000000000000000000006',
      },
      '0xffa3f8737c39e36dec4300b162c2153c67c8352f': {
        address: '0xffa3f8737c39e36dec4300b162c2153c67c8352f',
        chainId: 8453,
        type: 'LP',
        symbol: 'WETH/WELL',
        decimals: 18,
        totalSupply: '2480441911694706748887',
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0xff8adec2221f9f4d8dfbafa6b9a297d17603493d',
        priceInUsd: 19.38623025094618,
      },
      '0x267d950110d9ed57999c3451b89c35a9d278c074': {
        address: '0x267d950110d9ed57999c3451b89c35a9d278c074',
        chainId: 8453,
        type: 'LP',
        symbol: 'AERO/USD+',
        decimals: 18,
        totalSupply: '33889672016811',
        token0: '0x940181a94a35a4569e4529a3cdfb74e38fd98631',
        token1: '0xb79dd08ea68a908a97220c76d19a6aa9cbde4376',
        priceInUsd: 2058978.2082661353,
      },
      '0xc50578736dcbb177de5d42b597edb4b1ad26848d': {
        address: '0xc50578736dcbb177de5d42b597edb4b1ad26848d',
        chainId: 8453,
        type: 'ERC721-NATIVE',
        symbol: 'WETH/CALLS',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0xac743b05f5e590d9db6a4192e02457838e4af61e',
      },
      '0xeb4ab2038ef5662ff00acabbb76a09abd7440d10': {
        address: '0xeb4ab2038ef5662ff00acabbb76a09abd7440d10',
        chainId: 8453,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'WETH/SAINT',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0x7588880d9c78e81fade7b7e8dc0781e95995a792',
      },
      '0xb7c971aab3c79f54bf94cf8f7c5fd3688936e57f': {
        address: '0xb7c971aab3c79f54bf94cf8f7c5fd3688936e57f',
        chainId: 8453,
        type: 'ERC721-NATIVE',
        symbol: 'WETH/SIM',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0x749e5334752466cda899b302ed4176b8573dc877',
      },
      '0x6446021f4e396da3df4235c62537431372195d38': {
        address: '0x6446021f4e396da3df4235c62537431372195d38',
        chainId: 8453,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'WETH/SUPEROETHB',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0xdbfefd2e8460a6ee4955a68582f85708baea60a3',
      },
      '0x87cd18069b6547a0e88b6155dd657e71779500ea': {
        address: '0x87cd18069b6547a0e88b6155dd657e71779500ea',
        chainId: 8453,
        type: 'ERC721-AERODROME-CL-GAUGE',
        symbol: 'WETH/PRIME',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0xfa980ced6895ac314e7de34ef1bfae90a5add21b',
      },
      '0x774a61f53f14d3bf92dfcdb79c5b6a8ad5f06965': {
        address: '0x774a61f53f14d3bf92dfcdb79c5b6a8ad5f06965',
        chainId: 8453,
        type: 'ERC721-NATIVE',
        symbol: 'WETH/SAINT',
        decimals: 18,
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0x7588880d9c78e81fade7b7e8dc0781e95995a792',
      },
      '0xcdac0d6c6c59727a65f871236188350531885c43': {
        address: '0xcdac0d6c6c59727a65f871236188350531885c43',
        chainId: 8453,
        type: 'LP',
        symbol: 'WETH/USDC',
        decimals: 18,
        totalSupply: '171892339136285978',
        token0: '0x4200000000000000000000000000000000000006',
        token1: '0x833589fcd6edb6e08f4c7c32d4f71b54bda02913',
        priceInUsd: 131613255.94613779,
      },
    },
    '42161': {
      '0x9ffca51d23ac7f7df82da414865ef1055e5afcc3': {
        address: '0x9ffca51d23ac7f7df82da414865ef1055e5afcc3',
        chainId: 42161,
        type: 'ERC721',
        symbol: 'ARB/USDC',
        decimals: 18,
        token0: '0x912ce59144191c1204e64559fe8253a0e49e6548',
        token1: '0xaf88d065e77c8cc2239327c5edb3a432268e5831',
      },
      '0xdd672b3b768a16b9bcb4ee1060d3e8221435beaa': {
        address: '0xdd672b3b768a16b9bcb4ee1060d3e8221435beaa',
        chainId: 42161,
        type: 'ERC721-NATIVE',
        symbol: 'WETH/AAVE',
        decimals: 18,
        token0: '0x82af49447d8a07e3bd95bd0d56f35241523fbab1',
        token1: '0xba5ddd1f9d7f570dc94a51479a000e3bce967196',
      },
      '0xe37304f7489ed253b2a46a1d9dabdca3d311d22e': {
        address: '0xe37304f7489ed253b2a46a1d9dabdca3d311d22e',
        chainId: 42161,
        type: 'ERC721',
        symbol: 'WETH/XUSD',
        decimals: 18,
        token0: '0x82af49447d8a07e3bd95bd0d56f35241523fbab1',
        token1: '0xe80772eaf6e2e18b651f160bc9158b2a5cafca65',
      },
      '0x3db70832f48f8c01ee041671f7bb1cfaa2677584': {
        address: '0x3db70832f48f8c01ee041671f7bb1cfaa2677584',
        chainId: 42161,
        type: 'ERC721-NATIVE',
        symbol: 'USDC/AAVE',
        decimals: 18,
        token0: '0xaf88d065e77c8cc2239327c5edb3a432268e5831',
        token1: '0xba5ddd1f9d7f570dc94a51479a000e3bce967196',
      },
      '0x446bf9748b4ea044dd759d9b9311c70491df8f29': {
        address: '0x446bf9748b4ea044dd759d9b9311c70491df8f29',
        chainId: 42161,
        type: 'ERC721-NATIVE',
        symbol: 'RDNT/WETH',
        decimals: 18,
        token0: '0x3082cc23568ea640225c2467653db90e9250aaa0',
        token1: '0x82af49447d8a07e3bd95bd0d56f35241523fbab1',
      },
      '0x421803da50d3932caa36bd1731d36a0e2af93542': {
        address: '0x421803da50d3932caa36bd1731d36a0e2af93542',
        chainId: 42161,
        type: 'ERC721-NATIVE',
        symbol: 'WETH/XUSD',
        decimals: 18,
        token0: '0x82af49447d8a07e3bd95bd0d56f35241523fbab1',
        token1: '0xe80772eaf6e2e18b651f160bc9158b2a5cafca65',
      },
      '0x5a17cbf5f866bde11c28861a2742764fac0eba4b': {
        address: '0x5a17cbf5f866bde11c28861a2742764fac0eba4b',
        chainId: 42161,
        type: 'ERC721',
        symbol: 'WBTC/USDC',
        decimals: 18,
        token0: '0x2f2a2543b76a4166549f7aab2e75bef0aefc5b0f',
        token1: '0xaf88d065e77c8cc2239327c5edb3a432268e5831',
      },
      '0xcb198a55e2a88841e855be4eacaad99422416b33': {
        address: '0xcb198a55e2a88841e855be4eacaad99422416b33',
        chainId: 42161,
        type: 'ERC721-NATIVE',
        symbol: 'TBTC/WETH',
        decimals: 18,
        token0: '0x6c84a8f1c29108f47a79964b5fe888d4f4d0de40',
        token1: '0x82af49447d8a07e3bd95bd0d56f35241523fbab1',
      },
      '0x4688300d46ef400c3506a165d5bdca6a51350978': {
        address: '0x4688300d46ef400c3506a165d5bdca6a51350978',
        chainId: 42161,
        type: 'SINGLE-LP',
        symbol: 'LP-USDC',
        decimals: 18,
        totalSupply: '117025316382535971088',
        priceInUsd: 1.059009367529744,
      },
      '0x7548bd60cb8f627a9b8ed94f8ca174348dbe6a05': {
        address: '0x7548bd60cb8f627a9b8ed94f8ca174348dbe6a05',
        chainId: 42161,
        type: 'ERC721-NATIVE',
        symbol: 'USDC/XUSD',
        decimals: 18,
        token0: '0xaf88d065e77c8cc2239327c5edb3a432268e5831',
        token1: '0xe80772eaf6e2e18b651f160bc9158b2a5cafca65',
      },
      '0x14353445c8329df76e6f15e9ead18fa2d45a8bb6': {
        address: '0x14353445c8329df76e6f15e9ead18fa2d45a8bb6',
        chainId: 42161,
        type: 'ERC721-NATIVE',
        symbol: 'WEETH/WETH',
        decimals: 18,
        token0: '0x35751007a407ca6feffe80b3cb397736d2cf4dbe',
        token1: '0x82af49447d8a07e3bd95bd0d56f35241523fbab1',
      },
      '0xc82819f72a9e77e2c0c3a69b3196478f44303cf4': {
        address: '0xc82819f72a9e77e2c0c3a69b3196478f44303cf4',
        chainId: 42161,
        type: 'ERC721-NATIVE',
        symbol: 'WETH/USD0',
        decimals: 18,
        token0: '0x82af49447d8a07e3bd95bd0d56f35241523fbab1',
        token1: '0xfd086bc7cd5c481dcc9c85ebe478a1c0b69fcbb9',
      },
      '0x060d8a5a7c03882e33aca8fc304babe869e21ee9': {
        address: '0x060d8a5a7c03882e33aca8fc304babe869e21ee9',
        chainId: 42161,
        type: 'ERC721',
        symbol: 'GRAI/USDC',
        decimals: 18,
        token0: '0x894134a25a5fac1c2c26f1d8fbf05111a3cb9487',
        token1: '0xaf88d065e77c8cc2239327c5edb3a432268e5831',
      },
      '0xf0346b437fe43e64fa799c2bd3cf5db1f7e9327c': {
        address: '0xf0346b437fe43e64fa799c2bd3cf5db1f7e9327c',
        chainId: 42161,
        type: 'ERC721',
        symbol: 'ZRO/WETH',
        decimals: 18,
        token0: '0x6985884c4392d348587b19cb9eaaf157f13271cd',
        token1: '0x82af49447d8a07e3bd95bd0d56f35241523fbab1',
      },
      '0x0e75ca30b075aa0df8c360e30cd0ed26ed62432a': {
        address: '0x0e75ca30b075aa0df8c360e30cd0ed26ed62432a',
        chainId: 42161,
        type: 'LP',
        symbol: 'USDEX+/GDEX',
        decimals: 18,
        totalSupply: '2877667015761085868',
        token0: '0x4117ec0a779448872d3820f37ba2060ae0b7c34b',
        token1: '0x92a212d9f5eef0b262ac7d84aea64a0d0758b94f',
        priceInUsd: 2.083977663157845,
      },
      '0x5918aca9ae924e6eaaa3d293bb92bdec9ab79338': {
        address: '0x5918aca9ae924e6eaaa3d293bb92bdec9ab79338',
        chainId: 42161,
        type: 'ERC721-NATIVE',
        symbol: 'TAP/WETH',
        decimals: 18,
        token0: '0x2c650dab03a59332e2e0c0c4a7f726913e5028c1',
        token1: '0x82af49447d8a07e3bd95bd0d56f35241523fbab1',
      },
      '0x5baf59a6e6df0ee95bce8c43daa05b288e340e7d': {
        address: '0x5baf59a6e6df0ee95bce8c43daa05b288e340e7d',
        chainId: 42161,
        type: 'ERC721-NATIVE',
        symbol: 'RSETH/WSTETH',
        decimals: 18,
        token0: '0x4186bfc76e2e237523cbc30fd220fe055156b41f',
        token1: '0x5979d7b546e38e414f7e9822514be443a4800529',
      },
      '0x2977b0b54a76c2b56d32cef19f8ea83cc766cfd9': {
        address: '0x2977b0b54a76c2b56d32cef19f8ea83cc766cfd9',
        chainId: 42161,
        type: 'SINGLE-LP',
        symbol: 'LP-USDC',
        decimals: 18,
        totalSupply: '118895302944542632003175',
        priceInUsd: 1.01895584247359,
      },
      '0x35218a1cbac5bbc3e57fd9bd38219d37571b3537': {
        address: '0x35218a1cbac5bbc3e57fd9bd38219d37571b3537',
        chainId: 42161,
        type: 'ERC721-NATIVE',
        symbol: 'WSTETH/WETH',
        decimals: 18,
        token0: '0x5979d7b546e38e414f7e9822514be443a4800529',
        token1: '0x82af49447d8a07e3bd95bd0d56f35241523fbab1',
      },
      '0xb4beb0fdf0163a39d39b175942e7973da2c336fb': {
        address: '0xb4beb0fdf0163a39d39b175942e7973da2c336fb',
        chainId: 42161,
        type: 'SINGLE-LP',
        symbol: 'LP-PENDLE',
        decimals: 18,
        totalSupply: '319821755824587632625',
        priceInUsd: 3.516061039555587,
      },
      '0x539bde0d7dbd336b79148aa742883198bbf60342': {
        address: '0x539bde0d7dbd336b79148aa742883198bbf60342',
        chainId: 42161,
        type: 'ERC20',
        symbol: 'MAGIC',
        decimals: 18,
        totalSupply: '291950757485400237225268732',
        priceInUsd: 0.175905915586341,
      },
      '0x74d0ae8b8e1fca6039707564704a25ad2ee036b0': {
        address: '0x74d0ae8b8e1fca6039707564704a25ad2ee036b0',
        chainId: 42161,
        type: 'ERC721-NATIVE',
        symbol: 'WETH/GRT',
        decimals: 18,
        token0: '0x82af49447d8a07e3bd95bd0d56f35241523fbab1',
        token1: '0x9623063377ad1b27544c965ccd7342f7ea7e88c7',
      },
      '0xda064d44871ba31dae33a65b3e23b37e44e9168a': {
        address: '0xda064d44871ba31dae33a65b3e23b37e44e9168a',
        chainId: 42161,
        type: 'ERC20',
        symbol: 'GDEX',
        decimals: 18,
        totalSupply: '120000000000000000000000',
        priceInUsd: 6.063558019296196,
      },
      '0x67ab7dc903a10838a0de8861dfdff3287cf98e5c': {
        address: '0x67ab7dc903a10838a0de8861dfdff3287cf98e5c',
        chainId: 42161,
        type: 'ERC721-NATIVE',
        symbol: 'XUSD/USD0',
        decimals: 18,
        token0: '0xe80772eaf6e2e18b651f160bc9158b2a5cafca65',
        token1: '0xfd086bc7cd5c481dcc9c85ebe478a1c0b69fcbb9',
      },
      '0xf0b860d338e8b5199606322653b83a166d96e417': {
        address: '0xf0b860d338e8b5199606322653b83a166d96e417',
        chainId: 42161,
        type: 'ERC721',
        symbol: 'XAI/WETH',
        decimals: 18,
        token0: '0x4cb9a7ae498cedcbb5eae9f25736ae7d428c9d66',
        token1: '0x82af49447d8a07e3bd95bd0d56f35241523fbab1',
      },
      '0x689c96ceab93f5e131631d225d75dea3fd37747e': {
        address: '0x689c96ceab93f5e131631d225d75dea3fd37747e',
        chainId: 42161,
        type: 'ERC721-NATIVE',
        symbol: 'WBTC/ARB',
        decimals: 18,
        token0: '0x2f2a2543b76a4166549f7aab2e75bef0aefc5b0f',
        token1: '0x912ce59144191c1204e64559fe8253a0e49e6548',
      },
      '0x0bacc7a9717e70ea0da5ac075889bd87d4c81197': {
        address: '0x0bacc7a9717e70ea0da5ac075889bd87d4c81197',
        chainId: 42161,
        type: 'ERC721',
        symbol: 'WETH/USD0',
        decimals: 18,
        token0: '0x82af49447d8a07e3bd95bd0d56f35241523fbab1',
        token1: '0xfd086bc7cd5c481dcc9c85ebe478a1c0b69fcbb9',
      },
      '0xe62880cc6872c9e9fb1ddd73f400850fdabe798d': {
        address: '0xe62880cc6872c9e9fb1ddd73f400850fdabe798d',
        chainId: 42161,
        type: 'SINGLE-LP',
        symbol: 'LP-WETH',
        decimals: 18,
        totalSupply: '108102042763595876',
        priceInUsd: 4399.953729424929,
      },
      '0xc91b7b39bbb2c733f0e7459348fd0c80259c8471': {
        address: '0xc91b7b39bbb2c733f0e7459348fd0c80259c8471',
        chainId: 42161,
        type: 'ERC721-NATIVE',
        symbol: 'GNS/WETH',
        decimals: 18,
        token0: '0x18c11fd286c5ec11c3b683caa813b77f5163a122',
        token1: '0x82af49447d8a07e3bd95bd0d56f35241523fbab1',
      },
      '0x6966553568634f4225330d559a8783de7649c7d3': {
        address: '0x6966553568634f4225330d559a8783de7649c7d3',
        chainId: 42161,
        type: 'SINGLE-LP',
        symbol: 'LP-FRXETH',
        decimals: 18,
        totalSupply: '2630977755657435575',
        priceInUsd: 4201.800931585195,
      },
      '0x85cebd962861be410a777755dfa06914de6af003': {
        address: '0x85cebd962861be410a777755dfa06914de6af003',
        chainId: 42161,
        type: 'SINGLE-LP',
        symbol: 'LP-USDT',
        decimals: 18,
        totalSupply: '43722771570494298287744',
        priceInUsd: 1.0297876607190999,
      },
      '0x7b5eb3940021ec0e8e463d5dbb4b7b09a89ddf96': {
        address: '0x7b5eb3940021ec0e8e463d5dbb4b7b09a89ddf96',
        chainId: 42161,
        type: 'ERC20',
        symbol: 'WOM',
        decimals: 18,
        totalSupply: '43932591151794580000000000',
        priceInUsd: 0.0024965380989427793,
      },
      '0x0c1cf6883efa1b496b01f654e247b9b419873054': {
        address: '0x0c1cf6883efa1b496b01f654e247b9b419873054',
        chainId: 42161,
        type: 'LP',
        symbol: 'DPX/WETH',
        decimals: 18,
        totalSupply: '1053828024369943198910',
        token0: '0x6c2c06790b3e3e3c38e12ee22f8183b37a13ee55',
        token1: '0x82af49447d8a07e3bd95bd0d56f35241523fbab1',
        priceInUsd: 337.9267189728424,
      },
      '0xde509fe1555ab907e5c29f987ba0be1ac0626dae': {
        address: '0xde509fe1555ab907e5c29f987ba0be1ac0626dae',
        chainId: 42161,
        type: 'SINGLE-LP',
        symbol: 'LP-JUSDC',
        decimals: 18,
        totalSupply: '39045963729354249523',
        priceInUsd: 0.821937199043949,
      },
      '0xe9e6b9aaafaf6816c3364345f6ef745ccfc8660a': {
        address: '0xe9e6b9aaafaf6816c3364345f6ef745ccfc8660a',
        chainId: 42161,
        type: 'ERC721-NATIVE',
        symbol: 'WBTC/TBTC',
        decimals: 18,
        token0: '0x2f2a2543b76a4166549f7aab2e75bef0aefc5b0f',
        token1: '0x6c84a8f1c29108f47a79964b5fe888d4f4d0de40',
      },
      '0xc6962004f452be9203591991d15f6b388e09e8d0': {
        address: '0xc6962004f452be9203591991d15f6b388e09e8d0',
        chainId: 42161,
        type: 'ERC721-NATIVE',
        symbol: 'WETH/USDC',
        decimals: 18,
        token0: '0x82af49447d8a07e3bd95bd0d56f35241523fbab1',
        token1: '0xaf88d065e77c8cc2239327c5edb3a432268e5831',
      },
      '0x2c093f7d7db41057a2ddd3cb1ad8b4e9c3dffbec': {
        address: '0x2c093f7d7db41057a2ddd3cb1ad8b4e9c3dffbec',
        chainId: 42161,
        type: 'ERC20',
        symbol: 'USDEX+',
        decimals: 18,
        totalSupply: '254184174045391486535709',
        priceInUsd: 0.16832017171000146,
      },
      '0xc6f780497a95e246eb9449f5e4770916dcd6396a': {
        address: '0xc6f780497a95e246eb9449f5e4770916dcd6396a',
        chainId: 42161,
        type: 'ERC721-NATIVE',
        symbol: 'WETH/ARB',
        decimals: 18,
        token0: '0x82af49447d8a07e3bd95bd0d56f35241523fbab1',
        token1: '0x912ce59144191c1204e64559fe8253a0e49e6548',
      },
      '0xc7341e85996eeb05897d3dec79448b6e4ccc09cf': {
        address: '0xc7341e85996eeb05897d3dec79448b6e4ccc09cf',
        chainId: 42161,
        type: 'ERC721-NATIVE',
        symbol: 'WSTETH/USDC',
        decimals: 18,
        token0: '0x5979d7b546e38e414f7e9822514be443a4800529',
        token1: '0xff970a61a04b1ca14834a43f5de4533ebddb5cc8',
      },
      '0xbf6cbb1f40a542af50839cad01b0dc1747f11e18': {
        address: '0xbf6cbb1f40a542af50839cad01b0dc1747f11e18',
        chainId: 42161,
        type: 'LP',
        symbol: 'WETH/ARB',
        decimals: 18,
        totalSupply: '974381181605707561570',
        token0: '0x82af49447d8a07e3bd95bd0d56f35241523fbab1',
        token1: '0x912ce59144191c1204e64559fe8253a0e49e6548',
        priceInUsd: 209.26392843880996,
      },
      '0xaa9e653252ed9e87a9bd545b974efbfb2f389f3f': {
        address: '0xaa9e653252ed9e87a9bd545b974efbfb2f389f3f',
        chainId: 42161,
        type: 'ERC721-NATIVE',
        symbol: 'GNS/USDC',
        decimals: 18,
        token0: '0x18c11fd286c5ec11c3b683caa813b77f5163a122',
        token1: '0xaf88d065e77c8cc2239327c5edb3a432268e5831',
      },
      '0xcfbcc53e96908cc3719f2807457db0b89870c4de': {
        address: '0xcfbcc53e96908cc3719f2807457db0b89870c4de',
        chainId: 42161,
        type: 'ERC721',
        symbol: 'WBTC/SOLVBTC',
        decimals: 18,
        token0: '0x2f2a2543b76a4166549f7aab2e75bef0aefc5b0f',
        token1: '0x3647c54c4c2c65bc7a2d63c0da2809b399dbbdc0',
      },
      '0x468b88941e7cc0b88c1869d68ab6b570bcef62ff': {
        address: '0x468b88941e7cc0b88c1869d68ab6b570bcef62ff',
        chainId: 42161,
        type: 'ERC721-NATIVE',
        symbol: 'WETH/LINK',
        decimals: 18,
        token0: '0x82af49447d8a07e3bd95bd0d56f35241523fbab1',
        token1: '0xf97f4df75117a78c1a5a0dbb814af92458539fb4',
      },
      '0x4cfa50b7ce747e2d61724fcac57f24b748ff2b2a': {
        address: '0x4cfa50b7ce747e2d61724fcac57f24b748ff2b2a',
        chainId: 42161,
        type: 'ERC20',
        symbol: 'FUSDC',
        decimals: 6,
        totalSupply: '44745976936',
        priceInUsd: 0.9973213890403826,
      },
      '0x42161084d0672e1d3f26a9b53e653be2084ff19c': {
        address: '0x42161084d0672e1d3f26a9b53e653be2084ff19c',
        chainId: 42161,
        type: 'ERC721-NATIVE',
        symbol: 'WETH/USD0',
        decimals: 18,
        token0: '0x82af49447d8a07e3bd95bd0d56f35241523fbab1',
        token1: '0xfd086bc7cd5c481dcc9c85ebe478a1c0b69fcbb9',
      },
      '0xb0f6ca40411360c03d41c5ffc5f179b8403cdcf8': {
        address: '0xb0f6ca40411360c03d41c5ffc5f179b8403cdcf8',
        chainId: 42161,
        type: 'ERC721-NATIVE',
        symbol: 'ARB/USDC',
        decimals: 18,
        token0: '0x912ce59144191c1204e64559fe8253a0e49e6548',
        token1: '0xaf88d065e77c8cc2239327c5edb3a432268e5831',
      },
      '0x8a06339abd7499af755df585738ebf43d5d62b94': {
        address: '0x8a06339abd7499af755df585738ebf43d5d62b94',
        chainId: 42161,
        type: 'ERC721',
        symbol: 'USDT+/XUSD',
        decimals: 18,
        token0: '0xb1084db8d3c05cebd5fa9335df95ee4b8a0edc30',
        token1: '0xe80772eaf6e2e18b651f160bc9158b2a5cafca65',
      },
      '0xd4d42f0b6def4ce0383636770ef773390d85c61a': {
        address: '0xd4d42f0b6def4ce0383636770ef773390d85c61a',
        chainId: 42161,
        type: 'ERC20',
        symbol: 'SUSHI',
        decimals: 18,
        totalSupply: '487009725195640073062640',
        priceInUsd: 0.6744481617247808,
      },
      '0x05477c22a5349cee601500da0489dad137fd6bfa': {
        address: '0x05477c22a5349cee601500da0489dad137fd6bfa',
        chainId: 42161,
        type: 'ERC721-NATIVE',
        symbol: 'USDC/UNI',
        decimals: 18,
        token0: '0xaf88d065e77c8cc2239327c5edb3a432268e5831',
        token1: '0xfa7f8980b0f1e64a2062791cc3b0871572f1f7f0',
      },
      '0xa95b0f5a65a769d82ab4f3e82842e45b8bbaf101': {
        address: '0xa95b0f5a65a769d82ab4f3e82842e45b8bbaf101',
        chainId: 42161,
        type: 'ERC721-NATIVE',
        symbol: 'CRV/WETH',
        decimals: 18,
        token0: '0x11cdb42b0eb46d95f990bedd4695a6e3fa034978',
        token1: '0x82af49447d8a07e3bd95bd0d56f35241523fbab1',
      },
      '0xc473e2aee3441bf9240be85eb122abb059a3b57c': {
        address: '0xc473e2aee3441bf9240be85eb122abb059a3b57c',
        chainId: 42161,
        type: 'ERC721-NATIVE',
        symbol: 'WETH/USDC',
        decimals: 18,
        token0: '0x82af49447d8a07e3bd95bd0d56f35241523fbab1',
        token1: '0xaf88d065e77c8cc2239327c5edb3a432268e5831',
      },
      '0x905dfcd5649217c42684f23958568e533c711aa3': {
        address: '0x905dfcd5649217c42684f23958568e533c711aa3',
        chainId: 42161,
        type: 'LP',
        symbol: 'WETH/USDC',
        decimals: 18,
        totalSupply: '4045134427299171',
        token0: '0x82af49447d8a07e3bd95bd0d56f35241523fbab1',
        token1: '0xff970a61a04b1ca14834a43f5de4533ebddb5cc8',
        priceInUsd: 224227226.58235276,
      },
      '0x6b7c9db425951543aa556b984869c50e6a18c7b2': {
        address: '0x6b7c9db425951543aa556b984869c50e6a18c7b2',
        chainId: 42161,
        type: 'SINGLE-LP',
        symbol: 'LP-WOM',
        decimals: 18,
        totalSupply: '87105052266204156592058',
        priceInUsd: 0.0012166839789776345,
      },
      '0x7418f5a2621e13c05d1efbd71ec922070794b90a': {
        address: '0x7418f5a2621e13c05d1efbd71ec922070794b90a',
        chainId: 42161,
        type: 'LP',
        symbol: 'RDPX/WETH',
        decimals: 18,
        totalSupply: '15732490638864838069661008',
        token0: '0x32eb7902d4134bf98a28b963d26de779af92a212',
        token1: '0x82af49447d8a07e3bd95bd0d56f35241523fbab1',
        priceInUsd: 9.816282794175547e-7,
      },
      '0x03a33aee5f4947b9c1cde042c5f037d1be304be7': {
        address: '0x03a33aee5f4947b9c1cde042c5f037d1be304be7',
        chainId: 42161,
        type: 'ERC721-NATIVE',
        symbol: 'XAI/WETH',
        decimals: 18,
        token0: '0x4cb9a7ae498cedcbb5eae9f25736ae7d428c9d66',
        token1: '0x82af49447d8a07e3bd95bd0d56f35241523fbab1',
      },
      '0x1b896893dfc86bb67cf57767298b9073d2c1ba2c': {
        address: '0x1b896893dfc86bb67cf57767298b9073d2c1ba2c',
        chainId: 42161,
        type: 'ERC20',
        symbol: 'CAKE',
        decimals: 18,
        totalSupply: '184578798963590000000000',
        priceInUsd: 2.8393231942581103,
      },
      '0xd97c8ee1c1e47f50a66e69d5ad155f882e38b0e5': {
        address: '0xd97c8ee1c1e47f50a66e69d5ad155f882e38b0e5',
        chainId: 42161,
        type: 'ERC721-NATIVE',
        symbol: 'UNI/USD0',
        decimals: 18,
        token0: '0xfa7f8980b0f1e64a2062791cc3b0871572f1f7f0',
        token1: '0xfd086bc7cd5c481dcc9c85ebe478a1c0b69fcbb9',
      },
      '0xfe193d41bf8ee691bec999bce0981b6d06c89394': {
        address: '0xfe193d41bf8ee691bec999bce0981b6d06c89394',
        chainId: 42161,
        type: 'ERC721',
        symbol: 'XUSD/USD0',
        decimals: 18,
        token0: '0xe80772eaf6e2e18b651f160bc9158b2a5cafca65',
        token1: '0xfd086bc7cd5c481dcc9c85ebe478a1c0b69fcbb9',
      },
      '0x42e9dc3f1a7dd582e81d2edf7e5c4869007ce14a': {
        address: '0x42e9dc3f1a7dd582e81d2edf7e5c4869007ce14a',
        chainId: 42161,
        type: 'LP',
        symbol: 'PREMIA/WETH',
        decimals: 18,
        totalSupply: '10543880933888011671',
        token0: '0x51fc0f6660482ea73330e414efd7808811a57fa2',
        token1: '0x82af49447d8a07e3bd95bd0d56f35241523fbab1',
        priceInUsd: 54.103381278736336,
      },
      '0xf00d8790a76ee5a5dbc10eacac39151aa2af0331': {
        address: '0xf00d8790a76ee5a5dbc10eacac39151aa2af0331',
        chainId: 42161,
        type: 'ERC20',
        symbol: 'QUO',
        decimals: 18,
        totalSupply: '16746000276792740000000000',
        priceInUsd: 0,
      },
      '0x20384b876fab2848cf9f632e5df8c50fe6f311f8': {
        address: '0x20384b876fab2848cf9f632e5df8c50fe6f311f8',
        chainId: 42161,
        type: 'ERC721-NATIVE',
        symbol: 'RSETH/WETH',
        decimals: 18,
        token0: '0x4186bfc76e2e237523cbc30fd220fe055156b41f',
        token1: '0x82af49447d8a07e3bd95bd0d56f35241523fbab1',
      },
      '0x4117ec0a779448872d3820f37ba2060ae0b7c34b': {
        address: '0x4117ec0a779448872d3820f37ba2060ae0b7c34b',
        chainId: 42161,
        type: 'ERC20',
        symbol: 'USDEX+',
        decimals: 18,
        totalSupply: '366016395359910839300751',
        priceInUsd: 0.2818079564065219,
      },
      '0x4fc7ac44dae553464d92c049175133239a8705c1': {
        address: '0x4fc7ac44dae553464d92c049175133239a8705c1',
        chainId: 42161,
        type: 'ERC721',
        symbol: 'WETH/USDC',
        decimals: 18,
        token0: '0x82af49447d8a07e3bd95bd0d56f35241523fbab1',
        token1: '0xff970a61a04b1ca14834a43f5de4533ebddb5cc8',
      },
      '0x858dff46915d3f81bb7ff06158b2806164acb2a0': {
        address: '0x858dff46915d3f81bb7ff06158b2806164acb2a0',
        chainId: 42161,
        type: 'ERC721',
        symbol: 'USD0/USDC',
        decimals: 18,
        token0: '0xfd086bc7cd5c481dcc9c85ebe478a1c0b69fcbb9',
        token1: '0xff970a61a04b1ca14834a43f5de4533ebddb5cc8',
      },
      '0xcb0e5bfa72bbb4d16ab5aa0c60601c438f04b4ad': {
        address: '0xcb0e5bfa72bbb4d16ab5aa0c60601c438f04b4ad',
        chainId: 42161,
        type: 'LP',
        symbol: 'WETH/USD0',
        decimals: 18,
        totalSupply: '823944812024401',
        token0: '0x82af49447d8a07e3bd95bd0d56f35241523fbab1',
        token1: '0xfd086bc7cd5c481dcc9c85ebe478a1c0b69fcbb9',
        priceInUsd: 273416265.96293575,
      },
      '0x02c12fd05cb0d26579789abcfdc58b07db755236': {
        address: '0x02c12fd05cb0d26579789abcfdc58b07db755236',
        chainId: 42161,
        type: 'ERC721',
        symbol: 'EGP/WETH',
        decimals: 18,
        token0: '0x7e7a7c916c19a45769f6bdaf91087f93c6c12f78',
        token1: '0x82af49447d8a07e3bd95bd0d56f35241523fbab1',
      },
      '0x389938cf14be379217570d8e4619e51fbdafaa21': {
        address: '0x389938cf14be379217570d8e4619e51fbdafaa21',
        chainId: 42161,
        type: 'ERC721',
        symbol: 'WETH/USD0',
        decimals: 18,
        token0: '0x82af49447d8a07e3bd95bd0d56f35241523fbab1',
        token1: '0xfd086bc7cd5c481dcc9c85ebe478a1c0b69fcbb9',
      },
      '0xc74a9d15037886ea357f0ef243c50010b11133cb': {
        address: '0xc74a9d15037886ea357f0ef243c50010b11133cb',
        chainId: 42161,
        type: 'SINGLE-LP',
        symbol: 'LP-FUSDC',
        decimals: 18,
        totalSupply: '40272152281947873629',
        priceInUsd: 0.9430542934886077,
      },
      '0x5ad0b68c8544d475ee73ffd4c8dfe7e273b01266': {
        address: '0x5ad0b68c8544d475ee73ffd4c8dfe7e273b01266',
        chainId: 42161,
        type: 'SINGLE-LP',
        symbol: 'LP-MPENDLE',
        decimals: 18,
        totalSupply: '3941253504911405117481',
        priceInUsd: 2.367853814851993,
      },
      '0x0e4831319a50228b9e450861297ab92dee15b44f': {
        address: '0x0e4831319a50228b9e450861297ab92dee15b44f',
        chainId: 42161,
        type: 'ERC721-NATIVE',
        symbol: 'WBTC/USDC',
        decimals: 18,
        token0: '0x2f2a2543b76a4166549f7aab2e75bef0aefc5b0f',
        token1: '0xaf88d065e77c8cc2239327c5edb3a432268e5831',
      },
      '0x1aeedd3727a6431b8f070c0afaa81cc74f273882': {
        address: '0x1aeedd3727a6431b8f070c0afaa81cc74f273882',
        chainId: 42161,
        type: 'ERC721-NATIVE',
        symbol: 'WETH/GMX',
        decimals: 18,
        token0: '0x82af49447d8a07e3bd95bd0d56f35241523fbab1',
        token1: '0xfc5a1a6eb076a2c7ad06ed22c90d7e710e35ad0a',
      },
      '0xd9e2a1a61b6e61b275cec326465d417e52c1b95c': {
        address: '0xd9e2a1a61b6e61b275cec326465d417e52c1b95c',
        chainId: 42161,
        type: 'ERC721',
        symbol: 'WETH/USDC',
        decimals: 18,
        token0: '0x82af49447d8a07e3bd95bd0d56f35241523fbab1',
        token1: '0xaf88d065e77c8cc2239327c5edb3a432268e5831',
      },
      '0x152703894d31e54437d01b03bdd21c03583e9709': {
        address: '0x152703894d31e54437d01b03bdd21c03583e9709',
        chainId: 42161,
        type: 'ERC721',
        symbol: 'ZRO/WETH',
        decimals: 18,
        token0: '0x6985884c4392d348587b19cb9eaaf157f13271cd',
        token1: '0x82af49447d8a07e3bd95bd0d56f35241523fbab1',
      },
      '0xdddc78f940e012cfc1ad04de2ca089eb94900145': {
        address: '0xdddc78f940e012cfc1ad04de2ca089eb94900145',
        chainId: 42161,
        type: 'SINGLE-LP',
        symbol: 'LP-MWOM',
        decimals: 18,
        totalSupply: '58598378098243608287129',
        priceInUsd: 0.0023033686026391726,
      },
      '0xaeeceec4b31d3c1057210115bf176ebb05b9805d': {
        address: '0xaeeceec4b31d3c1057210115bf176ebb05b9805d',
        chainId: 42161,
        type: 'ERC721-NATIVE',
        symbol: 'AXLUSDC/USDC',
        decimals: 18,
        token0: '0xeb466342c4d449bc9f53a865d5cb90586f405215',
        token1: '0xff970a61a04b1ca14834a43f5de4533ebddb5cc8',
      },
      '0x32eb7902d4134bf98a28b963d26de779af92a212': {
        address: '0x32eb7902d4134bf98a28b963d26de779af92a212',
        chainId: 42161,
        type: 'ERC20',
        symbol: 'RDPX',
        decimals: 18,
        totalSupply: '2113750386452103996345063',
        priceInUsd: 1.1939752185517791,
      },
      '0x4cef551255ec96d89fec975446301b5c4e164c59': {
        address: '0x4cef551255ec96d89fec975446301b5c4e164c59',
        chainId: 42161,
        type: 'ERC721-NATIVE',
        symbol: 'ZRO/WETH',
        decimals: 18,
        token0: '0x6985884c4392d348587b19cb9eaaf157f13271cd',
        token1: '0x82af49447d8a07e3bd95bd0d56f35241523fbab1',
      },
      '0x47b6de853d181626918eecb1e0ed946a5cf96449': {
        address: '0x47b6de853d181626918eecb1e0ed946a5cf96449',
        chainId: 42161,
        type: 'ERC721-NATIVE',
        symbol: 'EMC/USD0',
        decimals: 18,
        token0: '0xdfb8be6f8c87f74295a87de951974362cedcfa30',
        token1: '0xfd086bc7cd5c481dcc9c85ebe478a1c0b69fcbb9',
      },
      '0x0ad1e922e764df5ab6d636f5d21ecc2e41e827f0': {
        address: '0x0ad1e922e764df5ab6d636f5d21ecc2e41e827f0',
        chainId: 42161,
        type: 'ERC721-NATIVE',
        symbol: 'EMP/WETH',
        decimals: 18,
        token0: '0x772598e9e62155d7fdfe65fdf01eb5a53a8465be',
        token1: '0x82af49447d8a07e3bd95bd0d56f35241523fbab1',
      },
      '0x7e928afb59f5de9d2f4d162f754c6eb40c88aa8e': {
        address: '0x7e928afb59f5de9d2f4d162f754c6eb40c88aa8e',
        chainId: 42161,
        type: 'ERC721',
        symbol: 'USDC/USD0',
        decimals: 18,
        token0: '0xaf88d065e77c8cc2239327c5edb3a432268e5831',
        token1: '0xfd086bc7cd5c481dcc9c85ebe478a1c0b69fcbb9',
      },
      '0x4b89179dafe5c36ae611208b5590fef9153b7daa': {
        address: '0x4b89179dafe5c36ae611208b5590fef9153b7daa',
        chainId: 42161,
        type: 'ERC721',
        symbol: 'RSETH/WETH',
        decimals: 18,
        token0: '0x4186bfc76e2e237523cbc30fd220fe055156b41f',
        token1: '0x82af49447d8a07e3bd95bd0d56f35241523fbab1',
      },
      '0x042691f78269ba3d6325c945044239758aecc275': {
        address: '0x042691f78269ba3d6325c945044239758aecc275',
        chainId: 42161,
        type: 'ERC721',
        symbol: 'PENDLE/WETH',
        decimals: 18,
        token0: '0x0c880f6761f1af8d9aa9c466984b80dab9a8c9e8',
        token1: '0x82af49447d8a07e3bd95bd0d56f35241523fbab1',
      },
      '0x2f5e87c9312fa29aed5c179e456625d79015299c': {
        address: '0x2f5e87c9312fa29aed5c179e456625d79015299c',
        chainId: 42161,
        type: 'ERC721-NATIVE',
        symbol: 'WBTC/WETH',
        decimals: 18,
        token0: '0x2f2a2543b76a4166549f7aab2e75bef0aefc5b0f',
        token1: '0x82af49447d8a07e3bd95bd0d56f35241523fbab1',
      },
      '0x6f38e884725a116c9c7fbf208e79fe8828a2595f': {
        address: '0x6f38e884725a116c9c7fbf208e79fe8828a2595f',
        chainId: 42161,
        type: 'ERC721-NATIVE',
        symbol: 'WETH/USDC',
        decimals: 18,
        token0: '0x82af49447d8a07e3bd95bd0d56f35241523fbab1',
        token1: '0xaf88d065e77c8cc2239327c5edb3a432268e5831',
      },
      '0x80a9ae39310abf666a87c743d6ebbd0e8c42158e': {
        address: '0x80a9ae39310abf666a87c743d6ebbd0e8c42158e',
        chainId: 42161,
        type: 'ERC721-NATIVE',
        symbol: 'WETH/GMX',
        decimals: 18,
        token0: '0x82af49447d8a07e3bd95bd0d56f35241523fbab1',
        token1: '0xfc5a1a6eb076a2c7ad06ed22c90d7e710e35ad0a',
      },
      '0x1944ac04bd9fed9a2bcdb38b70c35949c864ec35': {
        address: '0x1944ac04bd9fed9a2bcdb38b70c35949c864ec35',
        chainId: 42161,
        type: 'ERC721-NATIVE',
        symbol: 'PEPE/WETH',
        decimals: 18,
        token0: '0x25d887ce7a35172c62febfd67a1856f20faebb00',
        token1: '0x82af49447d8a07e3bd95bd0d56f35241523fbab1',
      },
      '0x021a4e8adce1dd0cfac1d8561005c1e1ffc55608': {
        address: '0x021a4e8adce1dd0cfac1d8561005c1e1ffc55608',
        chainId: 42161,
        type: 'ERC721-NATIVE',
        symbol: 'GRAI/USDC',
        decimals: 18,
        token0: '0x894134a25a5fac1c2c26f1d8fbf05111a3cb9487',
        token1: '0xaf88d065e77c8cc2239327c5edb3a432268e5831',
      },
      '0x641c00a822e8b671738d32a431a4fb6074e5c79d': {
        address: '0x641c00a822e8b671738d32a431a4fb6074e5c79d',
        chainId: 42161,
        type: 'ERC721-NATIVE',
        symbol: 'WETH/USD0',
        decimals: 18,
        token0: '0x82af49447d8a07e3bd95bd0d56f35241523fbab1',
        token1: '0xfd086bc7cd5c481dcc9c85ebe478a1c0b69fcbb9',
      },
      '0x0d7c4b40018969f81750d0a164c3839a77353efb': {
        address: '0x0d7c4b40018969f81750d0a164c3839a77353efb',
        chainId: 42161,
        type: 'ERC721',
        symbol: 'WETH/ARB',
        decimals: 18,
        token0: '0x82af49447d8a07e3bd95bd0d56f35241523fbab1',
        token1: '0x912ce59144191c1204e64559fe8253a0e49e6548',
      },
      '0x6fd1112cdfa0f53a698fb4d6c6f7dcec82e20b58': {
        address: '0x6fd1112cdfa0f53a698fb4d6c6f7dcec82e20b58',
        chainId: 42161,
        type: 'ERC721',
        symbol: 'USDV/WETH',
        decimals: 18,
        token0: '0x323665443cef804a3b5206103304bd4872ea4253',
        token1: '0x82af49447d8a07e3bd95bd0d56f35241523fbab1',
      },
      '0xc6af8e73e2261264ef95466b97b13e03bd88165e': {
        address: '0xc6af8e73e2261264ef95466b97b13e03bd88165e',
        chainId: 42161,
        type: 'ERC721-NATIVE',
        symbol: 'PENDLE/USDC',
        decimals: 18,
        token0: '0x0c880f6761f1af8d9aa9c466984b80dab9a8c9e8',
        token1: '0xaf88d065e77c8cc2239327c5edb3a432268e5831',
      },
      '0x908974b441bfca9ec4fdcd2ea49434e6e73d28f1': {
        address: '0x908974b441bfca9ec4fdcd2ea49434e6e73d28f1',
        chainId: 42161,
        type: 'ERC721-NATIVE',
        symbol: 'WETH/TIA.N',
        decimals: 18,
        token0: '0x82af49447d8a07e3bd95bd0d56f35241523fbab1',
        token1: '0xd56734d7f9979dd94fae3d67c7e928234e71cd4c',
      },
      '0xc24f7d8e51a64dc1238880bd00bb961d54cbeb29': {
        address: '0xc24f7d8e51a64dc1238880bd00bb961d54cbeb29',
        chainId: 42161,
        type: 'ERC721-NATIVE',
        symbol: 'WETH/UNI',
        decimals: 18,
        token0: '0x82af49447d8a07e3bd95bd0d56f35241523fbab1',
        token1: '0xfa7f8980b0f1e64a2062791cc3b0871572f1f7f0',
      },
      '0xe2d9b612446180334d56e10e82dc78e3dee814b0': {
        address: '0xe2d9b612446180334d56e10e82dc78e3dee814b0',
        chainId: 42161,
        type: 'ERC721',
        symbol: 'WETH/ETHX',
        decimals: 18,
        token0: '0x82af49447d8a07e3bd95bd0d56f35241523fbab1',
        token1: '0xed65c5085a18fa160af0313e60dcc7905e944dc7',
      },
      '0x24129a6c5b700435cc0d1bd3500796f3fb9ebd49': {
        address: '0x24129a6c5b700435cc0d1bd3500796f3fb9ebd49',
        chainId: 42161,
        type: 'LP',
        symbol: 'USDEX+/USDC',
        decimals: 18,
        totalSupply: '267368964583926',
        token0: '0x4117ec0a779448872d3820f37ba2060ae0b7c34b',
        token1: '0xaf88d065e77c8cc2239327c5edb3a432268e5831',
        priceInUsd: 1087838.2948115119,
      },
      '0x81d1cc282e9a097115e59f67b9d81d4d1d00ac51': {
        address: '0x81d1cc282e9a097115e59f67b9d81d4d1d00ac51',
        chainId: 42161,
        type: 'ERC721',
        symbol: 'ARB/USD0',
        decimals: 18,
        token0: '0x912ce59144191c1204e64559fe8253a0e49e6548',
        token1: '0xfd086bc7cd5c481dcc9c85ebe478a1c0b69fcbb9',
      },
      '0xab007665a4dfd24830f0ca19206f9fbd7c3aa85f': {
        address: '0xab007665a4dfd24830f0ca19206f9fbd7c3aa85f',
        chainId: 42161,
        type: 'ERC721-NATIVE',
        symbol: 'WSTETH/USDC',
        decimals: 18,
        token0: '0x5979d7b546e38e414f7e9822514be443a4800529',
        token1: '0xaf88d065e77c8cc2239327c5edb3a432268e5831',
      },
      '0x52f9d14bed8ce6536da063aaf274ae2747ef4853': {
        address: '0x52f9d14bed8ce6536da063aaf274ae2747ef4853',
        chainId: 42161,
        type: 'ERC721-NATIVE',
        symbol: 'LDO/WETH',
        decimals: 18,
        token0: '0x13ad51ed4f1b7e9dc168d8a00cb3f4ddd85efa60',
        token1: '0x82af49447d8a07e3bd95bd0d56f35241523fbab1',
      },
      '0xb7e50106a5bd3cf21af210a755f9c8740890a8c9': {
        address: '0xb7e50106a5bd3cf21af210a755f9c8740890a8c9',
        chainId: 42161,
        type: 'LP',
        symbol: 'MAGIC/WETH',
        decimals: 18,
        totalSupply: '5157676812874809497808',
        token0: '0x539bde0d7dbd336b79148aa742883198bbf60342',
        token1: '0x82af49447d8a07e3bd95bd0d56f35241523fbab1',
        priceInUsd: 92.93952651702119,
      },
      '0xfeb104864f3ad0c75e6b1bb4a0edb3f89e562e6e': {
        address: '0xfeb104864f3ad0c75e6b1bb4a0edb3f89e562e6e',
        chainId: 42161,
        type: 'ERC721',
        symbol: 'WETH/TIA.N',
        decimals: 18,
        token0: '0x82af49447d8a07e3bd95bd0d56f35241523fbab1',
        token1: '0xd56734d7f9979dd94fae3d67c7e928234e71cd4c',
      },
      '0x7fcdc35463e3770c2fb992716cd070b63540b947': {
        address: '0x7fcdc35463e3770c2fb992716cd070b63540b947',
        chainId: 42161,
        type: 'ERC721',
        symbol: 'WETH/USDC',
        decimals: 18,
        token0: '0x82af49447d8a07e3bd95bd0d56f35241523fbab1',
        token1: '0xaf88d065e77c8cc2239327c5edb3a432268e5831',
      },
      '0xdbaeb7f0dfe3a0aafd798ccecb5b22e708f7852c': {
        address: '0xdbaeb7f0dfe3a0aafd798ccecb5b22e708f7852c',
        chainId: 42161,
        type: 'ERC721-NATIVE',
        symbol: 'PENDLE/WETH',
        decimals: 18,
        token0: '0x0c880f6761f1af8d9aa9c466984b80dab9a8c9e8',
        token1: '0x82af49447d8a07e3bd95bd0d56f35241523fbab1',
      },
      '0x92a212d9f5eef0b262ac7d84aea64a0d0758b94f': {
        address: '0x92a212d9f5eef0b262ac7d84aea64a0d0758b94f',
        chainId: 42161,
        type: 'ERC20',
        symbol: 'GDEX',
        decimals: 18,
        totalSupply: '120000000000000000000000',
        priceInUsd: 6.745119721006401,
      },
      '0x3dd2fdba71282083d440687cce9e4231aaac534e': {
        address: '0x3dd2fdba71282083d440687cce9e4231aaac534e',
        chainId: 42161,
        type: 'ERC721-NATIVE',
        symbol: 'WETH/XUSD',
        decimals: 18,
        token0: '0x82af49447d8a07e3bd95bd0d56f35241523fbab1',
        token1: '0xe80772eaf6e2e18b651f160bc9158b2a5cafca65',
      },
      '0xb08a8794a5d3ccca3725d92964696858d3201909': {
        address: '0xb08a8794a5d3ccca3725d92964696858d3201909',
        chainId: 42161,
        type: 'ERC721-NATIVE',
        symbol: 'PENDLE/WETH',
        decimals: 18,
        token0: '0x0c880f6761f1af8d9aa9c466984b80dab9a8c9e8',
        token1: '0x82af49447d8a07e3bd95bd0d56f35241523fbab1',
      },
      '0x50e7b9293aef80c304234e86c84a01be8401c530': {
        address: '0x50e7b9293aef80c304234e86c84a01be8401c530',
        chainId: 42161,
        type: 'ERC721-NATIVE',
        symbol: 'PENDLE/USD0',
        decimals: 18,
        token0: '0x0c880f6761f1af8d9aa9c466984b80dab9a8c9e8',
        token1: '0xfd086bc7cd5c481dcc9c85ebe478a1c0b69fcbb9',
      },
      '0x51e073d92b0c226f7b0065909440b18a85769606': {
        address: '0x51e073d92b0c226f7b0065909440b18a85769606',
        chainId: 42161,
        type: 'SINGLE-LP',
        symbol: 'LP-DAI+',
        decimals: 18,
        totalSupply: '22252833350804717632',
        priceInUsd: 0.8533480998716072,
      },
      '0xb75ed91d1654e586015d72cabbc8f4b8b9aa0fd9': {
        address: '0xb75ed91d1654e586015d72cabbc8f4b8b9aa0fd9',
        chainId: 42161,
        type: 'SINGLE-LP',
        symbol: 'LP-USDC.E',
        decimals: 18,
        totalSupply: '119640637614562379232',
        priceInUsd: 1.052567040611476,
      },
      '0x2ac2b254bc18cd4999f64773a966e4f4869c34ee': {
        address: '0x2ac2b254bc18cd4999f64773a966e4f4869c34ee',
        chainId: 42161,
        type: 'ERC20',
        symbol: 'PNP',
        decimals: 18,
        totalSupply: '8655303775655560000000000',
        priceInUsd: 2.7768307038115037,
      },
      '0x32a5746ba6826828716cc1a394bc33301ebc7656': {
        address: '0x32a5746ba6826828716cc1a394bc33301ebc7656',
        chainId: 42161,
        type: 'ERC721-NATIVE',
        symbol: 'LINK/USD0',
        decimals: 18,
        token0: '0xf97f4df75117a78c1a5a0dbb814af92458539fb4',
        token1: '0xfd086bc7cd5c481dcc9c85ebe478a1c0b69fcbb9',
      },
      '0xaf7b48ae2f4773fd44f9208cca3db5ae7bfa7e37': {
        address: '0xaf7b48ae2f4773fd44f9208cca3db5ae7bfa7e37',
        chainId: 42161,
        type: 'ERC721-NATIVE',
        symbol: 'USDE/USD0',
        decimals: 18,
        token0: '0x5d3a1ff2b6bab83b63cd9ad0787074081a52ef34',
        token1: '0xfd086bc7cd5c481dcc9c85ebe478a1c0b69fcbb9',
      },
      '0xc24b560c7f8a1a50c2336cd8917af61b5e14984f': {
        address: '0xc24b560c7f8a1a50c2336cd8917af61b5e14984f',
        chainId: 42161,
        type: 'ERC721',
        symbol: 'SQD/WETH',
        decimals: 18,
        token0: '0x1337420ded5adb9980cfc35f8f2b054ea86f8ab1',
        token1: '0x82af49447d8a07e3bd95bd0d56f35241523fbab1',
      },
      '0xa1f9159e11ad48524c16c9bf10bf440815b03e6c': {
        address: '0xa1f9159e11ad48524c16c9bf10bf440815b03e6c',
        chainId: 42161,
        type: 'ERC721',
        symbol: 'USDC/XUSD',
        decimals: 18,
        token0: '0xaf88d065e77c8cc2239327c5edb3a432268e5831',
        token1: '0xe80772eaf6e2e18b651f160bc9158b2a5cafca65',
      },
      '0x1ebcf8831b93450ea81b0619c5e05b98751c8322': {
        address: '0x1ebcf8831b93450ea81b0619c5e05b98751c8322',
        chainId: 42161,
        type: 'ERC721-NATIVE',
        symbol: 'FRAX/USD0',
        decimals: 18,
        token0: '0x17fc002b466eec40dae837fc4be5c67993ddbd6f',
        token1: '0xfd086bc7cd5c481dcc9c85ebe478a1c0b69fcbb9',
      },
      '0x59d72ddb29da32847a4665d08ffc8464a7185fae': {
        address: '0x59d72ddb29da32847a4665d08ffc8464a7185fae',
        chainId: 42161,
        type: 'ERC721-NATIVE',
        symbol: 'MAGIC/WETH',
        decimals: 18,
        token0: '0x539bde0d7dbd336b79148aa742883198bbf60342',
        token1: '0x82af49447d8a07e3bd95bd0d56f35241523fbab1',
      },
      '0x6c2c06790b3e3e3c38e12ee22f8183b37a13ee55': {
        address: '0x6c2c06790b3e3e3c38e12ee22f8183b37a13ee55',
        chainId: 42161,
        type: 'ERC20',
        symbol: 'DPX',
        decimals: 18,
        totalSupply: '475346506169325674029503',
        priceInUsd: 5.142189453570223,
      },
      '0x843ac8dc6d34aeb07a56812b8b36429ee46bdd07': {
        address: '0x843ac8dc6d34aeb07a56812b8b36429ee46bdd07',
        chainId: 42161,
        type: 'ERC721',
        symbol: 'WBTC/USDC',
        decimals: 18,
        token0: '0x2f2a2543b76a4166549f7aab2e75bef0aefc5b0f',
        token1: '0xaf88d065e77c8cc2239327c5edb3a432268e5831',
      },
      '0x6985cb98ce393fce8d6272127f39013f61e36166': {
        address: '0x6985cb98ce393fce8d6272127f39013f61e36166',
        chainId: 42161,
        type: 'ERC721-NATIVE',
        symbol: 'WBTC/USDC',
        decimals: 18,
        token0: '0x2f2a2543b76a4166549f7aab2e75bef0aefc5b0f',
        token1: '0xaf88d065e77c8cc2239327c5edb3a432268e5831',
      },
      '0x09ba302a3f5ad2bf8853266e271b005a5b3716fe': {
        address: '0x09ba302a3f5ad2bf8853266e271b005a5b3716fe',
        chainId: 42161,
        type: 'ERC721-NATIVE',
        symbol: 'WETH/RETH',
        decimals: 18,
        token0: '0x82af49447d8a07e3bd95bd0d56f35241523fbab1',
        token1: '0xec70dcb4a1efa46b8f2d97c310c9c4790ba5ffa8',
      },
      '0x4bfc22a4da7f31f8a912a79a7e44a822398b4390': {
        address: '0x4bfc22a4da7f31f8a912a79a7e44a822398b4390',
        chainId: 42161,
        type: 'ERC721',
        symbol: 'WBTC/WETH',
        decimals: 18,
        token0: '0x2f2a2543b76a4166549f7aab2e75bef0aefc5b0f',
        token1: '0x82af49447d8a07e3bd95bd0d56f35241523fbab1',
      },
    },
    '43114': {
      '0xe3ba3d5e3f98eeff5e9eddd5bd20e476202770da': {
        address: '0xe3ba3d5e3f98eeff5e9eddd5bd20e476202770da',
        chainId: 43114,
        type: 'LP',
        symbol: 'USDT/WAVAX',
        decimals: 18,
        totalSupply: '7123327114935004',
        token0: '0x9702230a8ea53601f5cd2dc00fdbc13d4df4a8c7',
        token1: '0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7',
        priceInUsd: 19462524.313037653,
      },
      '0xe530dc2095ef5653205cf5ea79f8979a7028065c': {
        address: '0xe530dc2095ef5653205cf5ea79f8979a7028065c',
        chainId: 43114,
        type: 'LP',
        symbol: 'QI/WAVAX',
        decimals: 18,
        totalSupply: '105737147450',
        token0: '0x8729438eb15e2c8b576fcc6aecda6a148776c0f5',
        token1: '0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7',
        priceInUsd: 5718862524166.842,
      },
      '0xfae3f424a0a47706811521e3ee268f00cfb5c45e': {
        address: '0xfae3f424a0a47706811521e3ee268f00cfb5c45e',
        chainId: 43114,
        type: 'ERC721-NATIVE',
        symbol: 'WAVAX/USDC',
        decimals: 18,
        token0: '0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7',
        token1: '0xb97ef9ef8734c71904d8002f8b6bc66dd9c48a6e',
      },
      '0xe28984e1ee8d431346d32bec9ec800efb643eef4': {
        address: '0xe28984e1ee8d431346d32bec9ec800efb643eef4',
        chainId: 43114,
        type: 'LP',
        symbol: 'WAVAX/USDT.E',
        decimals: 18,
        totalSupply: '8524473771617516',
        token0: '0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7',
        token1: '0xc7198437980c041c805a1edcba50c1ce5db95118',
        priceInUsd: 23598083.828085795,
      },
      '0x804226ca4edb38e7ef56d16d16e92dc3223347a0': {
        address: '0x804226ca4edb38e7ef56d16d16e92dc3223347a0',
        chainId: 43114,
        type: 'ERC721-NATIVE',
        symbol: 'USDT/USDC',
        decimals: 18,
        token0: '0x9702230a8ea53601f5cd2dc00fdbc13d4df4a8c7',
        token1: '0xb97ef9ef8734c71904d8002f8b6bc66dd9c48a6e',
      },
      '0x7c05d54fc5cb6e4ad87c6f5db3b807c94bb89c52': {
        address: '0x7c05d54fc5cb6e4ad87c6f5db3b807c94bb89c52',
        chainId: 43114,
        type: 'LP',
        symbol: 'WETH.E/WAVAX',
        decimals: 18,
        totalSupply: '578601690011466961543',
        token0: '0x49d5c2bdffac6ce2bfdb6640f4f80f226bc10bab',
        token1: '0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7',
        priceInUsd: 1004.4461035544107,
      },
      '0x9d86243ae7008ec1f9cce83c49d76f7a557b80cf': {
        address: '0x9d86243ae7008ec1f9cce83c49d76f7a557b80cf',
        chainId: 43114,
        type: 'LP',
        symbol: 'WBTC.E/USDC',
        decimals: 18,
        totalSupply: '73929925',
        token0: '0x50b7545627a5162f82a992c33b87adc75187b218',
        token1: '0xb97ef9ef8734c71904d8002f8b6bc66dd9c48a6e',
        priceInUsd: 68166924927169.89,
      },
      '0x8a9c36bc3ced5ecce703a4da8032218dfe72fe86': {
        address: '0x8a9c36bc3ced5ecce703a4da8032218dfe72fe86',
        chainId: 43114,
        type: 'LP',
        symbol: 'USDC.E/USDC',
        decimals: 18,
        totalSupply: '16535063137',
        token0: '0xa7d7079b0fead91f3e65f86e8915cb59c1a4c664',
        token1: '0xb97ef9ef8734c71904d8002f8b6bc66dd9c48a6e',
        priceInUsd: 2062859431134.4534,
      },
      '0x7b602f98d71715916e7c963f51bfebc754ade2d0': {
        address: '0x7b602f98d71715916e7c963f51bfebc754ade2d0',
        chainId: 43114,
        type: 'ERC721-NATIVE',
        symbol: 'WETH.E/WAVAX',
        decimals: 18,
        token0: '0x49d5c2bdffac6ce2bfdb6640f4f80f226bc10bab',
        token1: '0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7',
      },
      '0x0e0100ab771e9288e0aa97e11557e6654c3a9665': {
        address: '0x0e0100ab771e9288e0aa97e11557e6654c3a9665',
        chainId: 43114,
        type: 'LP',
        symbol: 'WAVAX/USDC',
        decimals: 18,
        totalSupply: '9947579300439321',
        token0: '0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7',
        token1: '0xb97ef9ef8734c71904d8002f8b6bc66dd9c48a6e',
        priceInUsd: 18687883.001016833,
      },
      '0x3712871408a829c5cd4e86da1f4ce727efcd28f6': {
        address: '0x3712871408a829c5cd4e86da1f4ce727efcd28f6',
        chainId: 43114,
        type: 'ERC20',
        symbol: 'GLCR',
        decimals: 18,
        totalSupply: '293044556298341595232967660',
        priceInUsd: 6.7277413906080125e-6,
      },
      '0x1784b2ff6841d46163fbf817b3feb98a0e163e0f': {
        address: '0x1784b2ff6841d46163fbf817b3feb98a0e163e0f',
        chainId: 43114,
        type: 'LP',
        symbol: 'PNG/USDC',
        decimals: 18,
        totalSupply: '2332349078804',
        token0: '0x60781c2586d68229fde47564546784ab3faca982',
        token1: '0xb97ef9ef8734c71904d8002f8b6bc66dd9c48a6e',
        priceInUsd: 5535405600.458593,
      },
      '0x5875c368cddd5fb9bf2f410666ca5aad236dabd4': {
        address: '0x5875c368cddd5fb9bf2f410666ca5aad236dabd4',
        chainId: 43114,
        type: 'LP',
        symbol: 'LINK.E/WAVAX',
        decimals: 18,
        totalSupply: '1057827507834275892493',
        token0: '0x5947bb275c521040051d82396192181b413227a3',
        token1: '0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7',
        priceInUsd: 89.01802544805055,
      },
      '0x2071a39da7450d68e4f4902774203df208860da2': {
        address: '0x2071a39da7450d68e4f4902774203df208860da2',
        chainId: 43114,
        type: 'LP',
        symbol: 'GLCR/WAVAX',
        decimals: 18,
        totalSupply: '11824370978646518677172',
        token0: '0x3712871408a829c5cd4e86da1f4ce727efcd28f6',
        token1: '0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7',
        priceInUsd: 0.030352530280665275,
      },
      '0x60781c2586d68229fde47564546784ab3faca982': {
        address: '0x60781c2586d68229fde47564546784ab3faca982',
        chainId: 43114,
        type: 'ERC20',
        symbol: 'PNG',
        decimals: 18,
        totalSupply: '538000000000000000000000000',
        priceInUsd: 0.12884082477844655,
      },
      '0xa13403733db5c101490436cfff012f6ac93a6097': {
        address: '0xa13403733db5c101490436cfff012f6ac93a6097',
        chainId: 43114,
        type: 'LP',
        symbol: 'YAK/WAVAX',
        decimals: 18,
        totalSupply: '1396431905336192028',
        token0: '0x59414b3089ce2af0010e7523dea7e2b35d776ec7',
        token1: '0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7',
        priceInUsd: 291.7322127232482,
      },
      '0xbd918ed441767fe7924e99f6a0e0b568ac1970d9': {
        address: '0xbd918ed441767fe7924e99f6a0e0b568ac1970d9',
        chainId: 43114,
        type: 'LP',
        symbol: 'USDC.E/WAVAX',
        decimals: 18,
        totalSupply: '4933628959591071',
        token0: '0xa7d7079b0fead91f3e65f86e8915cb59c1a4c664',
        token1: '0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7',
        priceInUsd: 21497377.719738297,
      },
      '0x94e909ca096e2add53c01a0aab3e7d63e9b7e313': {
        address: '0x94e909ca096e2add53c01a0aab3e7d63e9b7e313',
        chainId: 43114,
        type: 'ERC721-NATIVE',
        symbol: 'WAVAX/XAVA',
        decimals: 18,
        token0: '0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7',
        token1: '0xd1c3f94de7e5b45fa4edbba472491a9f4b166fc4',
      },
    },
  },
  zapper: {
    '10': {
      '0x9560e827af36c94d2ac33a39bce1fe78631088db': {
        address: '0x9560e827af36c94d2ac33a39bce1fe78631088db',
        chainId: 10,
        type: 'ERC20',
        symbol: 'VELO',
        decimals: 18,
        totalSupply: '2215130979333906718250137553',
        priceInUsd: 0.04605597689828343,
      },
      '0x0b2c639c533813f4aa9d7837caf62653d097ff85': {
        address: '0x0b2c639c533813f4aa9d7837caf62653d097ff85',
        chainId: 10,
        symbol: 'USDC',
        decimals: 6,
        totalSupply: '210616461915277',
        priceInUsd: 0.9987001872810729,
      },
      '0x4200000000000000000000000000000000000042': {
        address: '0x4200000000000000000000000000000000000042',
        chainId: 10,
        symbol: 'OP',
        decimals: 18,
        totalSupply: '4294963292498750113616177748',
        priceInUsd: 0.6993461695461693,
      },
      '0x94b008aa00579c1307b0ef2c499ad98a8ce58e58': {
        address: '0x94b008aa00579c1307b0ef2c499ad98a8ce58e58',
        chainId: 10,
        symbol: 'USDT',
        decimals: 6,
        totalSupply: '201246175495018',
        priceInUsd: 0.9988945270653359,
      },
    },
    '146': {
      '0x29219dd400f2bf60e5a23d13be72b486d4038894': {
        address: '0x29219dd400f2bf60e5a23d13be72b486d4038894',
        chainId: 146,
        symbol: 'USDC.E',
        decimals: 6,
        totalSupply: '107809765735442',
        priceInUsd: 0.9945957913700029,
      },
    },
    '169': {
      '0x6da9ebd271a0676f39c088a2b5fd849d5080c0af': {
        address: '0x6da9ebd271a0676f39c088a2b5fd849d5080c0af',
        chainId: 169,
        symbol: 'USDEX+',
        decimals: 18,
        totalSupply: '485895350571938193100443',
        priceInUsd: 0.21778316038882078,
      },
      '0xb73603c5d87fa094b7314c74ace2e64d165016fb': {
        address: '0xb73603c5d87fa094b7314c74ace2e64d165016fb',
        chainId: 169,
        symbol: 'USDC',
        decimals: 6,
        totalSupply: '2356959618641',
        priceInUsd: 0.9958041938841876,
      },
    },
    '369': {
      '0xa1077a294dde1b09bb078844df40758a5d0f9a27': {
        address: '0xa1077a294dde1b09bb078844df40758a5d0f9a27',
        chainId: 369,
        symbol: 'WPLS',
        decimals: 18,
        totalSupply: '7606581839464487669448989299157',
        priceInUsd: 3.622618155898347e-5,
      },
      '0x30fcb23a906493371b1721c8feb8815804808d74': {
        address: '0x30fcb23a906493371b1721c8feb8815804808d74',
        chainId: 369,
        symbol: 'SDAI',
        decimals: 18,
        totalSupply: '1061499018386603134024458',
        priceInUsd: 0.5445666778305576,
      },
      '0xaa2c47a35c1298795b5271490971ec4874c8e53d': {
        address: '0xaa2c47a35c1298795b5271490971ec4874c8e53d',
        chainId: 369,
        symbol: 'USDEX+',
        decimals: 18,
        totalSupply: '251451858483236672588491',
        priceInUsd: 0.5403032743917803,
      },
      '0x02dcdd04e3f455d838cd1249292c58f3b79e3c3c': {
        address: '0x02dcdd04e3f455d838cd1249292c58f3b79e3c3c',
        chainId: 369,
        symbol: 'WETH',
        decimals: 18,
        totalSupply: '5982599654954158080949',
        priceInUsd: 4118.691313525024,
      },
      '0xefd766ccb38eaf1dfd701853bfce31359239f305': {
        address: '0xefd766ccb38eaf1dfd701853bfce31359239f305',
        chainId: 369,
        symbol: 'DAI',
        decimals: 18,
        totalSupply: '21500824051155927013426563',
        priceInUsd: 0.959165819094838,
      },
    },
    '8453': {
      '0x833589fcd6edb6e08f4c7c32d4f71b54bda02913': {
        address: '0x833589fcd6edb6e08f4c7c32d4f71b54bda02913',
        chainId: 8453,
        symbol: 'USDC',
        decimals: 6,
        totalSupply: '4007246177975286',
        priceInUsd: 0.9990044840597347,
      },
      '0xd9aaec86b65d86f6a7b5b1b0c42ffa531710b6ca': {
        address: '0xd9aaec86b65d86f6a7b5b1b0c42ffa531710b6ca',
        chainId: 8453,
        symbol: 'USDBC',
        decimals: 6,
        totalSupply: '9155121665370',
        priceInUsd: 0.9977597906584159,
      },
    },
    '42161': {
      '0xaf88d065e77c8cc2239327c5edb3a432268e5831': {
        address: '0xaf88d065e77c8cc2239327c5edb3a432268e5831',
        chainId: 42161,
        symbol: 'USDC',
        decimals: 6,
        totalSupply: '7998315013965677',
        priceInUsd: 0.998986934880982,
      },
    },
    '43114': {
      '0xc7198437980c041c805a1edcba50c1ce5db95118': {
        address: '0xc7198437980c041c805a1edcba50c1ce5db95118',
        chainId: 43114,
        symbol: 'USDT.E',
        decimals: 6,
        totalSupply: '21670132324413',
        priceInUsd: 0.9962574838132385,
      },
      '0xb97ef9ef8734c71904d8002f8b6bc66dd9c48a6e': {
        address: '0xb97ef9ef8734c71904d8002f8b6bc66dd9c48a6e',
        chainId: 43114,
        symbol: 'USDC',
        decimals: 6,
        totalSupply: '1028815424092150',
        priceInUsd: 0.9868562840477054,
      },
    },
  },
  common: {
    '10': {
      '0x0000000000000000000000000000000000000000': {
        address: '0x0000000000000000000000000000000000000000',
        chainId: 10,
        decimals: 18,
        symbol: 'ETH',
        priceInUsd: 4179.1922276611995,
      },
      '0x4200000000000000000000000000000000000006': {
        address: '0x4200000000000000000000000000000000000006',
        chainId: 10,
        decimals: 18,
        symbol: 'WETH',
        priceInUsd: 4179.1922276611995,
      },
    },
    '56': {
      '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c': {
        address: '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c',
        chainId: 56,
        decimals: 18,
        symbol: 'WBNB',
        priceInUsd: 1026.0145979771205,
      },
      '0x0000000000000000000000000000000000000000': {
        address: '0x0000000000000000000000000000000000000000',
        chainId: 56,
        decimals: 18,
        symbol: 'BNB',
        priceInUsd: 1026.0145979771205,
      },
    },
    '146': {
      '0x039e2fb66102314ce7b64ce5ce3e5183bc94ad38': {
        address: '0x039e2fb66102314ce7b64ce5ce3e5183bc94ad38',
        chainId: 146,
        decimals: 18,
        symbol: 'WS',
        priceInUsd: 0.252511776130936,
      },
      '0x0000000000000000000000000000000000000000': {
        address: '0x0000000000000000000000000000000000000000',
        chainId: 146,
        decimals: 18,
        symbol: 'S',
        priceInUsd: 0.252511776130936,
      },
    },
    '169': {
      '0x0000000000000000000000000000000000000000': {
        address: '0x0000000000000000000000000000000000000000',
        chainId: 169,
        decimals: 18,
        symbol: 'ETH',
        priceInUsd: 4167.517714751349,
      },
      '0x0dc808adce2099a9f62aa87d9670745aba741746': {
        address: '0x0dc808adce2099a9f62aa87d9670745aba741746',
        chainId: 169,
        decimals: 18,
        symbol: 'WETH',
        priceInUsd: 4167.517714751349,
      },
    },
    '369': {
      '0x0000000000000000000000000000000000000000': {
        address: '0x0000000000000000000000000000000000000000',
        chainId: 369,
        decimals: 18,
        symbol: 'PLS',
        priceInUsd: 3.622618278641478e-5,
      },
      '0xa1077a294dde1b09bb078844df40758a5d0f9a27': {
        address: '0xa1077a294dde1b09bb078844df40758a5d0f9a27',
        chainId: 369,
        decimals: 18,
        symbol: 'WPLS',
        priceInUsd: 3.622618278641478e-5,
      },
    },
    '8453': {
      '0x0000000000000000000000000000000000000000': {
        address: '0x0000000000000000000000000000000000000000',
        chainId: 8453,
        decimals: 18,
        symbol: 'ETH',
        priceInUsd: 4181.227366404168,
      },
      '0x4200000000000000000000000000000000000006': {
        address: '0x4200000000000000000000000000000000000006',
        chainId: 8453,
        decimals: 18,
        symbol: 'WETH',
        priceInUsd: 4181.227366404168,
      },
    },
    '42161': {
      '0x82af49447d8a07e3bd95bd0d56f35241523fbab1': {
        address: '0x82af49447d8a07e3bd95bd0d56f35241523fbab1',
        chainId: 42161,
        decimals: 18,
        symbol: 'WETH',
        priceInUsd: 4180.44415332335,
      },
      '0x0000000000000000000000000000000000000000': {
        address: '0x0000000000000000000000000000000000000000',
        chainId: 42161,
        decimals: 18,
        symbol: 'ETH',
        priceInUsd: 4180.44415332335,
      },
    },
    '43114': {
      '0x0000000000000000000000000000000000000000': {
        address: '0x0000000000000000000000000000000000000000',
        chainId: 43114,
        decimals: 18,
        symbol: 'AVAX',
        priceInUsd: 34.21546856213187,
      },
      '0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7': {
        address: '0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7',
        chainId: 43114,
        decimals: 18,
        symbol: 'WAVAX',
        priceInUsd: 34.21546856213187,
      },
    },
  },
  etf: {
    '10': {
      '0x0da31f47491079a074d3d86cacfc5be1314fc20e': {
        address: '0x0da31f47491079a074d3d86cacfc5be1314fc20e',
        chainId: 10,
        type: 'ETF',
        symbol: 'OPMAXIETF',
        decimals: 18,
        totalSupply: '18623839564996966614',
        priceInUsd: 0.84,
        innerTokens: [
          {
            weight: '800000000000000000',
            address: '0x4200000000000000000000000000000000000042',
            chainId: 10,
            symbol: 'OP',
            decimals: 18,
            totalSupply: '4294963292498750113616177748',
          },
          {
            weight: '200000000000000000',
            address: '0x0b2c639c533813f4aa9d7837caf62653d097ff85',
            chainId: 10,
            symbol: 'USDC',
            decimals: 6,
            totalSupply: '210606992572404',
          },
        ],
      },
      '0x280d1b9442c3d9d7bc27b5d2e1ca871f96fb6bb6': {
        address: '0x280d1b9442c3d9d7bc27b5d2e1ca871f96fb6bb6',
        chainId: 10,
        type: 'ETF',
        symbol: 'ETHMAXIETF',
        decimals: 18,
        totalSupply: '1442635513623112677',
        priceInUsd: 58.97,
        innerTokens: [
          {
            weight: '200000000000000000',
            address: '0x4200000000000000000000000000000000000042',
            chainId: 10,
            symbol: 'OP',
            decimals: 18,
            totalSupply: '4294963292498750113616177748',
          },
          {
            weight: '800000000000000000',
            address: '0x4200000000000000000000000000000000000006',
            chainId: 10,
            symbol: 'WETH',
            decimals: 18,
            totalSupply: '21400640393622630005966',
          },
        ],
      },
      '0x238ca40d2a2a35320d2b2fd0a7604b655316b04a': {
        address: '0x238ca40d2a2a35320d2b2fd0a7604b655316b04a',
        chainId: 10,
        type: 'ETF',
        symbol: 'RSETF',
        decimals: 18,
        totalSupply: '14464780315614606315',
        priceInUsd: 0.89,
        innerTokens: [
          {
            weight: '200000000000000000',
            address: '0x4200000000000000000000000000000000000042',
            chainId: 10,
            symbol: 'OP',
            decimals: 18,
            totalSupply: '4294963292498750113616177748',
          },
          {
            weight: '800000000000000000',
            address: '0x0b2c639c533813f4aa9d7837caf62653d097ff85',
            chainId: 10,
            symbol: 'USDC',
            decimals: 6,
            totalSupply: '210606992572404',
          },
        ],
      },
    },
    '56': {
      '0x9732fb5a970186067ec5c135d6ee91568bca228b': {
        address: '0x9732fb5a970186067ec5c135d6ee91568bca228b',
        chainId: 56,
        type: 'ETF',
        symbol: 'EMPETF',
        decimals: 18,
        totalSupply: '33185921507245121822',
        priceInUsd: 4.04,
        innerTokens: [
          {
            weight: '500000000000000000',
            address: '0x3a30dce3938a2278f4459f2768126de4fc955e9d',
            chainId: 56,
            symbol: 'EMP',
            decimals: 18,
            totalSupply: '59415235180586772432170006',
          },
          {
            weight: '250000000000000000',
            address: '0x29c55f1b02a95f0b30e61976835a3eee2359ad92',
            chainId: 56,
            symbol: 'ESHARE',
            decimals: 18,
            totalSupply: '73313002197190036961824',
          },
          {
            weight: '250000000000000000',
            address: '0x2170ed0880ac9a755fd29b2688956bd959f933f8',
            chainId: 56,
            symbol: 'ETH',
            decimals: 18,
            totalSupply: '604999999958821101704211',
          },
        ],
      },
      '0x01e5e868a6fb767b5219b805b3c39ea98b8fc7d5': {
        address: '0x01e5e868a6fb767b5219b805b3c39ea98b8fc7d5',
        chainId: 56,
        type: 'ETF',
        symbol: 'GSETF',
        decimals: 18,
        totalSupply: '443070310382764908067',
        priceInUsd: 2.99,
        innerTokens: [
          {
            weight: '750000000000000000',
            address: '0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d',
            chainId: 56,
            symbol: 'USDC',
            decimals: 18,
            totalSupply: '1048999979839803987446539541',
          },
          {
            weight: '250000000000000000',
            address: '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c',
            chainId: 56,
            symbol: 'WBNB',
            decimals: 18,
            totalSupply: '1311072079570585229562716',
          },
        ],
      },
      '0x227b093d9bc7e59555db823e3d6f700ea2dbf2ca': {
        address: '0x227b093d9bc7e59555db823e3d6f700ea2dbf2ca',
        chainId: 56,
        type: 'ETF',
        symbol: 'MCETF',
        decimals: 18,
        totalSupply: '10474479662181119625',
        priceInUsd: 157.98,
        innerTokens: [
          {
            weight: '500000000000000000',
            address: '0x2170ed0880ac9a755fd29b2688956bd959f933f8',
            chainId: 56,
            symbol: 'ETH',
            decimals: 18,
            totalSupply: '604999999958821101704211',
          },
          {
            weight: '500000000000000000',
            address: '0x7130d2a12b9bcbfae4f2634d864a1ee1ce3ead9c',
            chainId: 56,
            symbol: 'BTCB',
            decimals: 18,
            totalSupply: '65300969964784133902393',
          },
        ],
      },
    },
    '146': {
      '0x5c2fec17fb8cc110e53d611f8cca59fd9767fa4b': {
        address: '0x5c2fec17fb8cc110e53d611f8cca59fd9767fa4b',
        chainId: 146,
        type: 'ETF',
        symbol: 'SETF',
        decimals: 18,
        totalSupply: '285864284190477834239',
        priceInUsd: 1.13,
        innerTokens: [
          {
            weight: '500000000000000000',
            address: '0x039e2fb66102314ce7b64ce5ce3e5183bc94ad38',
            chainId: 146,
            symbol: 'WS',
            decimals: 18,
            totalSupply: '274396287815247217108724476',
          },
          {
            weight: '500000000000000000',
            address: '0x29219dd400f2bf60e5a23d13be72b486d4038894',
            chainId: 146,
            symbol: 'USDC.E',
            decimals: 6,
            totalSupply: '107809765735442',
          },
        ],
      },
      '0xf56febebb8e7d7aa68f52f8c115a766638102d04': {
        address: '0xf56febebb8e7d7aa68f52f8c115a766638102d04',
        chainId: 146,
        type: 'ETF',
        symbol: 'SMETF',
        decimals: 18,
        totalSupply: '1250834181056777976',
        priceInUsd: 0.32,
        innerTokens: [
          {
            weight: '250000000000000000',
            address: '0x039e2fb66102314ce7b64ce5ce3e5183bc94ad38',
            chainId: 146,
            symbol: 'WS',
            decimals: 18,
            totalSupply: '274396287815247217108724476',
          },
          {
            weight: '250000000000000000',
            address: '0x9f0df7799f6fdad409300080cff680f5a23df4b1',
            chainId: 146,
            symbol: 'WOS',
            decimals: 18,
            totalSupply: '19453141048754882395511088',
          },
          {
            weight: '250000000000000000',
            address: '0xe5da20f15420ad15de0fa650600afc998bbe3955',
            chainId: 146,
            symbol: 'STS',
            decimals: 18,
            totalSupply: '277954591085708557604761233',
          },
          {
            weight: '250000000000000000',
            address: '0xd3dce716f3ef535c5ff8d041c1a41c3bd89b97ae',
            chainId: 146,
            symbol: 'SCUSD',
            decimals: 6,
            totalSupply: '7966765778724',
          },
        ],
      },
      '0x97dff9a0eb4e8382e998ce847dda2659e7581261': {
        address: '0x97dff9a0eb4e8382e998ce847dda2659e7581261',
        chainId: 146,
        type: 'ETF',
        symbol: 'SEETF',
        decimals: 18,
        totalSupply: '4216046739776738325',
        priceInUsd: 8.33,
        innerTokens: [
          {
            weight: '340000000000000000',
            address: '0x3333111a391cc08fa51353e9195526a70b333333',
            chainId: 146,
            type: 'ERC20',
            symbol: 'X33',
            decimals: 18,
            totalSupply: '614350293774813286608191',
          },
          {
            weight: '330000000000000000',
            address: '0x5555b2733602ded58d47b8d3d989e631cbee5555',
            chainId: 146,
            type: 'ERC20',
            symbol: 'GEMS',
            decimals: 18,
            totalSupply: '2320925133348580903578',
          },
          {
            weight: '330000000000000000',
            address: '0x039e2fb66102314ce7b64ce5ce3e5183bc94ad38',
            chainId: 146,
            symbol: 'WS',
            decimals: 18,
            totalSupply: '274396287815247217108724476',
          },
        ],
      },
    },
    '169': {
      '0xa9d47ba4d1129d2ebcf3679d799700fb6d6f28ae': {
        address: '0xa9d47ba4d1129d2ebcf3679d799700fb6d6f28ae',
        chainId: 169,
        type: 'ETF',
        symbol: 'METF',
        decimals: 18,
        totalSupply: '252009867707665852265',
        priceInUsd: 0.86,
        innerTokens: [
          {
            weight: '250000000000000000',
            address: '0x95cef13441be50d20ca4558cc0a27b601ac544e5',
            chainId: 169,
            symbol: 'MANTA',
            decimals: 18,
            totalSupply: '1020000000000000000000000000',
          },
          {
            weight: '250000000000000000',
            address: '0x0dc808adce2099a9f62aa87d9670745aba741746',
            chainId: 169,
            symbol: 'WETH',
            decimals: 18,
            totalSupply: '530417901326638827082',
          },
          {
            weight: '250000000000000000',
            address: '0xec901da9c68e90798bbbb74c11406a32a70652c3',
            chainId: 169,
            symbol: 'STONE',
            decimals: 18,
            totalSupply: '3294209912408381249751',
          },
          {
            weight: '250000000000000000',
            address: '0x4c2a0f964a37a3ce305fe41c575beeb48c8c3fa2',
            chainId: 169,
            symbol: 'GCETO',
            decimals: 18,
            totalSupply: '10000000000000000000000',
          },
        ],
      },
      '0xa6bdf6dbfaf92f5216f9c87938d4468c1b766e2c': {
        address: '0xa6bdf6dbfaf92f5216f9c87938d4468c1b766e2c',
        chainId: 169,
        type: 'ETF',
        symbol: 'GCMETF',
        decimals: 18,
        totalSupply: '6442981947923789554422',
        priceInUsd: 0.05,
        innerTokens: [
          {
            weight: '850000000000000000',
            address: '0x4c2a0f964a37a3ce305fe41c575beeb48c8c3fa2',
            chainId: 169,
            symbol: 'GCETO',
            decimals: 18,
            totalSupply: '10000000000000000000000',
          },
          {
            weight: '150000000000000000',
            address: '0x0dc808adce2099a9f62aa87d9670745aba741746',
            chainId: 169,
            symbol: 'WETH',
            decimals: 18,
            totalSupply: '530417901326638827082',
          },
        ],
      },
      '0xeffc99646a5e3479416e3351b48b446937d8c209': {
        address: '0xeffc99646a5e3479416e3351b48b446937d8c209',
        chainId: 169,
        type: 'ETF',
        symbol: 'ETHMAXIETF',
        decimals: 18,
        totalSupply: '1764360056129896176',
        priceInUsd: 62.11,
        innerTokens: [
          {
            weight: '250000000000000000',
            address: '0xb73603c5d87fa094b7314c74ace2e64d165016fb',
            chainId: 169,
            symbol: 'USDC',
            decimals: 6,
            totalSupply: '2356959618641',
          },
          {
            weight: '750000000000000000',
            address: '0x0dc808adce2099a9f62aa87d9670745aba741746',
            chainId: 169,
            symbol: 'WETH',
            decimals: 18,
            totalSupply: '530417901326638827082',
          },
        ],
      },
      '0x433d1134a92362434c5a0619302d74c22e509641': {
        address: '0x433d1134a92362434c5a0619302d74c22e509641',
        chainId: 169,
        type: 'ETF',
        symbol: 'CETF',
        decimals: 18,
        totalSupply: '40972488168800582344',
        priceInUsd: 0.6,
        innerTokens: [
          {
            weight: '400000000000000000',
            address: '0x4c2a0f964a37a3ce305fe41c575beeb48c8c3fa2',
            chainId: 169,
            symbol: 'GCETO',
            decimals: 18,
            totalSupply: '10000000000000000000000',
          },
          {
            weight: '300000000000000000',
            address: '0x6da9ebd271a0676f39c088a2b5fd849d5080c0af',
            chainId: 169,
            symbol: 'USDEX+',
            decimals: 18,
            totalSupply: '485895350571938193100443',
          },
          {
            weight: '300000000000000000',
            address: '0x0dc808adce2099a9f62aa87d9670745aba741746',
            chainId: 169,
            symbol: 'WETH',
            decimals: 18,
            totalSupply: '530417901326638827082',
          },
        ],
      },
    },
    '369': {
      '0x778e55f1472455da958309dffe2923726f8577e0': {
        address: '0x778e55f1472455da958309dffe2923726f8577e0',
        chainId: 369,
        type: 'ETF',
        symbol: 'SMETF',
        decimals: 18,
        totalSupply: '376704767583093000007',
        priceInUsd: 0.05,
        innerTokens: [
          {
            weight: '750000000000000000',
            address: '0x6386704cd6f7a584ea9d23ccca66af7eba5a727e',
            chainId: 369,
            type: 'ERC20',
            symbol: 'SPARK',
            decimals: 18,
            totalSupply: '71346965343122843931342213',
          },
          {
            weight: '250000000000000000',
            address: '0x30fcb23a906493371b1721c8feb8815804808d74',
            chainId: 369,
            symbol: 'SDAI',
            decimals: 18,
            totalSupply: '1061499018386603134024458',
          },
        ],
      },
      '0xb56aa77d87ecaa9d596b01931eccaddda78b57c1': {
        address: '0xb56aa77d87ecaa9d596b01931eccaddda78b57c1',
        chainId: 369,
        type: 'ETF',
        symbol: 'PETF',
        decimals: 18,
        totalSupply: '280023929345690158238',
        priceInUsd: 1.59,
        innerTokens: [
          {
            weight: '500000000000000000',
            address: '0xa1077a294dde1b09bb078844df40758a5d0f9a27',
            chainId: 369,
            symbol: 'WPLS',
            decimals: 18,
            totalSupply: '7606581839464487669448989299157',
          },
          {
            weight: '250000000000000000',
            address: '0x02dcdd04e3f455d838cd1249292c58f3b79e3c3c',
            chainId: 369,
            symbol: 'WETH',
            decimals: 18,
            totalSupply: '5982599654954158080949',
          },
          {
            weight: '250000000000000000',
            address: '0x30fcb23a906493371b1721c8feb8815804808d74',
            chainId: 369,
            symbol: 'SDAI',
            decimals: 18,
            totalSupply: '1061499018386603134024458',
          },
        ],
      },
      '0xa8e6045fb7980eca402b0a3e6ebd15ab2fad3619': {
        address: '0xa8e6045fb7980eca402b0a3e6ebd15ab2fad3619',
        chainId: 369,
        type: 'ETF',
        symbol: 'SETF',
        decimals: 18,
        totalSupply: '1536292999800100462839',
        priceInUsd: 0.67,
        innerTokens: [
          {
            weight: '340000000000000000',
            address: '0x6386704cd6f7a584ea9d23ccca66af7eba5a727e',
            chainId: 369,
            type: 'ERC20',
            symbol: 'SPARK',
            decimals: 18,
            totalSupply: '71346965343122843931342213',
          },
          {
            weight: '330000000000000000',
            address: '0x30fcb23a906493371b1721c8feb8815804808d74',
            chainId: 369,
            symbol: 'SDAI',
            decimals: 18,
            totalSupply: '1061499018386603134024458',
          },
          {
            weight: '330000000000000000',
            address: '0x02dcdd04e3f455d838cd1249292c58f3b79e3c3c',
            chainId: 369,
            symbol: 'WETH',
            decimals: 18,
            totalSupply: '5982599654954158080949',
          },
        ],
      },
      '0x35d4f8f54e80b190a5c326d16c1030a906c47f7d': {
        address: '0x35d4f8f54e80b190a5c326d16c1030a906c47f7d',
        chainId: 369,
        type: 'ETF',
        symbol: 'EMETF',
        decimals: 18,
        totalSupply: '20187217702700644',
        priceInUsd: 0,
        innerTokens: [
          {
            weight: '750000000000000000',
            address: '0x9231937ac31506b6913ac5fb1db5a1c1ae83783a',
            chainId: 369,
            symbol: 'EMP',
            decimals: 18,
            totalSupply: '50200000000000000000000000',
          },
          {
            weight: '250000000000000000',
            address: '0x30fcb23a906493371b1721c8feb8815804808d74',
            chainId: 369,
            symbol: 'SDAI',
            decimals: 18,
            totalSupply: '1061499018386603134024458',
          },
        ],
      },
      '0x74f82b5f7cd79b98c3924328fb70fffb73a7dd53': {
        address: '0x74f82b5f7cd79b98c3924328fb70fffb73a7dd53',
        chainId: 369,
        type: 'ETF',
        symbol: 'EMPETF',
        decimals: 18,
        totalSupply: '120493975915755382457',
        priceInUsd: 0,
        innerTokens: [
          {
            weight: '500000000000000000',
            address: '0x9231937ac31506b6913ac5fb1db5a1c1ae83783a',
            chainId: 369,
            symbol: 'EMP',
            decimals: 18,
            totalSupply: '50200000000000000000000000',
          },
          {
            weight: '500000000000000000',
            address: '0x02dcdd04e3f455d838cd1249292c58f3b79e3c3c',
            chainId: 369,
            symbol: 'WETH',
            decimals: 18,
            totalSupply: '5982599654954158080949',
          },
        ],
      },
    },
    '8453': {
      '0xfa23f8deb13d3fa408d355863c747bf7cd61d9a6': {
        address: '0xfa23f8deb13d3fa408d355863c747bf7cd61d9a6',
        chainId: 8453,
        type: 'ETF',
        symbol: 'GETF',
        decimals: 18,
        totalSupply: '20086966226639473070248',
        priceInUsd: 0.09,
        innerTokens: [
          {
            weight: '250000000000000000',
            address: '0x4200000000000000000000000000000000000006',
            chainId: 8453,
            symbol: 'WETH',
            decimals: 18,
            totalSupply: '184493080476368713223810',
          },
          {
            weight: '500000000000000000',
            address: '0x2bd8880e7424dfb94597429de7253de73694de01',
            chainId: 8453,
            symbol: 'GIA',
            decimals: 18,
            totalSupply: '100000000000000000000000000000',
          },
          {
            weight: '250000000000000000',
            address: '0x53cb59d32a8d08fc6d3f81454f150946a028a44d',
            chainId: 8453,
            symbol: 'GDEX',
            decimals: 18,
            totalSupply: '120000000000000000000000',
          },
        ],
      },
      '0x74f82b5f7cd79b98c3924328fb70fffb73a7dd53': {
        address: '0x74f82b5f7cd79b98c3924328fb70fffb73a7dd53',
        chainId: 8453,
        type: 'ETF',
        symbol: 'ETHMAXIETF',
        decimals: 18,
        totalSupply: '864453490744833718704',
        priceInUsd: 88.38,
        innerTokens: [
          {
            weight: '250000000000000000',
            address: '0x833589fcd6edb6e08f4c7c32d4f71b54bda02913',
            chainId: 8453,
            symbol: 'USDC',
            decimals: 6,
            totalSupply: '4007246177975286',
          },
          {
            weight: '750000000000000000',
            address: '0x2ae3f1ec7f1f5012cfeab0185bfc7aa3cf0dec22',
            chainId: 8453,
            symbol: 'CBETH',
            decimals: 18,
            totalSupply: '23064187515383766707857',
          },
        ],
      },
      '0xa8e6045fb7980eca402b0a3e6ebd15ab2fad3619': {
        address: '0xa8e6045fb7980eca402b0a3e6ebd15ab2fad3619',
        chainId: 8453,
        type: 'ETF',
        symbol: 'GSETF',
        decimals: 18,
        totalSupply: '5382695500351437210865',
        priceInUsd: 1.24,
        innerTokens: [
          {
            weight: '750000000000000000',
            address: '0x833589fcd6edb6e08f4c7c32d4f71b54bda02913',
            chainId: 8453,
            symbol: 'USDC',
            decimals: 6,
            totalSupply: '4007246177975286',
          },
          {
            weight: '250000000000000000',
            address: '0x2ae3f1ec7f1f5012cfeab0185bfc7aa3cf0dec22',
            chainId: 8453,
            symbol: 'CBETH',
            decimals: 18,
            totalSupply: '23064187515383766707857',
          },
        ],
      },
    },
    '42161': {
      '0x0676dbb8ca7d13c6a9436ab3c2e5444634f7a058': {
        address: '0x0676dbb8ca7d13c6a9436ab3c2e5444634f7a058',
        chainId: 42161,
        type: 'ETF',
        symbol: 'DEXFIETF',
        decimals: 18,
        totalSupply: '131492382064119891',
        priceInUsd: 27.9,
        innerTokens: [
          {
            weight: '100000000000000000',
            address: '0xff970a61a04b1ca14834a43f5de4533ebddb5cc8',
            chainId: 42161,
            symbol: 'USDC',
            decimals: 6,
            totalSupply: '73712157598771',
          },
          {
            weight: '300000000000000000',
            address: '0xda064d44871ba31dae33a65b3e23b37e44e9168a',
            chainId: 42161,
            symbol: 'GDEX',
            decimals: 18,
            totalSupply: '120000000000000000000000',
          },
          {
            weight: '300000000000000000',
            address: '0x2c093f7d7db41057a2ddd3cb1ad8b4e9c3dffbec',
            chainId: 42161,
            symbol: 'USDEX+',
            decimals: 18,
            totalSupply: '254184174045391486535709',
          },
          {
            weight: '300000000000000000',
            address: '0x82af49447d8a07e3bd95bd0d56f35241523fbab1',
            chainId: 42161,
            symbol: 'WETH',
            decimals: 18,
            totalSupply: '161117841381650650959221',
          },
        ],
      },
      '0x3ffc19bb4700d1d65ecf64e9b145b9fd9cc24086': {
        address: '0x3ffc19bb4700d1d65ecf64e9b145b9fd9cc24086',
        chainId: 42161,
        type: 'ETF',
        symbol: 'ETHMAXIETF',
        decimals: 18,
        totalSupply: '166312234631846286',
        priceInUsd: 87.81,
        innerTokens: [
          {
            weight: '900000000000000000',
            address: '0x82af49447d8a07e3bd95bd0d56f35241523fbab1',
            chainId: 42161,
            symbol: 'WETH',
            decimals: 18,
            totalSupply: '161117841381650650959221',
          },
          {
            weight: '100000000000000000',
            address: '0xff970a61a04b1ca14834a43f5de4533ebddb5cc8',
            chainId: 42161,
            symbol: 'USDC',
            decimals: 6,
            totalSupply: '73712157598771',
          },
        ],
      },
      '0x6da809359c8005e50ec87d0d368457639b18a45b': {
        address: '0x6da809359c8005e50ec87d0d368457639b18a45b',
        chainId: 42161,
        type: 'ETF',
        symbol: 'ARBBCETF',
        decimals: 18,
        totalSupply: '122785689828804315',
        priceInUsd: 128.16,
        innerTokens: [
          {
            weight: '340000000000000000',
            address: '0x912ce59144191c1204e64559fe8253a0e49e6548',
            chainId: 42161,
            symbol: 'ARB',
            decimals: 18,
            totalSupply: '9999998977630224104158908096',
          },
          {
            weight: '330000000000000000',
            address: '0x2f2a2543b76a4166549f7aab2e75bef0aefc5b0f',
            chainId: 42161,
            symbol: 'WBTC',
            decimals: 8,
            totalSupply: '823154847677',
          },
          {
            weight: '330000000000000000',
            address: '0x82af49447d8a07e3bd95bd0d56f35241523fbab1',
            chainId: 42161,
            symbol: 'WETH',
            decimals: 18,
            totalSupply: '161117841381650650959221',
          },
        ],
      },
      '0x3f7eac02201ebfbe9fddd70928e2f921cae31a8d': {
        address: '0x3f7eac02201ebfbe9fddd70928e2f921cae31a8d',
        chainId: 42161,
        type: 'ETF',
        symbol: '50BCETF',
        decimals: 18,
        totalSupply: '9248923619894219308',
        priceInUsd: 398.67,
        innerTokens: [
          {
            weight: '500000000000000000',
            address: '0x2f2a2543b76a4166549f7aab2e75bef0aefc5b0f',
            chainId: 42161,
            symbol: 'WBTC',
            decimals: 8,
            totalSupply: '823154847677',
          },
          {
            weight: '500000000000000000',
            address: '0x82af49447d8a07e3bd95bd0d56f35241523fbab1',
            chainId: 42161,
            symbol: 'WETH',
            decimals: 18,
            totalSupply: '161117841381650650959221',
          },
        ],
      },
      '0xe0449ab87048be6982f25b66fe1a03a084e14904': {
        address: '0xe0449ab87048be6982f25b66fe1a03a084e14904',
        chainId: 42161,
        type: 'ETF',
        symbol: 'DEXFIETF',
        decimals: 18,
        totalSupply: '15668177312531938658',
        priceInUsd: 4.73,
        innerTokens: [
          {
            weight: '300000000000000000',
            address: '0x92a212d9f5eef0b262ac7d84aea64a0d0758b94f',
            chainId: 42161,
            type: 'ERC20',
            symbol: 'GDEX',
            decimals: 18,
            totalSupply: '120000000000000000000000',
          },
          {
            weight: '100000000000000000',
            address: '0xaf88d065e77c8cc2239327c5edb3a432268e5831',
            chainId: 42161,
            symbol: 'USDC',
            decimals: 6,
            totalSupply: '7998315013965677',
          },
          {
            weight: '300000000000000000',
            address: '0x4117ec0a779448872d3820f37ba2060ae0b7c34b',
            chainId: 42161,
            type: 'ERC20',
            symbol: 'USDEX+',
            decimals: 18,
            totalSupply: '366016395359910839300751',
          },
          {
            weight: '300000000000000000',
            address: '0x82af49447d8a07e3bd95bd0d56f35241523fbab1',
            chainId: 42161,
            symbol: 'WETH',
            decimals: 18,
            totalSupply: '161117841381650650959221',
          },
        ],
      },
      '0x0175b9fdbb7cd36701e6261e4018d7662d7608e3': {
        address: '0x0175b9fdbb7cd36701e6261e4018d7662d7608e3',
        chainId: 42161,
        type: 'ETF',
        symbol: 'ETF_02',
        decimals: 18,
        totalSupply: '4303106866860198434',
        priceInUsd: 4.29,
        innerTokens: [
          {
            weight: '500000000000000000',
            address: '0x82af49447d8a07e3bd95bd0d56f35241523fbab1',
            chainId: 42161,
            symbol: 'WETH',
            decimals: 18,
            totalSupply: '161117841381650650959221',
          },
          {
            weight: '300000000000000000',
            address: '0x2f2a2543b76a4166549f7aab2e75bef0aefc5b0f',
            chainId: 42161,
            symbol: 'WBTC',
            decimals: 8,
            totalSupply: '823154847677',
          },
          {
            weight: '200000000000000000',
            address: '0xff970a61a04b1ca14834a43f5de4533ebddb5cc8',
            chainId: 42161,
            symbol: 'USDC',
            decimals: 6,
            totalSupply: '73712157598771',
          },
        ],
      },
      '0x1f0d86b0be59232a6958cfccc159d6ca2d9a42b7': {
        address: '0x1f0d86b0be59232a6958cfccc159d6ca2d9a42b7',
        chainId: 42161,
        type: 'ETF',
        symbol: 'ARBMAXIETF',
        decimals: 18,
        totalSupply: '6181429501150160565',
        priceInUsd: 3.88,
        innerTokens: [
          {
            weight: '800000000000000000',
            address: '0x912ce59144191c1204e64559fe8253a0e49e6548',
            chainId: 42161,
            symbol: 'ARB',
            decimals: 18,
            totalSupply: '9999998977630224104158908096',
          },
          {
            weight: '200000000000000000',
            address: '0x82af49447d8a07e3bd95bd0d56f35241523fbab1',
            chainId: 42161,
            symbol: 'WETH',
            decimals: 18,
            totalSupply: '161117841381650650959221',
          },
        ],
      },
      '0xa52980606c4fcbabdc81f132c61dd6e61d8be8bf': {
        address: '0xa52980606c4fcbabdc81f132c61dd6e61d8be8bf',
        chainId: 42161,
        type: 'ETF',
        symbol: 'GSETF',
        decimals: 18,
        totalSupply: '770293171682318730204',
        priceInUsd: 1.35,
        innerTokens: [
          {
            weight: '200000000000000000',
            address: '0x82af49447d8a07e3bd95bd0d56f35241523fbab1',
            chainId: 42161,
            symbol: 'WETH',
            decimals: 18,
            totalSupply: '161117841381650650959221',
          },
          {
            weight: '800000000000000000',
            address: '0xff970a61a04b1ca14834a43f5de4533ebddb5cc8',
            chainId: 42161,
            symbol: 'USDC',
            decimals: 6,
            totalSupply: '73712157598771',
          },
        ],
      },
      '0x59ef502d6f278dc65d57a7bef78afb33a2487ff8': {
        address: '0x59ef502d6f278dc65d57a7bef78afb33a2487ff8',
        chainId: 42161,
        type: 'ETF',
        symbol: 'GDEXETF',
        decimals: 18,
        totalSupply: '15319060467859570117',
        priceInUsd: 0,
        innerTokens: [
          {
            weight: '750000000000000000',
            address: '0x92a212d9f5eef0b262ac7d84aea64a0d0758b94f',
            chainId: 42161,
            type: 'ERC20',
            symbol: 'GDEX',
            decimals: 18,
            totalSupply: '120000000000000000000000',
          },
          {
            weight: '250000000000000000',
            address: '0x4117ec0a779448872d3820f37ba2060ae0b7c34b',
            chainId: 42161,
            type: 'ERC20',
            symbol: 'USDEX+',
            decimals: 18,
            totalSupply: '366016395359910839300751',
          },
        ],
      },
      '0x2a02e6915ac59dfd52792a9804b3c074bb614109': {
        address: '0x2a02e6915ac59dfd52792a9804b3c074bb614109',
        chainId: 42161,
        type: 'ETF',
        symbol: 'GDEXETF',
        decimals: 18,
        totalSupply: '1046887337162514082',
        priceInUsd: 0,
        innerTokens: [
          {
            weight: '750000000000000000',
            address: '0xda064d44871ba31dae33a65b3e23b37e44e9168a',
            chainId: 42161,
            symbol: 'GDEX',
            decimals: 18,
            totalSupply: '120000000000000000000000',
          },
          {
            weight: '250000000000000000',
            address: '0x2c093f7d7db41057a2ddd3cb1ad8b4e9c3dffbec',
            chainId: 42161,
            symbol: 'USDEX+',
            decimals: 18,
            totalSupply: '254184174045391486535709',
          },
        ],
      },
    },
    '43114': {
      '0xd8daaae660537dd4364dde0807aa621870d6d3cb': {
        address: '0xd8daaae660537dd4364dde0807aa621870d6d3cb',
        chainId: 43114,
        type: 'ETF',
        symbol: 'FSETF',
        decimals: 18,
        totalSupply: '5545000000000000',
        priceInUsd: 1.2,
        innerTokens: [
          {
            weight: '200000000000000000',
            address: '0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7',
            chainId: 43114,
            symbol: 'WAVAX',
            decimals: 18,
            totalSupply: '14414578309935877900280719',
          },
          {
            weight: '800000000000000000',
            address: '0xc7198437980c041c805a1edcba50c1ce5db95118',
            chainId: 43114,
            symbol: 'USDT.E',
            decimals: 6,
            totalSupply: '21670132324413',
          },
        ],
      },
      '0xce275d4eabfe5dc86d1290d52fb4bc35dd49544b': {
        address: '0xce275d4eabfe5dc86d1290d52fb4bc35dd49544b',
        chainId: 43114,
        type: 'ETF',
        symbol: 'AVAXETF',
        decimals: 18,
        totalSupply: '4873542625341435878',
        priceInUsd: 40.28,
        innerTokens: [
          {
            weight: '800000000000000000',
            address: '0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7',
            chainId: 43114,
            symbol: 'WAVAX',
            decimals: 18,
            totalSupply: '14414578309935877900280719',
          },
          {
            weight: '200000000000000000',
            address: '0xc7198437980c041c805a1edcba50c1ce5db95118',
            chainId: 43114,
            symbol: 'USDT.E',
            decimals: 6,
            totalSupply: '21670132324413',
          },
        ],
      },
      '0x5022131e48e717dffa2f0a376930ba5956d06244': {
        address: '0x5022131e48e717dffa2f0a376930ba5956d06244',
        chainId: 43114,
        type: 'ETF',
        symbol: 'ETHMAXIETF',
        decimals: 18,
        totalSupply: '159493539972529781',
        priceInUsd: 68.91,
        innerTokens: [
          {
            weight: '800000000000000000',
            address: '0x49d5c2bdffac6ce2bfdb6640f4f80f226bc10bab',
            chainId: 43114,
            symbol: 'WETH.E',
            decimals: 18,
            totalSupply: '37842379859864610292461',
          },
          {
            weight: '200000000000000000',
            address: '0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7',
            chainId: 43114,
            symbol: 'WAVAX',
            decimals: 18,
            totalSupply: '14414578309935877900280719',
          },
        ],
      },
    },
  },
  custom: {},
  poolv3: {
    '10': {
      '0xaddb6a0412de1ba0f936dcaeb8aaa24578dcf3b2': {
        address: '0xaddb6a0412de1ba0f936dcaeb8aaa24578dcf3b2',
        chainId: 10,
        type: 'ERC20',
        symbol: 'CBETH',
        decimals: 18,
        totalSupply: '23255806276341200740',
        priceInUsd: 505.600656586387,
      },
      '0x8700daec35af8ff88c16bdf0418774cb3d7599b4': {
        address: '0x8700daec35af8ff88c16bdf0418774cb3d7599b4',
        chainId: 10,
        type: 'ERC20',
        symbol: 'SNX',
        decimals: 18,
        totalSupply: '61299192579938395330595604',
        priceInUsd: 0.7187237762988224,
      },
      '0x2416092f143378750bb29b79ed961ab195cceea5': {
        address: '0x2416092f143378750bb29b79ed961ab195cceea5',
        chainId: 10,
        type: 'ERC20',
        symbol: 'EZETH',
        decimals: 18,
        totalSupply: '424948604468717264779',
        priceInUsd: 4423.325634167588,
      },
      '0xdc6ff44d5d932cbd77b52e5612ba0529dc6226f1': {
        address: '0xdc6ff44d5d932cbd77b52e5612ba0529dc6226f1',
        chainId: 10,
        type: 'ERC20',
        symbol: 'WLD',
        decimals: 18,
        totalSupply: '334455974638050437976114965',
        priceInUsd: 1.2978075773387348,
      },
      '0x94b008aa00579c1307b0ef2c499ad98a8ce58e58': {
        address: '0x94b008aa00579c1307b0ef2c499ad98a8ce58e58',
        chainId: 10,
        type: 'ERC20',
        symbol: 'USDT',
        decimals: 6,
        totalSupply: '201246175495018',
        priceInUsd: 0.9988945270653359,
      },
      '0x8c6f28f2f1a3c87f0f938b96d27520d9751ec8d9': {
        address: '0x8c6f28f2f1a3c87f0f938b96d27520d9751ec8d9',
        chainId: 10,
        type: 'ERC20',
        symbol: 'SUSD',
        decimals: 18,
        totalSupply: '17636995851795230381689287',
        priceInUsd: 0.9609174447799597,
      },
      '0x73cb180bf0521828d8849bc8cf2b920918e23032': {
        address: '0x73cb180bf0521828d8849bc8cf2b920918e23032',
        chainId: 10,
        type: 'ERC20',
        symbol: 'USD+',
        decimals: 6,
        totalSupply: '78084890378',
        priceInUsd: 0.9988119759596688,
      },
      '0xdfa46478f9e5ea86d57387849598dbfb2e964b02': {
        address: '0xdfa46478f9e5ea86d57387849598dbfb2e964b02',
        chainId: 10,
        type: 'ERC20',
        symbol: 'MAI',
        decimals: 18,
        totalSupply: '19380012000000000000000000',
        priceInUsd: 0.3683386142979289,
      },
      '0x4200000000000000000000000000000000000042': {
        address: '0x4200000000000000000000000000000000000042',
        chainId: 10,
        type: 'ERC20',
        symbol: 'OP',
        decimals: 18,
        totalSupply: '4294963292498750113616177748',
        priceInUsd: 0.6993461695461693,
      },
      '0xc55e93c62874d8100dbd2dfe307edc1036ad5434': {
        address: '0xc55e93c62874d8100dbd2dfe307edc1036ad5434',
        chainId: 10,
        type: 'ERC20',
        symbol: 'MOOBIFI',
        decimals: 18,
        totalSupply: '12790555176671597216114',
        priceInUsd: 208.0560892770347,
      },
      '0xc40f949f8a4e094d1b49a23ea9241d289b7b2819': {
        address: '0xc40f949f8a4e094d1b49a23ea9241d289b7b2819',
        chainId: 10,
        type: 'ERC20',
        symbol: 'LUSD',
        decimals: 18,
        totalSupply: '462159605517246576479789',
        priceInUsd: 1.006858712567632,
      },
      '0x93919784c523f39cacaa98ee0a9d96c3f32b593e': {
        address: '0x93919784c523f39cacaa98ee0a9d96c3f32b593e',
        chainId: 10,
        type: 'ERC20',
        symbol: 'UNIBTC',
        decimals: 8,
        totalSupply: '319851409',
        priceInUsd: 110133.29052548263,
      },
      '0x0b2c639c533813f4aa9d7837caf62653d097ff85': {
        address: '0x0b2c639c533813f4aa9d7837caf62653d097ff85',
        chainId: 10,
        type: 'ERC20',
        symbol: 'USDC',
        decimals: 6,
        totalSupply: '210616461915277',
        priceInUsd: 0.9987001872810729,
      },
      '0x2218a117083f5b482b0bb821d27056ba9c04b1d3': {
        address: '0x2218a117083f5b482b0bb821d27056ba9c04b1d3',
        chainId: 10,
        type: 'ERC20',
        symbol: 'SDAI',
        decimals: 18,
        totalSupply: '219101063740994636810610',
        priceInUsd: 1.164266819263071,
      },
      '0x7f5c764cbc14f9669b88837ca1490cca17c31607': {
        address: '0x7f5c764cbc14f9669b88837ca1490cca17c31607',
        chainId: 10,
        type: 'ERC20',
        symbol: 'USDC',
        decimals: 6,
        totalSupply: '40546246826676',
        priceInUsd: 0.9984330311564553,
      },
      '0x9560e827af36c94d2ac33a39bce1fe78631088db': {
        address: '0x9560e827af36c94d2ac33a39bce1fe78631088db',
        chainId: 10,
        type: 'ERC20',
        symbol: 'VELO',
        decimals: 18,
        totalSupply: '2215130979333906718250137553',
        priceInUsd: 0.04652118878614488,
      },
      '0x920cf626a271321c151d027030d5d08af699456b': {
        address: '0x920cf626a271321c151d027030d5d08af699456b',
        chainId: 10,
        type: 'ERC20',
        symbol: 'KWENTA',
        decimals: 18,
        totalSupply: '505774703263286195931621',
        priceInUsd: 11.354098472448598,
      },
      '0x747e42eb0591547a0ab429b3627816208c734ea7': {
        address: '0x747e42eb0591547a0ab429b3627816208c734ea7',
        chainId: 10,
        type: 'ERC20',
        symbol: 'T',
        decimals: 18,
        totalSupply: '1879507406952841209607942',
        priceInUsd: 0.0153525656675971,
      },
      '0x6c84a8f1c29108f47a79964b5fe888d4f4d0de40': {
        address: '0x6c84a8f1c29108f47a79964b5fe888d4f4d0de40',
        chainId: 10,
        type: 'ERC20',
        symbol: 'TBTC',
        decimals: 18,
        totalSupply: '23136645910000000000',
        priceInUsd: 112219.72386437785,
      },
      '0x4200000000000000000000000000000000000006': {
        address: '0x4200000000000000000000000000000000000006',
        chainId: 10,
        type: 'ERC20',
        symbol: 'WETH',
        decimals: 18,
        totalSupply: '21400640393622630005966',
        priceInUsd: 4179.1922276611995,
      },
      '0xeb466342c4d449bc9f53a865d5cb90586f405215': {
        address: '0xeb466342c4d449bc9f53a865d5cb90586f405215',
        chainId: 10,
        type: 'ERC20',
        symbol: 'AXLUSDC',
        decimals: 6,
        totalSupply: '219112677403',
        priceInUsd: 0.9988363668827235,
      },
      '0x68f180fcce6836688e9084f035309e29bf0a2095': {
        address: '0x68f180fcce6836688e9084f035309e29bf0a2095',
        chainId: 10,
        type: 'ERC20',
        symbol: 'WBTC',
        decimals: 8,
        totalSupply: '83672805269',
        priceInUsd: 112481.92859812638,
      },
      '0xda10009cbd5d07dd0cecc66161fc93d7c9000da1': {
        address: '0xda10009cbd5d07dd0cecc66161fc93d7c9000da1',
        chainId: 10,
        type: 'ERC20',
        symbol: 'DAI',
        decimals: 18,
        totalSupply: '16137526486821202252474361',
        priceInUsd: 0.9981676457127934,
      },
      '0x1f32b1c2345538c0c6f582fcb022739c4a194ebb': {
        address: '0x1f32b1c2345538c0c6f582fcb022739c4a194ebb',
        chainId: 10,
        type: 'ERC20',
        symbol: 'WSTETH',
        decimals: 18,
        totalSupply: '26581342544670270764646',
        priceInUsd: 5063.688237561571,
      },
    },
    '56': {
      '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c': {
        address: '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c',
        chainId: 56,
        type: 'ERC20',
        symbol: 'WBNB',
        decimals: 18,
        totalSupply: '1311072079570585229562716',
        priceInUsd: 1026.0145979771205,
      },
      '0x4ea98c1999575aaadfb38237dd015c5e773f75a2': {
        address: '0x4ea98c1999575aaadfb38237dd015c5e773f75a2',
        chainId: 56,
        type: 'ERC20',
        symbol: 'TRUMP',
        decimals: 9,
        totalSupply: '1224689973955160',
        priceInUsd: 0.12518051679323572,
      },
      '0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d': {
        address: '0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d',
        chainId: 56,
        type: 'ERC20',
        symbol: 'USDC',
        decimals: 18,
        totalSupply: '1048999979839803987446539541',
        priceInUsd: 0.991619233353461,
      },
      '0x2170ed0880ac9a755fd29b2688956bd959f933f8': {
        address: '0x2170ed0880ac9a755fd29b2688956bd959f933f8',
        chainId: 56,
        type: 'ERC20',
        symbol: 'ETH',
        decimals: 18,
        totalSupply: '604999999958821101704211',
        priceInUsd: 4162.155101791282,
      },
      '0xa2b726b1145a4773f68593cf171187d8ebe4d495': {
        address: '0xa2b726b1145a4773f68593cf171187d8ebe4d495',
        chainId: 56,
        type: 'ERC20',
        symbol: 'INJ',
        decimals: 18,
        totalSupply: '6500000000000000000000000',
        priceInUsd: 12.242637983174511,
      },
      '0x7083609fce4d1d8dc0c979aab8c869ea2c873402': {
        address: '0x7083609fce4d1d8dc0c979aab8c869ea2c873402',
        chainId: 56,
        type: 'ERC20',
        symbol: 'DOT',
        decimals: 18,
        totalSupply: '15999999991309552546802105',
        priceInUsd: 4.023532246886815,
      },
      '0x1fa4a73a3f0133f0025378af00236f3abdee5d63': {
        address: '0x1fa4a73a3f0133f0025378af00236f3abdee5d63',
        chainId: 56,
        type: 'ERC20',
        symbol: 'NEAR',
        decimals: 18,
        totalSupply: '11949999999999920000000000',
        priceInUsd: 3.0184509334330185,
      },
      '0x3ee2200efb3400fabb9aacf31297cbdd1d435d47': {
        address: '0x3ee2200efb3400fabb9aacf31297cbdd1d435d47',
        chainId: 56,
        type: 'ERC20',
        symbol: 'ADA',
        decimals: 18,
        totalSupply: '451907177779999899990000000',
        priceInUsd: 0.8135442011222125,
      },
      '0x55d398326f99059ff775485246999027b3197955': {
        address: '0x55d398326f99059ff775485246999027b3197955',
        chainId: 56,
        type: 'ERC20',
        symbol: 'USDT',
        decimals: 18,
        totalSupply: '7484993499453934506691316887',
        priceInUsd: 0.9974092526495643,
      },
      '0xb3ed0a426155b79b898849803e3b36552f7ed507': {
        address: '0xb3ed0a426155b79b898849803e3b36552f7ed507',
        chainId: 56,
        type: 'ERC20',
        symbol: 'PENDLE',
        decimals: 18,
        totalSupply: '3247020878018100000000000',
        priceInUsd: 4.716786814984324,
      },
      '0xbf5140a22578168fd562dccf235e5d43a02ce9b1': {
        address: '0xbf5140a22578168fd562dccf235e5d43a02ce9b1',
        chainId: 56,
        type: 'ERC20',
        symbol: 'UNI',
        decimals: 18,
        totalSupply: '6759999999999999999999999',
        priceInUsd: 8.081173511572283,
      },
      '0xba2ae424d960c26247dd6c32edc70b295c744c43': {
        address: '0xba2ae424d960c26247dd6c32edc70b295c744c43',
        chainId: 56,
        type: 'ERC20',
        symbol: 'DOGE',
        decimals: 8,
        totalSupply: '256399999999999998',
        priceInUsd: 0.24065510578902327,
      },
      '0xd41fdb03ba84762dd66a0af1a6c8540ff1ba5dfb': {
        address: '0xd41fdb03ba84762dd66a0af1a6c8540ff1ba5dfb',
        chainId: 56,
        type: 'ERC20',
        symbol: 'SFP',
        decimals: 18,
        totalSupply: '500000000000000000000000000',
        priceInUsd: 0.4491485263150989,
      },
      '0x6985884c4392d348587b19cb9eaaf157f13271cd': {
        address: '0x6985884c4392d348587b19cb9eaaf157f13271cd',
        chainId: 56,
        type: 'ERC20',
        symbol: 'ZRO',
        decimals: 18,
        totalSupply: '4609386094720000000000000',
        priceInUsd: 2.199803160903585,
      },
      '0x3a30dce3938a2278f4459f2768126de4fc955e9d': {
        address: '0x3a30dce3938a2278f4459f2768126de4fc955e9d',
        chainId: 56,
        type: 'ERC20',
        symbol: 'EMP',
        decimals: 18,
        totalSupply: '59415235180586772432170006',
        priceInUsd: 0.20697881694589565,
      },
      '0x7130d2a12b9bcbfae4f2634d864a1ee1ce3ead9c': {
        address: '0x7130d2a12b9bcbfae4f2634d864a1ee1ce3ead9c',
        chainId: 56,
        type: 'ERC20',
        symbol: 'BTCB',
        decimals: 18,
        totalSupply: '65300969964784133902393',
        priceInUsd: 112019.68875561673,
      },
      '0x8f0528ce5ef7b51152a59745befdd91d97091d2f': {
        address: '0x8f0528ce5ef7b51152a59745befdd91d97091d2f',
        chainId: 56,
        type: 'ERC20',
        symbol: 'ALPACA',
        decimals: 18,
        totalSupply: '186453234760943419399659106',
        priceInUsd: 0.01644700009132873,
      },
      '0xad29abb318791d579433d831ed122afeaf29dcfe': {
        address: '0xad29abb318791d579433d831ed122afeaf29dcfe',
        chainId: 56,
        type: 'ERC20',
        symbol: 'FTM',
        decimals: 18,
        totalSupply: '12246736529306301014479141',
        priceInUsd: 0.2585150278486476,
      },
      '0x570a5d26f7765ecb712c0924e4de545b89fd43df': {
        address: '0x570a5d26f7765ecb712c0924e4de545b89fd43df',
        chainId: 56,
        type: 'ERC20',
        symbol: 'SOL',
        decimals: 18,
        totalSupply: '1100000099996996547272355',
        priceInUsd: 210.04891207320844,
      },
      '0x0c7ecdb459111cd806e54adc9da1f4a03b43b64a': {
        address: '0x0c7ecdb459111cd806e54adc9da1f4a03b43b64a',
        chainId: 56,
        type: 'ERC20',
        symbol: 'GG',
        decimals: 18,
        totalSupply: '1000000000000000000000000000',
        priceInUsd: 0,
      },
      '0xf486ad071f3bee968384d2e39e2d8af0fcf6fd46': {
        address: '0xf486ad071f3bee968384d2e39e2d8af0fcf6fd46',
        chainId: 56,
        type: 'ERC20',
        symbol: 'VELO',
        decimals: 18,
        totalSupply: '30000000000000000000000000000',
        priceInUsd: 0.013235496298205621,
      },
      '0x29c55f1b02a95f0b30e61976835a3eee2359ad92': {
        address: '0x29c55f1b02a95f0b30e61976835a3eee2359ad92',
        chainId: 56,
        type: 'ERC20',
        symbol: 'ESHARE',
        decimals: 18,
        totalSupply: '73313002197190036961824',
        priceInUsd: 37.941499006217605,
      },
      '0x1d2f0da169ceb9fc7b3144628db156f3f6c60dbe': {
        address: '0x1d2f0da169ceb9fc7b3144628db156f3f6c60dbe',
        chainId: 56,
        type: 'ERC20',
        symbol: 'XRP',
        decimals: 18,
        totalSupply: '325799999909998860000000001',
        priceInUsd: 2.8138518940821005,
      },
      '0x0e09fabb73bd3ade0a17ecc321fd13a19e81ce82': {
        address: '0x0e09fabb73bd3ade0a17ecc321fd13a19e81ce82',
        chainId: 56,
        type: 'ERC20',
        symbol: 'CAKE',
        decimals: 18,
        totalSupply: '2698657747751051201610995531',
        priceInUsd: 2.8367189987054306,
      },
      '0xcf6bb5389c92bdda8a3747ddb454cb7a64626c63': {
        address: '0xcf6bb5389c92bdda8a3747ddb454cb7a64626c63',
        chainId: 56,
        type: 'ERC20',
        symbol: 'XVS',
        decimals: 18,
        totalSupply: '30000000000000000000000000',
        priceInUsd: 6.387394008374172,
      },
      '0x6894cde390a3f51155ea41ed24a33a4827d3063d': {
        address: '0x6894cde390a3f51155ea41ed24a33a4827d3063d',
        chainId: 56,
        type: 'ERC20',
        symbol: 'CAT',
        decimals: 18,
        totalSupply: '9000000000000000000000000000000',
        priceInUsd: 7.432114972442225e-6,
      },
      '0x2d060ef4d6bf7f9e5edde373ab735513c0e4f944': {
        address: '0x2d060ef4d6bf7f9e5edde373ab735513c0e4f944',
        chainId: 56,
        type: 'ERC20',
        symbol: 'AITECH',
        decimals: 18,
        totalSupply: '1987211428000000000000000000',
        priceInUsd: 0.0311613635572128,
      },
      '0x4268b8f0b87b6eae5d897996e6b845ddbd99adf3': {
        address: '0x4268b8f0b87b6eae5d897996e6b845ddbd99adf3',
        chainId: 56,
        type: 'ERC20',
        symbol: 'AXLUSDC',
        decimals: 6,
        totalSupply: '250992505667',
        priceInUsd: 0.9982609858053432,
      },
    },
    '146': {
      '0x31e2eed04a62b232da964a097d8c171584e3c3bd': {
        address: '0x31e2eed04a62b232da964a097d8c171584e3c3bd',
        chainId: 146,
        type: 'ERC20',
        symbol: 'OIL',
        decimals: 18,
        totalSupply: '24204858967907175011861201',
        priceInUsd: 0.0001827855493735745,
      },
      '0xe51ee9868c1f0d6cd968a8b8c8376dc2991bfe44': {
        address: '0xe51ee9868c1f0d6cd968a8b8c8376dc2991bfe44',
        chainId: 146,
        type: 'ERC20',
        symbol: 'BRUSH',
        decimals: 18,
        totalSupply: '307424045109260399029814024',
        priceInUsd: 0.007792901716830878,
      },
      '0x5555b2733602ded58d47b8d3d989e631cbee5555': {
        address: '0x5555b2733602ded58d47b8d3d989e631cbee5555',
        chainId: 146,
        type: 'ERC20',
        symbol: 'GEMS',
        decimals: 18,
        totalSupply: '2320925133348580903578',
        priceInUsd: 21.060494225824055,
      },
      '0x29219dd400f2bf60e5a23d13be72b486d4038894': {
        address: '0x29219dd400f2bf60e5a23d13be72b486d4038894',
        chainId: 146,
        type: 'ERC20',
        symbol: 'USDC.E',
        decimals: 6,
        totalSupply: '107809765735442',
        priceInUsd: 0.9945957913700029,
      },
      '0xb387f9577cc7df1b0358fb1aea57b3500068130f': {
        address: '0xb387f9577cc7df1b0358fb1aea57b3500068130f',
        chainId: 146,
        type: 'ERC20',
        symbol: 'SSGRIM',
        decimals: 18,
        totalSupply: '1000000000000000000000000000',
        priceInUsd: 1.0699466023752312e-5,
      },
      '0x3333b97138d4b086720b5ae8a7844b1345a33333': {
        address: '0x3333b97138d4b086720b5ae8a7844b1345a33333',
        chainId: 146,
        type: 'ERC20',
        symbol: 'SHADOW',
        decimals: 18,
        totalSupply: '3976098218353987895508089',
        priceInUsd: 7.16073163669871,
      },
      '0xe5da20f15420ad15de0fa650600afc998bbe3955': {
        address: '0xe5da20f15420ad15de0fa650600afc998bbe3955',
        chainId: 146,
        type: 'ERC20',
        symbol: 'STS',
        decimals: 18,
        totalSupply: '277954591085708557604761233',
        priceInUsd: 0.2606491873979457,
      },
      '0xb5a10bd15af95381d830f71e85328f2d1d823de7': {
        address: '0xb5a10bd15af95381d830f71e85328f2d1d823de7',
        chainId: 146,
        type: 'ERC20',
        symbol: 'SPUB',
        decimals: 18,
        totalSupply: '1000000000000000000000000',
        priceInUsd: 0.0013571613505580363,
      },
      '0x79bbf4508b1391af3a0f4b30bb5fc4aa9ab0e07c': {
        address: '0x79bbf4508b1391af3a0f4b30bb5fc4aa9ab0e07c',
        chainId: 146,
        type: 'ERC20',
        symbol: 'ANON',
        decimals: 18,
        totalSupply: '16032993192941000000000000',
        priceInUsd: 1.5364521329744238,
      },
      '0x50c42deacd8fc9773493ed674b675be577f2634b': {
        address: '0x50c42deacd8fc9773493ed674b675be577f2634b',
        chainId: 146,
        type: 'ERC20',
        symbol: 'WETH',
        decimals: 18,
        totalSupply: '8017052649140162169872',
        priceInUsd: 4163.167381825203,
      },
      '0x43f9a13675e352154f745d6402e853fecc388aa5': {
        address: '0x43f9a13675e352154f745d6402e853fecc388aa5',
        chainId: 146,
        type: 'ERC20',
        symbol: 'SGOAT',
        decimals: 18,
        totalSupply: '20398272368909000200000000',
        priceInUsd: 0.0028648974068871463,
      },
      '0x6881b80ea7c858e4aeef63893e18a8a36f3682f3': {
        address: '0x6881b80ea7c858e4aeef63893e18a8a36f3682f3',
        chainId: 146,
        type: 'ERC20',
        symbol: 'NAVI',
        decimals: 18,
        totalSupply: '3216433191967780930951694',
        priceInUsd: 0.20402201164635078,
      },
      '0x93cd403693da40d27188714a872943f717e3c543': {
        address: '0x93cd403693da40d27188714a872943f717e3c543',
        chainId: 146,
        type: 'ERC20',
        symbol: 'SBEER',
        decimals: 18,
        totalSupply: '66666666000000000000000000',
        priceInUsd: 0.0004689051423706575,
      },
      '0xc046dcb16592fbb3f9fa0c629b8d93090dd4cb76': {
        address: '0xc046dcb16592fbb3f9fa0c629b8d93090dd4cb76',
        chainId: 146,
        type: 'ERC20',
        symbol: 'JOINT',
        decimals: 18,
        totalSupply: '1000000000000000000000000000',
        priceInUsd: 2.3834316568929483e-5,
      },
      '0x9b567e03d891f537b2b7874aa4a3308cfe2f4fbb': {
        address: '0x9b567e03d891f537b2b7874aa4a3308cfe2f4fbb',
        chainId: 146,
        type: 'ERC20',
        symbol: '$STONER',
        decimals: 18,
        totalSupply: '420000000000000000000',
        priceInUsd: 26.274680034184236,
      },
      '0x3333111a391cc08fa51353e9195526a70b333333': {
        address: '0x3333111a391cc08fa51353e9195526a70b333333',
        chainId: 146,
        type: 'ERC20',
        symbol: 'X33',
        decimals: 18,
        totalSupply: '614350293774813286608191',
        priceInUsd: 13.133833784407413,
      },
      '0xa04bc7140c26fc9bb1f36b1a604c7a5a88fb0e70': {
        address: '0xa04bc7140c26fc9bb1f36b1a604c7a5a88fb0e70',
        chainId: 146,
        type: 'ERC20',
        symbol: 'SWPX',
        decimals: 18,
        totalSupply: '95612620723747457060340110',
        priceInUsd: 0.041511072031722364,
      },
      '0xd3dce716f3ef535c5ff8d041c1a41c3bd89b97ae': {
        address: '0xd3dce716f3ef535c5ff8d041c1a41c3bd89b97ae',
        chainId: 146,
        type: 'ERC20',
        symbol: 'SCUSD',
        decimals: 6,
        totalSupply: '7966765778724',
        priceInUsd: 0.9919068146709652,
      },
      '0xf26ff70573ddc8a90bd7865af8d7d70b8ff019bc': {
        address: '0xf26ff70573ddc8a90bd7865af8d7d70b8ff019bc',
        chainId: 146,
        type: 'ERC20',
        symbol: 'EGGS',
        decimals: 18,
        totalSupply: '21594072121390428744786684927',
        priceInUsd: 0.00029030322927349494,
      },
      '0x9fdbc3f8abc05fa8f3ad3c17d2f806c1230c4564': {
        address: '0x9fdbc3f8abc05fa8f3ad3c17d2f806c1230c4564',
        chainId: 146,
        type: 'ERC20',
        symbol: 'GOGLZ',
        decimals: 18,
        totalSupply: '38274418263925000000000000',
        priceInUsd: 0.07526543081133089,
      },
      '0x7ad5935ea295c4e743e4f2f5b4cda951f41223c2': {
        address: '0x7ad5935ea295c4e743e4f2f5b4cda951f41223c2',
        chainId: 146,
        type: 'ERC20',
        symbol: 'SACRA',
        decimals: 18,
        totalSupply: '16199266155713489053360020',
        priceInUsd: 2.6490115842036416e-6,
      },
      '0x3bce5cb273f0f148010bbea2470e7b5df84c7812': {
        address: '0x3bce5cb273f0f148010bbea2470e7b5df84c7812',
        chainId: 146,
        type: 'ERC20',
        symbol: 'SCETH',
        decimals: 18,
        totalSupply: '3165455799614496718153',
        priceInUsd: 4151.951098959118,
      },
      '0x039e2fb66102314ce7b64ce5ce3e5183bc94ad38': {
        address: '0x039e2fb66102314ce7b64ce5ce3e5183bc94ad38',
        chainId: 146,
        type: 'ERC20',
        symbol: 'WS',
        decimals: 18,
        totalSupply: '274396287815247217108724476',
        priceInUsd: 0.252511776130936,
      },
      '0x0e0ce4d450c705f8a0b6dd9d5123e3df2787d16b': {
        address: '0x0e0ce4d450c705f8a0b6dd9d5123e3df2787d16b',
        chainId: 146,
        type: 'ERC20',
        symbol: 'WAGMI',
        decimals: 18,
        totalSupply: '1286069702879859596285703021',
        priceInUsd: 0.003406128334631112,
      },
      '0xe920d1da9a4d59126dc35996ea242d60efca1304': {
        address: '0xe920d1da9a4d59126dc35996ea242d60efca1304',
        chainId: 146,
        type: 'ERC20',
        symbol: 'DERP',
        decimals: 18,
        totalSupply: '420696969000000000000000000',
        priceInUsd: 0.0016410270189201612,
      },
      '0xb1e25689d55734fd3fffc939c4c3eb52dff8a794': {
        address: '0xb1e25689d55734fd3fffc939c4c3eb52dff8a794',
        chainId: 146,
        type: 'ERC20',
        symbol: 'OS',
        decimals: 18,
        totalSupply: '30708511015915914585829344',
        priceInUsd: 0.2491622640662682,
      },
    },
    '169': {
      '0xf417f5a458ec102b90352f697d6e2ac3a3d2851f': {
        address: '0xf417f5a458ec102b90352f697d6e2ac3a3d2851f',
        chainId: 169,
        type: 'ERC20',
        symbol: 'USDT',
        decimals: 6,
        totalSupply: '4570348533628',
        priceInUsd: 0.9955745372134795,
      },
      '0xec901da9c68e90798bbbb74c11406a32a70652c3': {
        address: '0xec901da9c68e90798bbbb74c11406a32a70652c3',
        chainId: 169,
        type: 'ERC20',
        symbol: 'STONE',
        decimals: 18,
        totalSupply: '3294209912408381249751',
        priceInUsd: 4338.603103511322,
      },
      '0x0dc808adce2099a9f62aa87d9670745aba741746': {
        address: '0x0dc808adce2099a9f62aa87d9670745aba741746',
        chainId: 169,
        type: 'ERC20',
        symbol: 'WETH',
        decimals: 18,
        totalSupply: '530417901326638827082',
        priceInUsd: 4167.517714751349,
      },
      '0x305e88d809c9dc03179554bfbf85ac05ce8f18d6': {
        address: '0x305e88d809c9dc03179554bfbf85ac05ce8f18d6',
        chainId: 169,
        type: 'ERC20',
        symbol: 'WBTC',
        decimals: 8,
        totalSupply: '912564741',
        priceInUsd: 96135.66517000884,
      },
      '0x95cef13441be50d20ca4558cc0a27b601ac544e5': {
        address: '0x95cef13441be50d20ca4558cc0a27b601ac544e5',
        chainId: 169,
        type: 'ERC20',
        symbol: 'MANTA',
        decimals: 18,
        totalSupply: '1020000000000000000000000000',
        priceInUsd: 0.17588134237650904,
      },
      '0xb73603c5d87fa094b7314c74ace2e64d165016fb': {
        address: '0xb73603c5d87fa094b7314c74ace2e64d165016fb',
        chainId: 169,
        type: 'ERC20',
        symbol: 'USDC',
        decimals: 6,
        totalSupply: '2356959618641',
        priceInUsd: 0.9958041938841876,
      },
    },
    '8453': {
      '0x4e74d4db6c0726ccded4656d0bce448876bb4c7a': {
        address: '0x4e74d4db6c0726ccded4656d0bce448876bb4c7a',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'WBLT',
        decimals: 18,
        totalSupply: '1328418885398312217724872',
        priceInUsd: 1.2442888190227233,
      },
      '0xdb6e0e5094a25a052ab6845a9f1e486b9a9b3dde': {
        address: '0xdb6e0e5094a25a052ab6845a9f1e486b9a9b3dde',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'OKAYEG',
        decimals: 18,
        totalSupply: '420690000000000000000000000000',
        priceInUsd: 4.7983714253301985e-6,
      },
      '0x940181a94a35a4569e4529a3cdfb74e38fd98631': {
        address: '0x940181a94a35a4569e4529a3cdfb74e38fd98631',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'AERO',
        decimals: 18,
        totalSupply: '1748524991070015284057744555',
        priceInUsd: 1.101277824766844,
      },
      '0x20d704099b62ada091028bcfc44445041ed16f09': {
        address: '0x20d704099b62ada091028bcfc44445041ed16f09',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'CHAOS',
        decimals: 18,
        totalSupply: '100000000000000000000000000000',
        priceInUsd: 8.414076801263307e-6,
      },
      '0x2676e4e0e2eb58d9bdb5078358ff8a3a964cedf5': {
        address: '0x2676e4e0e2eb58d9bdb5078358ff8a3a964cedf5',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'POLY',
        decimals: 18,
        totalSupply: '998041989380973430752444153',
        priceInUsd: 0.00038656563025148003,
      },
      '0x0b3e328455c4059eeb9e3f84b5543f74e24e7e1b': {
        address: '0x0b3e328455c4059eeb9e3f84b5543f74e24e7e1b',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'VIRTUAL',
        decimals: 18,
        totalSupply: '497377803531729745700580420',
        priceInUsd: 1.108063199080437,
      },
      '0xb4fde59a779991bfb6a52253b51947828b982be3': {
        address: '0xb4fde59a779991bfb6a52253b51947828b982be3',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'PEPE',
        decimals: 18,
        totalSupply: '89177174843691588596693410138',
        priceInUsd: 9.55201690592428e-6,
      },
      '0x236aa50979d5f3de3bd1eeb40e81137f22ab794b': {
        address: '0x236aa50979d5f3de3bd1eeb40e81137f22ab794b',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'TBTC',
        decimals: 18,
        totalSupply: '237972683160000000000',
        priceInUsd: 112329.14631355298,
      },
      '0xf1143f3a8d76f1ca740d29d5671d365f66c44ed1': {
        address: '0xf1143f3a8d76f1ca740d29d5671d365f66c44ed1',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'UBTC',
        decimals: 18,
        totalSupply: '725419307239654937',
        priceInUsd: 110369.16126001335,
      },
      '0x625bb9bb04bdca51871ed6d07e2dd9034e914631': {
        address: '0x625bb9bb04bdca51871ed6d07e2dd9034e914631',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'H4CK',
        decimals: 18,
        totalSupply: '990394624521189968888072417',
        priceInUsd: 0.00017569418539907758,
      },
      '0x161e113b8e9bbaefb846f73f31624f6f9607bd44': {
        address: '0x161e113b8e9bbaefb846f73f31624f6f9607bd44',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'SIMMI',
        decimals: 18,
        totalSupply: '100000000000000000000000000000',
        priceInUsd: 4.910525469997922e-5,
      },
      '0xdbfefd2e8460a6ee4955a68582f85708baea60a3': {
        address: '0xdbfefd2e8460a6ee4955a68582f85708baea60a3',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'SUPEROETHB',
        decimals: 18,
        totalSupply: '224159140086279092839482',
        priceInUsd: 4179.556693654683,
      },
      '0xf5f2a79eeccf6e7f4c570c803f529930e29cc96b': {
        address: '0xf5f2a79eeccf6e7f4c570c803f529930e29cc96b',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'CERTAI',
        decimals: 18,
        totalSupply: '997195783428037522462036401',
        priceInUsd: 0.0003737965805426599,
      },
      '0x4621b7a9c75199271f773ebd9a499dbd165c3191': {
        address: '0x4621b7a9c75199271f773ebd9a499dbd165c3191',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'DOLA',
        decimals: 18,
        totalSupply: '1149689987657754452971275',
        priceInUsd: 0.979256919305525,
      },
      '0x50da645f148798f68ef2d7db7c1cb22a6819bb2c': {
        address: '0x50da645f148798f68ef2d7db7c1cb22a6819bb2c',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'SPX',
        decimals: 8,
        totalSupply: '3228800899912298',
        priceInUsd: 1.0490532169965245,
      },
      '0xeb466342c4d449bc9f53a865d5cb90586f405215': {
        address: '0xeb466342c4d449bc9f53a865d5cb90586f405215',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'AXLUSDC',
        decimals: 6,
        totalSupply: '644795307835',
        priceInUsd: 0.9929108952052197,
      },
      '0xa3d1a8deb97b111454b294e2324efad13a9d8396': {
        address: '0xa3d1a8deb97b111454b294e2324efad13a9d8396',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'OVN',
        decimals: 18,
        totalSupply: '823927326807325333165437',
        priceInUsd: 0.7307295974417468,
      },
      '0x53cb59d32a8d08fc6d3f81454f150946a028a44d': {
        address: '0x53cb59d32a8d08fc6d3f81454f150946a028a44d',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'GDEX',
        decimals: 18,
        totalSupply: '120000000000000000000000',
        priceInUsd: 17.074737174152844,
      },
      '0x01e75e59eabf83c85360351a100d22e025a75bc2': {
        address: '0x01e75e59eabf83c85360351a100d22e025a75bc2',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'HEIR',
        decimals: 18,
        totalSupply: '100000000000000000000000000000',
        priceInUsd: 8.374794138889141e-7,
      },
      '0x0521aaa7c96e25afee79fdd4f1bb48f008ae4eac': {
        address: '0x0521aaa7c96e25afee79fdd4f1bb48f008ae4eac',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'FDREAM',
        decimals: 18,
        totalSupply: '1100000000000000000000000000',
        priceInUsd: 5.539800653387862e-5,
      },
      '0x23da5f2d509cb43a59d43c108a43edf34510eff1': {
        address: '0x23da5f2d509cb43a59d43c108a43edf34510eff1',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'XPUFETH',
        decimals: 18,
        totalSupply: '186226881890260369879',
        priceInUsd: 4405.989006274085,
      },
      '0xedfa23602d0ec14714057867a78d01e94176bea0': {
        address: '0xedfa23602d0ec14714057867a78d01e94176bea0',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'WRSETH',
        decimals: 18,
        totalSupply: '7273137386901072385208',
        priceInUsd: 4405.3974575230795,
      },
      '0xb1a03eda10342529bbf8eb700a06c60441fef25d': {
        address: '0xb1a03eda10342529bbf8eb700a06c60441fef25d',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'MIGGLES',
        decimals: 18,
        totalSupply: '1000000000000000000000000000',
        priceInUsd: 0.023349222846228417,
      },
      '0x1bc0c42215582d5a085795f4badbac3ff36d1bcb': {
        address: '0x1bc0c42215582d5a085795f4badbac3ff36d1bcb',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'CLANKER',
        decimals: 18,
        totalSupply: '1000000000000000000000000',
        priceInUsd: 31.845478718302118,
      },
      '0x4200000000000000000000000000000000000006': {
        address: '0x4200000000000000000000000000000000000006',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'WETH',
        decimals: 18,
        totalSupply: '184493080476368713223810',
        priceInUsd: 4181.227366404168,
      },
      '0xb0505e5a99abd03d94a1169e638b78edfed26ea4': {
        address: '0xb0505e5a99abd03d94a1169e638b78edfed26ea4',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'USUI',
        decimals: 18,
        totalSupply: '1009400056008390521745808',
        priceInUsd: 3.3803093041445655,
      },
      '0x2dad3a13ef0c6366220f989157009e501e7938f8': {
        address: '0x2dad3a13ef0c6366220f989157009e501e7938f8',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'EXTRA',
        decimals: 18,
        totalSupply: '94526943021039277186748804',
        priceInUsd: 0.01821638087259597,
      },
      '0x85483696cc9970ad9edd786b2c5ef735f38d156f': {
        address: '0x85483696cc9970ad9edd786b2c5ef735f38d156f',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'USDC+',
        decimals: 6,
        totalSupply: '98517100829',
        priceInUsd: 0.9989006444023151,
      },
      '0x8c81b4c816d66d36c4bf348bdec01dbcbc70e987': {
        address: '0x8c81b4c816d66d36c4bf348bdec01dbcbc70e987',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'BRIUN',
        decimals: 18,
        totalSupply: '1000000000000000000000000000',
        priceInUsd: 0.0002537682802328472,
      },
      '0x60a3e35cc302bfa44cb288bc5a4f316fdb1adb42': {
        address: '0x60a3e35cc302bfa44cb288bc5a4f316fdb1adb42',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'EURC',
        decimals: 6,
        totalSupply: '41591980600000',
        priceInUsd: 1.1753892592692095,
      },
      '0x13741c5df9ab03e7aa9fb3bf1f714551dd5a5f8a': {
        address: '0x13741c5df9ab03e7aa9fb3bf1f714551dd5a5f8a',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'NOGS',
        decimals: 18,
        totalSupply: '26100862044912047871943750439',
        priceInUsd: 1.2333973955162685e-5,
      },
      '0x08c81699f9a357a9f0d04a09b353576ca328d60d': {
        address: '0x08c81699f9a357a9f0d04a09b353576ca328d60d',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'NFTXBT',
        decimals: 18,
        totalSupply: '994733220378227884563094434',
        priceInUsd: 0.00023030724380127966,
      },
      '0x9a26f5433671751c3276a065f57e5a02d2817973': {
        address: '0x9a26f5433671751c3276a065f57e5a02d2817973',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'KEYCAT',
        decimals: 18,
        totalSupply: '10000000000000000000000000000',
        priceInUsd: 0.0033030761050769374,
      },
      '0x5babfc2f240bc5de90eb7e19d789412db1dec402': {
        address: '0x5babfc2f240bc5de90eb7e19d789412db1dec402',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'CIRCLE',
        decimals: 18,
        totalSupply: '1000000000000000000000000',
        priceInUsd: 1.0622999381605354,
      },
      '0xacfe6019ed1a7dc6f7b508c02d1b04ec88cc21bf': {
        address: '0xacfe6019ed1a7dc6f7b508c02d1b04ec88cc21bf',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'VVV',
        decimals: 18,
        totalSupply: '108966270457829492734560103',
        priceInUsd: 2.0700769535420314,
      },
      '0x79bbf4508b1391af3a0f4b30bb5fc4aa9ab0e07c': {
        address: '0x79bbf4508b1391af3a0f4b30bb5fc4aa9ab0e07c',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'ANON',
        decimals: 18,
        totalSupply: '1032434311132000000000000',
        priceInUsd: 1.5190352278194863,
      },
      '0xfea9dcdc9e23a9068bf557ad5b186675c61d33ea': {
        address: '0xfea9dcdc9e23a9068bf557ad5b186675c61d33ea',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'BSHIB',
        decimals: 18,
        totalSupply: '10000000000000000000000000000',
        priceInUsd: 1.0238908214665694e-5,
      },
      '0xc27468b12ffa6d714b1b5fbc87ef403f38b82ad4': {
        address: '0xc27468b12ffa6d714b1b5fbc87ef403f38b82ad4',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'TRUMP',
        decimals: 18,
        totalSupply: '13619947371000000000000',
        priceInUsd: 7.510401841107008,
      },
      '0x7588880d9c78e81fade7b7e8dc0781e95995a792': {
        address: '0x7588880d9c78e81fade7b7e8dc0781e95995a792',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'SAINT',
        decimals: 18,
        totalSupply: '999339265721661264324826900',
        priceInUsd: 0.00029541049498874413,
      },
      '0x928a6a9fc62b2c94baf2992a6fba4715f5bb0066': {
        address: '0x928a6a9fc62b2c94baf2992a6fba4715f5bb0066',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'RWA',
        decimals: 18,
        totalSupply: '10000000000000000000000000',
        priceInUsd: 0.010437934271794926,
      },
      '0x0db510e79909666d6dec7f5e49370838c16d950f': {
        address: '0x0db510e79909666d6dec7f5e49370838c16d950f',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'ANON',
        decimals: 18,
        totalSupply: '1000000000000000000000000000',
        priceInUsd: 0.0003700541667100315,
      },
      '0xa608512bbc9934e4b1ddecf0f5fb38b6ad93308d': {
        address: '0xa608512bbc9934e4b1ddecf0f5fb38b6ad93308d',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'GUD',
        decimals: 18,
        totalSupply: '193150555113522795572347803',
        priceInUsd: 0.005052546324518636,
      },
      '0x76c71f1703fbf19ffdcf3051e1e684cb9934510f': {
        address: '0x76c71f1703fbf19ffdcf3051e1e684cb9934510f',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'AIXCB',
        decimals: 18,
        totalSupply: '993506898705891798291820240',
        priceInUsd: 0.0018936185343225269,
      },
      '0x6b2504a03ca4d43d0d73776f6ad46dab2f2a4cfd': {
        address: '0x6b2504a03ca4d43d0d73776f6ad46dab2f2a4cfd',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'REI',
        decimals: 18,
        totalSupply: '1000000000000000000000000000',
        priceInUsd: 0.05998491328199401,
      },
      '0x731814e491571a2e9ee3c5b1f7f3b962ee8f4870': {
        address: '0x731814e491571a2e9ee3c5b1f7f3b962ee8f4870',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'VADER',
        decimals: 18,
        totalSupply: '996739513197730759543222706',
        priceInUsd: 0.009887944100037826,
      },
      '0x1e2093ab84768948c6176db5ad98c909ce97f368': {
        address: '0x1e2093ab84768948c6176db5ad98c909ce97f368',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'DORA',
        decimals: 18,
        totalSupply: '1000000000000000000000000000',
        priceInUsd: 0.0004484018358423384,
      },
      '0xab964f7b7b6391bd6c4e8512ef00d01f255d9c0d': {
        address: '0xab964f7b7b6391bd6c4e8512ef00d01f255d9c0d',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'CONVO',
        decimals: 18,
        totalSupply: '999888098421226198033418598',
        priceInUsd: 0.002146719484680812,
      },
      '0xd98832e8a59156acbee4744b9a94a9989a728f36': {
        address: '0xd98832e8a59156acbee4744b9a94a9989a728f36',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'AGENT',
        decimals: 18,
        totalSupply: '21000000000000000000000000',
        priceInUsd: 0.043692734819886093,
      },
      '0x2da56acb9ea78330f947bd57c54119debda7af71': {
        address: '0x2da56acb9ea78330f947bd57c54119debda7af71',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'MOG',
        decimals: 18,
        totalSupply: '72023572902724471027097787446678',
        priceInUsd: 7.029768606030204e-7,
      },
      '0x2ae3f1ec7f1f5012cfeab0185bfc7aa3cf0dec22': {
        address: '0x2ae3f1ec7f1f5012cfeab0185bfc7aa3cf0dec22',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'CBETH',
        decimals: 18,
        totalSupply: '23064187515383766707857',
        priceInUsd: 4582.9201885054945,
      },
      '0x2bd8880e7424dfb94597429de7253de73694de01': {
        address: '0x2bd8880e7424dfb94597429de7253de73694de01',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'GIA',
        decimals: 18,
        totalSupply: '100000000000000000000000000000',
        priceInUsd: 1.8219882408862565e-6,
      },
      '0x3ed6a56a9adec22cf1abfc8fc7100fda77312a10': {
        address: '0x3ed6a56a9adec22cf1abfc8fc7100fda77312a10',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'ZERO',
        decimals: 18,
        totalSupply: '1000000000000000000000000000',
        priceInUsd: 8.652815355915634e-6,
      },
      '0x6985884c4392d348587b19cb9eaaf157f13271cd': {
        address: '0x6985884c4392d348587b19cb9eaaf157f13271cd',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'ZRO',
        decimals: 18,
        totalSupply: '6388079774918000000000000',
        priceInUsd: 2.1022609869780444,
      },
      '0x288f4eb27400fa220d14b864259ad1b7f77c1594': {
        address: '0x288f4eb27400fa220d14b864259ad1b7f77c1594',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'KUDAI',
        decimals: 18,
        totalSupply: '100000000000000000000000000000',
        priceInUsd: 1.115474320921855e-5,
      },
      '0x4f9fd6be4a90f2620860d680c0d4d5fb53d1a825': {
        address: '0x4f9fd6be4a90f2620860d680c0d4d5fb53d1a825',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'AIXBT',
        decimals: 18,
        totalSupply: '998914867384139147138361299',
        priceInUsd: 0.09868827812799898,
      },
      '0x833589fcd6edb6e08f4c7c32d4f71b54bda02913': {
        address: '0x833589fcd6edb6e08f4c7c32d4f71b54bda02913',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'USDC',
        decimals: 6,
        totalSupply: '4007246177975286',
        priceInUsd: 0.9990044840597347,
      },
      '0xac1bd2486aaf3b5c0fc3fd868558b082a531b2b4': {
        address: '0xac1bd2486aaf3b5c0fc3fd868558b082a531b2b4',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'TOSHI',
        decimals: 18,
        totalSupply: '420689999999999999999999999000',
        priceInUsd: 0.0008352881007514683,
      },
      '0x7d9ce55d54ff3feddb611fc63ff63ec01f26d15f': {
        address: '0x7d9ce55d54ff3feddb611fc63ff63ec01f26d15f',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'FUNGI',
        decimals: 9,
        totalSupply: '210000000000000000',
        priceInUsd: 0.006916499821724303,
      },
      '0x2615a94df961278dcbc41fb0a54fec5f10a693ae': {
        address: '0x2615a94df961278dcbc41fb0a54fec5f10a693ae',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'UXRP',
        decimals: 18,
        totalSupply: '1449535100088137390233286',
        priceInUsd: 2.8571249516697796,
      },
      '0xcfa3ef56d303ae4faaba0592388f19d7c3399fb4': {
        address: '0xcfa3ef56d303ae4faaba0592388f19d7c3399fb4',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'EUSD',
        decimals: 18,
        totalSupply: '8973917236791571983675092',
        priceInUsd: 0.9990805269104485,
      },
      '0xcb327b99ff831bf8223cced12b1338ff3aa322ff': {
        address: '0xcb327b99ff831bf8223cced12b1338ff3aa322ff',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'BSDETH',
        decimals: 18,
        totalSupply: '4264891964461916681774',
        priceInUsd: 4333.1661381522335,
      },
      '0xcc0adb6c436eb1f65b2f27733bf926691b94c5f1': {
        address: '0xcc0adb6c436eb1f65b2f27733bf926691b94c5f1',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'GUAN',
        decimals: 18,
        totalSupply: '989358687231409265436282195',
        priceInUsd: 0.0004408869945681521,
      },
      '0x2a06a17cbc6d0032cac2c6696da90f29d39a1a29': {
        address: '0x2a06a17cbc6d0032cac2c6696da90f29d39a1a29',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'BITCOIN',
        decimals: 8,
        totalSupply: '1260124503472711',
        priceInUsd: 0.0715825944104359,
      },
      '0x63cb9a22cbc00bf9159429e9dede4b88c3dba8ce': {
        address: '0x63cb9a22cbc00bf9159429e9dede4b88c3dba8ce',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'CAPO',
        decimals: 18,
        totalSupply: '1000000000000000000000000000',
        priceInUsd: 2.4541689283926978e-5,
      },
      '0xd722e55c1d9d9fa0021a5215cbb904b92b3dc5d4': {
        address: '0xd722e55c1d9d9fa0021a5215cbb904b92b3dc5d4',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'RDNT',
        decimals: 18,
        totalSupply: '67141206221330380000000000',
        priceInUsd: 0.019372035531331485,
      },
      '0x98d0baa52b2d063e780de12f615f963fe8537553': {
        address: '0x98d0baa52b2d063e780de12f615f963fe8537553',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'KAITO',
        decimals: 18,
        totalSupply: '1000000000000000000000000000',
        priceInUsd: 1.0149360253320592,
      },
      '0x9b8df6e244526ab5f6e6400d331db28c8fdddb55': {
        address: '0x9b8df6e244526ab5f6e6400d331db28c8fdddb55',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'USOL',
        decimals: 18,
        totalSupply: '30221068324149669067595',
        priceInUsd: 210.24387129814798,
      },
      '0x39d5313c3750140e5042887413ba8aa6145a9bd2': {
        address: '0x39d5313c3750140e5042887413ba8aa6145a9bd2',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'EMP',
        decimals: 18,
        totalSupply: '11943012777462938961198',
        priceInUsd: 51.256243041024796,
      },
      '0x04d5ddf5f3a8939889f11e97f8c4bb48317f1938': {
        address: '0x04d5ddf5f3a8939889f11e97f8c4bb48317f1938',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'USDZ',
        decimals: 18,
        totalSupply: '111887382476971480000000000',
        priceInUsd: 0.9892875023222181,
      },
      '0xc1cba3fcea344f92d9239c08c0568f6f2f0ee452': {
        address: '0xc1cba3fcea344f92d9239c08c0568f6f2f0ee452',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'WSTETH',
        decimals: 18,
        totalSupply: '46369048002344533308726',
        priceInUsd: 5042.531792040166,
      },
      '0x290f057a2c59b95d8027aa4abf31782676502071': {
        address: '0x290f057a2c59b95d8027aa4abf31782676502071',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'CLIZA',
        decimals: 18,
        totalSupply: '1000000000000000000000000000',
        priceInUsd: 0.0007648654359652574,
      },
      '0xac743b05f5e590d9db6a4192e02457838e4af61e': {
        address: '0xac743b05f5e590d9db6a4192e02457838e4af61e',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'CALLS',
        decimals: 18,
        totalSupply: '994140636208156771885099293',
        priceInUsd: 0.00016801573191774626,
      },
      '0x2f6c17fa9f9bc3600346ab4e48c0701e1d5962ae': {
        address: '0x2f6c17fa9f9bc3600346ab4e48c0701e1d5962ae',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'FARTCOIN',
        decimals: 18,
        totalSupply: '100000000000000000000000000000',
        priceInUsd: 0.00011659125630234737,
      },
      '0x514d8e8099286a13486ef6c525c120f51c239b52': {
        address: '0x514d8e8099286a13486ef6c525c120f51c239b52',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'OBT',
        decimals: 18,
        totalSupply: '1145976000000000000000000000',
        priceInUsd: 0.004793913615427473,
      },
      '0xb33ff54b9f7242ef1593d2c9bcd8f9df46c77935': {
        address: '0xb33ff54b9f7242ef1593d2c9bcd8f9df46c77935',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'FAI',
        decimals: 18,
        totalSupply: '8189700000000000000000000000',
        priceInUsd: 0.009662651563801826,
      },
      '0x0fd7a301b51d0a83fcaf6718628174d527b373b6': {
        address: '0x0fd7a301b51d0a83fcaf6718628174d527b373b6',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'LUM',
        decimals: 18,
        totalSupply: '1000000000000000000000000',
        priceInUsd: 1.0264676310806904,
      },
      '0xfa980ced6895ac314e7de34ef1bfae90a5add21b': {
        address: '0xfa980ced6895ac314e7de34ef1bfae90a5add21b',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'PRIME',
        decimals: 18,
        totalSupply: '1521235719433569890280086',
        priceInUsd: 1.721870452605976,
      },
      '0x4ed4e862860bed51a9570b96d89af5e1b0efefed': {
        address: '0x4ed4e862860bed51a9570b96d89af5e1b0efefed',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'DEGEN',
        decimals: 18,
        totalSupply: '36960002958517368079862816932',
        priceInUsd: 0.0030482215697855597,
      },
      '0xb79dd08ea68a908a97220c76d19a6aa9cbde4376': {
        address: '0xb79dd08ea68a908a97220c76d19a6aa9cbde4376',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'USD+',
        decimals: 6,
        totalSupply: '9440086420647',
        priceInUsd: 0.9937416101117171,
      },
      '0xcf67815cce72e682eb4429eca46843bed81ca739': {
        address: '0xcf67815cce72e682eb4429eca46843bed81ca739',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'G3',
        decimals: 18,
        totalSupply: '70352662653458398390500351',
        priceInUsd: 0.003950425494687138,
      },
      '0x6921b130d297cc43754afba22e5eac0fbf8db75b': {
        address: '0x6921b130d297cc43754afba22e5eac0fbf8db75b',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'DOGINME',
        decimals: 18,
        totalSupply: '69000000000000000000000000000',
        priceInUsd: 0.0004202281392826349,
      },
      '0x532f27101965dd16442e59d40670faf5ebb142e4': {
        address: '0x532f27101965dd16442e59d40670faf5ebb142e4',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'BRETT',
        decimals: 18,
        totalSupply: '9999997544723143783218048495',
        priceInUsd: 0.04219716225958442,
      },
      '0x96419929d7949d6a801a6909c145c8eef6a40431': {
        address: '0x96419929d7949d6a801a6909c145c8eef6a40431',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'SPEC',
        decimals: 18,
        totalSupply: '2956043930535027955381188',
        priceInUsd: 0.3794113186421193,
      },
      '0xe3086852a4b125803c815a158249ae468a3254ca': {
        address: '0xe3086852a4b125803c815a158249ae468a3254ca',
        chainId: 8453,
        type: 'ERC20',
        symbol: '$MFER',
        decimals: 18,
        totalSupply: '999997819542365138940470525',
        priceInUsd: 0.006101949792654306,
      },
      '0x3080ce06eee2869e1b0287ad0de73f9421f977a3': {
        address: '0x3080ce06eee2869e1b0287ad0de73f9421f977a3',
        chainId: 8453,
        type: 'ERC20',
        symbol: '$COOL',
        decimals: 18,
        totalSupply: '100000000000000000000000000000',
        priceInUsd: 1.1664263513566283e-6,
      },
      '0x1c4cca7c5db003824208adda61bd749e55f463a3': {
        address: '0x1c4cca7c5db003824208adda61bd749e55f463a3',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'GAME',
        decimals: 18,
        totalSupply: '999779370712097075583741338',
        priceInUsd: 0.012459896724366515,
      },
      '0x55cd6469f597452b5a7536e2cd98fde4c1247ee4': {
        address: '0x55cd6469f597452b5a7536e2cd98fde4c1247ee4',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'LUNA',
        decimals: 18,
        totalSupply: '998493080203940838204986252',
        priceInUsd: 0.010518632153729588,
      },
      '0x3ec2156d4c0a9cbdab4a016633b7bcf6a8d68ea2': {
        address: '0x3ec2156d4c0a9cbdab4a016633b7bcf6a8d68ea2',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'DRB',
        decimals: 18,
        totalSupply: '100000000000000000000000000000',
        priceInUsd: 5.027111500015065e-5,
      },
      '0x749e5334752466cda899b302ed4176b8573dc877': {
        address: '0x749e5334752466cda899b302ed4176b8573dc877',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'SIM',
        decimals: 18,
        totalSupply: '88888888000000000000000000',
        priceInUsd: 0.0007569573983457742,
      },
      '0xcbb7c0000ab88b473b1f5afd9ef808440eed33bf': {
        address: '0xcbb7c0000ab88b473b1f5afd9ef808440eed33bf',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'CBBTC',
        decimals: 8,
        totalSupply: '2061385086800',
        priceInUsd: 112717.37171923106,
      },
      '0x806041b6473da60abbe1b256d9a2749a151be6c6': {
        address: '0x806041b6473da60abbe1b256d9a2749a151be6c6',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'STTAO',
        decimals: 9,
        totalSupply: '1879191764825',
        priceInUsd: 384.61677372178053,
      },
      '0x1185cb5122edad199bdbc0cbd7a0457e448f23c7': {
        address: '0x1185cb5122edad199bdbc0cbd7a0457e448f23c7',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'SEKOIA',
        decimals: 18,
        totalSupply: '986227199657323768966110697',
        priceInUsd: 0.0005932753998156068,
      },
      '0x2416092f143378750bb29b79ed961ab195cceea5': {
        address: '0x2416092f143378750bb29b79ed961ab195cceea5',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'EZETH',
        decimals: 18,
        totalSupply: '2915607065361400774426',
        priceInUsd: 4409.450329165165,
      },
      '0xd9aaec86b65d86f6a7b5b1b0c42ffa531710b6ca': {
        address: '0xd9aaec86b65d86f6a7b5b1b0c42ffa531710b6ca',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'USDBC',
        decimals: 6,
        totalSupply: '9155121665370',
        priceInUsd: 0.9977597906584159,
      },
      '0xece7b98bd817ee5b1f2f536daf34d0b6af8bb542': {
        address: '0xece7b98bd817ee5b1f2f536daf34d0b6af8bb542',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'ROCK',
        decimals: 18,
        totalSupply: '10000000000000000000000000000',
        priceInUsd: 9.936380225867448e-6,
      },
      '0xc0041ef357b183448b235a8ea73ce4e4ec8c265f': {
        address: '0xc0041ef357b183448b235a8ea73ce4e4ec8c265f',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'COOKIE',
        decimals: 18,
        totalSupply: '185422971233330000000000000',
        priceInUsd: 0.11221438536053423,
      },
      '0x0578d8a44db98b23bf096a382e016e29a5ce0ffe': {
        address: '0x0578d8a44db98b23bf096a382e016e29a5ce0ffe',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'HIGHER',
        decimals: 18,
        totalSupply: '1000000000000000000000000000',
        priceInUsd: 0.0025340610865844547,
      },
      '0xebff2db643cf955247339c8c6bcd8406308ca437': {
        address: '0xebff2db643cf955247339c8c6bcd8406308ca437',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'CHOMP',
        decimals: 18,
        totalSupply: '100000000000000000000000000',
        priceInUsd: 0.04788583803348519,
      },
      '0xb3b32f9f8827d4634fe7d973fa1034ec9fddb3b3': {
        address: '0xb3b32f9f8827d4634fe7d973fa1034ec9fddb3b3',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'B3',
        decimals: 18,
        totalSupply: '100000000000000000000000000000',
        priceInUsd: 0.002875921459105949,
      },
      '0xfde4c96c8593536e31f229ea8f37b2ada2699bb2': {
        address: '0xfde4c96c8593536e31f229ea8f37b2ada2699bb2',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'USDT',
        decimals: 6,
        totalSupply: '23428145810677',
        priceInUsd: 0.9991604191243793,
      },
      '0x1fba65de0a9cbd2d1df82d141897042d36bb6c86': {
        address: '0x1fba65de0a9cbd2d1df82d141897042d36bb6c86',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'WIF',
        decimals: 18,
        totalSupply: '60393703499000000000000',
        priceInUsd: 0.8125231197108309,
      },
      '0x05019be5a6750bbde6f889d6471c37ef923472d3': {
        address: '0x05019be5a6750bbde6f889d6471c37ef923472d3',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'FCAST',
        decimals: 18,
        totalSupply: '1000000000000000000000000',
        priceInUsd: 0.08387985629971524,
      },
      '0x22af33fe49fd1fa80c7149773dde5890d3c76f3b': {
        address: '0x22af33fe49fd1fa80c7149773dde5890d3c76f3b',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'BNKR',
        decimals: 18,
        totalSupply: '100000000000000000000000000000',
        priceInUsd: 0.0005345604209271062,
      },
      '0x3c8cd0db9a01efa063a7760267b822a129bc7dca': {
        address: '0x3c8cd0db9a01efa063a7760267b822a129bc7dca',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'FROC',
        decimals: 18,
        totalSupply: '100000000000000000000000000000',
        priceInUsd: 5.978939304186698e-6,
      },
      '0x2e2cc4dfce60257f091980631e75f5c436b71c87': {
        address: '0x2e2cc4dfce60257f091980631e75f5c436b71c87',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'GRK',
        decimals: 18,
        totalSupply: '100000000000000000000000000000',
        priceInUsd: 1.3398112359217856e-6,
      },
      '0x57f5fbd3de65dfc0bd3630f732969e5fb97e6d37': {
        address: '0x57f5fbd3de65dfc0bd3630f732969e5fb97e6d37',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'TRUMP',
        decimals: 9,
        totalSupply: '3374346977021350',
        priceInUsd: 0.13103670042631343,
      },
      '0xcde90558fc317c69580deeaf3efc509428df9080': {
        address: '0xcde90558fc317c69580deeaf3efc509428df9080',
        chainId: 8453,
        type: 'ERC20',
        symbol: 'NORMILIO',
        decimals: 18,
        totalSupply: '1000000000000000000000000000',
        priceInUsd: 0.0004384335072614244,
      },
    },
    '42161': {
      '0xfa7f8980b0f1e64a2062791cc3b0871572f1f7f0': {
        address: '0xfa7f8980b0f1e64a2062791cc3b0871572f1f7f0',
        chainId: 42161,
        type: 'ERC20',
        symbol: 'UNI',
        decimals: 18,
        totalSupply: '1127318296526806395091952',
        priceInUsd: 8.114920369078396,
      },
      '0xec70dcb4a1efa46b8f2d97c310c9c4790ba5ffa8': {
        address: '0xec70dcb4a1efa46b8f2d97c310c9c4790ba5ffa8',
        chainId: 42161,
        type: 'ERC20',
        symbol: 'RETH',
        decimals: 18,
        totalSupply: '7607434949455652253172',
        priceInUsd: 4770.522056378193,
      },
      '0xed65c5085a18fa160af0313e60dcc7905e944dc7': {
        address: '0xed65c5085a18fa160af0313e60dcc7905e944dc7',
        chainId: 42161,
        type: 'ERC20',
        symbol: 'ETHX',
        decimals: 18,
        totalSupply: '14956046382275522571',
        priceInUsd: 0,
      },
      '0x13ad51ed4f1b7e9dc168d8a00cb3f4ddd85efa60': {
        address: '0x13ad51ed4f1b7e9dc168d8a00cb3f4ddd85efa60',
        chainId: 42161,
        type: 'ERC20',
        symbol: 'LDO',
        decimals: 18,
        totalSupply: '1660235709032615261741243',
        priceInUsd: 1.122654879576566,
      },
      '0x539bde0d7dbd336b79148aa742883198bbf60342': {
        address: '0x539bde0d7dbd336b79148aa742883198bbf60342',
        chainId: 42161,
        type: 'ERC20',
        symbol: 'MAGIC',
        decimals: 18,
        totalSupply: '291950757485400237225268732',
        priceInUsd: 0.175905915586341,
      },
      '0x7e7a7c916c19a45769f6bdaf91087f93c6c12f78': {
        address: '0x7e7a7c916c19a45769f6bdaf91087f93c6c12f78',
        chainId: 42161,
        type: 'ERC20',
        symbol: 'EGP',
        decimals: 18,
        totalSupply: '10000000000000000000000000',
        priceInUsd: 0.5194214870887701,
      },
      '0x5979d7b546e38e414f7e9822514be443a4800529': {
        address: '0x5979d7b546e38e414f7e9822514be443a4800529',
        chainId: 42161,
        type: 'ERC20',
        symbol: 'WSTETH',
        decimals: 18,
        totalSupply: '72171617858760098139638',
        priceInUsd: 5069.557838693734,
      },
      '0x1337420ded5adb9980cfc35f8f2b054ea86f8ab1': {
        address: '0x1337420ded5adb9980cfc35f8f2b054ea86f8ab1',
        chainId: 42161,
        type: 'ERC20',
        symbol: 'SQD',
        decimals: 18,
        totalSupply: '1327198809910873074179861699',
        priceInUsd: 0.07082405555271831,
      },
      '0x5d3a1ff2b6bab83b63cd9ad0787074081a52ef34': {
        address: '0x5d3a1ff2b6bab83b63cd9ad0787074081a52ef34',
        chainId: 42161,
        type: 'ERC20',
        symbol: 'USDE',
        decimals: 18,
        totalSupply: '9280169759389000000000000',
        priceInUsd: 0.9993936359219028,
      },
      '0xeb466342c4d449bc9f53a865d5cb90586f405215': {
        address: '0xeb466342c4d449bc9f53a865d5cb90586f405215',
        chainId: 42161,
        type: 'ERC20',
        symbol: 'AXLUSDC',
        decimals: 6,
        totalSupply: '469961654118',
        priceInUsd: 0.9987436306983258,
      },
      '0xff970a61a04b1ca14834a43f5de4533ebddb5cc8': {
        address: '0xff970a61a04b1ca14834a43f5de4533ebddb5cc8',
        chainId: 42161,
        type: 'ERC20',
        symbol: 'USDC',
        decimals: 6,
        totalSupply: '73712157598771',
        priceInUsd: 0.998933317044855,
      },
      '0xaf88d065e77c8cc2239327c5edb3a432268e5831': {
        address: '0xaf88d065e77c8cc2239327c5edb3a432268e5831',
        chainId: 42161,
        type: 'ERC20',
        symbol: 'USDC',
        decimals: 6,
        totalSupply: '7998315013965677',
        priceInUsd: 0.998986934880982,
      },
      '0x4186bfc76e2e237523cbc30fd220fe055156b41f': {
        address: '0x4186bfc76e2e237523cbc30fd220fe055156b41f',
        chainId: 42161,
        type: 'ERC20',
        symbol: 'RSETH',
        decimals: 18,
        totalSupply: '11937094989000000000000',
        priceInUsd: 4306.846244956883,
      },
      '0x3082cc23568ea640225c2467653db90e9250aaa0': {
        address: '0x3082cc23568ea640225c2467653db90e9250aaa0',
        chainId: 42161,
        type: 'ERC20',
        symbol: 'RDNT',
        decimals: 18,
        totalSupply: '1118686438517401660000000000',
        priceInUsd: 0.01935004081475592,
      },
      '0xba5ddd1f9d7f570dc94a51479a000e3bce967196': {
        address: '0xba5ddd1f9d7f570dc94a51479a000e3bce967196',
        chainId: 42161,
        type: 'ERC20',
        symbol: 'AAVE',
        decimals: 18,
        totalSupply: '79790116334959208504690',
        priceInUsd: 275.8273603107743,
      },
      '0x323665443cef804a3b5206103304bd4872ea4253': {
        address: '0x323665443cef804a3b5206103304bd4872ea4253',
        chainId: 42161,
        type: 'ERC20',
        symbol: 'USDV',
        decimals: 6,
        totalSupply: '88758208749',
        priceInUsd: 0.11369000712384843,
      },
      '0x912ce59144191c1204e64559fe8253a0e49e6548': {
        address: '0x912ce59144191c1204e64559fe8253a0e49e6548',
        chainId: 42161,
        type: 'ERC20',
        symbol: 'ARB',
        decimals: 18,
        totalSupply: '9999998977630224104158908096',
        priceInUsd: 0.4405096372404035,
      },
      '0x6985884c4392d348587b19cb9eaaf157f13271cd': {
        address: '0x6985884c4392d348587b19cb9eaaf157f13271cd',
        chainId: 42161,
        type: 'ERC20',
        symbol: 'ZRO',
        decimals: 18,
        totalSupply: '32607204130156000000000000',
        priceInUsd: 2.2214033617811904,
      },
      '0x2c650dab03a59332e2e0c0c4a7f726913e5028c1': {
        address: '0x2c650dab03a59332e2e0c0c4a7f726913e5028c1',
        chainId: 42161,
        type: 'ERC20',
        symbol: 'TAP',
        decimals: 18,
        totalSupply: '47500000000000000000000000',
        priceInUsd: 8.260515144727239e-5,
      },
      '0x4cb9a7ae498cedcbb5eae9f25736ae7d428c9d66': {
        address: '0x4cb9a7ae498cedcbb5eae9f25736ae7d428c9d66',
        chainId: 42161,
        type: 'ERC20',
        symbol: 'XAI',
        decimals: 18,
        totalSupply: '2006909081686207390162096854',
        priceInUsd: 0.04389001902455737,
      },
      '0x17fc002b466eec40dae837fc4be5c67993ddbd6f': {
        address: '0x17fc002b466eec40dae837fc4be5c67993ddbd6f',
        chainId: 42161,
        type: 'ERC20',
        symbol: 'FRAX',
        decimals: 18,
        totalSupply: '12950710637946371915156189',
        priceInUsd: 0.16848652549202037,
      },
      '0xf97f4df75117a78c1a5a0dbb814af92458539fb4': {
        address: '0xf97f4df75117a78c1a5a0dbb814af92458539fb4',
        chainId: 42161,
        type: 'ERC20',
        symbol: 'LINK',
        decimals: 18,
        totalSupply: '3729426957299934444493179',
        priceInUsd: 21.606181394573976,
      },
      '0xfd086bc7cd5c481dcc9c85ebe478a1c0b69fcbb9': {
        address: '0xfd086bc7cd5c481dcc9c85ebe478a1c0b69fcbb9',
        chainId: 42161,
        type: 'ERC20',
        symbol: 'USD0',
        decimals: 6,
        totalSupply: '1023388016174830',
        priceInUsd: 0.9992839098034167,
      },
      '0x772598e9e62155d7fdfe65fdf01eb5a53a8465be': {
        address: '0x772598e9e62155d7fdfe65fdf01eb5a53a8465be',
        chainId: 42161,
        type: 'ERC20',
        symbol: 'EMP',
        decimals: 18,
        totalSupply: '37447890624219800000000',
        priceInUsd: 51.505117206487704,
      },
      '0x3647c54c4c2c65bc7a2d63c0da2809b399dbbdc0': {
        address: '0x3647c54c4c2c65bc7a2d63c0da2809b399dbbdc0',
        chainId: 42161,
        type: 'ERC20',
        symbol: 'SOLVBTC',
        decimals: 18,
        totalSupply: '25520483223841656188',
        priceInUsd: 112421.37085820448,
      },
      '0x9623063377ad1b27544c965ccd7342f7ea7e88c7': {
        address: '0x9623063377ad1b27544c965ccd7342f7ea7e88c7',
        chainId: 42161,
        type: 'ERC20',
        symbol: 'GRT',
        decimals: 18,
        totalSupply: '3448851684668556852726904819',
        priceInUsd: 0.08425243675851336,
      },
      '0xd56734d7f9979dd94fae3d67c7e928234e71cd4c': {
        address: '0xd56734d7f9979dd94fae3d67c7e928234e71cd4c',
        chainId: 42161,
        type: 'ERC20',
        symbol: 'TIA.N',
        decimals: 6,
        totalSupply: '178619264398',
        priceInUsd: 1.4599609921796384,
      },
      '0x82af49447d8a07e3bd95bd0d56f35241523fbab1': {
        address: '0x82af49447d8a07e3bd95bd0d56f35241523fbab1',
        chainId: 42161,
        type: 'ERC20',
        symbol: 'WETH',
        decimals: 18,
        totalSupply: '161117841381650650959221',
        priceInUsd: 4180.502048835852,
      },
      '0x894134a25a5fac1c2c26f1d8fbf05111a3cb9487': {
        address: '0x894134a25a5fac1c2c26f1d8fbf05111a3cb9487',
        chainId: 42161,
        type: 'ERC20',
        symbol: 'GRAI',
        decimals: 18,
        totalSupply: '111786721131498872086790',
        priceInUsd: 1.012961585435433,
      },
      '0xb1084db8d3c05cebd5fa9335df95ee4b8a0edc30': {
        address: '0xb1084db8d3c05cebd5fa9335df95ee4b8a0edc30',
        chainId: 42161,
        type: 'ERC20',
        symbol: 'USDT+',
        decimals: 6,
        totalSupply: '221240984470',
        priceInUsd: 0.9974414391413972,
      },
      '0xe80772eaf6e2e18b651f160bc9158b2a5cafca65': {
        address: '0xe80772eaf6e2e18b651f160bc9158b2a5cafca65',
        chainId: 42161,
        type: 'ERC20',
        symbol: 'XUSD',
        decimals: 6,
        totalSupply: '2429376259269',
        priceInUsd: 0.9987627243286068,
      },
      '0x0c880f6761f1af8d9aa9c466984b80dab9a8c9e8': {
        address: '0x0c880f6761f1af8d9aa9c466984b80dab9a8c9e8',
        chainId: 42161,
        type: 'ERC20',
        symbol: 'PENDLE',
        decimals: 18,
        totalSupply: '30234792204144462017987913',
        priceInUsd: 4.769761014014859,
      },
      '0x2f2a2543b76a4166549f7aab2e75bef0aefc5b0f': {
        address: '0x2f2a2543b76a4166549f7aab2e75bef0aefc5b0f',
        chainId: 42161,
        type: 'ERC20',
        symbol: 'WBTC',
        decimals: 8,
        totalSupply: '823154847677',
        priceInUsd: 112509.02378213973,
      },
      '0x6c84a8f1c29108f47a79964b5fe888d4f4d0de40': {
        address: '0x6c84a8f1c29108f47a79964b5fe888d4f4d0de40',
        chainId: 42161,
        type: 'ERC20',
        symbol: 'TBTC',
        decimals: 18,
        totalSupply: '175661601510000000000',
        priceInUsd: 112327.18979657003,
      },
      '0x35751007a407ca6feffe80b3cb397736d2cf4dbe': {
        address: '0x35751007a407ca6feffe80b3cb397736d2cf4dbe',
        chainId: 42161,
        type: 'ERC20',
        symbol: 'WEETH',
        decimals: 18,
        totalSupply: '116243404797083640270574',
        priceInUsd: 4486.199010307597,
      },
      '0x11cdb42b0eb46d95f990bedd4695a6e3fa034978': {
        address: '0x11cdb42b0eb46d95f990bedd4695a6e3fa034978',
        chainId: 42161,
        type: 'ERC20',
        symbol: 'CRV',
        decimals: 18,
        totalSupply: '17858885266466206227391290',
        priceInUsd: 0.6854794289200573,
      },
      '0x18c11fd286c5ec11c3b683caa813b77f5163a122': {
        address: '0x18c11fd286c5ec11c3b683caa813b77f5163a122',
        chainId: 42161,
        type: 'ERC20',
        symbol: 'GNS',
        decimals: 18,
        totalSupply: '20096031361276999056001302',
        priceInUsd: 1.8524186316566529,
      },
      '0xfc5a1a6eb076a2c7ad06ed22c90d7e710e35ad0a': {
        address: '0xfc5a1a6eb076a2c7ad06ed22c90d7e710e35ad0a',
        chainId: 42161,
        type: 'ERC20',
        symbol: 'GMX',
        decimals: 18,
        totalSupply: '10665596280516719390000001',
        priceInUsd: 16.905226567046018,
      },
      '0xdfb8be6f8c87f74295a87de951974362cedcfa30': {
        address: '0xdfb8be6f8c87f74295a87de951974362cedcfa30',
        chainId: 42161,
        type: 'ERC20',
        symbol: 'EMC',
        decimals: 18,
        totalSupply: '979840164688614545603688520',
        priceInUsd: 0.001042864577623032,
      },
      '0x25d887ce7a35172c62febfd67a1856f20faebb00': {
        address: '0x25d887ce7a35172c62febfd67a1856f20faebb00',
        chainId: 42161,
        type: 'ERC20',
        symbol: 'PEPE',
        decimals: 18,
        totalSupply: '187464592919390800000000000000',
        priceInUsd: 9.517183081141241e-6,
      },
    },
    '43114': {
      '0x9702230a8ea53601f5cd2dc00fdbc13d4df4a8c7': {
        address: '0x9702230a8ea53601f5cd2dc00fdbc13d4df4a8c7',
        chainId: 43114,
        type: 'ERC20',
        symbol: 'USDT',
        decimals: 6,
        totalSupply: '1847205574047338',
        priceInUsd: 0.9697928134562249,
      },
      '0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7': {
        address: '0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7',
        chainId: 43114,
        type: 'ERC20',
        symbol: 'WAVAX',
        decimals: 18,
        totalSupply: '14414578309935877900280719',
        priceInUsd: 34.23162220846084,
      },
      '0xd1c3f94de7e5b45fa4edbba472491a9f4b166fc4': {
        address: '0xd1c3f94de7e5b45fa4edbba472491a9f4b166fc4',
        chainId: 43114,
        type: 'ERC20',
        symbol: 'XAVA',
        decimals: 18,
        totalSupply: '100000000000000000000000000',
        priceInUsd: 0.29364500709814856,
      },
      '0x49d5c2bdffac6ce2bfdb6640f4f80f226bc10bab': {
        address: '0x49d5c2bdffac6ce2bfdb6640f4f80f226bc10bab',
        chainId: 43114,
        type: 'ERC20',
        symbol: 'WETH.E',
        decimals: 18,
        totalSupply: '37842379859864610292461',
        priceInUsd: 4159.553030910598,
      },
      '0xb97ef9ef8734c71904d8002f8b6bc66dd9c48a6e': {
        address: '0xb97ef9ef8734c71904d8002f8b6bc66dd9c48a6e',
        chainId: 43114,
        type: 'ERC20',
        symbol: 'USDC',
        decimals: 6,
        totalSupply: '1028815424092150',
        priceInUsd: 0.9868562840477054,
      },
    },
  },
} as const;
